// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg part=\"icon\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M15.293 4H12V3h3.293a1 1 0 0 1 .707.293l.707.707a1 1 0 0 1 .293.707V8h-1V4.707l-6.646 6.647-.708-.708L15.293 4zM3 7a2 2 0 0 1 2-2h4v1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4h1v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,<svg part=\"icon\" id=\"mi-chevron-down\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M8.717 13.643l-5.1-6.071.766-.644L9.483 13h1.034l5.1-6.072.766.644-5.1 6.071a1 1 0 0 1-.766.357H9.483a1 1 0 0 1-.766-.357z\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,<svg part=\"icon\" id=\"mi-chevron-up\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M10.517 7H9.483l-5.1 6.072-.766-.644 5.1-6.071A1 1 0 0 1 9.483 6h1.034a1 1 0 0 1 .766.357l5.1 6.071-.766.644L10.517 7z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** 
 * These SASS variables are auto-generated out of their counter-part design-tokens 
 * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
 **/
/** 
 * These classes are auto-generated out of their counter-part design-tokens 
 * during build of foundations using scripts/utils/generate-gap-utility-classes.mjs 
 **/
/** 
 * These SASS variables are auto-generated out of their counter-part design-tokens 
 * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
 **/
.mds {
  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
  /* Document
     ========================================================================== */
  /**
   * Render the \`main\` element consistently in IE.
   */
  /**
   * Correct the font size and margin on \`h1\` elements within \`section\` and
   * \`article\` contexts in Chrome, Firefox, and Safari.
   */
  /* Grouping content
     ========================================================================== */
  /**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */
  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd \`em\` font sizing in all browsers.
   */
  /* Text-level semantics
     ========================================================================== */
  /**
   * Remove the gray background on active links in IE 10.
   */
  /**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */
  /**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */
  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd \`em\` font sizing in all browsers.
   */
  /**
   * Add the correct font size in all browsers.
   */
  /**
   * Prevent \`sub\` and \`sup\` elements from affecting the line height in
   * all browsers.
   */
  /* Embedded content
     ========================================================================== */
  /**
   * Remove the border on images inside links in IE 10.
   */
  /* Forms
     ========================================================================== */
  /**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */
  /**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */
  /**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */
  /**
   * Correct the inability to style clickable types in iOS and Safari.
   */
  /**
   * Remove the inner border and padding in Firefox.
   */
  /**
   * Restore the focus styles unset by the previous rule.
   */
  /**
   * Correct the padding in Firefox.
   */
  /**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from \`fieldset\` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    \`fieldset\` elements in all browsers.
   */
  /**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */
  /**
   * Remove the default vertical scrollbar in IE 10+.
   */
  /**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */
  /**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */
  /**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */
  /**
   * Remove the inner padding in Chrome and Safari on macOS.
   */
  /**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to \`inherit\` in Safari.
   */
  /* Interactive
     ========================================================================== */
  /*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */
  /*
   * Add the correct display in all browsers.
   */
  /* Misc
     ========================================================================== */
  /**
   * Add the correct display in IE 10+.
   */
  /**
   * Add the correct display in IE 10.
   */
  /** 
   * These SASS variables are auto-generated out of their counter-part design-tokens 
   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
   **/
  /*
  @description: 
  A breadcrumb is a secondary navigation component used to show users their location within a website or application hierarchy.
  Breadcrumbs should provide context and an easy way for users to navigate up the site hierarchy. They are not intended to replace primary navigation but to enhance the user’s understanding of where they are within the website or application. Use a breadcrumb for applications with a hierarchy of more than 2 levels.
  */
  /*
  @description: 
  Color system for the Maersk Design System.
  It includes a set of color appearances and variants that can be used for text, background, borders, and links.
  The color system is designed to be flexible, making it suitable for various design needs.
  It includes a set of predefined colors that can be used throughout the UI.
  */
  /** 
   * These SASS variables are auto-generated out of their counter-part design-tokens 
   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
   **/
  /** 
   * These SASS variables are auto-generated out of their counter-part design-tokens 
   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
   **/
  /** 
   * These SASS variables are auto-generated out of their counter-part design-tokens 
   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
   **/
  /*
  @description: 
  Base grid system utilities for layouts. 
  The grid system provides a flexible layout structure, allowing for consistent alignment and spacing of elements and is independent of container or viewport size. 
  It includes utilities for defining rows, columns, and spans, enabling developers to create complex layouts with ease.
  For responsive layouts, use the container-based grid system in _container-grid.css or viewport-based grid system in _viewport-grid.css.
  */
  /** 
   * These SASS variables are auto-generated out of their counter-part design-tokens 
   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
   **/
  /** 
   * These SASS variables are auto-generated out of their counter-part design-tokens 
   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs 
   **/
  /*
  @description: 
  Container and grid system utilities for responsive layouts. 
  Container-based grid respond to the width of the container rather than the entire viewport. 
  This enables more granular control over layout behavior—allowing components to adapt based on their immediate context. 
  It’s especially effective in complex or modular layouts where sections of a page need to remain visually consistent, even within wider screens.
  It includes utilities for defining rows, columns, and spans, enabling developers to create complex layouts with ease.
  */
  /** 
   * These classes are auto-generated out of their counter-part design-tokens 
   * during build of foundations using scripts/utils/generate-gap-utility-classes.mjs 
   **/
  /** Table with caption **/
  /** Caption **/
}
.mds main {
  display: block;
}
.mds h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
.mds hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}
.mds pre {
  font-family: monospace; /* 1 */
  font-size: 1em; /* 2 */
}
.mds a {
  background-color: transparent;
}
.mds abbr[title] {
  border-bottom-width: 0; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}
.mds b,
.mds strong {
  font-weight: bolder;
}
.mds code,
.mds kbd,
.mds samp {
  font-family: monospace; /* 1 */
  font-size: 1em; /* 2 */
}
.mds small {
  font-size: 80%;
}
.mds sub,
.mds sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
.mds sub {
  bottom: -0.25em;
}
.mds sup {
  top: -0.5em;
}
.mds img {
  border-style: none;
}
.mds button,
.mds input,
.mds optgroup,
.mds select,
.mds textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}
.mds button,
.mds input {
  /* 1 */
  overflow: visible;
}
.mds button,
.mds select {
  /* 1 */
  text-transform: none;
}
.mds button,
.mds [type=button],
.mds [type=reset],
.mds [type=submit] {
  -webkit-appearance: button;
}
.mds button::-moz-focus-inner,
.mds [type=button]::-moz-focus-inner,
.mds [type=reset]::-moz-focus-inner,
.mds [type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
.mds button:-moz-focusring,
.mds [type=button]:-moz-focusring,
.mds [type=reset]:-moz-focusring,
.mds [type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}
.mds fieldset {
  border-width: 0;
  padding: 0;
  margin: 0;
}
.mds legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}
.mds progress {
  vertical-align: baseline;
}
.mds textarea {
  overflow: auto;
}
.mds [type=checkbox],
.mds [type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}
.mds [type=number]::-webkit-inner-spin-button,
.mds [type=number]::-webkit-outer-spin-button {
  height: auto;
}
.mds [type=search] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
.mds [type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}
.mds ::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
.mds details {
  display: block;
}
.mds summary {
  display: list-item;
}
.mds template {
  display: none;
}
.mds [hidden] {
  display: none;
}
.mds * {
  box-sizing: border-box;
}
.mds footer,
.mds main {
  display: block;
}
.mds button,
.mds input,
.mds optgroup,
.mds select,
.mds textarea {
  font-family: inherit;
}
.mds code {
  word-break: break-word;
}
.mds [slot=label],
.mds [slot=errormessage],
.mds [slot=hint],
.mds [slot=legend] {
  display: flex;
  align-items: center;
  gap: var(--mds_foundations_slot_gap);
}
.mds mc-modal h1,
.mds mc-tab-bar h1,
.mds mc-popover h1,
.mds mc-c-accordion h1 {
  margin: calc(var(--mds_foundations_typography_heading-1_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-1_margin-bottom) / 2) 0;
}
.mds mc-modal h2,
.mds mc-tab-bar h2,
.mds mc-popover h2,
.mds mc-c-accordion h2 {
  margin: calc(var(--mds_foundations_typography_heading-2_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-2_margin-bottom) / 2) 0;
}
.mds mc-modal h3,
.mds mc-tab-bar h3,
.mds mc-popover h3,
.mds mc-c-accordion h3 {
  margin: calc(var(--mds_foundations_typography_heading-3_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-3_margin-bottom) / 2) 0;
}
.mds mc-modal h4,
.mds mc-tab-bar h4,
.mds mc-popover h4,
.mds mc-c-accordion h4 {
  margin: calc(var(--mds_foundations_typography_heading-4_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-4_margin-bottom) / 2) 0;
}
.mds mc-modal h5,
.mds mc-tab-bar h5,
.mds mc-popover h5,
.mds mc-c-accordion h5 {
  margin: calc(var(--mds_foundations_typography_heading-4_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-4_margin-bottom) / 2) 0;
}
.mds mc-modal h6,
.mds mc-tab-bar h6,
.mds mc-popover h6,
.mds mc-c-accordion h6 {
  margin: calc(var(--mds_foundations_typography_heading-4_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-4_margin-bottom) / 2) 0;
}
.mds mc-modal p,
.mds mc-tab-bar p,
.mds mc-popover p,
.mds mc-c-accordion p {
  margin: calc(var(--mds_foundations_typography_paragraph_margin-top) / 2) 0 calc(var(--mds_foundations_typography_paragraph_margin-bottom) / 2) 0;
}
.mds mc-modal hr,
.mds mc-tab-bar hr,
.mds mc-popover hr,
.mds mc-c-accordion hr {
  margin: calc(var(----mds_foundations_horizontal-rule_margin-top) / 2) 0 calc(var(--mds_foundations_horizontal-rule_margin-bottom) / 2) 0;
}
.mds mc-modal ol,
.mds mc-modal ul,
.mds mc-tab-bar ol,
.mds mc-tab-bar ul,
.mds mc-popover ol,
.mds mc-popover ul,
.mds mc-c-accordion ol,
.mds mc-c-accordion ul {
  margin: calc(var(--mds_foundations_list_margin-top) / 2) 0 calc(var(--mds_foundations_list_margin-bottom) / 2) 0;
}
.mds .mds-breadcrumb {
  /* 
  @name: mds-breadcrumb
  @category: Navigation
  @usage: 
  Use breadcrumbs to give context and help users navigate.
  All breadcrumbs items except the current page should be clickable links.
  Use concise and descriptive link text for each level in the breadcrumb.
  Avoid using dynamic or changing breadcrumbs, since it can confuse users.
  Use truncation if the breadcrumb has more than 5 levels.
  The breadcrumb should never wrap to the second line.
  Place the breadcrumb consistently on each page across the website or application.
  Don’t use a breadcrumb for simple and flat hierarchies e.g. a 2 level hierarchy.
  @example:
  <nav class="mds-breadcrumb" aria-label="breadcrumb">
    <ol>
      <li><a href="#home">Home</a></li>
      <li><a href="#digital-solutions">Digital Solutions</a></li>
      <li><a href="#data-integrations">Data Integrations</a></li>
      <li><a href="#ocean-booking">Ocean Booking</a></li>
      <li>Current page</li>
    </ol>
  </nav> */
}
.mds .mds-breadcrumb ol {
  list-style: none;
  flex-flow: row wrap;
  gap: 0;
  margin: 0;
  padding: 0;
}
.mds .mds-breadcrumb ol li {
  display: flex;
  padding: 0;
}
.mds .mds-breadcrumb ol a {
  text-decoration: none;
  color: var(--mds_foundations_breadcrumb_item_text-color);
  align-items: center;
}
.mds .mds-breadcrumb ol a:hover {
  text-decoration: underline;
}
.mds .mds-breadcrumb ol a mc-icon::part(icon) {
  fill: var(--mds_foundations_breadcrumb_item_text-color);
}
.mds .mds-breadcrumb ol li::after {
  padding: 0 var(--mds_foundations_breadcrumb_item_padding);
  color: var(--mds_brand_appearance_neutral_weakest_text-color);
  content: "/";
}
.mds .mds-breadcrumb ol li:last-child {
  color: var(--mds_foundations_breadcrumb_item_text-color);
}
.mds .mds-breadcrumb ol li:last-child::after {
  content: "";
}
.mds .mds-breadcrumb ol li:last-child {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-breadcrumb ol li:last-child {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-breadcrumb ol li:last-child {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
.mds .mds-breadcrumb ol .mds-breadcrumb__long-and-truncated {
  /* 
  @name: mds-breadcrumb__long-and-truncated
  @category: Navigation
  @usage: 
  It is recommended to limit the breadcrumb to 3-5 levels. If the website or application has a deeper hierarchy or is too long, then use truncation. Displaying more than 5 levels will make it hard for the user to comprehend the structure and in most cases there also starts to be a problem with space.
  When truncated the breadcrumb only shows the first and the last two levels and the levels in between is replaced by an ellipsis.
  @example:   
  <nav class="mds-breadcrumb" aria-label="breadcrumb example 1">
    <ol>
      <li><a href="#home">Home</a></li>
      <li>
        <a href="#data-integrations" title="Data Integrations</a>
      </li>
      <li><a href="#ocean-booking">Ocean Booking</a></li>
      <li class="mds-breadcrumb__long-and-truncated">API (Leverage the power of integrated data)</li>
    </ol>
  </nav> */
  flex: 0.5 1;
  display: block;
  max-width: max-content;
  padding-right: var(--mds_foundations_breadcrumb_truncated_item_padding);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}
.mds .mds-breadcrumb ol .mds-breadcrumb__long-and-truncated a {
  display: inline;
}
.mds .mds-breadcrumb ol .mds-breadcrumb__long-and-truncated::after {
  position: absolute;
  top: 0;
  right: 0;
}
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li {
  display: none;
}
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:first-child,
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3),
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2),
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:last-child {
  display: flex;
}
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) ~ li.mds-breadcrumb__long-and-truncated,
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2) ~ li.mds-breadcrumb__long-and-truncated {
  display: block;
}
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) a {
  display: none;
}
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3)::after {
  content: "...";
  padding: 0 var(--mds_foundations_breadcrumb_collapsed_padding) 0 0;
  color: var(--mds_foundations_breadcrumb_item_text-color);
}
.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2)::before {
  content: "/";
  padding: 0 var(--mds_foundations_breadcrumb_item_padding);
  color: var(--mds_foundations_breadcrumb_separator_text-color);
}
.mds .mds-breadcrumb {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-breadcrumb {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-breadcrumb {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
@media only screen and (max-width: 640px) {
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li {
    display: none;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:first-child,
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3),
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2),
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:last-child {
    display: flex;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) ~ li.mds-breadcrumb__long-and-truncated,
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2) ~ li.mds-breadcrumb__long-and-truncated {
    display: block;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) a {
    display: none;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3)::after {
    content: "...";
    padding: 0 var(--mds_foundations_breadcrumb_collapsed_padding) 0 0;
    color: var(--mds_foundations_breadcrumb_item_text-color);
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2)::before {
    content: "/";
    padding: 0 var(--mds_foundations_breadcrumb_item_padding);
    color: var(--mds_foundations_breadcrumb_separator_text-color);
  }
}
@container (max-width: 640px) {
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li {
    display: none;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:first-child,
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3),
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2),
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:last-child {
    display: flex;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) ~ li.mds-breadcrumb__long-and-truncated,
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2) ~ li.mds-breadcrumb__long-and-truncated {
    display: block;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) a {
    display: none;
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3)::after {
    content: "...";
    padding: 0 var(--mds_foundations_breadcrumb_collapsed_padding) 0 0;
    color: var(--mds_foundations_breadcrumb_item_text-color);
  }
  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2)::before {
    content: "/";
    padding: 0 var(--mds_foundations_breadcrumb_item_padding);
    color: var(--mds_foundations_breadcrumb_separator_text-color);
  }
}
.mds .mds-tree-nav ul,
.mds .mds-tree-nav ol {
  display: flex;
  flex-direction: column;
  gap: 0;
  list-style: none;
  margin: 0;
  padding: 0;
}
.mds .mds-tree-nav ul,
.mds .mds-tree-nav ol {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-tree-nav ul,
  .mds .mds-tree-nav ol {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-tree-nav ul,
.mds .mds-tree-nav ol {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
.mds .mds-tree-nav li {
  margin: 0;
  padding: 0;
}
.mds .mds-tree-nav li.mds-tree-nav--separator {
  border-top: 1px solid var(--mds_brand_appearance_neutral_weak_border-color);
  margin: 10px 0;
  padding: 0;
}
.mds .mds-tree-nav summary,
.mds .mds-tree-nav a {
  position: relative;
  border-radius: var(--mds_brand_border_medium_radius);
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2px;
  overflow: hidden;
  padding: 6px 36px 6px 8px;
  -webkit-text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
          text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.mds .mds-tree-nav summary mc-icon,
.mds .mds-tree-nav a mc-icon {
  margin-right: 8px;
}
.mds .mds-tree-nav summary mc-icon::part(icon),
.mds .mds-tree-nav a mc-icon::part(icon) {
  fill: var(--mds_brand_appearance_neutral_weak_text-color);
}
.mds .mds-tree-nav summary:visited,
.mds .mds-tree-nav a:visited {
  color: var(--mds_brand_appearance_neutral_weak_text-color);
}
.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,
.mds .mds-tree-nav a:hover,
.mds .mds-tree-nav a:active {
  background-color: var(--mds_brand_appearance_state_neutral_default_hover_background-color);
  color: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-tree-nav summary:hover mc-icon::part(icon), .mds .mds-tree-nav summary:active mc-icon::part(icon),
.mds .mds-tree-nav a:hover mc-icon::part(icon),
.mds .mds-tree-nav a:active mc-icon::part(icon) {
  fill: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,
.mds .mds-tree-nav a:hover,
.mds .mds-tree-nav a:active {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,
  .mds .mds-tree-nav a:hover,
  .mds .mds-tree-nav a:active {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,
.mds .mds-tree-nav a:hover,
.mds .mds-tree-nav a:active {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,
.mds .mds-tree-nav a:hover,
.mds .mds-tree-nav a:active {
  color: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-tree-nav summary:focus-visible,
.mds .mds-tree-nav a:focus-visible {
  outline: 0;
  box-shadow: inset var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);
}
.mds .mds-tree-nav summary,
.mds .mds-tree-nav a {
  color: var(--mds_brand_appearance_neutral_weak_text-color);
}
.mds .mds-tree-nav a.mds-tree-nav__active {
  background-color: var(--mds_brand_appearance_info_weak_background-color);
  color: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-tree-nav a.mds-tree-nav__active mc-icon::part(icon) {
  fill: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-tree-nav a.mds-tree-nav__active {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-tree-nav a.mds-tree-nav__active {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-tree-nav a.mds-tree-nav__active {
  font-style: var(--mds_brand_typography_text_small_medium_font-style);
  font-weight: var(--mds_brand_typography_text_small_medium_font-weight);
}
.mds .mds-tree-nav a.mds-tree-nav__external::after {
  margin-left: 16px;
  display: inline;
  height: 20px;
  width: 20px;
  background-color: var(--mds_brand_appearance_neutral_weak_text-color);
  content: "";
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%;
  mask-size: cover;
}
.mds .mds-tree-nav summary {
  list-style-type: none;
  border-radius: var(--mds_brand_border_large_radius);
}
.mds .mds-tree-nav summary::-webkit-details-marker {
  display: none;
}
.mds .mds-tree-nav details[open] {
  color: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-tree-nav details > summary::after,
.mds .mds-tree-nav a.mds-tree-nav__external::after {
  position: absolute;
  right: 8px;
}
.mds .mds-tree-nav details > summary::after {
  margin-left: 16px;
  height: 20px;
  width: 20px;
  background-color: var(--mds_brand_appearance_neutral_weak_text-color);
  content: "";
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 50% 50%;
  mask-size: cover;
}
.mds .mds-tree-nav details[open] > summary::after {
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 50% 50%;
}
.mds .mds-tree-nav details[open] > summary {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-tree-nav details[open] > summary {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-tree-nav details[open] > summary {
  font-style: var(--mds_brand_typography_text_small_medium_font-style);
  font-weight: var(--mds_brand_typography_text_small_medium_font-weight);
}
.mds .mds-tree-nav details > summary:hover::after {
  background-color: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-tree-nav summary:has(mc-badge),
.mds .mds-tree-nav a:has(mc-badge) {
  padding-right: 8px;
}
.mds .mds-tree-nav summary:has(mc-badge[position=right]),
.mds .mds-tree-nav a:has(mc-badge[position=right]) {
  justify-content: space-between;
}
.mds .mds-tree-nav summary mc-badge[position=right] {
  padding-right: 28px;
}
.mds .mds-tree-nav .mds-tree-nav__external mc-badge[position=right] {
  padding-right: 28px;
}
.mds .mds-tree-nav li details li a,
.mds .mds-tree-nav li details li summary {
  padding-left: 24px;
}
.mds .mds-tree-nav li details li details li a,
.mds .mds-tree-nav li details li details li summary {
  padding-left: 48px;
}
.mds .mds-tree-nav li details li details li details li a,
.mds .mds-tree-nav li details li details li details li summary {
  padding-left: 72px;
}
.mds .mds-tree-nav li details li details li details li details li a,
.mds .mds-tree-nav li details li details li details li details li summary {
  padding-left: 96px;
}
.mds .mds-tree-nav li details li details li details li details li details li a,
.mds .mds-tree-nav li details li details li details li details li details li summary {
  padding-left: 120px;
}
.mds .mds-neutral__text-color {
  /* 
  @name: mds-neutral__text-color
  @category: Colors
  @usage: 
  Use mds-neutral__text-color class to get the neutral color for text.
  @example:
  <div class="mds-neutral__text-color">text color in neutral appearance</div>
  */
}
.mds .mds-neutral__text-color {
  color: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds .mds-neutral--weakest__text-color {
  /* 
  @name: mds-neutral--weakest__text-color
  @category: Colors
  @usage: 
  Use mds-neutral--weakest__text-color class to get the neutral weakest color for text.
  @example:
  <div class="mds-neutral--weakest__text-color">text color in neutral weakest appearance</div>
  */
}
.mds .mds-neutral--weakest__text-color {
  color: var(--mds_brand_appearance_neutral_weakest_text-color);
}
.mds .mds-neutral--weak__text-color {
  /* 
  @name: mds-neutral--weak__text-color
  @category: Colors
  @usage: 
  Use mds-neutral--weak__text-color class to get the neutral weak color for text.
  @example:
  <div class="mds-neutral--weak__text-color">text color in neutral weak appearance</div>
  */
}
.mds .mds-neutral--weak__text-color {
  color: var(--mds_brand_appearance_neutral_weak_text-color);
}
.mds .mds-neutral--strong__text-color {
  /* 
  @name: mds-neutral--strong__text-color
  @category: Colors
  @usage: 
  Use mds-neutral--strong__text-color class to get the neutral strong color for text.
  @example:
  <div class="mds-neutral--strong__text-color">text color in neutral strong appearance</div>
  */
}
.mds .mds-neutral--strong__text-color {
  color: var(--mds_brand_appearance_neutral_strong_text-color);
}
.mds .mds-neutral--strongest__text-color {
  /* 
  @name: mds-neutral--strongest__text-color
  @category: Colors
  @usage: 
  Use mds-neutral--strongest__text-color class to get the neutral strongest color for text.
  @example:
  <div class="mds-neutral--strongest__text-color">text color in neutral strongest appearance</div>
  */
}
.mds .mds-neutral--strongest__text-color {
  color: var(--mds_brand_appearance_neutral_strongest_text-color);
}
.mds .mds-neutral--inverse__text-color {
  /* 
  @name: mds-neutral--inverse__text-color
  @category: Colors
  @usage: 
  Use mds-neutral--inverse__text-color class to get the neutral inverse color for text.
  @example:
  <div class="mds-neutral--inverse__text-color">text color in neutral inverse appearance</div>
  */
}
.mds .mds-neutral--inverse__text-color {
  color: var(--mds_brand_appearance_neutral_inverse_text-color);
}
.mds .mds-neutral--subtle__text-color {
  /* 
  @name: mds-neutral--subtle__text-color
  @category: Colors
  @usage: 
  Use mds-neutral--subtle__text-color class to get the neutral subtle color for text.
  @example:
  <div class="mds-neutral--subtle__text-color">text color in neutral subtle appearance</div>
  */
}
.mds .mds-neutral--subtle__text-color {
  color: var(--mds_brand_appearance_neutral_subtle_text-color);
}
.mds .mds-neutral--alt__text-color {
  /* 
  @name: mds-neutral--alt__text-color
  @category: Colors
  @usage: 
  Use mds-neutral--alt__text-color class to get the neutral alt color for text.
  @example:
  <div class="mds-neutral--alt__text-color">text color in neutral alt appearance</div>
  */
}
.mds .mds-neutral--alt__text-color {
  color: var(--mds_brand_appearance_neutral_alt_text-color);
}
.mds .mds-neutral__background-color {
  /* 
  @name: mds-neutral__background-color
  @category: Colors
  @usage: 
  Use mds-neutral__background-color class to get the neutral color for background.
  @example:
  <div class="mds-neutral__background-color">background color in neutral appearance</div>
  */
}
.mds .mds-neutral__background-color {
  background-color: var(--mds_brand_appearance_neutral_default_background-color);
}
.mds .mds-neutral--weakest__background-color {
  /* 
  @name: mds-neutral--weakest__background-color
  @category: Colors
  @usage: 
  Use mds-neutral--weakest__background-color class to get the neutral weakest color for background.
  @example:
  <div class="mds-neutral--weakest__background-color">background color in neutral weakest appearance</div>
  */
}
.mds .mds-neutral--weakest__background-color {
  background-color: var(--mds_brand_appearance_neutral_weakest_background-color);
}
.mds .mds-neutral--weak__background-color {
  /* 
  @name: mds-neutral--weak__background-color
  @category: Colors
  @usage: 
  Use mds-neutral--weak__background-color class to get the neutral weak color for background.
  @example:
  <div class="mds-neutral--weak__background-color">background color in neutral weak appearance</div>
  */
}
.mds .mds-neutral--weak__background-color {
  background-color: var(--mds_brand_appearance_neutral_weak_background-color);
}
.mds .mds-neutral--strong__background-color {
  /* 
  @name: mds-neutral--strong__background-color
  @category: Colors
  @usage: 
  Use mds-neutral--strong__background-color class to get the neutral strong color for background.
  @example:
  <div class="mds-neutral--strong__background-color">background color in neutral strong appearance</div>
  */
}
.mds .mds-neutral--strong__background-color {
  background-color: var(--mds_brand_appearance_neutral_strong_background-color);
}
.mds .mds-neutral--strongest__background-color {
  /* 
  @name: mds-neutral--strongest__background-color
  @category: Colors
  @usage: 
  Use mds-neutral--strongest__background-color class to get the neutral strongest color for background.
  @example:
  <div class="mds-neutral--strongest__background-color">background color in neutral strongest appearance</div>
  */
}
.mds .mds-neutral--strongest__background-color {
  background-color: var(--mds_brand_appearance_neutral_strongest_background-color);
}
.mds .mds-neutral--inverse__background-color {
  /* 
  @name: mds-neutral--inverse__background-color
  @category: Colors
  @usage: 
  Use mds-neutral--inverse__background-color class to get the neutral inverse color for background.
  @example:
  <div class="mds-neutral--inverse__background-color">background color in neutral inverse appearance</div>
  */
}
.mds .mds-neutral--inverse__background-color {
  background-color: var(--mds_brand_appearance_neutral_inverse_background-color);
}
.mds .mds-neutral--subtle__background-color {
  /* 
  @name: mds-neutral--subtle__background-color
  @category: Colors
  @usage: 
  Use mds-neutral--subtle__background-color class to get the neutral subtle color for background.
  @example:
  <div class="mds-neutral--subtle__background-color">background color in neutral subtle appearance</div>
  */
}
.mds .mds-neutral--subtle__background-color {
  background-color: var(--mds_brand_appearance_neutral_subtle_background-color);
}
.mds .mds-neutral--alt__background-color {
  /* 
  @name: mds-neutral--alt__background-color
  @category: Colors
  @usage: 
  Use mds-neutral--alt__background-color class to get the neutral alt color for background.
  @example:
  <div class="mds-neutral--alt__background-color">background color in neutral alt appearance</div>
  */
}
.mds .mds-neutral--alt__background-color {
  background-color: var(--mds_brand_appearance_neutral_alt_background-color);
}
.mds .mds-neutral__on-background-color {
  /* 
  @name: mds-neutral__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral__on-background-color class to get the neutral color for on-background.
  @example:
  <div class="mds-neutral__on-background-color">on-background color in neutral appearance</div>
  */
}
.mds .mds-neutral__on-background-color {
  color: var(--mds_brand_appearance_neutral_default_on-background-color);
}
.mds .mds-neutral--weakest__on-background-color {
  /* 
  @name: mds-neutral--weakest__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral--weakest__on-background-color class to get the neutral weakest color for on-background.
  @example:
  <div class="mds-neutral--weakest__on-background-color">on-background color in neutral weakest appearance</div>
  */
}
.mds .mds-neutral--weakest__on-background-color {
  color: var(--mds_brand_appearance_neutral_weakest_on-background-color);
}
.mds .mds-neutral--weak__on-background-color {
  /* 
  @name: mds-neutral--weak__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral--weak__on-background-color class to get the neutral weak color for on-background.
  @example:
  <div class="mds-neutral--weak__on-background-color">on-background color in neutral weak appearance</div>
  */
}
.mds .mds-neutral--weak__on-background-color {
  color: var(--mds_brand_appearance_neutral_weak_on-background-color);
}
.mds .mds-neutral--strong__on-background-color {
  /* 
  @name: mds-neutral--strong__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral--strong__on-background-color class to get the neutral strong color for on-background.
  @example:
  <div class="mds-neutral--strong__on-background-color">on-background color in neutral strong appearance</div>
  */
}
.mds .mds-neutral--strong__on-background-color {
  color: var(--mds_brand_appearance_neutral_strong_on-background-color);
}
.mds .mds-neutral--strongest__on-background-color {
  /* 
  @name: mds-neutral--strongest__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral--strongest__on-background-color class to get the neutral strongest color for on-background.
  @example:
  <div class="mds-neutral--strongest__on-background-color">on-background color in neutral strongest appearance</div>
  */
}
.mds .mds-neutral--strongest__on-background-color {
  color: var(--mds_brand_appearance_neutral_strongest_on-background-color);
}
.mds .mds-neutral--inverse__on-background-color {
  /* 
  @name: mds-neutral--inverse__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral--inverse__on-background-color class to get the neutral inverse color for on-background.
  @example:
  <div class="mds-neutral--inverse__on-background-color">on-background color in neutral inverse appearance</div>
  */
}
.mds .mds-neutral--inverse__on-background-color {
  color: var(--mds_brand_appearance_neutral_inverse_on-background-color);
}
.mds .mds-neutral--subtle__on-background-color {
  /* 
  @name: mds-neutral--subtle__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral--subtle__on-background-color class to get the neutral subtle color for on-background.
  @example:
  <div class="mds-neutral--subtle__on-background-color">on-background color in neutral subtle appearance</div>
  */
}
.mds .mds-neutral--subtle__on-background-color {
  color: var(--mds_brand_appearance_neutral_subtle_on-background-color);
}
.mds .mds-neutral--alt__on-background-color {
  /* 
  @name: mds-neutral--alt__on-background-color
  @category: Colors
  @usage: 
  Use mds-neutral--alt__on-background-color class to get the neutral alt color for on-background.
  @example:
  <div class="mds-neutral--alt__on-background-color">on-background color in neutral alt appearance</div>
  */
}
.mds .mds-neutral--alt__on-background-color {
  color: var(--mds_brand_appearance_neutral_alt_on-background-color);
}
.mds .mds-neutral__border-color {
  /* 
  @name: mds-neutral__border-color
  @category: Colors
  @usage: 
  Use mds-neutral__border-color class to get the neutral color for border.
  @example:
  <div class="mds-neutral__border-color">border color in neutral appearance</div>
  */
}
.mds .mds-neutral__border-color {
  border-color: var(--mds_brand_appearance_neutral_default_border-color);
}
.mds .mds-neutral--weakest__border-color {
  /* 
  @name: mds-neutral--weakest__border-color
  @category: Colors
  @usage: 
  Use mds-neutral--weakest__border-color class to get the neutral weakest color for border.
  @example:
  <div class="mds-neutral--weakest__border-color">border color in neutral weakest appearance</div>
  */
}
.mds .mds-neutral--weakest__border-color {
  border-color: var(--mds_brand_appearance_neutral_weakest_border-color);
}
.mds .mds-neutral--weak__border-color {
  /* 
  @name: mds-neutral--weak__border-color
  @category: Colors
  @usage: 
  Use mds-neutral--weak__border-color class to get the neutral weak color for border.
  @example:
  <div class="mds-neutral--weak__border-color">border color in neutral weak appearance</div>
  */
}
.mds .mds-neutral--weak__border-color {
  border-color: var(--mds_brand_appearance_neutral_weak_border-color);
}
.mds .mds-neutral--strong__border-color {
  /* 
  @name: mds-neutral--strong__border-color
  @category: Colors
  @usage: 
  Use mds-neutral--strong__border-color class to get the neutral strong color for border.
  @example:
  <div class="mds-neutral--strong__border-color">border color in neutral strong appearance</div>
  */
}
.mds .mds-neutral--strong__border-color {
  border-color: var(--mds_brand_appearance_neutral_strong_border-color);
}
.mds .mds-neutral--strongest__border-color {
  /* 
  @name: mds-neutral--strongest__border-color
  @category: Colors
  @usage: 
  Use mds-neutral--strongest__border-color class to get the neutral strongest color for border.
  @example:
  <div class="mds-neutral--strongest__border-color">border color in neutral strongest appearance</div>
  */
}
.mds .mds-neutral--strongest__border-color {
  border-color: var(--mds_brand_appearance_neutral_strongest_border-color);
}
.mds .mds-neutral--inverse__border-color {
  /* 
  @name: mds-neutral--inverse__border-color
  @category: Colors
  @usage: 
  Use mds-neutral--inverse__border-color class to get the neutral inverse color for border.
  @example:
  <div class="mds-neutral--inverse__border-color">border color in neutral inverse appearance</div>
  */
}
.mds .mds-neutral--inverse__border-color {
  border-color: var(--mds_brand_appearance_neutral_inverse_border-color);
}
.mds .mds-neutral--subtle__border-color {
  /* 
  @name: mds-neutral--subtle__border-color
  @category: Colors
  @usage: 
  Use mds-neutral--subtle__border-color class to get the neutral subtle color for border.
  @example:
  <div class="mds-neutral--subtle__border-color">border color in neutral subtle appearance</div>
  */
}
.mds .mds-neutral--subtle__border-color {
  border-color: var(--mds_brand_appearance_neutral_subtle_border-color);
}
.mds .mds-neutral--alt__border-color {
  /* 
  @name: mds-neutral--alt__border-color
  @category: Colors
  @usage: 
  Use mds-neutral--alt__border-color class to get the neutral alt color for border.
  @example:
  <div class="mds-neutral--alt__border-color">border color in neutral alt appearance</div>
  */
}
.mds .mds-neutral--alt__border-color {
  border-color: var(--mds_brand_appearance_neutral_alt_border-color);
}
.mds a.mds-neutral__text-color,
.mds a.mds-neutral__text-color:active,
.mds a.mds-neutral__text-color:visited {
  color: var(--mds_brand_appearance_neutral_default_text-color);
}
.mds a.mds-neutral--weakest__text-color,
.mds a.mds-neutral--weakest__text-color:active,
.mds a.mds-neutral--weakest__text-color:visited {
  color: var(--mds_brand_appearance_neutral_weakest_text-color);
}
.mds a.mds-neutral--weak__text-color,
.mds a.mds-neutral--weak__text-color:active,
.mds a.mds-neutral--weak__text-color:visited {
  color: var(--mds_brand_appearance_neutral_weak_text-color);
}
.mds a.mds-neutral--strong__text-color,
.mds a.mds-neutral--strong__text-color:active,
.mds a.mds-neutral--strong__text-color:visited {
  color: var(--mds_brand_appearance_neutral_strong_text-color);
}
.mds a.mds-neutral--strongest__text-color,
.mds a.mds-neutral--strongest__text-color:active,
.mds a.mds-neutral--strongest__text-color:visited {
  color: var(--mds_brand_appearance_neutral_strongest_text-color);
}
.mds a.mds-neutral--inverse__text-color,
.mds a.mds-neutral--inverse__text-color:active,
.mds a.mds-neutral--inverse__text-color:visited {
  color: var(--mds_brand_appearance_neutral_inverse_text-color);
}
.mds a.mds-neutral--subtle__text-color,
.mds a.mds-neutral--subtle__text-color:active,
.mds a.mds-neutral--subtle__text-color:visited {
  color: var(--mds_brand_appearance_neutral_subtle_text-color);
}
.mds a.mds-neutral--alt__text-color,
.mds a.mds-neutral--alt__text-color:active,
.mds a.mds-neutral--alt__text-color:visited {
  color: var(--mds_brand_appearance_neutral_alt_text-color);
}
.mds .mds-primary__text-color {
  /* 
  @name: mds-primary__text-color
  @category: Colors
  @usage: 
  Use mds-primary__text-color class to get the primary color for text.
  @example:
  <div class="mds-primary__text-color">text color in primary appearance</div>
  */
}
.mds .mds-primary__text-color {
  color: var(--mds_brand_appearance_primary_default_text-color);
}
.mds .mds-primary--weak__text-color {
  /* 
  @name: mds-primary--weak__text-color
  @category: Colors
  @usage: 
  Use mds-primary--weak__text-color class to get the primary weak color for text.
  @example:
  <div class="mds-primary--weak__text-color">text color in primary weak appearance</div>
  */
}
.mds .mds-primary--weak__text-color {
  color: var(--mds_brand_appearance_primary_weak_text-color);
}
.mds .mds-primary--subtle__text-color {
  /* 
  @name: mds-primary--subtle__text-color
  @category: Colors
  @usage: 
  Use mds-primary--subtle__text-color class to get the primary subtle color for text.
  @example:
  <div class="mds-primary--subtle__text-color">text color in primary subtle appearance</div>
  */
}
.mds .mds-primary--subtle__text-color {
  color: var(--mds_brand_appearance_primary_subtle_text-color);
}
.mds .mds-primary__background-color {
  /* 
  @name: mds-primary__background-color
  @category: Colors
  @usage: 
  Use mds-primary__background-color class to get the primary color for background.
  @example:
  <div class="mds-primary__background-color">background color in primary appearance</div>
  */
}
.mds .mds-primary__background-color {
  background-color: var(--mds_brand_appearance_primary_default_background-color);
}
.mds .mds-primary--weak__background-color {
  /* 
  @name: mds-primary--weak__background-color
  @category: Colors
  @usage: 
  Use mds-primary--weak__background-color class to get the primary weak color for background.
  @example:
  <div class="mds-primary--weak__background-color">background color in primary weak appearance</div>
  */
}
.mds .mds-primary--weak__background-color {
  background-color: var(--mds_brand_appearance_primary_weak_background-color);
}
.mds .mds-primary--subtle__background-color {
  /* 
  @name: mds-primary--subtle__background-color
  @category: Colors
  @usage: 
  Use mds-primary--subtle__background-color class to get the primary subtle color for background.
  @example:
  <div class="mds-primary--subtle__background-color">background color in primary subtle appearance</div>
  */
}
.mds .mds-primary--subtle__background-color {
  background-color: var(--mds_brand_appearance_primary_subtle_background-color);
}
.mds .mds-primary__on-background-color {
  /* 
  @name: mds-primary__on-background-color
  @category: Colors
  @usage: 
  Use mds-primary__on-background-color class to get the primary color for on-background.
  @example:
  <div class="mds-primary__on-background-color">on-background color in primary appearance</div>
  */
}
.mds .mds-primary__on-background-color {
  color: var(--mds_brand_appearance_primary_default_on-background-color);
}
.mds .mds-primary--weak__on-background-color {
  /* 
  @name: mds-primary--weak__on-background-color
  @category: Colors
  @usage: 
  Use mds-primary--weak__on-background-color class to get the primary weak color for on-background.
  @example:
  <div class="mds-primary--weak__on-background-color">on-background color in primary weak appearance</div>
  */
}
.mds .mds-primary--weak__on-background-color {
  color: var(--mds_brand_appearance_primary_weak_on-background-color);
}
.mds .mds-primary--subtle__on-background-color {
  /* 
  @name: mds-primary--subtle__on-background-color
  @category: Colors
  @usage: 
  Use mds-primary--subtle__on-background-color class to get the primary subtle color for on-background.
  @example:
  <div class="mds-primary--subtle__on-background-color">on-background color in primary subtle appearance</div>
  */
}
.mds .mds-primary--subtle__on-background-color {
  color: var(--mds_brand_appearance_primary_subtle_on-background-color);
}
.mds .mds-primary__border-color {
  /* 
  @name: mds-primary__border-color
  @category: Colors
  @usage: 
  Use mds-primary__border-color class to get the primary color for border.
  @example:
  <div class="mds-primary__border-color">border color in primary appearance</div>
  */
}
.mds .mds-primary__border-color {
  border-color: var(--mds_brand_appearance_primary_default_border-color);
}
.mds .mds-primary--weak__border-color {
  /* 
  @name: mds-primary--weak__border-color
  @category: Colors
  @usage: 
  Use mds-primary--weak__border-color class to get the primary weak color for border.
  @example:
  <div class="mds-primary--weak__border-color">border color in primary weak appearance</div>
  */
}
.mds .mds-primary--weak__border-color {
  border-color: var(--mds_brand_appearance_primary_weak_border-color);
}
.mds .mds-primary--subtle__border-color {
  /* 
  @name: mds-primary--subtle__border-color
  @category: Colors
  @usage: 
  Use mds-primary--subtle__border-color class to get the primary subtle color for border.
  @example:
  <div class="mds-primary--subtle__border-color">border color in primary subtle appearance</div>
  */
}
.mds .mds-primary--subtle__border-color {
  border-color: var(--mds_brand_appearance_primary_subtle_border-color);
}
.mds a.mds-primary__text-color,
.mds a.mds-primary__text-color:active,
.mds a.mds-primary__text-color:visited {
  color: var(--mds_brand_appearance_primary_default_text-color);
}
.mds a.mds-primary--weak__text-color,
.mds a.mds-primary--weak__text-color:active,
.mds a.mds-primary--weak__text-color:visited {
  color: var(--mds_brand_appearance_primary_weak_text-color);
}
.mds a.mds-primary--subtle__text-color,
.mds a.mds-primary--subtle__text-color:active,
.mds a.mds-primary--subtle__text-color:visited {
  color: var(--mds_brand_appearance_primary_subtle_text-color);
}
.mds .mds-secondary__text-color {
  /* 
  @name: mds-secondary__text-color
  @category: Colors
  @usage: 
  Use mds-secondary__text-color class to get the secondary color for text.
  @example:
  <div class="mds-secondary__text-color">text color in secondary appearance</div>
  */
}
.mds .mds-secondary__text-color {
  color: var(--mds_brand_appearance_secondary_default_text-color);
}
.mds .mds-secondary--weak__text-color {
  /* 
  @name: mds-secondary--weak__text-color
  @category: Colors
  @usage: 
  Use mds-secondary--weak__text-color class to get the secondary weak color for text.
  @example:
  <div class="mds-secondary--weak__text-color">text color in secondary weak appearance</div>
  */
}
.mds .mds-secondary--weak__text-color {
  color: var(--mds_brand_appearance_secondary_weak_text-color);
}
.mds .mds-secondary--subtle__text-color {
  /* 
  @name: mds-secondary--subtle__text-color
  @category: Colors
  @usage: 
  Use mds-secondary--subtle__text-color class to get the secondary subtle color for text.
  @example:
  <div class="mds-secondary--subtle__text-color">text color in secondary subtle appearance</div>
  */
}
.mds .mds-secondary--subtle__text-color {
  color: var(--mds_brand_appearance_secondary_subtle_text-color);
}
.mds .mds-secondary__background-color {
  /* 
  @name: mds-secondary__background-color
  @category: Colors
  @usage: 
  Use mds-secondary__background-color class to get the secondary color for background.
  @example:
  <div class="mds-secondary__background-color">background color in secondary appearance</div>
  */
}
.mds .mds-secondary__background-color {
  background-color: var(--mds_brand_appearance_secondary_default_background-color);
}
.mds .mds-secondary--weak__background-color {
  /* 
  @name: mds-secondary--weak__background-color
  @category: Colors
  @usage: 
  Use mds-secondary--weak__background-color class to get the secondary weak color for background.
  @example:
  <div class="mds-secondary--weak__background-color">background color in secondary weak appearance</div>
  */
}
.mds .mds-secondary--weak__background-color {
  background-color: var(--mds_brand_appearance_secondary_weak_background-color);
}
.mds .mds-secondary--subtle__background-color {
  /* 
  @name: mds-secondary--subtle__background-color
  @category: Colors
  @usage: 
  Use mds-secondary--subtle__background-color class to get the secondary subtle color for background.
  @example:
  <div class="mds-secondary--subtle__background-color">background color in secondary subtle appearance</div>
  */
}
.mds .mds-secondary--subtle__background-color {
  background-color: var(--mds_brand_appearance_secondary_subtle_background-color);
}
.mds .mds-secondary__on-background-color {
  /* 
  @name: mds-secondary__on-background-color
  @category: Colors
  @usage: 
  Use mds-secondary__on-background-color class to get the secondary color for on-background.
  @example:
  <div class="mds-secondary__on-background-color">on-background color in secondary appearance</div>
  */
}
.mds .mds-secondary__on-background-color {
  color: var(--mds_brand_appearance_secondary_default_on-background-color);
}
.mds .mds-secondary--weak__on-background-color {
  /* 
  @name: mds-secondary--weak__on-background-color
  @category: Colors
  @usage: 
  Use mds-secondary--weak__on-background-color class to get the secondary weak color for on-background.
  @example:
  <div class="mds-secondary--weak__on-background-color">on-background color in secondary weak appearance</div>
  */
}
.mds .mds-secondary--weak__on-background-color {
  color: var(--mds_brand_appearance_secondary_weak_on-background-color);
}
.mds .mds-secondary--subtle__on-background-color {
  /* 
  @name: mds-secondary--subtle__on-background-color
  @category: Colors
  @usage: 
  Use mds-secondary--subtle__on-background-color class to get the secondary subtle color for on-background.
  @example:
  <div class="mds-secondary--subtle__on-background-color">on-background color in secondary subtle appearance</div>
  */
}
.mds .mds-secondary--subtle__on-background-color {
  color: var(--mds_brand_appearance_secondary_subtle_on-background-color);
}
.mds .mds-secondary__border-color {
  /* 
  @name: mds-secondary__border-color
  @category: Colors
  @usage: 
  Use mds-secondary__border-color class to get the secondary color for border.
  @example:
  <div class="mds-secondary__border-color">border color in secondary appearance</div>
  */
}
.mds .mds-secondary__border-color {
  border-color: var(--mds_brand_appearance_secondary_default_border-color);
}
.mds .mds-secondary--weak__border-color {
  /* 
  @name: mds-secondary--weak__border-color
  @category: Colors
  @usage: 
  Use mds-secondary--weak__border-color class to get the secondary weak color for border.
  @example:
  <div class="mds-secondary--weak__border-color">border color in secondary weak appearance</div>
  */
}
.mds .mds-secondary--weak__border-color {
  border-color: var(--mds_brand_appearance_secondary_weak_border-color);
}
.mds .mds-secondary--subtle__border-color {
  /* 
  @name: mds-secondary--subtle__border-color
  @category: Colors
  @usage: 
  Use mds-secondary--subtle__border-color class to get the secondary subtle color for border.
  @example:
  <div class="mds-secondary--subtle__border-color">border color in secondary subtle appearance</div>
  */
}
.mds .mds-secondary--subtle__border-color {
  border-color: var(--mds_brand_appearance_secondary_subtle_border-color);
}
.mds a.mds-secondary__text-color,
.mds a.mds-secondary__text-color:active,
.mds a.mds-secondary__text-color:visited {
  color: var(--mds_brand_appearance_secondary_default_text-color);
}
.mds a.mds-secondary--weak__text-color,
.mds a.mds-secondary--weak__text-color:active,
.mds a.mds-secondary--weak__text-color:visited {
  color: var(--mds_brand_appearance_secondary_weak_text-color);
}
.mds a.mds-secondary--subtle__text-color,
.mds a.mds-secondary--subtle__text-color:active,
.mds a.mds-secondary--subtle__text-color:visited {
  color: var(--mds_brand_appearance_secondary_subtle_text-color);
}
.mds .mds-info__text-color {
  /* 
  @name: mds-info__text-color
  @category: Colors
  @usage: 
  Use mds-info__text-color class to get the info color for text.
  @example:
  <div class="mds-info__text-color">text color in info appearance</div>
  */
}
.mds .mds-info__text-color {
  color: var(--mds_brand_appearance_info_default_text-color);
}
.mds .mds-info--weak__text-color {
  /* 
  @name: mds-info--weak__text-color
  @category: Colors
  @usage: 
  Use mds-info--weak__text-color class to get the info weak color for text.
  @example:
  <div class="mds-info--weak__text-color">text color in info weak appearance</div>
  */
}
.mds .mds-info--weak__text-color {
  color: var(--mds_brand_appearance_info_weak_text-color);
}
.mds .mds-info--subtle__text-color {
  /* 
  @name: mds-info--subtle__text-color
  @category: Colors
  @usage: 
  Use mds-info--subtle__text-color class to get the info subtle color for text.
  @example:
  <div class="mds-info--subtle__text-color">text color in info subtle appearance</div>
  */
}
.mds .mds-info--subtle__text-color {
  color: var(--mds_brand_appearance_info_subtle_text-color);
}
.mds .mds-info__background-color {
  /* 
  @name: mds-info__background-color
  @category: Colors
  @usage: 
  Use mds-info__background-color class to get the info color for background.
  @example:
  <div class="mds-info__background-color">background color in info appearance</div>
  */
}
.mds .mds-info__background-color {
  background-color: var(--mds_brand_appearance_info_default_background-color);
}
.mds .mds-info--weak__background-color {
  /* 
  @name: mds-info--weak__background-color
  @category: Colors
  @usage: 
  Use mds-info--weak__background-color class to get the info weak color for background.
  @example:
  <div class="mds-info--weak__background-color">background color in info weak appearance</div>
  */
}
.mds .mds-info--weak__background-color {
  background-color: var(--mds_brand_appearance_info_weak_background-color);
}
.mds .mds-info--subtle__background-color {
  /* 
  @name: mds-info--subtle__background-color
  @category: Colors
  @usage: 
  Use mds-info--subtle__background-color class to get the info subtle color for background.
  @example:
  <div class="mds-info--subtle__background-color">background color in info subtle appearance</div>
  */
}
.mds .mds-info--subtle__background-color {
  background-color: var(--mds_brand_appearance_info_subtle_background-color);
}
.mds .mds-info__on-background-color {
  /* 
  @name: mds-info__on-background-color
  @category: Colors
  @usage: 
  Use mds-info__on-background-color class to get the info color for on-background.
  @example:
  <div class="mds-info__on-background-color">on-background color in info appearance</div>
  */
}
.mds .mds-info__on-background-color {
  color: var(--mds_brand_appearance_info_default_on-background-color);
}
.mds .mds-info--weak__on-background-color {
  /* 
  @name: mds-info--weak__on-background-color
  @category: Colors
  @usage: 
  Use mds-info--weak__on-background-color class to get the info weak color for on-background.
  @example:
  <div class="mds-info--weak__on-background-color">on-background color in info weak appearance</div>
  */
}
.mds .mds-info--weak__on-background-color {
  color: var(--mds_brand_appearance_info_weak_on-background-color);
}
.mds .mds-info--subtle__on-background-color {
  /* 
  @name: mds-info--subtle__on-background-color
  @category: Colors
  @usage: 
  Use mds-info--subtle__on-background-color class to get the info subtle color for on-background.
  @example:
  <div class="mds-info--subtle__on-background-color">on-background color in info subtle appearance</div>
  */
}
.mds .mds-info--subtle__on-background-color {
  color: var(--mds_brand_appearance_info_subtle_on-background-color);
}
.mds .mds-info__border-color {
  /* 
  @name: mds-info__border-color
  @category: Colors
  @usage: 
  Use mds-info__border-color class to get the info color for border.
  @example:
  <div class="mds-info__border-color">border color in info appearance</div>
  */
}
.mds .mds-info__border-color {
  border-color: var(--mds_brand_appearance_info_default_border-color);
}
.mds .mds-info--weak__border-color {
  /* 
  @name: mds-info--weak__border-color
  @category: Colors
  @usage: 
  Use mds-info--weak__border-color class to get the info weak color for border.
  @example:
  <div class="mds-info--weak__border-color">border color in info weak appearance</div>
  */
}
.mds .mds-info--weak__border-color {
  border-color: var(--mds_brand_appearance_info_weak_border-color);
}
.mds .mds-info--subtle__border-color {
  /* 
  @name: mds-info--subtle__border-color
  @category: Colors
  @usage: 
  Use mds-info--subtle__border-color class to get the info subtle color for border.
  @example:
  <div class="mds-info--subtle__border-color">border color in info subtle appearance</div>
  */
}
.mds .mds-info--subtle__border-color {
  border-color: var(--mds_brand_appearance_info_subtle_border-color);
}
.mds a.mds-info__text-color,
.mds a.mds-info__text-color:active,
.mds a.mds-info__text-color:visited {
  color: var(--mds_brand_appearance_info_default_text-color);
}
.mds a.mds-info--weak__text-color,
.mds a.mds-info--weak__text-color:active,
.mds a.mds-info--weak__text-color:visited {
  color: var(--mds_brand_appearance_info_weak_text-color);
}
.mds a.mds-info--subtle__text-color,
.mds a.mds-info--subtle__text-color:active,
.mds a.mds-info--subtle__text-color:visited {
  color: var(--mds_brand_appearance_info_subtle_text-color);
}
.mds .mds-error__text-color {
  /* 
  @name: mds-error__text-color
  @category: Colors
  @usage: 
  Use mds-error__text-color class to get the error color for text.
  @example:
  <div class="mds-error__text-color">text color in error appearance</div>
  */
}
.mds .mds-error__text-color {
  color: var(--mds_brand_appearance_error_default_text-color);
}
.mds .mds-error--weak__text-color {
  /* 
  @name: mds-error--weak__text-color
  @category: Colors
  @usage: 
  Use mds-error--weak__text-color class to get the error weak color for text.
  @example:
  <div class="mds-error--weak__text-color">text color in error weak appearance</div>
  */
}
.mds .mds-error--weak__text-color {
  color: var(--mds_brand_appearance_error_weak_text-color);
}
.mds .mds-error--subtle__text-color {
  /* 
  @name: mds-error--subtle__text-color
  @category: Colors
  @usage: 
  Use mds-error--subtle__text-color class to get the error subtle color for text.
  @example:
  <div class="mds-error--subtle__text-color">text color in error subtle appearance</div>
  */
}
.mds .mds-error--subtle__text-color {
  color: var(--mds_brand_appearance_error_subtle_text-color);
}
.mds .mds-error__background-color {
  /* 
  @name: mds-error__background-color
  @category: Colors
  @usage: 
  Use mds-error__background-color class to get the error color for background.
  @example:
  <div class="mds-error__background-color">background color in error appearance</div>
  */
}
.mds .mds-error__background-color {
  background-color: var(--mds_brand_appearance_error_default_background-color);
}
.mds .mds-error--weak__background-color {
  /* 
  @name: mds-error--weak__background-color
  @category: Colors
  @usage: 
  Use mds-error--weak__background-color class to get the error weak color for background.
  @example:
  <div class="mds-error--weak__background-color">background color in error weak appearance</div>
  */
}
.mds .mds-error--weak__background-color {
  background-color: var(--mds_brand_appearance_error_weak_background-color);
}
.mds .mds-error--subtle__background-color {
  /* 
  @name: mds-error--subtle__background-color
  @category: Colors
  @usage: 
  Use mds-error--subtle__background-color class to get the error subtle color for background.
  @example:
  <div class="mds-error--subtle__background-color">background color in error subtle appearance</div>
  */
}
.mds .mds-error--subtle__background-color {
  background-color: var(--mds_brand_appearance_error_subtle_background-color);
}
.mds .mds-error__on-background-color {
  /* 
  @name: mds-error__on-background-color
  @category: Colors
  @usage: 
  Use mds-error__on-background-color class to get the error color for on-background.
  @example:
  <div class="mds-error__on-background-color">on-background color in error appearance</div>
  */
}
.mds .mds-error__on-background-color {
  color: var(--mds_brand_appearance_error_default_on-background-color);
}
.mds .mds-error--weak__on-background-color {
  /* 
  @name: mds-error--weak__on-background-color
  @category: Colors
  @usage: 
  Use mds-error--weak__on-background-color class to get the error weak color for on-background.
  @example:
  <div class="mds-error--weak__on-background-color">on-background color in error weak appearance</div>
  */
}
.mds .mds-error--weak__on-background-color {
  color: var(--mds_brand_appearance_error_weak_on-background-color);
}
.mds .mds-error--subtle__on-background-color {
  /* 
  @name: mds-error--subtle__on-background-color
  @category: Colors
  @usage: 
  Use mds-error--subtle__on-background-color class to get the error subtle color for on-background.
  @example:
  <div class="mds-error--subtle__on-background-color">on-background color in error subtle appearance</div>
  */
}
.mds .mds-error--subtle__on-background-color {
  color: var(--mds_brand_appearance_error_subtle_on-background-color);
}
.mds .mds-error__border-color {
  /* 
  @name: mds-error__border-color
  @category: Colors
  @usage: 
  Use mds-error__border-color class to get the error color for border.
  @example:
  <div class="mds-error__border-color">border color in error appearance</div>
  */
}
.mds .mds-error__border-color {
  border-color: var(--mds_brand_appearance_error_default_border-color);
}
.mds .mds-error--weak__border-color {
  /* 
  @name: mds-error--weak__border-color
  @category: Colors
  @usage: 
  Use mds-error--weak__border-color class to get the error weak color for border.
  @example:
  <div class="mds-error--weak__border-color">border color in error weak appearance</div>
  */
}
.mds .mds-error--weak__border-color {
  border-color: var(--mds_brand_appearance_error_weak_border-color);
}
.mds .mds-error--subtle__border-color {
  /* 
  @name: mds-error--subtle__border-color
  @category: Colors
  @usage: 
  Use mds-error--subtle__border-color class to get the error subtle color for border.
  @example:
  <div class="mds-error--subtle__border-color">border color in error subtle appearance</div>
  */
}
.mds .mds-error--subtle__border-color {
  border-color: var(--mds_brand_appearance_error_subtle_border-color);
}
.mds a.mds-error__text-color,
.mds a.mds-error__text-color:active,
.mds a.mds-error__text-color:visited {
  color: var(--mds_brand_appearance_error_default_text-color);
}
.mds a.mds-error--weak__text-color,
.mds a.mds-error--weak__text-color:active,
.mds a.mds-error--weak__text-color:visited {
  color: var(--mds_brand_appearance_error_weak_text-color);
}
.mds a.mds-error--subtle__text-color,
.mds a.mds-error--subtle__text-color:active,
.mds a.mds-error--subtle__text-color:visited {
  color: var(--mds_brand_appearance_error_subtle_text-color);
}
.mds .mds-warning__text-color {
  /* 
  @name: mds-warning__text-color
  @category: Colors
  @usage: 
  Use mds-warning__text-color class to get the warning color for text.
  @example:
  <div class="mds-warning__text-color">text color in warning appearance</div>
  */
}
.mds .mds-warning__text-color {
  color: var(--mds_brand_appearance_warning_default_text-color);
}
.mds .mds-warning--weak__text-color {
  /* 
  @name: mds-warning--weak__text-color
  @category: Colors
  @usage: 
  Use mds-warning--weak__text-color class to get the warning weak color for text.
  @example:
  <div class="mds-warning--weak__text-color">text color in warning weak appearance</div>
  */
}
.mds .mds-warning--weak__text-color {
  color: var(--mds_brand_appearance_warning_weak_text-color);
}
.mds .mds-warning--subtle__text-color {
  /* 
  @name: mds-warning--subtle__text-color
  @category: Colors
  @usage: 
  Use mds-warning--subtle__text-color class to get the warning subtle color for text.
  @example:
  <div class="mds-warning--subtle__text-color">text color in warning subtle appearance</div>
  */
}
.mds .mds-warning--subtle__text-color {
  color: var(--mds_brand_appearance_warning_subtle_text-color);
}
.mds .mds-warning__background-color {
  /* 
  @name: mds-warning__background-color
  @category: Colors
  @usage: 
  Use mds-warning__background-color class to get the warning color for background.
  @example:
  <div class="mds-warning__background-color">background color in warning appearance</div>
  */
}
.mds .mds-warning__background-color {
  background-color: var(--mds_brand_appearance_warning_default_background-color);
}
.mds .mds-warning--weak__background-color {
  /* 
  @name: mds-warning--weak__background-color
  @category: Colors
  @usage: 
  Use mds-warning--weak__background-color class to get the warning weak color for background.
  @example:
  <div class="mds-warning--weak__background-color">background color in warning weak appearance</div>
  */
}
.mds .mds-warning--weak__background-color {
  background-color: var(--mds_brand_appearance_warning_weak_background-color);
}
.mds .mds-warning--subtle__background-color {
  /* 
  @name: mds-warning--subtle__background-color
  @category: Colors
  @usage: 
  Use mds-warning--subtle__background-color class to get the warning subtle color for background.
  @example:
  <div class="mds-warning--subtle__background-color">background color in warning subtle appearance</div>
  */
}
.mds .mds-warning--subtle__background-color {
  background-color: var(--mds_brand_appearance_warning_subtle_background-color);
}
.mds .mds-warning__on-background-color {
  /* 
  @name: mds-warning__on-background-color
  @category: Colors
  @usage: 
  Use mds-warning__on-background-color class to get the warning color for on-background.
  @example:
  <div class="mds-warning__on-background-color">on-background color in warning appearance</div>
  */
}
.mds .mds-warning__on-background-color {
  color: var(--mds_brand_appearance_warning_default_on-background-color);
}
.mds .mds-warning--weak__on-background-color {
  /* 
  @name: mds-warning--weak__on-background-color
  @category: Colors
  @usage: 
  Use mds-warning--weak__on-background-color class to get the warning weak color for on-background.
  @example:
  <div class="mds-warning--weak__on-background-color">on-background color in warning weak appearance</div>
  */
}
.mds .mds-warning--weak__on-background-color {
  color: var(--mds_brand_appearance_warning_weak_on-background-color);
}
.mds .mds-warning--subtle__on-background-color {
  /* 
  @name: mds-warning--subtle__on-background-color
  @category: Colors
  @usage: 
  Use mds-warning--subtle__on-background-color class to get the warning subtle color for on-background.
  @example:
  <div class="mds-warning--subtle__on-background-color">on-background color in warning subtle appearance</div>
  */
}
.mds .mds-warning--subtle__on-background-color {
  color: var(--mds_brand_appearance_warning_subtle_on-background-color);
}
.mds .mds-warning__border-color {
  /* 
  @name: mds-warning__border-color
  @category: Colors
  @usage: 
  Use mds-warning__border-color class to get the warning color for border.
  @example:
  <div class="mds-warning__border-color">border color in warning appearance</div>
  */
}
.mds .mds-warning__border-color {
  border-color: var(--mds_brand_appearance_warning_default_border-color);
}
.mds .mds-warning--weak__border-color {
  /* 
  @name: mds-warning--weak__border-color
  @category: Colors
  @usage: 
  Use mds-warning--weak__border-color class to get the warning weak color for border.
  @example:
  <div class="mds-warning--weak__border-color">border color in warning weak appearance</div>
  */
}
.mds .mds-warning--weak__border-color {
  border-color: var(--mds_brand_appearance_warning_weak_border-color);
}
.mds .mds-warning--subtle__border-color {
  /* 
  @name: mds-warning--subtle__border-color
  @category: Colors
  @usage: 
  Use mds-warning--subtle__border-color class to get the warning subtle color for border.
  @example:
  <div class="mds-warning--subtle__border-color">border color in warning subtle appearance</div>
  */
}
.mds .mds-warning--subtle__border-color {
  border-color: var(--mds_brand_appearance_warning_subtle_border-color);
}
.mds a.mds-warning__text-color,
.mds a.mds-warning__text-color:active,
.mds a.mds-warning__text-color:visited {
  color: var(--mds_brand_appearance_warning_default_text-color);
}
.mds a.mds-warning--weak__text-color,
.mds a.mds-warning--weak__text-color:active,
.mds a.mds-warning--weak__text-color:visited {
  color: var(--mds_brand_appearance_warning_weak_text-color);
}
.mds a.mds-warning--subtle__text-color,
.mds a.mds-warning--subtle__text-color:active,
.mds a.mds-warning--subtle__text-color:visited {
  color: var(--mds_brand_appearance_warning_subtle_text-color);
}
.mds .mds-success__text-color {
  /* 
  @name: mds-success__text-color
  @category: Colors
  @usage: 
  Use mds-success__text-color class to get the success color for text.
  @example:
  <div class="mds-success__text-color">text color in success appearance</div>
  */
}
.mds .mds-success__text-color {
  color: var(--mds_brand_appearance_success_default_text-color);
}
.mds .mds-success--weak__text-color {
  /* 
  @name: mds-success--weak__text-color
  @category: Colors
  @usage: 
  Use mds-success--weak__text-color class to get the success weak color for text.
  @example:
  <div class="mds-success--weak__text-color">text color in success weak appearance</div>
  */
}
.mds .mds-success--weak__text-color {
  color: var(--mds_brand_appearance_success_weak_text-color);
}
.mds .mds-success--subtle__text-color {
  /* 
  @name: mds-success--subtle__text-color
  @category: Colors
  @usage: 
  Use mds-success--subtle__text-color class to get the success subtle color for text.
  @example:
  <div class="mds-success--subtle__text-color">text color in success subtle appearance</div>
  */
}
.mds .mds-success--subtle__text-color {
  color: var(--mds_brand_appearance_success_subtle_text-color);
}
.mds .mds-success__background-color {
  /* 
  @name: mds-success__background-color
  @category: Colors
  @usage: 
  Use mds-success__background-color class to get the success color for background.
  @example:
  <div class="mds-success__background-color">background color in success appearance</div>
  */
}
.mds .mds-success__background-color {
  background-color: var(--mds_brand_appearance_success_default_background-color);
}
.mds .mds-success--weak__background-color {
  /* 
  @name: mds-success--weak__background-color
  @category: Colors
  @usage: 
  Use mds-success--weak__background-color class to get the success weak color for background.
  @example:
  <div class="mds-success--weak__background-color">background color in success weak appearance</div>
  */
}
.mds .mds-success--weak__background-color {
  background-color: var(--mds_brand_appearance_success_weak_background-color);
}
.mds .mds-success--subtle__background-color {
  /* 
  @name: mds-success--subtle__background-color
  @category: Colors
  @usage: 
  Use mds-success--subtle__background-color class to get the success subtle color for background.
  @example:
  <div class="mds-success--subtle__background-color">background color in success subtle appearance</div>
  */
}
.mds .mds-success--subtle__background-color {
  background-color: var(--mds_brand_appearance_success_subtle_background-color);
}
.mds .mds-success__on-background-color {
  /* 
  @name: mds-success__on-background-color
  @category: Colors
  @usage: 
  Use mds-success__on-background-color class to get the success color for on-background.
  @example:
  <div class="mds-success__on-background-color">on-background color in success appearance</div>
  */
}
.mds .mds-success__on-background-color {
  color: var(--mds_brand_appearance_success_default_on-background-color);
}
.mds .mds-success--weak__on-background-color {
  /* 
  @name: mds-success--weak__on-background-color
  @category: Colors
  @usage: 
  Use mds-success--weak__on-background-color class to get the success weak color for on-background.
  @example:
  <div class="mds-success--weak__on-background-color">on-background color in success weak appearance</div>
  */
}
.mds .mds-success--weak__on-background-color {
  color: var(--mds_brand_appearance_success_weak_on-background-color);
}
.mds .mds-success--subtle__on-background-color {
  /* 
  @name: mds-success--subtle__on-background-color
  @category: Colors
  @usage: 
  Use mds-success--subtle__on-background-color class to get the success subtle color for on-background.
  @example:
  <div class="mds-success--subtle__on-background-color">on-background color in success subtle appearance</div>
  */
}
.mds .mds-success--subtle__on-background-color {
  color: var(--mds_brand_appearance_success_subtle_on-background-color);
}
.mds .mds-success__border-color {
  /* 
  @name: mds-success__border-color
  @category: Colors
  @usage: 
  Use mds-success__border-color class to get the success color for border.
  @example:
  <div class="mds-success__border-color">border color in success appearance</div>
  */
}
.mds .mds-success__border-color {
  border-color: var(--mds_brand_appearance_success_default_border-color);
}
.mds .mds-success--weak__border-color {
  /* 
  @name: mds-success--weak__border-color
  @category: Colors
  @usage: 
  Use mds-success--weak__border-color class to get the success weak color for border.
  @example:
  <div class="mds-success--weak__border-color">border color in success weak appearance</div>
  */
}
.mds .mds-success--weak__border-color {
  border-color: var(--mds_brand_appearance_success_weak_border-color);
}
.mds .mds-success--subtle__border-color {
  /* 
  @name: mds-success--subtle__border-color
  @category: Colors
  @usage: 
  Use mds-success--subtle__border-color class to get the success subtle color for border.
  @example:
  <div class="mds-success--subtle__border-color">border color in success subtle appearance</div>
  */
}
.mds .mds-success--subtle__border-color {
  border-color: var(--mds_brand_appearance_success_subtle_border-color);
}
.mds a.mds-success__text-color,
.mds a.mds-success__text-color:active,
.mds a.mds-success__text-color:visited {
  color: var(--mds_brand_appearance_success_default_text-color);
}
.mds a.mds-success--weak__text-color,
.mds a.mds-success--weak__text-color:active,
.mds a.mds-success--weak__text-color:visited {
  color: var(--mds_brand_appearance_success_weak_text-color);
}
.mds a.mds-success--subtle__text-color,
.mds a.mds-success--subtle__text-color:active,
.mds a.mds-success--subtle__text-color:visited {
  color: var(--mds_brand_appearance_success_subtle_text-color);
}
.mds .mds-layout {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: grid;
  transition: none;
}
.mds .mds-layout mc-top-bar {
  grid-area: top-bar;
  height: 64px;
  width: 100%;
  background-color: var(--mds_brand_appearance_neutral_default_background-color);
  border-bottom: 1px solid var(--mds_brand_appearance_neutral_weak_border-color);
}
@media only screen and (max-width: 1024px) {
  .mds .mds-layout mc-top-bar {
    padding: 0 16px 0 52px;
  }
}
@media only screen and (min-width: 1025px) {
  .mds .mds-layout mc-top-bar {
    padding: 0 24px 0 60px;
  }
}
.mds .mds-layout mc-side-bar {
  grid-area: side-bar;
}
.mds .mds-layout mc-side-bar:not([open]) .mds-tree-nav {
  opacity: 0;
}
@media only screen and (max-width: 1024px) {
  .mds .mds-layout mc-side-bar {
    height: 64px;
    left: 0;
    position: fixed;
    top: 0;
    width: 52px;
  }
}
@media only screen and (min-width: 1025px) {
  .mds .mds-layout mc-side-bar {
    width: 100%;
    position: relative;
  }
}
@media only screen and (min-width: 1025px) {
  .mds .mds-layout:has(mc-side-bar:not([open])) {
    grid-template-columns: 0 1fr;
  }
}
.mds .mds-layout .mds-page {
  grid-area: page;
  overflow-y: auto;
  height: auto;
}
.mds .mds-layout .mds-page > .mds-grid {
  padding-left: 24px;
  padding-right: 24px;
}
@media only screen and (max-width: 1024px) {
  .mds .mds-layout .mds-page > .mds-grid {
    margin: 24px 0;
  }
}
@media only screen and (min-width: 1025px) {
  .mds .mds-layout .mds-page > .mds-grid {
    margin: 24px auto;
    max-width: 1080px;
  }
}
.mds .mds-layout .mds-page .mds-grid.mds-full-width {
  max-width: none;
}
@media only screen and (min-width: 1025px) {
  .mds .mds-layout .mds-page .mds-grid.mds-full-width {
    margin: 24px 0;
    max-width: none;
  }
}
.mds .mds-layout .mds-footer {
  grid-area: footer;
}
.mds .mds-layout.mds-layout-no-side-bar {
  grid-template-columns: 0 1fr;
}
@media only screen and (max-width: 640px) {
  .mds .mds-layout.mds-layout-no-side-bar mc-top-bar {
    padding-left: 16px;
  }
}
@media only screen and (min-width: 641px) {
  .mds .mds-layout.mds-layout-no-side-bar mc-top-bar {
    padding-left: 24px;
  }
}
@media only screen and (max-width: 640px) {
  .mds .mds-layout {
    grid-template-areas: "top-bar top-bar" "page page" "footer footer";
    grid-template-rows: 64px 1fr auto;
    grid-template-columns: 1fr;
    height: auto;
  }
}
@media only screen and (min-width: 641px) {
  .mds .mds-layout {
    grid-template-areas: "top-bar top-bar" "page page" "footer footer";
    grid-template-rows: 64px 1fr auto;
    grid-template-columns: 1fr;
  }
}
@media only screen and (min-width: 1025px) {
  .mds .mds-layout {
    grid-template-areas: "top-bar top-bar" "side-bar page" "side-bar footer";
    grid-template-rows: 64px 1fr auto;
    grid-template-columns: 300px 1fr;
  }
  .mds .mds-layout:has(mc-side-bar:hover), .mds .mds-layout:has(mc-side-bar:focus-within) {
    will-change: grid-template-columns;
    transition: grid-template-columns 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
.mds .mds-page-centered {
  padding-left: 24px;
  padding-right: 24px;
}
@media only screen and (max-width: 1024px) {
  .mds .mds-page-centered {
    margin: 24px 0;
  }
}
@media only screen and (min-width: 1025px) {
  .mds .mds-page-centered {
    margin: 24px auto;
    max-width: 1080px;
  }
}
.mds .mds-page-full-width {
  max-width: none;
}
@media only screen and (min-width: 1025px) {
  .mds .mds-page-full-width {
    margin: 24px 0;
    max-width: none;
  }
}
.mds .mds-skip-to {
  opacity: 0;
  position: absolute;
  left: -9999px;
  z-index: 999;
  padding: 1em;
  line-height: 86px;
  height: 86px;
  background-color: #f7f7f7;
  color: #0073ab;
  justify-content: center;
  outline: none;
}
.mds .mds-skip-to:focus {
  left: 50%;
  transform: translateX(-50%);
  opacity: 1;
  box-shadow: none;
}
.mds .mds-container .mds-grid {
  display: grid;
}
.mds .mds-container .mds-grid .mds-grid-row-1 {
  grid-row-start: 1;
}
.mds .mds-container .mds-grid .mds-grid-row-2 {
  grid-row-start: 2;
}
.mds .mds-container .mds-grid .mds-grid-row-3 {
  grid-row-start: 3;
}
.mds .mds-container .mds-grid .mds-grid-row-4 {
  grid-row-start: 4;
}
.mds .mds-container .mds-grid .mds-grid-row-5 {
  grid-row-start: 5;
}
.mds .mds-container .mds-grid .mds-grid-row-6 {
  grid-row-start: 6;
}
.mds .mds-container .mds-grid .mds-grid-row-7 {
  grid-row-start: 7;
}
.mds .mds-container .mds-grid .mds-grid-row-8 {
  grid-row-start: 8;
}
.mds .mds-container .mds-grid .mds-grid-row-9 {
  grid-row-start: 9;
}
.mds .mds-container .mds-grid .mds-grid-row-10 {
  grid-row-start: 10;
}
.mds .mds-container .mds-grid .mds-grid-row-11 {
  grid-row-start: 11;
}
.mds .mds-container .mds-grid .mds-grid-row-12 {
  grid-row-start: 12;
}
.mds .mds-container .mds-grid .mds-grid-row-13 {
  grid-row-start: 13;
}
.mds .mds-container .mds-grid .mds-grid-row-14 {
  grid-row-start: 14;
}
.mds .mds-container .mds-grid .mds-grid-row-15 {
  grid-row-start: 15;
}
.mds .mds-container .mds-grid .mds-grid-row-16 {
  grid-row-start: 16;
}
.mds .mds-container .mds-grid .mds-grid-row-17 {
  grid-row-start: 17;
}
.mds .mds-container .mds-grid .mds-grid-row-18 {
  grid-row-start: 18;
}
.mds .mds-container .mds-grid .mds-grid-row-19 {
  grid-row-start: 19;
}
.mds .mds-container .mds-grid .mds-grid-row-20 {
  grid-row-start: 20;
}
.mds .mds-container .mds-grid .mds-grid-row-21 {
  grid-row-start: 21;
}
.mds .mds-container .mds-grid .mds-grid-row-22 {
  grid-row-start: 22;
}
.mds .mds-container .mds-grid .mds-grid-row-23 {
  grid-row-start: 23;
}
.mds .mds-container .mds-grid .mds-grid-row-24 {
  grid-row-start: 24;
}
.mds .mds-container .mds-grid .mds-grid-row-span-to-end {
  grid-row-end: -1;
}
.mds .mds-container .mds-grid .mds-grid-row-span-to-start {
  grid-row-end: 1;
}
.mds .mds-container .mds-grid .mds-grid-row-span-1 {
  grid-row-end: span 1;
}
.mds .mds-container .mds-grid .mds-grid-row-span-2 {
  grid-row-end: span 2;
}
.mds .mds-container .mds-grid .mds-grid-row-span-3 {
  grid-row-end: span 3;
}
.mds .mds-container .mds-grid .mds-grid-row-span-4 {
  grid-row-end: span 4;
}
.mds .mds-container .mds-grid .mds-grid-row-span-5 {
  grid-row-end: span 5;
}
.mds .mds-container .mds-grid .mds-grid-row-span-6 {
  grid-row-end: span 6;
}
.mds .mds-container .mds-grid .mds-grid-row-span-7 {
  grid-row-end: span 7;
}
.mds .mds-container .mds-grid .mds-grid-row-span-8 {
  grid-row-end: span 8;
}
.mds .mds-container .mds-grid .mds-grid-row-span-9 {
  grid-row-end: span 9;
}
.mds .mds-container .mds-grid .mds-grid-row-span-10 {
  grid-row-end: span 10;
}
.mds .mds-container .mds-grid .mds-grid-row-span-11 {
  grid-row-end: span 11;
}
.mds .mds-container .mds-grid .mds-grid-row-span-12 {
  grid-row-end: span 12;
}
.mds .mds-container .mds-grid .mds-grid-row-span-13 {
  grid-row-end: span 13;
}
.mds .mds-container .mds-grid .mds-grid-row-span-14 {
  grid-row-end: span 14;
}
.mds .mds-container .mds-grid .mds-grid-row-span-15 {
  grid-row-end: span 15;
}
.mds .mds-container .mds-grid .mds-grid-row-span-16 {
  grid-row-end: span 16;
}
.mds .mds-container .mds-grid .mds-grid-row-span-17 {
  grid-row-end: span 17;
}
.mds .mds-container .mds-grid .mds-grid-row-span-18 {
  grid-row-end: span 18;
}
.mds .mds-container .mds-grid .mds-grid-row-span-19 {
  grid-row-end: span 19;
}
.mds .mds-container .mds-grid .mds-grid-row-span-20 {
  grid-row-end: span 20;
}
.mds .mds-container .mds-grid .mds-grid-row-span-21 {
  grid-row-end: span 21;
}
.mds .mds-container .mds-grid .mds-grid-row-span-22 {
  grid-row-end: span 22;
}
.mds .mds-container .mds-grid .mds-grid-row-span-23 {
  grid-row-end: span 23;
}
.mds .mds-container .mds-grid .mds-grid-row-span-24 {
  grid-row-end: span 24;
}
.mds .mds-container .mds-grid .mds-grid-col-1 {
  /* 
  @name: mds-grid-col-1
  @category: Grid
  @usage: 
  Use mds-grid-col-1 class to position the cell in the 1 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 1 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 1;
}
.mds .mds-container .mds-grid .mds-grid-col-2 {
  /* 
  @name: mds-grid-col-2
  @category: Grid
  @usage: 
  Use mds-grid-col-2 class to position the cell in the 2 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 2 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 2;
}
.mds .mds-container .mds-grid .mds-grid-col-3 {
  /* 
  @name: mds-grid-col-3
  @category: Grid
  @usage: 
  Use mds-grid-col-3 class to position the cell in the 3 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 3 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 3;
}
.mds .mds-container .mds-grid .mds-grid-col-4 {
  /* 
  @name: mds-grid-col-4
  @category: Grid
  @usage: 
  Use mds-grid-col-4 class to position the cell in the 4 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 4 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 4;
}
.mds .mds-container .mds-grid .mds-grid-col-5 {
  /* 
  @name: mds-grid-col-5
  @category: Grid
  @usage: 
  Use mds-grid-col-5 class to position the cell in the 5 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 5 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 5;
}
.mds .mds-container .mds-grid .mds-grid-col-6 {
  /* 
  @name: mds-grid-col-6
  @category: Grid
  @usage: 
  Use mds-grid-col-6 class to position the cell in the 6 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 6 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 6;
}
.mds .mds-container .mds-grid .mds-grid-col-7 {
  /* 
  @name: mds-grid-col-7
  @category: Grid
  @usage: 
  Use mds-grid-col-7 class to position the cell in the 7 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 7 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 7;
}
.mds .mds-container .mds-grid .mds-grid-col-8 {
  /* 
  @name: mds-grid-col-8
  @category: Grid
  @usage: 
  Use mds-grid-col-8 class to position the cell in the 8 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 8 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 8;
}
.mds .mds-container .mds-grid .mds-grid-col-9 {
  /* 
  @name: mds-grid-col-9
  @category: Grid
  @usage: 
  Use mds-grid-col-9 class to position the cell in the 9 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 9 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 9;
}
.mds .mds-container .mds-grid .mds-grid-col-10 {
  /* 
  @name: mds-grid-col-10
  @category: Grid
  @usage: 
  Use mds-grid-col-10 class to position the cell in the 10 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 10 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 10;
}
.mds .mds-container .mds-grid .mds-grid-col-11 {
  /* 
  @name: mds-grid-col-11
  @category: Grid
  @usage: 
  Use mds-grid-col-11 class to position the cell in the 11 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 11 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 11;
}
.mds .mds-container .mds-grid .mds-grid-col-12 {
  /* 
  @name: mds-grid-col-12
  @category: Grid
  @usage: 
  Use mds-grid-col-12 class to position the cell in the 12 column of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 12 in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1">Cell in column 1 in all breakpoints</div>
      <div class="mds-grid-col-2">Cell in column 2 in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: 12;
}
.mds .mds-container .mds-grid .mds-grid-col-1-reverse {
  /* 
  @name: mds-grid-col-1-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 1 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -2;
}
.mds .mds-container .mds-grid .mds-grid-col-2-reverse {
  /* 
  @name: mds-grid-col-2-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 2 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -3;
}
.mds .mds-container .mds-grid .mds-grid-col-3-reverse {
  /* 
  @name: mds-grid-col-3-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 3 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -4;
}
.mds .mds-container .mds-grid .mds-grid-col-4-reverse {
  /* 
  @name: mds-grid-col-4-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 4 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -5;
}
.mds .mds-container .mds-grid .mds-grid-col-5-reverse {
  /* 
  @name: mds-grid-col-5-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 5 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -6;
}
.mds .mds-container .mds-grid .mds-grid-col-6-reverse {
  /* 
  @name: mds-grid-col-6-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 6 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -7;
}
.mds .mds-container .mds-grid .mds-grid-col-7-reverse {
  /* 
  @name: mds-grid-col-7-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 7 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -8;
}
.mds .mds-container .mds-grid .mds-grid-col-8-reverse {
  /* 
  @name: mds-grid-col-8-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 8 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -9;
}
.mds .mds-container .mds-grid .mds-grid-col-9-reverse {
  /* 
  @name: mds-grid-col-9-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 9 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -10;
}
.mds .mds-container .mds-grid .mds-grid-col-10-reverse {
  /* 
  @name: mds-grid-col-10-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 10 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -11;
}
.mds .mds-container .mds-grid .mds-grid-col-11-reverse {
  /* 
  @name: mds-grid-col-11-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 11 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -12;
}
.mds .mds-container .mds-grid .mds-grid-col-12-reverse {
  /* 
  @name: mds-grid-col-12-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 12 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -13;
}
.mds .mds-container .mds-grid .mds-grid-col-13-reverse {
  /* 
  @name: mds-grid-col-13-reverse
  @category: Grid
  @usage: 
  Use mds-grid-col-13-reverse class to position the cell in the reverse order in the 13 column (from the end) of the grid.
  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 13 from the end in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
      <div class="mds-grid-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-start: -14;
}
.mds .mds-container .mds-grid .mds-grid-col-span-to-end {
  grid-column-end: -1;
}
.mds .mds-container .mds-grid .mds-grid-col-span-to-start {
  grid-column-end: 1;
}
.mds .mds-container .mds-grid .mds-grid-col-span-1 {
  /* 
  @name: mds-grid-col-span-1
  @category: Grid
  @usage: 
  Use mds-grid-col-span-1 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 1;
}
.mds .mds-container .mds-grid .mds-grid-col-span-2 {
  /* 
  @name: mds-grid-col-span-2
  @category: Grid
  @usage: 
  Use mds-grid-col-span-2 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 2;
}
.mds .mds-container .mds-grid .mds-grid-col-span-3 {
  /* 
  @name: mds-grid-col-span-3
  @category: Grid
  @usage: 
  Use mds-grid-col-span-3 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 3;
}
.mds .mds-container .mds-grid .mds-grid-col-span-4 {
  /* 
  @name: mds-grid-col-span-4
  @category: Grid
  @usage: 
  Use mds-grid-col-span-4 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 4;
}
.mds .mds-container .mds-grid .mds-grid-col-span-5 {
  /* 
  @name: mds-grid-col-span-5
  @category: Grid
  @usage: 
  Use mds-grid-col-span-5 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 5;
}
.mds .mds-container .mds-grid .mds-grid-col-span-6 {
  /* 
  @name: mds-grid-col-span-6
  @category: Grid
  @usage: 
  Use mds-grid-col-span-6 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 6;
}
.mds .mds-container .mds-grid .mds-grid-col-span-7 {
  /* 
  @name: mds-grid-col-span-7
  @category: Grid
  @usage: 
  Use mds-grid-col-span-7 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 7;
}
.mds .mds-container .mds-grid .mds-grid-col-span-8 {
  /* 
  @name: mds-grid-col-span-8
  @category: Grid
  @usage: 
  Use mds-grid-col-span-8 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 8;
}
.mds .mds-container .mds-grid .mds-grid-col-span-9 {
  /* 
  @name: mds-grid-col-span-9
  @category: Grid
  @usage: 
  Use mds-grid-col-span-9 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 9;
}
.mds .mds-container .mds-grid .mds-grid-col-span-10 {
  /* 
  @name: mds-grid-col-span-10
  @category: Grid
  @usage: 
  Use mds-grid-col-span-10 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 10;
}
.mds .mds-container .mds-grid .mds-grid-col-span-11 {
  /* 
  @name: mds-grid-col-span-11
  @category: Grid
  @usage: 
  Use mds-grid-col-span-11 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 11;
}
.mds .mds-container .mds-grid .mds-grid-col-span-12 {
  /* 
  @name: mds-grid-col-span-12
  @category: Grid
  @usage: 
  Use mds-grid-col-span-12 class to span multiple cells in your grid.
  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.
  @example:
  <div class="mds-container">
    <div class="mds-grid">
      <div class="mds-grid-col-1 mds-grid-col-span-2">Cell in column 1 that spans over 2 columns in all breakpoints</div>
      <div class="mds-grid-col-3 mds-grid-col-span-3">Cell in column 3 that spans over 3 columns in all breakpoints</div>
      ...
    </div>
  </div> */
  grid-column-end: span 12;
}
.mds .mds-container .mds-grid.mds-grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.mds .mds-container .mds-grid.mds-grid-rows-1 {
  grid-template-rows: repeat(1, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-2 {
  grid-template-rows: repeat(2, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-3 {
  grid-template-rows: repeat(3, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-4 {
  grid-template-rows: repeat(4, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-5 {
  grid-template-rows: repeat(5, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-6 {
  grid-template-rows: repeat(6, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-7 {
  grid-template-rows: repeat(7, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-8 {
  grid-template-rows: repeat(8, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-9 {
  grid-template-rows: repeat(9, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-10 {
  grid-template-rows: repeat(10, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-11 {
  grid-template-rows: repeat(11, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-12 {
  grid-template-rows: repeat(12, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-13 {
  grid-template-rows: repeat(13, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-14 {
  grid-template-rows: repeat(14, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-15 {
  grid-template-rows: repeat(15, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-16 {
  grid-template-rows: repeat(16, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-17 {
  grid-template-rows: repeat(17, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-18 {
  grid-template-rows: repeat(18, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-19 {
  grid-template-rows: repeat(19, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-20 {
  grid-template-rows: repeat(20, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-21 {
  grid-template-rows: repeat(21, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-22 {
  grid-template-rows: repeat(22, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-23 {
  grid-template-rows: repeat(23, auto);
}
.mds .mds-container .mds-grid.mds-grid-rows-24 {
  grid-template-rows: repeat(24, auto);
}
.mds .mds-container {
  /*
  @name: mds-container
  @category: Grid
  */
  container-type: inline-size;
  contain: layout;
  position: relative;
  z-index: 1;
}
@container (max-width: 640px) {
  .mds .mds-container .mds-grid {
    gap: var(--mds_foundations_grid_xs_column-gap) var(--mds_foundations_grid_xs_row-gap);
    grid-template-columns: repeat(var(--mds_foundations_grid_xs_columns), minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-1 {
    /* 
    @name: mds-grid-xs-col-1
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-1 class to position the cell in the 1 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 1 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 1;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-2 {
    /* 
    @name: mds-grid-xs-col-2
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-2 class to position the cell in the 2 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 2 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 2;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-3 {
    /* 
    @name: mds-grid-xs-col-3
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-3 class to position the cell in the 3 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 3 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 3;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-4 {
    /* 
    @name: mds-grid-xs-col-4
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-4 class to position the cell in the 4 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 4 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 4;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-5 {
    /* 
    @name: mds-grid-xs-col-5
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-5 class to position the cell in the 5 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 5 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 5;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-6 {
    /* 
    @name: mds-grid-xs-col-6
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-6 class to position the cell in the 6 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 6 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 6;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-7 {
    /* 
    @name: mds-grid-xs-col-7
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-7 class to position the cell in the 7 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 7 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 7;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-8 {
    /* 
    @name: mds-grid-xs-col-8
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-8 class to position the cell in the 8 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 8 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 8;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-9 {
    /* 
    @name: mds-grid-xs-col-9
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-9 class to position the cell in the 9 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 9 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 9;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-10 {
    /* 
    @name: mds-grid-xs-col-10
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-10 class to position the cell in the 10 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 10 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 10;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-11 {
    /* 
    @name: mds-grid-xs-col-11
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-11 class to position the cell in the 11 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 11 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 11;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-12 {
    /* 
    @name: mds-grid-xs-col-12
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-12 class to position the cell in the 12 column of the grid in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 12 for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1">Cell in column 1 for xs breakpoint</div>
        <div class="mds-grid-xs-col-2">Cell in column 2 for xs breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 12;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-1-reverse {
    /* 
    @name: mds-grid-xs-col-1-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 1 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -2;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-2-reverse {
    /* 
    @name: mds-grid-xs-col-2-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 2 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -3;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-3-reverse {
    /* 
    @name: mds-grid-xs-col-3-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 3 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -4;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-4-reverse {
    /* 
    @name: mds-grid-xs-col-4-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 4 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -5;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-5-reverse {
    /* 
    @name: mds-grid-xs-col-5-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 5 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -6;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-6-reverse {
    /* 
    @name: mds-grid-xs-col-6-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 6 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -7;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-7-reverse {
    /* 
    @name: mds-grid-xs-col-7-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 7 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -8;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-8-reverse {
    /* 
    @name: mds-grid-xs-col-8-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 8 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -9;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-9-reverse {
    /* 
    @name: mds-grid-xs-col-9-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 9 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -10;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-10-reverse {
    /* 
    @name: mds-grid-xs-col-10-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 10 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -11;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-11-reverse {
    /* 
    @name: mds-grid-xs-col-11-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 11 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -12;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-12-reverse {
    /* 
    @name: mds-grid-xs-col-12-reverse
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) in xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 12 from the end for xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-xs-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -13;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-1 {
    /* 
    @name: mds-grid-xs-col-span-1
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-1 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-1 class to position the cell in the 1 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 1;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-2 {
    /* 
    @name: mds-grid-xs-col-span-2
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-2 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-2 class to position the cell in the 2 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 2;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-3 {
    /* 
    @name: mds-grid-xs-col-span-3
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-3 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-3 class to position the cell in the 3 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 3;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-4 {
    /* 
    @name: mds-grid-xs-col-span-4
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-4 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-4 class to position the cell in the 4 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 4;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-5 {
    /* 
    @name: mds-grid-xs-col-span-5
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-5 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-5 class to position the cell in the 5 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 5;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-6 {
    /* 
    @name: mds-grid-xs-col-span-6
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-6 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-6 class to position the cell in the 6 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 6;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-7 {
    /* 
    @name: mds-grid-xs-col-span-7
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-7 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-7 class to position the cell in the 7 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 7;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-8 {
    /* 
    @name: mds-grid-xs-col-span-8
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-8 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-8 class to position the cell in the 8 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 8;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-9 {
    /* 
    @name: mds-grid-xs-col-span-9
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-9 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-9 class to position the cell in the 9 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 9;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-10 {
    /* 
    @name: mds-grid-xs-col-span-10
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-10 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-10 class to position the cell in the 10 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 10;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-11 {
    /* 
    @name: mds-grid-xs-col-span-11
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-11 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-11 class to position the cell in the 11 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 11;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-col-span-12 {
    /* 
    @name: mds-grid-xs-col-span-12
    @category: Grid
    @usage: 
    Use mds-grid-xs-col-span-12 class to span multiple cells in your grid for xs breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.
    Use it in combination with mds-grid-xs-col-12 class to position the cell in the 12 column of the grid in xs breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-xs-col-1 mds-grid-xs-col-span-2">Cell in column 1 that spans over 2 columns in xs breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 12;
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-xs-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-1 {
    grid-row-start: 1;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-2 {
    grid-row-start: 2;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-3 {
    grid-row-start: 3;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-4 {
    grid-row-start: 4;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-5 {
    grid-row-start: 5;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-6 {
    grid-row-start: 6;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-7 {
    grid-row-start: 7;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-8 {
    grid-row-start: 8;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-9 {
    grid-row-start: 9;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-10 {
    grid-row-start: 10;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-11 {
    grid-row-start: 11;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-12 {
    grid-row-start: 12;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-13 {
    grid-row-start: 13;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-14 {
    grid-row-start: 14;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-15 {
    grid-row-start: 15;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-16 {
    grid-row-start: 16;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-17 {
    grid-row-start: 17;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-18 {
    grid-row-start: 18;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-19 {
    grid-row-start: 19;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-20 {
    grid-row-start: 20;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-21 {
    grid-row-start: 21;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-22 {
    grid-row-start: 22;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-23 {
    grid-row-start: 23;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-24 {
    grid-row-start: 24;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-1 {
    grid-row-end: span 1;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-2 {
    grid-row-end: span 2;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-3 {
    grid-row-end: span 3;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-4 {
    grid-row-end: span 4;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-5 {
    grid-row-end: span 5;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-6 {
    grid-row-end: span 6;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-7 {
    grid-row-end: span 7;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-8 {
    grid-row-end: span 8;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-9 {
    grid-row-end: span 9;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-10 {
    grid-row-end: span 10;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-11 {
    grid-row-end: span 11;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-12 {
    grid-row-end: span 12;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-13 {
    grid-row-end: span 13;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-14 {
    grid-row-end: span 14;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-15 {
    grid-row-end: span 15;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-16 {
    grid-row-end: span 16;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-17 {
    grid-row-end: span 17;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-18 {
    grid-row-end: span 18;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-19 {
    grid-row-end: span 19;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-20 {
    grid-row-end: span 20;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-21 {
    grid-row-end: span 21;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-22 {
    grid-row-end: span 22;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-23 {
    grid-row-end: span 23;
  }
  .mds .mds-container .mds-grid .mds-grid-xs-row-span-24 {
    grid-row-end: span 24;
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-1 {
    grid-template-rows: repeat(1, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-2 {
    grid-template-rows: repeat(2, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-3 {
    grid-template-rows: repeat(3, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-4 {
    grid-template-rows: repeat(4, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-5 {
    grid-template-rows: repeat(5, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-6 {
    grid-template-rows: repeat(6, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-7 {
    grid-template-rows: repeat(7, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-8 {
    grid-template-rows: repeat(8, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-9 {
    grid-template-rows: repeat(9, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-10 {
    grid-template-rows: repeat(10, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-11 {
    grid-template-rows: repeat(11, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-12 {
    grid-template-rows: repeat(12, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-13 {
    grid-template-rows: repeat(13, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-14 {
    grid-template-rows: repeat(14, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-15 {
    grid-template-rows: repeat(15, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-16 {
    grid-template-rows: repeat(16, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-17 {
    grid-template-rows: repeat(17, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-18 {
    grid-template-rows: repeat(18, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-19 {
    grid-template-rows: repeat(19, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-20 {
    grid-template-rows: repeat(20, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-21 {
    grid-template-rows: repeat(21, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-22 {
    grid-template-rows: repeat(22, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-23 {
    grid-template-rows: repeat(23, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-xs-rows-24 {
    grid-template-rows: repeat(24, auto);
  }
}
@container (min-width: 641px) {
  .mds .mds-container .mds-grid {
    gap: var(--mds_foundations_grid_sm_column-gap) var(--mds_foundations_grid_sm_row-gap);
    grid-template-columns: repeat(var(--mds_foundations_grid_sm_columns), minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-1 {
    /* 
    @name: mds-grid-sm-col-1
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-1 class to position the cell in the 1 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 1 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 1;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-2 {
    /* 
    @name: mds-grid-sm-col-2
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-2 class to position the cell in the 2 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 2 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 2;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-3 {
    /* 
    @name: mds-grid-sm-col-3
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-3 class to position the cell in the 3 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 3 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 3;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-4 {
    /* 
    @name: mds-grid-sm-col-4
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-4 class to position the cell in the 4 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 4 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 4;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-5 {
    /* 
    @name: mds-grid-sm-col-5
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-5 class to position the cell in the 5 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 5 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 5;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-6 {
    /* 
    @name: mds-grid-sm-col-6
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-6 class to position the cell in the 6 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 6 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 6;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-7 {
    /* 
    @name: mds-grid-sm-col-7
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-7 class to position the cell in the 7 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 7 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 7;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-8 {
    /* 
    @name: mds-grid-sm-col-8
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-8 class to position the cell in the 8 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 8 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 8;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-9 {
    /* 
    @name: mds-grid-sm-col-9
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-9 class to position the cell in the 9 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 9 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 9;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-10 {
    /* 
    @name: mds-grid-sm-col-10
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-10 class to position the cell in the 10 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 10 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 10;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-11 {
    /* 
    @name: mds-grid-sm-col-11
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-11 class to position the cell in the 11 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 11 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 11;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-12 {
    /* 
    @name: mds-grid-sm-col-12
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-12 class to position the cell in the 12 column of the grid in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 12 for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1">Cell in column 1 for sm breakpoint</div>
        <div class="mds-grid-sm-col-2">Cell in column 2 for sm breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 12;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-1-reverse {
    /* 
    @name: mds-grid-sm-col-1-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 1 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -2;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-2-reverse {
    /* 
    @name: mds-grid-sm-col-2-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 2 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -3;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-3-reverse {
    /* 
    @name: mds-grid-sm-col-3-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 3 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -4;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-4-reverse {
    /* 
    @name: mds-grid-sm-col-4-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 4 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -5;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-5-reverse {
    /* 
    @name: mds-grid-sm-col-5-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 5 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -6;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-6-reverse {
    /* 
    @name: mds-grid-sm-col-6-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 6 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -7;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-7-reverse {
    /* 
    @name: mds-grid-sm-col-7-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 7 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -8;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-8-reverse {
    /* 
    @name: mds-grid-sm-col-8-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 8 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -9;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-9-reverse {
    /* 
    @name: mds-grid-sm-col-9-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 9 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -10;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-10-reverse {
    /* 
    @name: mds-grid-sm-col-10-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 10 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -11;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-11-reverse {
    /* 
    @name: mds-grid-sm-col-11-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 11 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -12;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-12-reverse {
    /* 
    @name: mds-grid-sm-col-12-reverse
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) in sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 12 from the end for sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-sm-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -13;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-1 {
    /* 
    @name: mds-grid-sm-col-span-1
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-1 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-1 class to position the cell in the 1 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 1;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-2 {
    /* 
    @name: mds-grid-sm-col-span-2
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-2 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-2 class to position the cell in the 2 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 2;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-3 {
    /* 
    @name: mds-grid-sm-col-span-3
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-3 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-3 class to position the cell in the 3 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 3;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-4 {
    /* 
    @name: mds-grid-sm-col-span-4
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-4 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-4 class to position the cell in the 4 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 4;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-5 {
    /* 
    @name: mds-grid-sm-col-span-5
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-5 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-5 class to position the cell in the 5 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 5;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-6 {
    /* 
    @name: mds-grid-sm-col-span-6
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-6 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-6 class to position the cell in the 6 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 6;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-7 {
    /* 
    @name: mds-grid-sm-col-span-7
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-7 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-7 class to position the cell in the 7 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 7;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-8 {
    /* 
    @name: mds-grid-sm-col-span-8
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-8 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-8 class to position the cell in the 8 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 8;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-9 {
    /* 
    @name: mds-grid-sm-col-span-9
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-9 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-9 class to position the cell in the 9 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 9;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-10 {
    /* 
    @name: mds-grid-sm-col-span-10
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-10 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-10 class to position the cell in the 10 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 10;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-11 {
    /* 
    @name: mds-grid-sm-col-span-11
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-11 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-11 class to position the cell in the 11 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 11;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-col-span-12 {
    /* 
    @name: mds-grid-sm-col-span-12
    @category: Grid
    @usage: 
    Use mds-grid-sm-col-span-12 class to span multiple cells in your grid for sm breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.
    Use it in combination with mds-grid-sm-col-12 class to position the cell in the 12 column of the grid in sm breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-sm-col-1 mds-grid-sm-col-span-2">Cell in column 1 that spans over 2 columns in sm breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 12;
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-sm-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-1 {
    grid-row-start: 1;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-2 {
    grid-row-start: 2;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-3 {
    grid-row-start: 3;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-4 {
    grid-row-start: 4;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-5 {
    grid-row-start: 5;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-6 {
    grid-row-start: 6;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-7 {
    grid-row-start: 7;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-8 {
    grid-row-start: 8;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-9 {
    grid-row-start: 9;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-10 {
    grid-row-start: 10;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-11 {
    grid-row-start: 11;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-12 {
    grid-row-start: 12;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-13 {
    grid-row-start: 13;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-14 {
    grid-row-start: 14;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-15 {
    grid-row-start: 15;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-16 {
    grid-row-start: 16;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-17 {
    grid-row-start: 17;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-18 {
    grid-row-start: 18;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-19 {
    grid-row-start: 19;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-20 {
    grid-row-start: 20;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-21 {
    grid-row-start: 21;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-22 {
    grid-row-start: 22;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-23 {
    grid-row-start: 23;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-24 {
    grid-row-start: 24;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-1 {
    grid-row-end: span 1;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-2 {
    grid-row-end: span 2;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-3 {
    grid-row-end: span 3;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-4 {
    grid-row-end: span 4;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-5 {
    grid-row-end: span 5;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-6 {
    grid-row-end: span 6;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-7 {
    grid-row-end: span 7;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-8 {
    grid-row-end: span 8;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-9 {
    grid-row-end: span 9;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-10 {
    grid-row-end: span 10;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-11 {
    grid-row-end: span 11;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-12 {
    grid-row-end: span 12;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-13 {
    grid-row-end: span 13;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-14 {
    grid-row-end: span 14;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-15 {
    grid-row-end: span 15;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-16 {
    grid-row-end: span 16;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-17 {
    grid-row-end: span 17;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-18 {
    grid-row-end: span 18;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-19 {
    grid-row-end: span 19;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-20 {
    grid-row-end: span 20;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-21 {
    grid-row-end: span 21;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-22 {
    grid-row-end: span 22;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-23 {
    grid-row-end: span 23;
  }
  .mds .mds-container .mds-grid .mds-grid-sm-row-span-24 {
    grid-row-end: span 24;
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-1 {
    grid-template-rows: repeat(1, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-2 {
    grid-template-rows: repeat(2, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-3 {
    grid-template-rows: repeat(3, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-4 {
    grid-template-rows: repeat(4, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-5 {
    grid-template-rows: repeat(5, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-6 {
    grid-template-rows: repeat(6, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-7 {
    grid-template-rows: repeat(7, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-8 {
    grid-template-rows: repeat(8, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-9 {
    grid-template-rows: repeat(9, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-10 {
    grid-template-rows: repeat(10, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-11 {
    grid-template-rows: repeat(11, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-12 {
    grid-template-rows: repeat(12, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-13 {
    grid-template-rows: repeat(13, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-14 {
    grid-template-rows: repeat(14, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-15 {
    grid-template-rows: repeat(15, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-16 {
    grid-template-rows: repeat(16, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-17 {
    grid-template-rows: repeat(17, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-18 {
    grid-template-rows: repeat(18, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-19 {
    grid-template-rows: repeat(19, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-20 {
    grid-template-rows: repeat(20, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-21 {
    grid-template-rows: repeat(21, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-22 {
    grid-template-rows: repeat(22, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-23 {
    grid-template-rows: repeat(23, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-sm-rows-24 {
    grid-template-rows: repeat(24, auto);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-grid {
    gap: var(--mds_foundations_grid_md_column-gap) var(--mds_foundations_grid_md_row-gap);
    grid-template-columns: repeat(var(--mds_foundations_grid_md_columns), minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-1 {
    /* 
    @name: mds-grid-md-col-1
    @category: Grid
    @usage: 
    Use mds-grid-md-col-1 class to position the cell in the 1 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 1 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 1;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-2 {
    /* 
    @name: mds-grid-md-col-2
    @category: Grid
    @usage: 
    Use mds-grid-md-col-2 class to position the cell in the 2 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 2 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 2;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-3 {
    /* 
    @name: mds-grid-md-col-3
    @category: Grid
    @usage: 
    Use mds-grid-md-col-3 class to position the cell in the 3 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 3 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 3;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-4 {
    /* 
    @name: mds-grid-md-col-4
    @category: Grid
    @usage: 
    Use mds-grid-md-col-4 class to position the cell in the 4 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 4 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 4;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-5 {
    /* 
    @name: mds-grid-md-col-5
    @category: Grid
    @usage: 
    Use mds-grid-md-col-5 class to position the cell in the 5 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 5 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 5;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-6 {
    /* 
    @name: mds-grid-md-col-6
    @category: Grid
    @usage: 
    Use mds-grid-md-col-6 class to position the cell in the 6 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 6 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 6;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-7 {
    /* 
    @name: mds-grid-md-col-7
    @category: Grid
    @usage: 
    Use mds-grid-md-col-7 class to position the cell in the 7 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 7 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 7;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-8 {
    /* 
    @name: mds-grid-md-col-8
    @category: Grid
    @usage: 
    Use mds-grid-md-col-8 class to position the cell in the 8 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 8 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 8;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-9 {
    /* 
    @name: mds-grid-md-col-9
    @category: Grid
    @usage: 
    Use mds-grid-md-col-9 class to position the cell in the 9 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 9 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 9;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-10 {
    /* 
    @name: mds-grid-md-col-10
    @category: Grid
    @usage: 
    Use mds-grid-md-col-10 class to position the cell in the 10 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 10 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 10;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-11 {
    /* 
    @name: mds-grid-md-col-11
    @category: Grid
    @usage: 
    Use mds-grid-md-col-11 class to position the cell in the 11 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 11 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 11;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-12 {
    /* 
    @name: mds-grid-md-col-12
    @category: Grid
    @usage: 
    Use mds-grid-md-col-12 class to position the cell in the 12 column of the grid in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will only be in column 12 for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1">Cell in column 1 for md breakpoint</div>
        <div class="mds-grid-md-col-2">Cell in column 2 for md breakpoint</div>
        ...
      </div>  
    </div> */
    grid-column-start: 12;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-1-reverse {
    /* 
    @name: mds-grid-md-col-1-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 1 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -2;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-2-reverse {
    /* 
    @name: mds-grid-md-col-2-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 2 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -3;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-3-reverse {
    /* 
    @name: mds-grid-md-col-3-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 3 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -4;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-4-reverse {
    /* 
    @name: mds-grid-md-col-4-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 4 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -5;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-5-reverse {
    /* 
    @name: mds-grid-md-col-5-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 5 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -6;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-6-reverse {
    /* 
    @name: mds-grid-md-col-6-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 6 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -7;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-7-reverse {
    /* 
    @name: mds-grid-md-col-7-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 7 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -8;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-8-reverse {
    /* 
    @name: mds-grid-md-col-8-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 8 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -9;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-9-reverse {
    /* 
    @name: mds-grid-md-col-9-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 9 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -10;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-10-reverse {
    /* 
    @name: mds-grid-md-col-10-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 10 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -11;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-11-reverse {
    /* 
    @name: mds-grid-md-col-11-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 11 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -12;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-12-reverse {
    /* 
    @name: mds-grid-md-col-12-reverse
    @category: Grid
    @usage: 
    Use mds-grid-md-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) in md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cell will be only in column 12 from the end for md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-2-reverse">Cell in column 2 from the end in all breakpoints</div>
        <div class="mds-grid-md-col-1-reverse">Cell in column 1 from the end in all breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-start: -13;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-1 {
    /* 
    @name: mds-grid-md-col-span-1
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-1 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-1 class to position the cell in the 1 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 1;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-2 {
    /* 
    @name: mds-grid-md-col-span-2
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-2 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-2 class to position the cell in the 2 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 2;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-3 {
    /* 
    @name: mds-grid-md-col-span-3
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-3 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-3 class to position the cell in the 3 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 3;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-4 {
    /* 
    @name: mds-grid-md-col-span-4
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-4 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-4 class to position the cell in the 4 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 4;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-5 {
    /* 
    @name: mds-grid-md-col-span-5
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-5 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-5 class to position the cell in the 5 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 5;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-6 {
    /* 
    @name: mds-grid-md-col-span-6
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-6 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-6 class to position the cell in the 6 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 6;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-7 {
    /* 
    @name: mds-grid-md-col-span-7
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-7 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-7 class to position the cell in the 7 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 7;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-8 {
    /* 
    @name: mds-grid-md-col-span-8
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-8 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-8 class to position the cell in the 8 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 8;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-9 {
    /* 
    @name: mds-grid-md-col-span-9
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-9 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-9 class to position the cell in the 9 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 9;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-10 {
    /* 
    @name: mds-grid-md-col-span-10
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-10 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-10 class to position the cell in the 10 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 10;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-11 {
    /* 
    @name: mds-grid-md-col-span-11
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-11 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-11 class to position the cell in the 11 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 11;
  }
  .mds .mds-container .mds-grid .mds-grid-md-col-span-12 {
    /* 
    @name: mds-grid-md-col-span-12
    @category: Grid
    @usage: 
    Use mds-grid-md-col-span-12 class to span multiple cells in your grid for md breakpoint.
    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.
    Use it in combination with mds-grid-md-col-12 class to position the cell in the 12 column of the grid in md breakpoint.
    @example:
    <div class="mds-container">
      <div class="mds-grid">
        <div class="mds-grid-md-col-1 mds-grid-md-col-span-2">Cell in column 1 that spans over 2 columns in md breakpoints</div>
        ...
      </div>
    </div> */
    grid-column-end: span 12;
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid.mds-grid-md-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-1 {
    grid-row-start: 1;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-2 {
    grid-row-start: 2;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-3 {
    grid-row-start: 3;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-4 {
    grid-row-start: 4;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-5 {
    grid-row-start: 5;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-6 {
    grid-row-start: 6;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-7 {
    grid-row-start: 7;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-8 {
    grid-row-start: 8;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-9 {
    grid-row-start: 9;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-10 {
    grid-row-start: 10;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-11 {
    grid-row-start: 11;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-12 {
    grid-row-start: 12;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-13 {
    grid-row-start: 13;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-14 {
    grid-row-start: 14;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-15 {
    grid-row-start: 15;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-16 {
    grid-row-start: 16;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-17 {
    grid-row-start: 17;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-18 {
    grid-row-start: 18;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-19 {
    grid-row-start: 19;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-20 {
    grid-row-start: 20;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-21 {
    grid-row-start: 21;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-22 {
    grid-row-start: 22;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-23 {
    grid-row-start: 23;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-24 {
    grid-row-start: 24;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-1 {
    grid-row-end: span 1;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-2 {
    grid-row-end: span 2;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-3 {
    grid-row-end: span 3;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-4 {
    grid-row-end: span 4;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-5 {
    grid-row-end: span 5;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-6 {
    grid-row-end: span 6;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-7 {
    grid-row-end: span 7;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-8 {
    grid-row-end: span 8;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-9 {
    grid-row-end: span 9;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-10 {
    grid-row-end: span 10;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-11 {
    grid-row-end: span 11;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-12 {
    grid-row-end: span 12;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-13 {
    grid-row-end: span 13;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-14 {
    grid-row-end: span 14;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-15 {
    grid-row-end: span 15;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-16 {
    grid-row-end: span 16;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-17 {
    grid-row-end: span 17;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-18 {
    grid-row-end: span 18;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-19 {
    grid-row-end: span 19;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-20 {
    grid-row-end: span 20;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-21 {
    grid-row-end: span 21;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-22 {
    grid-row-end: span 22;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-23 {
    grid-row-end: span 23;
  }
  .mds .mds-container .mds-grid .mds-grid-md-row-span-24 {
    grid-row-end: span 24;
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-1 {
    grid-template-rows: repeat(1, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-2 {
    grid-template-rows: repeat(2, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-3 {
    grid-template-rows: repeat(3, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-4 {
    grid-template-rows: repeat(4, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-5 {
    grid-template-rows: repeat(5, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-6 {
    grid-template-rows: repeat(6, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-7 {
    grid-template-rows: repeat(7, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-8 {
    grid-template-rows: repeat(8, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-9 {
    grid-template-rows: repeat(9, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-10 {
    grid-template-rows: repeat(10, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-11 {
    grid-template-rows: repeat(11, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-12 {
    grid-template-rows: repeat(12, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-13 {
    grid-template-rows: repeat(13, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-14 {
    grid-template-rows: repeat(14, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-15 {
    grid-template-rows: repeat(15, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-16 {
    grid-template-rows: repeat(16, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-17 {
    grid-template-rows: repeat(17, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-18 {
    grid-template-rows: repeat(18, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-19 {
    grid-template-rows: repeat(19, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-20 {
    grid-template-rows: repeat(20, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-21 {
    grid-template-rows: repeat(21, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-22 {
    grid-template-rows: repeat(22, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-23 {
    grid-template-rows: repeat(23, auto);
  }
  .mds .mds-container .mds-grid.mds-grid-md-rows-24 {
    grid-template-rows: repeat(24, auto);
  }
}
.mds {
  background: var(--mds_foundations_body_background-color);
  color: var(--mds_foundations_body_text-color);
  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizelegibility;
  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;
}
.mds {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds {
  font-style: var(--mds_brand_typography_text_medium_normal_font-style);
  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);
}

.mds .mds-headline--x-small, .mds h4 {
  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);
  font-size: var(--mds_brand_typography_headline_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_headline_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-headline--x-small, .mds h4 {
    font-size: var(--mds_brand_typography_headline_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_x-small_desktop_line-height);
  }
}
.mds .mds-headline--x-small, .mds h4 {
  text-transform: var(--mds_brand_typography_headline_x-small_text-transform);
  font-style: var(--mds_brand_typography_headline_x-small_font-style);
  font-weight: var(--mds_brand_typography_headline_x-small_font-weight);
}
.mds .mds-headline--small, .mds h3 {
  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);
  font-size: var(--mds_brand_typography_headline_small_mobile_font-size);
  line-height: var(--mds_brand_typography_headline_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-headline--small, .mds h3 {
    font-size: var(--mds_brand_typography_headline_small_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_small_desktop_line-height);
  }
}
.mds .mds-headline--small, .mds h3 {
  text-transform: var(--mds_brand_typography_headline_small_text-transform);
  font-style: var(--mds_brand_typography_headline_small_font-style);
  font-weight: var(--mds_brand_typography_headline_small_font-weight);
}
.mds .mds-headline--medium, .mds h2 {
  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);
  font-size: var(--mds_brand_typography_headline_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_headline_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-headline--medium, .mds h2 {
    font-size: var(--mds_brand_typography_headline_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_medium_desktop_line-height);
  }
}
.mds .mds-headline--medium, .mds h2 {
  text-transform: var(--mds_brand_typography_headline_medium_text-transform);
  font-style: var(--mds_brand_typography_headline_medium_font-style);
  font-weight: var(--mds_brand_typography_headline_medium_font-weight);
}
.mds .mds-headline--large, .mds h1 {
  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);
  font-size: var(--mds_brand_typography_headline_large_mobile_font-size);
  line-height: var(--mds_brand_typography_headline_large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-headline--large, .mds h1 {
    font-size: var(--mds_brand_typography_headline_large_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_large_desktop_line-height);
  }
}
.mds .mds-headline--large, .mds h1 {
  text-transform: var(--mds_brand_typography_headline_large_text-transform);
  font-style: var(--mds_brand_typography_headline_large_font-style);
  font-weight: var(--mds_brand_typography_headline_large_font-weight);
}
.mds .mds-headline--x-large {
  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);
  font-size: var(--mds_brand_typography_headline_x-large_mobile_font-size);
  line-height: var(--mds_brand_typography_headline_x-large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-headline--x-large {
    font-size: var(--mds_brand_typography_headline_x-large_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_x-large_desktop_line-height);
  }
}
.mds .mds-headline--x-large {
  text-transform: var(--mds_brand_typography_headline_x-large_text-transform);
  font-style: var(--mds_brand_typography_headline_x-large_font-style);
  font-weight: var(--mds_brand_typography_headline_x-large_font-weight);
}
.mds .mds-text--x-small-normal {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--x-small-normal {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
.mds .mds-text--x-small-normal {
  font-style: var(--mds_brand_typography_text_x-small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_x-small_normal_font-weight);
}
.mds .mds-text--x-small-medium {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--x-small-medium {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
.mds .mds-text--x-small-medium {
  font-style: var(--mds_brand_typography_text_x-small_medium_font-style);
  font-weight: var(--mds_brand_typography_text_x-small_medium_font-weight);
}
.mds .mds-text--x-small-bold {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--x-small-bold {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
.mds .mds-text--x-small-bold {
  font-style: var(--mds_brand_typography_text_x-small_bold_font-style);
  font-weight: var(--mds_brand_typography_text_x-small_bold_font-weight);
}
.mds .mds-text--x-small-italic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--x-small-italic {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
.mds .mds-text--x-small-italic {
  font-style: var(--mds_brand_typography_text_x-small_italic_font-style);
  font-weight: var(--mds_brand_typography_text_x-small_italic_font-weight);
}
.mds .mds-text--x-small-mediumitalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--x-small-mediumitalic {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
.mds .mds-text--x-small-mediumitalic {
  font-style: var(--mds_brand_typography_text_x-small_mediumitalic_font-style);
  font-weight: var(--mds_brand_typography_text_x-small_mediumitalic_font-weight);
}
.mds .mds-text--x-small-bolditalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--x-small-bolditalic {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
.mds .mds-text--x-small-bolditalic {
  font-style: var(--mds_brand_typography_text_x-small_bolditalic_font-style);
  font-weight: var(--mds_brand_typography_text_x-small_bolditalic_font-weight);
}
.mds .mds-text--small-normal {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--small-normal {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-text--small-normal {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
.mds .mds-text--small-medium {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--small-medium {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-text--small-medium {
  font-style: var(--mds_brand_typography_text_small_medium_font-style);
  font-weight: var(--mds_brand_typography_text_small_medium_font-weight);
}
.mds .mds-text--small-bold {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--small-bold {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-text--small-bold {
  font-style: var(--mds_brand_typography_text_small_bold_font-style);
  font-weight: var(--mds_brand_typography_text_small_bold_font-weight);
}
.mds .mds-text--small-italic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--small-italic {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-text--small-italic {
  font-style: var(--mds_brand_typography_text_small_italic_font-style);
  font-weight: var(--mds_brand_typography_text_small_italic_font-weight);
}
.mds .mds-text--small-mediumitalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--small-mediumitalic {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-text--small-mediumitalic {
  font-style: var(--mds_brand_typography_text_small_mediumitalic_font-style);
  font-weight: var(--mds_brand_typography_text_small_mediumitalic_font-weight);
}
.mds .mds-text--small-bolditalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--small-bolditalic {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-text--small-bolditalic {
  font-style: var(--mds_brand_typography_text_small_bolditalic_font-style);
  font-weight: var(--mds_brand_typography_text_small_bolditalic_font-weight);
}
.mds .mds-text--medium-normal {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--medium-normal {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-text--medium-normal {
  font-style: var(--mds_brand_typography_text_medium_normal_font-style);
  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);
}
.mds .mds-text--medium-medium {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--medium-medium {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-text--medium-medium {
  font-style: var(--mds_brand_typography_text_medium_medium_font-style);
  font-weight: var(--mds_brand_typography_text_medium_medium_font-weight);
}
.mds .mds-text--medium-bold, .mds h5,
.mds h6 {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--medium-bold, .mds h5,
  .mds h6 {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-text--medium-bold, .mds h5,
.mds h6 {
  font-style: var(--mds_brand_typography_text_medium_bold_font-style);
  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);
}
.mds .mds-text--medium-italic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--medium-italic {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-text--medium-italic {
  font-style: var(--mds_brand_typography_text_medium_italic_font-style);
  font-weight: var(--mds_brand_typography_text_medium_italic_font-weight);
}
.mds .mds-text--medium-mediumitalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--medium-mediumitalic {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-text--medium-mediumitalic {
  font-style: var(--mds_brand_typography_text_medium_mediumitalic_font-style);
  font-weight: var(--mds_brand_typography_text_medium_mediumitalic_font-weight);
}
.mds .mds-text--medium-bolditalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--medium-bolditalic {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-text--medium-bolditalic {
  font-style: var(--mds_brand_typography_text_medium_bolditalic_font-style);
  font-weight: var(--mds_brand_typography_text_medium_bolditalic_font-weight);
}
.mds .mds-text--large-normal {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_large_mobile_font-size);
  line-height: var(--mds_brand_typography_text_large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--large-normal {
    font-size: var(--mds_brand_typography_text_large_desktop_font-size);
    line-height: var(--mds_brand_typography_text_large_desktop_line-height);
  }
}
.mds .mds-text--large-normal {
  font-style: var(--mds_brand_typography_text_large_normal_font-style);
  font-weight: var(--mds_brand_typography_text_large_normal_font-weight);
}
.mds .mds-text--large-medium {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_large_mobile_font-size);
  line-height: var(--mds_brand_typography_text_large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--large-medium {
    font-size: var(--mds_brand_typography_text_large_desktop_font-size);
    line-height: var(--mds_brand_typography_text_large_desktop_line-height);
  }
}
.mds .mds-text--large-medium {
  font-style: var(--mds_brand_typography_text_large_medium_font-style);
  font-weight: var(--mds_brand_typography_text_large_medium_font-weight);
}
.mds .mds-text--large-bold {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_large_mobile_font-size);
  line-height: var(--mds_brand_typography_text_large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--large-bold {
    font-size: var(--mds_brand_typography_text_large_desktop_font-size);
    line-height: var(--mds_brand_typography_text_large_desktop_line-height);
  }
}
.mds .mds-text--large-bold {
  font-style: var(--mds_brand_typography_text_large_bold_font-style);
  font-weight: var(--mds_brand_typography_text_large_bold_font-weight);
}
.mds .mds-text--large-italic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_large_mobile_font-size);
  line-height: var(--mds_brand_typography_text_large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--large-italic {
    font-size: var(--mds_brand_typography_text_large_desktop_font-size);
    line-height: var(--mds_brand_typography_text_large_desktop_line-height);
  }
}
.mds .mds-text--large-italic {
  font-style: var(--mds_brand_typography_text_large_italic_font-style);
  font-weight: var(--mds_brand_typography_text_large_italic_font-weight);
}
.mds .mds-text--large-mediumitalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_large_mobile_font-size);
  line-height: var(--mds_brand_typography_text_large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--large-mediumitalic {
    font-size: var(--mds_brand_typography_text_large_desktop_font-size);
    line-height: var(--mds_brand_typography_text_large_desktop_line-height);
  }
}
.mds .mds-text--large-mediumitalic {
  font-style: var(--mds_brand_typography_text_large_mediumitalic_font-style);
  font-weight: var(--mds_brand_typography_text_large_mediumitalic_font-weight);
}
.mds .mds-text--large-bolditalic {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_large_mobile_font-size);
  line-height: var(--mds_brand_typography_text_large_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-text--large-bolditalic {
    font-size: var(--mds_brand_typography_text_large_desktop_font-size);
    line-height: var(--mds_brand_typography_text_large_desktop_line-height);
  }
}
.mds .mds-text--large-bolditalic {
  font-style: var(--mds_brand_typography_text_large_bolditalic_font-style);
  font-weight: var(--mds_brand_typography_text_large_bolditalic_font-weight);
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-headline--x-small, .mds .mds-container h4 {
    font-size: var(--mds_brand_typography_headline_x-small_mobile_font-size);
    line-height: var(--mds_brand_typography_headline_x-small_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-headline--x-small, .mds .mds-container h4 {
    font-size: var(--mds_brand_typography_headline_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_x-small_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-headline--small, .mds .mds-container h3 {
    font-size: var(--mds_brand_typography_headline_small_mobile_font-size);
    line-height: var(--mds_brand_typography_headline_small_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-headline--small, .mds .mds-container h3 {
    font-size: var(--mds_brand_typography_headline_small_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_small_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-headline--medium, .mds .mds-container h2 {
    font-size: var(--mds_brand_typography_headline_medium_mobile_font-size);
    line-height: var(--mds_brand_typography_headline_medium_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-headline--medium, .mds .mds-container h2 {
    font-size: var(--mds_brand_typography_headline_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_medium_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-headline--large, .mds .mds-container h1 {
    font-size: var(--mds_brand_typography_headline_large_mobile_font-size);
    line-height: var(--mds_brand_typography_headline_large_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-headline--large, .mds .mds-container h1 {
    font-size: var(--mds_brand_typography_headline_large_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_large_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-headline--x-large {
    font-size: var(--mds_brand_typography_headline_x-large_mobile_font-size);
    line-height: var(--mds_brand_typography_headline_x-large_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-headline--x-large {
    font-size: var(--mds_brand_typography_headline_x-large_desktop_font-size);
    line-height: var(--mds_brand_typography_headline_x-large_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-text--x-small-normal, .mds .mds-container .mds-text--x-small-medium, .mds .mds-container .mds-text--x-small-bold, .mds .mds-container .mds-text--x-small-italic, .mds .mds-container .mds-text--x-small-mediumitalic, .mds .mds-container .mds-text--x-small-bolditalic {
    font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
    line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-text--x-small-normal, .mds .mds-container .mds-text--x-small-medium, .mds .mds-container .mds-text--x-small-bold, .mds .mds-container .mds-text--x-small-italic, .mds .mds-container .mds-text--x-small-mediumitalic, .mds .mds-container .mds-text--x-small-bolditalic {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-text--small-normal, .mds .mds-container .mds-text--small-medium, .mds .mds-container .mds-text--small-bold, .mds .mds-container .mds-text--small-italic, .mds .mds-container .mds-text--small-mediumitalic, .mds .mds-container .mds-text--small-bolditalic {
    font-size: var(--mds_brand_typography_text_small_mobile_font-size);
    line-height: var(--mds_brand_typography_text_small_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-text--small-normal, .mds .mds-container .mds-text--small-medium, .mds .mds-container .mds-text--small-bold, .mds .mds-container .mds-text--small-italic, .mds .mds-container .mds-text--small-mediumitalic, .mds .mds-container .mds-text--small-bolditalic {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-text--medium-normal, .mds .mds-container .mds-text--medium-medium, .mds .mds-container .mds-text--medium-bold, .mds .mds-container h5,
  .mds .mds-container h6, .mds .mds-container .mds-text--medium-italic, .mds .mds-container .mds-text--medium-mediumitalic, .mds .mds-container .mds-text--medium-bolditalic {
    font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
    line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-text--medium-normal, .mds .mds-container .mds-text--medium-medium, .mds .mds-container .mds-text--medium-bold, .mds .mds-container h5,
  .mds .mds-container h6, .mds .mds-container .mds-text--medium-italic, .mds .mds-container .mds-text--medium-mediumitalic, .mds .mds-container .mds-text--medium-bolditalic {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
@container (max-width: 1024px) {
  .mds .mds-container .mds-text--large-normal, .mds .mds-container .mds-text--large-medium, .mds .mds-container .mds-text--large-bold, .mds .mds-container .mds-text--large-italic, .mds .mds-container .mds-text--large-mediumitalic, .mds .mds-container .mds-text--large-bolditalic {
    font-size: var(--mds_brand_typography_text_large_mobile_font-size);
    line-height: var(--mds_brand_typography_text_large_mobile_line-height);
  }
}
@container (min-width: 1025px) {
  .mds .mds-container .mds-text--large-normal, .mds .mds-container .mds-text--large-medium, .mds .mds-container .mds-text--large-bold, .mds .mds-container .mds-text--large-italic, .mds .mds-container .mds-text--large-mediumitalic, .mds .mds-container .mds-text--large-bolditalic {
    font-size: var(--mds_brand_typography_text_large_desktop_font-size);
    line-height: var(--mds_brand_typography_text_large_desktop_line-height);
  }
}
.mds .mds-tabular-figures {
  font-feature-settings: "tnum";
}
.mds .mds-numeric.mds-tabular-figures {
  font-feature-settings: "salt" on, "tnum";
}
.mds .mds-numeric {
  font-feature-settings: "salt" on;
  font-variant-numeric: slashed-zero;
}
.mds h1,
.mds h2,
.mds h3,
.mds h4,
.mds h5,
.mds h6,
.mds p {
  padding: 0;
  margin: 0;
}
.mds em {
  font-style: var(--mds_brand_typography_text_medium_italic_font-style);
}
.mds strong {
  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);
}
.mds .mds-underline--dotted {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
.mds .mds-gap-50,
.mds .mds-container .mds-gap-50,
.mds .mds-viewport .mds-gap-50 {
  gap: 2px;
}
.mds .mds-col-gap-50,
.mds .mds-container .mds-col-gap-50,
.mds .mds-viewport .mds-col-gap-50 {
  column-gap: 2px;
}
.mds .mds-row-gap-50,
.mds .mds-container .mds-row-gap-50,
.mds .mds-viewport .mds-row-gap-50 {
  row-gap: 2px;
}
.mds .mds-gap-100,
.mds .mds-container .mds-gap-100,
.mds .mds-viewport .mds-gap-100 {
  gap: 4px;
}
.mds .mds-col-gap-100,
.mds .mds-container .mds-col-gap-100,
.mds .mds-viewport .mds-col-gap-100 {
  column-gap: 4px;
}
.mds .mds-row-gap-100,
.mds .mds-container .mds-row-gap-100,
.mds .mds-viewport .mds-row-gap-100 {
  row-gap: 4px;
}
.mds .mds-gap-150,
.mds .mds-container .mds-gap-150,
.mds .mds-viewport .mds-gap-150 {
  gap: 6px;
}
.mds .mds-col-gap-150,
.mds .mds-container .mds-col-gap-150,
.mds .mds-viewport .mds-col-gap-150 {
  column-gap: 6px;
}
.mds .mds-row-gap-150,
.mds .mds-container .mds-row-gap-150,
.mds .mds-viewport .mds-row-gap-150 {
  row-gap: 6px;
}
.mds .mds-gap-200,
.mds .mds-container .mds-gap-200,
.mds .mds-viewport .mds-gap-200 {
  gap: 8px;
}
.mds .mds-col-gap-200,
.mds .mds-container .mds-col-gap-200,
.mds .mds-viewport .mds-col-gap-200 {
  column-gap: 8px;
}
.mds .mds-row-gap-200,
.mds .mds-container .mds-row-gap-200,
.mds .mds-viewport .mds-row-gap-200 {
  row-gap: 8px;
}
.mds .mds-gap-300,
.mds .mds-container .mds-gap-300,
.mds .mds-viewport .mds-gap-300 {
  gap: 12px;
}
.mds .mds-col-gap-300,
.mds .mds-container .mds-col-gap-300,
.mds .mds-viewport .mds-col-gap-300 {
  column-gap: 12px;
}
.mds .mds-row-gap-300,
.mds .mds-container .mds-row-gap-300,
.mds .mds-viewport .mds-row-gap-300 {
  row-gap: 12px;
}
.mds .mds-gap-400,
.mds .mds-container .mds-gap-400,
.mds .mds-viewport .mds-gap-400 {
  gap: 16px;
}
.mds .mds-col-gap-400,
.mds .mds-container .mds-col-gap-400,
.mds .mds-viewport .mds-col-gap-400 {
  column-gap: 16px;
}
.mds .mds-row-gap-400,
.mds .mds-container .mds-row-gap-400,
.mds .mds-viewport .mds-row-gap-400 {
  row-gap: 16px;
}
.mds .mds-gap-500,
.mds .mds-container .mds-gap-500,
.mds .mds-viewport .mds-gap-500 {
  gap: 20px;
}
.mds .mds-col-gap-500,
.mds .mds-container .mds-col-gap-500,
.mds .mds-viewport .mds-col-gap-500 {
  column-gap: 20px;
}
.mds .mds-row-gap-500,
.mds .mds-container .mds-row-gap-500,
.mds .mds-viewport .mds-row-gap-500 {
  row-gap: 20px;
}
.mds .mds-gap-600,
.mds .mds-container .mds-gap-600,
.mds .mds-viewport .mds-gap-600 {
  gap: 24px;
}
.mds .mds-col-gap-600,
.mds .mds-container .mds-col-gap-600,
.mds .mds-viewport .mds-col-gap-600 {
  column-gap: 24px;
}
.mds .mds-row-gap-600,
.mds .mds-container .mds-row-gap-600,
.mds .mds-viewport .mds-row-gap-600 {
  row-gap: 24px;
}
.mds .mds-gap-700,
.mds .mds-container .mds-gap-700,
.mds .mds-viewport .mds-gap-700 {
  gap: 28px;
}
.mds .mds-col-gap-700,
.mds .mds-container .mds-col-gap-700,
.mds .mds-viewport .mds-col-gap-700 {
  column-gap: 28px;
}
.mds .mds-row-gap-700,
.mds .mds-container .mds-row-gap-700,
.mds .mds-viewport .mds-row-gap-700 {
  row-gap: 28px;
}
.mds .mds-gap-800,
.mds .mds-container .mds-gap-800,
.mds .mds-viewport .mds-gap-800 {
  gap: 32px;
}
.mds .mds-col-gap-800,
.mds .mds-container .mds-col-gap-800,
.mds .mds-viewport .mds-col-gap-800 {
  column-gap: 32px;
}
.mds .mds-row-gap-800,
.mds .mds-container .mds-row-gap-800,
.mds .mds-viewport .mds-row-gap-800 {
  row-gap: 32px;
}
.mds .mds-gap-900,
.mds .mds-container .mds-gap-900,
.mds .mds-viewport .mds-gap-900 {
  gap: 36px;
}
.mds .mds-col-gap-900,
.mds .mds-container .mds-col-gap-900,
.mds .mds-viewport .mds-col-gap-900 {
  column-gap: 36px;
}
.mds .mds-row-gap-900,
.mds .mds-container .mds-row-gap-900,
.mds .mds-viewport .mds-row-gap-900 {
  row-gap: 36px;
}
.mds .mds-gap-1000,
.mds .mds-container .mds-gap-1000,
.mds .mds-viewport .mds-gap-1000 {
  gap: 40px;
}
.mds .mds-col-gap-1000,
.mds .mds-container .mds-col-gap-1000,
.mds .mds-viewport .mds-col-gap-1000 {
  column-gap: 40px;
}
.mds .mds-row-gap-1000,
.mds .mds-container .mds-row-gap-1000,
.mds .mds-viewport .mds-row-gap-1000 {
  row-gap: 40px;
}
.mds .mds-gap-1200,
.mds .mds-container .mds-gap-1200,
.mds .mds-viewport .mds-gap-1200 {
  gap: 48px;
}
.mds .mds-col-gap-1200,
.mds .mds-container .mds-col-gap-1200,
.mds .mds-viewport .mds-col-gap-1200 {
  column-gap: 48px;
}
.mds .mds-row-gap-1200,
.mds .mds-container .mds-row-gap-1200,
.mds .mds-viewport .mds-row-gap-1200 {
  row-gap: 48px;
}
.mds .mds-gap-1600,
.mds .mds-container .mds-gap-1600,
.mds .mds-viewport .mds-gap-1600 {
  gap: 64px;
}
.mds .mds-col-gap-1600,
.mds .mds-container .mds-col-gap-1600,
.mds .mds-viewport .mds-col-gap-1600 {
  column-gap: 64px;
}
.mds .mds-row-gap-1600,
.mds .mds-container .mds-row-gap-1600,
.mds .mds-viewport .mds-row-gap-1600 {
  row-gap: 64px;
}
.mds .mds-gap-2000,
.mds .mds-container .mds-gap-2000,
.mds .mds-viewport .mds-gap-2000 {
  gap: 80px;
}
.mds .mds-col-gap-2000,
.mds .mds-container .mds-col-gap-2000,
.mds .mds-viewport .mds-col-gap-2000 {
  column-gap: 80px;
}
.mds .mds-row-gap-2000,
.mds .mds-container .mds-row-gap-2000,
.mds .mds-viewport .mds-row-gap-2000 {
  row-gap: 80px;
}
.mds .mds-gap-2400,
.mds .mds-container .mds-gap-2400,
.mds .mds-viewport .mds-gap-2400 {
  gap: 96px;
}
.mds .mds-col-gap-2400,
.mds .mds-container .mds-col-gap-2400,
.mds .mds-viewport .mds-col-gap-2400 {
  column-gap: 96px;
}
.mds .mds-row-gap-2400,
.mds .mds-container .mds-row-gap-2400,
.mds .mds-viewport .mds-row-gap-2400 {
  row-gap: 96px;
}
.mds .mds-gap-2800,
.mds .mds-container .mds-gap-2800,
.mds .mds-viewport .mds-gap-2800 {
  gap: 112px;
}
.mds .mds-col-gap-2800,
.mds .mds-container .mds-col-gap-2800,
.mds .mds-viewport .mds-col-gap-2800 {
  column-gap: 112px;
}
.mds .mds-row-gap-2800,
.mds .mds-container .mds-row-gap-2800,
.mds .mds-viewport .mds-row-gap-2800 {
  row-gap: 112px;
}
.mds .mds-gap-3200,
.mds .mds-container .mds-gap-3200,
.mds .mds-viewport .mds-gap-3200 {
  gap: 128px;
}
.mds .mds-col-gap-3200,
.mds .mds-container .mds-col-gap-3200,
.mds .mds-viewport .mds-col-gap-3200 {
  column-gap: 128px;
}
.mds .mds-row-gap-3200,
.mds .mds-container .mds-row-gap-3200,
.mds .mds-viewport .mds-row-gap-3200 {
  row-gap: 128px;
}
.mds .mds-flex {
  display: flex;
  flex-wrap: wrap;
}
.mds .mds-flex-items-start {
  align-items: flex-start;
}
.mds .mds-flex-items-center {
  align-items: center;
}
.mds .mds-flex-items-end {
  align-items: flex-end;
}
.mds .mds-flex-items-baseline {
  align-items: baseline;
}
.mds .mds-flex-items-stretch {
  align-items: stretch;
}
.mds hr {
  border-bottom: var(--mds_foundations_horizontal-rule_border-width) var(--mds_foundations_horizontal-rule_border-style) var(--mds_foundations_horizontal-rule_border-color);
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0;
  height: 0;
  padding: 0;
  margin: 0;
}
.mds a.mds-link--stand-alone {
  -webkit-text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
          text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
}
.mds a.mds-link--stand-alone:hover, .mds a.mds-link--stand-alone:active {
  -webkit-text-decoration: var(--mds_foundations_link_stand-alone_hover_text-decoration);
          text-decoration: var(--mds_foundations_link_stand-alone_hover_text-decoration);
}
.mds a.mds-link--stand-alone:visited {
  -webkit-text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
          text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
}
.mds a.mds-link--disabled {
  pointer-events: inherit;
  cursor: not-allowed;
}
.mds a.mds-link--disabled:hover {
  -webkit-text-decoration: var(--mds_foundations_link_inline_text-decoration);
          text-decoration: var(--mds_foundations_link_inline_text-decoration);
}
.mds a.mds-link--disabled:hover.mds-link--stand-alone {
  -webkit-text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
          text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);
}
.mds a.mds-link--disabled {
  pointer-events: none;
  touch-action: none;
  opacity: var(--mds_brand_appearance_state_disabled_opacity);
  -webkit-user-select: none;
          user-select: none;
}
.mds a.mds-link--disabled * {
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  touch-action: none;
}
.mds a.mds-link--external {
  display: inline-flex;
}
.mds a.mds-link--external::after {
  content: "";
  text-decoration: none;
  height: var(--mds_foundations_link_external_icon_height);
  width: var(--mds_foundations_link_external_icon_width);
  background-color: var(--mds_foundations_link_default_text-color);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%;
  mask-size: cover;
}
.mds a.mds-link--focus-shadow-inset:focus-visible {
  outline: 0;
  box-shadow: inset var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);
}
.mds a {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  -webkit-text-decoration: var(--mds_foundations_link_inline_text-decoration);
          text-decoration: var(--mds_foundations_link_inline_text-decoration);
  transition-duration: var(--mds_foundations_link_transition-duration);
  transition-property: var(--mds_foundations_link_transition-properties);
  transition-timing-function: var(--mds_foundations_link_transition-timing);
}
.mds a:focus-visible {
  border-radius: var(--mds_foundations_link_focus_border-radius);
  -webkit-text-decoration: var(--mds_foundations_link_inline_hover_text-decoration);
          text-decoration: var(--mds_foundations_link_inline_hover_text-decoration);
  outline: 0;
  box-shadow: var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);
}
.mds a:hover, .mds a:active {
  -webkit-text-decoration: var(--mds_foundations_link_inline_hover_text-decoration);
          text-decoration: var(--mds_foundations_link_inline_hover_text-decoration);
}
.mds a:visited {
  -webkit-text-decoration: var(--mds_foundations_link_inline_text-decoration);
          text-decoration: var(--mds_foundations_link_inline_text-decoration);
}
.mds a {
  color: var(--mds_foundations_link_default_text-color);
}
.mds a:active, .mds a:visited {
  color: var(--mds_foundations_link_default_text-color);
}
.mds a mc-icon::part(icon) {
  fill: var(--mds_foundations_link_default_text-color);
}
.mds mc-button a,
.mds mc-button a:visited,
.mds mc-button-group-item a,
.mds mc-button-group-item a:visited,
.mds mc-link-button a,
.mds mc-link-button a:visited,
.mds mc-list-item a,
.mds mc-list-item a:visited,
.mds mc-pagination a,
.mds mc-pagination a:visited,
.mds mc-segmented-control-item a,
.mds mc-segmented-control-item a:visited,
.mds mc-tab a,
.mds mc-tab a:visited {
  text-decoration: none;
  display: inline-block;
  position: relative;
  z-index: 1;
}
.mds mc-button-group-item a:focus-visible,
.mds mc-list-item a:focus-visible,
.mds mc-pagination a:focus-visible,
.mds mc-segmented-control-item a:focus-visible,
.mds mc-tab a:focus-visible {
  outline: 0;
  box-shadow: inset var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);
}
.mds ul {
  list-style: var(--mds_foundations_list_unordered_list-style);
  display: flex;
  flex-direction: column;
  gap: var(--mds_foundations_list_vertical_item_gap);
  margin: 0;
  padding: 0;
}
.mds ul.mds-list--horizontal {
  flex-direction: row;
  gap: var(--mds_foundations_list_horizontal_item_gap);
  padding: 0;
}
.mds ul li {
  padding: 0;
  margin: 0;
}
.mds ol {
  list-style: var(--mds_foundations_list_ordered_list-style);
  display: flex;
  flex-direction: column;
  gap: var(--mds_foundations_list_vertical_item_gap);
  margin: 0;
  padding: 0;
}
.mds ol.mds-list--horizontal {
  flex-direction: row;
  gap: var(--mds_foundations_list_horizontal_item_gap);
  padding: 0;
}
.mds ol li {
  padding: 0;
  margin: 0;
}
.mds nav ol,
.mds nav ul {
  list-style: none;
}
.mds svg:not([fill]) {
  fill: currentcolor;
}
.mds mc-c-table {
  display: block;
}
.mds .mds-table {
  --row-border-radius: calc(var(--mds_foundations_table_border-radius) - 1px);
  border-radius: var(--mds_foundations_table_border-radius);
  border: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);
  max-width: 100%;
  /** Base cell styles **/
  /** Header cell styles **/
  /** Data cell styles **/
  /** Footer cell styles **/
  /** Cell positioning **/
  /** Large fit **/
  /** Small fit **/
  /** Zebra stripes **/
  /** Highlight on hover **/
  /** Border style variations **/
  /** Wrapping **/
  /** Vertical alignment **/
  /** Row selector **/
  /** Row expander **/
  /** Sortable header **/
  /** Scrollable **/
  /** No header **/
  /** Footer **/
  /** Sticky **/
  /** exapnded row **/
}
.mds .mds-table table {
  border-collapse: collapse;
  border-style: hidden;
  width: 100%;
  border-radius: var(--mds_foundations_table_border-radius);
}
.mds .mds-table th,
.mds .mds-table td {
  padding: var(--mds_foundations_table_medium_cell_padding-top) var(--mds_foundations_table_medium_cell_padding-right) var(--mds_foundations_table_medium_cell_padding-bottom) var(--mds_foundations_table_medium_cell_padding-left);
  text-align: left;
  vertical-align: middle;
  border: 0;
  border-bottom: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);
}
.mds .mds-table th .mds-table__subtext,
.mds .mds-table td .mds-table__subtext {
  color: var(--mds_foundations_table_subtext_text-color);
  display: block;
  font-weight: var(--mds_foundations_table_subtext_font-weight);
}
.mds .mds-table th .mds-table__subtext,
.mds .mds-table td .mds-table__subtext {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table th .mds-table__subtext,
  .mds .mds-table td .mds-table__subtext {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-table th .mds-table__subtext,
.mds .mds-table td .mds-table__subtext {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
.mds .mds-table th {
  background-color: var(--mds_foundations_table_header-cell_background-color);
  color: var(--mds_foundations_table_header-cell_text-color);
}
.mds .mds-table th {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table th {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-table th {
  font-style: var(--mds_brand_typography_text_medium_bold_font-style);
  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);
}
.mds .mds-table td {
  background-color: var(--mds_foundations_table_cell_background-color);
  color: var(--mds_foundations_table_cell_text-color);
}
.mds .mds-table td {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table td {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-table td {
  font-style: var(--mds_brand_typography_text_medium_normal_font-style);
  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);
}
.mds .mds-table tfoot td {
  background-color: var(--mds_foundations_table_cell_background-color);
  color: var(--mds_foundations_table_cell_text-color);
}
.mds .mds-table tfoot td {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table tfoot td {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-table tfoot td {
  font-style: var(--mds_brand_typography_text_medium_bold_font-style);
  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);
}
.mds .mds-table thead tr th,
.mds .mds-table tbody tr td,
.mds .mds-table tbody tr th,
.mds .mds-table tfoot tr td {
  position: relative;
}
.mds .mds-table.mds-table--large th,
.mds .mds-table.mds-table--large td {
  padding: var(--mds_foundations_table_large_cell_padding-top) var(--mds_foundations_table_large_cell_padding-right) var(--mds_foundations_table_large_cell_padding-bottom) var(--mds_foundations_table_large_cell_padding-left);
}
.mds .mds-table.mds-table--large .mds-table__row-selector > mc-checkbox {
  margin-top: 0;
}
.mds .mds-table.mds-table--large .mds-table__row-expander > mc-button {
  margin-top: 0;
}
.mds .mds-table.mds-table--large .mds-table__header-cell--sortable {
  padding-top: var(--mds_foundations_table_large_header-cell_sortable_padding-top);
  padding-bottom: var(--mds_foundations_table_large_header-cell_sortable_padding-bottom);
}
.mds .mds-table.mds-table--large .mds-table__expanded-row.mds-table__expanded-row--no-padding td {
  padding: 0;
}
.mds .mds-table.mds-table--large .mds-table__expanded-row td {
  padding: var(--mds_foundations_table_large_expanded-row_padding-top) var(--mds_foundations_table_large_expanded-row_padding-right) var(--mds_foundations_table_large_expanded-row_padding-bottom) var(--mds_foundations_table_large_expanded-row_padding-left);
}
.mds .mds-table.mds-table--small th {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table.mds-table--small th {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-table.mds-table--small th {
  font-style: var(--mds_brand_typography_text_small_bold_font-style);
  font-weight: var(--mds_brand_typography_text_small_bold_font-weight);
}
.mds .mds-table.mds-table--small td {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table.mds-table--small td {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-table.mds-table--small td {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
.mds .mds-table.mds-table--small th,
.mds .mds-table.mds-table--small td {
  padding: var(--mds_foundations_table_small_cell_padding-top) var(--mds_foundations_table_small_cell_padding-right) var(--mds_foundations_table_small_cell_padding-bottom) var(--mds_foundations_table_small_cell_padding-left);
}
.mds .mds-table.mds-table--small th .mds-table__subtext,
.mds .mds-table.mds-table--small td .mds-table__subtext {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table.mds-table--small th .mds-table__subtext,
  .mds .mds-table.mds-table--small td .mds-table__subtext {
    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);
  }
}
.mds .mds-table.mds-table--small th .mds-table__subtext,
.mds .mds-table.mds-table--small td .mds-table__subtext {
  font-style: var(--mds_brand_typography_text_x-small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_x-small_normal_font-weight);
}
.mds .mds-table.mds-table--small tfoot td {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table.mds-table--small tfoot td {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-table.mds-table--small tfoot td {
  font-style: var(--mds_brand_typography_text_small_bold_font-style);
  font-weight: var(--mds_brand_typography_text_small_bold_font-weight);
}
.mds .mds-table.mds-table--small .mds-table__header-cell--sortable {
  padding-top: var(--mds_foundations_table_small_header-cell_sortable_padding-top);
  padding-bottom: var(--mds_foundations_table_small_header-cell_sortable_padding-bottom);
}
.mds .mds-table.mds-table--small .mds-table__expanded-row.mds-table__expanded-row--no-padding td {
  padding: 0;
}
.mds .mds-table.mds-table--small .mds-table__expanded-row td {
  padding: var(--mds_foundations_table_small_expanded-row_padding-top) var(--mds_foundations_table_small_expanded-row_padding-right) var(--mds_foundations_table_small_expanded-row_padding-bottom) var(--mds_foundations_table_small_expanded-row_padding-left);
}
.mds .mds-table.mds-table--zebra-stripes tbody tr:nth-child(even) td {
  background-color: var(--mds_foundations_table_zebra-stripe_background-color);
  color: var(--mds_foundations_table_zebra-stripe_text-color);
}
.mds .mds-table.mds-table--zebra-stripes:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(even) td {
  background-color: var(--mds_foundations_table_zebra-stripe_background-color);
  color: var(--mds_foundations_table_zebra-stripe_text-color);
}
.mds .mds-table.mds-table--zebra-stripes:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(odd) td {
  background-color: var(--mds_foundations_table_cell_background-color);
  color: var(--mds_foundations_table_cell_text-color);
}
.mds .mds-table.mds-table--zebra-stripes-with-expand {
  /* Use row pairs (main row + expanded row) for zebra striping */
}
.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+1) td,
.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+2) td {
  background-color: var(--mds_foundations_table_cell_background-color);
  color: var(--mds_foundations_table_cell_text-color);
}
.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+3) td,
.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+4) td {
  background-color: var(--mds_foundations_table_zebra-stripe_background-color);
  color: var(--mds_foundations_table_zebra-stripe_text-color);
}
.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) {
  /* Use row pairs (main row + expanded row) for zebra striping */
}
.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+1) td,
.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+2) td {
  background-color: var(--mds_foundations_table_cell_background-color);
  color: var(--mds_foundations_table_cell_text-color);
}
.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+3) td,
.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+4) td {
  background-color: var(--mds_foundations_table_zebra-stripe_background-color);
  color: var(--mds_foundations_table_zebra-stripe_text-color);
}
.mds .mds-table:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(even):hover td, .mds .mds-table:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(odd):hover td {
  background-color: var(--mds_foundations_table_cell_hover_background-color);
  color: var(--mds_foundations_table_cell_hover_text-color);
}
.mds .mds-table thead tr:first-child th:first-child,
.mds .mds-table thead tr:first-child td:first-child {
  border-top-left-radius: calc(var(--mds_foundations_table_border-radius) - 1px);
}
.mds .mds-table thead tr:first-child th:last-child,
.mds .mds-table thead tr:first-child td:last-child {
  border-top-right-radius: calc(var(--mds_foundations_table_border-radius) - 1px);
}
.mds .mds-table tbody:last-child tr:last-child td:first-child,
.mds .mds-table tbody:last-child tr:last-child th:first-child,
.mds .mds-table tfoot tr:last-child td:first-child,
.mds .mds-table tfoot tr:last-child th:first-child {
  border-bottom-left-radius: calc(var(--mds_foundations_table_border-radius) - 1px);
}
.mds .mds-table tbody:last-child tr:last-child td:last-child,
.mds .mds-table tbody:last-child tr:last-child th:last-child,
.mds .mds-table tfoot tr:last-child td:last-child,
.mds .mds-table tfoot tr:last-child th:last-child {
  border-bottom-right-radius: calc(var(--mds_foundations_table_border-radius) - 1px);
}
.mds .mds-table.mds-table--horizontal-lines-dashed th,
.mds .mds-table.mds-table--horizontal-lines-dashed td {
  border-bottom-style: dashed;
}
.mds .mds-table.mds-table--horizontal-lines-dashed thead th,
.mds .mds-table.mds-table--horizontal-lines-dashed thead td {
  border-top-style: dashed;
}
.mds .mds-table.mds-table--horizontal-lines-dotted th,
.mds .mds-table.mds-table--horizontal-lines-dotted td {
  border-bottom-style: dotted;
}
.mds .mds-table.mds-table--horizontal-lines-dotted thead th,
.mds .mds-table.mds-table--horizontal-lines-dotted thead td {
  border-top-style: dotted;
}
.mds .mds-table.mds-table--vertical-lines-solid th,
.mds .mds-table.mds-table--vertical-lines-solid td {
  border-left: var(--mds_foundations_table_border-width) solid var(--mds_foundations_table_border-color);
  border-right: var(--mds_foundations_table_border-width) solid var(--mds_foundations_table_border-color);
}
.mds .mds-table.mds-table--vertical-lines-dashed th,
.mds .mds-table.mds-table--vertical-lines-dashed td {
  border-left: var(--mds_foundations_table_border-width) dashed var(--mds_foundations_table_border-color);
  border-right: var(--mds_foundations_table_border-width) dashed var(--mds_foundations_table_border-color);
}
.mds .mds-table.mds-table--vertical-lines-dotted th,
.mds .mds-table.mds-table--vertical-lines-dotted td {
  border-left: var(--mds_foundations_table_border-width) dotted var(--mds_foundations_table_border-color);
  border-right: var(--mds_foundations_table_border-width) dotted var(--mds_foundations_table_border-color);
}
.mds .mds-table.mds-table--horizontal-lines-none th,
.mds .mds-table.mds-table--horizontal-lines-none td {
  border-top-width: 0;
  border-bottom-width: 0;
}
.mds .mds-table.mds-table--vertical-lines-none th,
.mds .mds-table.mds-table--vertical-lines-none td {
  border-left-width: 0;
  border-right-width: 0;
}
.mds .mds-table.mds-table--outer-border-none {
  border-width: 0;
}
.mds .mds-table.mds-table--outer-border-dashed {
  border-style: dashed;
}
.mds .mds-table.mds-table--outer-border-dotted {
  border-style: dotted;
}
.mds .mds-table.mds-table--outer-border-corners-square {
  border-radius: 0;
}
.mds .mds-table.mds-table--outer-border-corners-square thead tr:first-child th,
.mds .mds-table.mds-table--outer-border-corners-square thead tr:first-child td,
.mds .mds-table.mds-table--outer-border-corners-square tbody:last-child tr:last-child th,
.mds .mds-table.mds-table--outer-border-corners-square tbody:last-child tr:last-child td,
.mds .mds-table.mds-table--outer-border-corners-square tfoot tr:last-child th,
.mds .mds-table.mds-table--outer-border-corners-square tfoot tr:last-child td {
  border-radius: 0;
}
.mds .mds-table table tr th,
.mds .mds-table table tr td {
  border-radius: 0;
}
.mds .mds-table.mds-table--nowrap {
  white-space: nowrap;
}
.mds .mds-table.mds-table--nowrap * {
  white-space: nowrap;
}
.mds .mds-table .mds-table__cell--nowrap {
  white-space: nowrap;
}
.mds .mds-table .mds-table__cell--nowrap * {
  white-space: nowrap;
}
.mds .mds-table.mds-table--vertical-align-top td,
.mds .mds-table.mds-table--vertical-align-top th {
  vertical-align: top;
}
.mds .mds-table.mds-table--vertical-align-baseline td,
.mds .mds-table.mds-table--vertical-align-baseline th {
  vertical-align: baseline;
}
.mds .mds-table.mds-table--vertical-align-bottom td,
.mds .mds-table.mds-table--vertical-align-bottom th {
  vertical-align: bottom;
}
.mds .mds-table .mds-table__column--row-selector {
  width: 1%;
  flex-grow: 0;
  flex-shrink: 0;
}
.mds .mds-table .mds_table__row--selected td {
  background-color: var(--mds_foundations_table_cell_selected_background-color);
  color: var(--mds_foundations_table_cell_selected_text-color);
}
.mds .mds-table .mds-table__column--row-expander {
  width: 1%;
  flex-grow: 0;
  flex-shrink: 0;
}
.mds .mds-table .mds-table__header-cell--sortable {
  cursor: pointer;
  -webkit-user-select: none !important;
          user-select: none !important;
  padding-top: var(--mds_foundations_table_medium_header-cell_sortable_padding-top);
  padding-bottom: var(--mds_foundations_table_medium_header-cell_sortable_padding-bottom);
}
.mds .mds-table .mds-table__header-cell--sortable:hover {
  background-color: var(--mds_foundations_table_header-cell_sort_hover_background-color);
}
.mds .mds-table .mds-table__header-cell--sortable:active {
  background-color: var(--mds_foundations_table_header-cell_sort_active_background-color);
}
.mds .mds-table .mds-table__header-cell--sortable mc-button {
  pointer-events: none;
}
.mds .mds-table .mds-table__header-cell--sortable mc-button::part(button) {
  border-radius: 0;
  padding: 0;
}
.mds .mds-table .mds-table__header-cell--sortable mc-button::part(text-and-icon) {
  font-weight: var(--mds_foundations_table_header-cell_sort-button_font-weight);
}
.mds .mds-table.mds-table--scrollable {
  overflow: auto;
}
.mds .mds-table.mds-table--scrollable thead tr:first-child th:last-child,
.mds .mds-table.mds-table--scrollable thead tr:first-child td:last-child {
  border-top-right-radius: 0;
}
.mds .mds-table.mds-table--scrollable tbody:last-child tr:last-child td:last-child,
.mds .mds-table.mds-table--scrollable tbody:last-child tr:last-child th:last-child,
.mds .mds-table.mds-table--scrollable tfoot tr:last-child td:last-child,
.mds .mds-table.mds-table--scrollable tfoot tr:last-child th:last-child {
  border-bottom-right-radius: 0;
}
.mds .mds-table.mds-table--header-none thead {
  display: none;
}
.mds .mds-table.mds-table--header-none tbody tr:first-child > *:first-child {
  border-top-left-radius: var(--row-border-radius);
}
.mds .mds-table.mds-table--header-none tbody tr:first-child > *:last-child {
  border-top-right-radius: var(--row-border-radius);
}
.mds .mds-table.mds-table--footer tbody tr:last-child > *:first-child {
  border-bottom-left-radius: 0;
}
.mds .mds-table.mds-table--footer tbody tr:last-child > *:last-child {
  border-bottom-right-radius: 0;
}
.mds .mds-table.mds-table--footer tfoot tr:first-child td,
.mds .mds-table.mds-table--footer tfoot tr:first-child th {
  border-top: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);
}
.mds .mds-table .mds-table__column--sticky {
  left: 0;
  position: sticky;
  z-index: 10;
  box-shadow: inset calc(0px - var(--mds_core_table_sticky-column_border-width, 3px)) 0 0 0 var(--mds_foundations_table_border-color);
}
.mds .mds-table.mds-table--header-sticky thead tr th {
  border-bottom: 0;
  box-shadow: inset 0 -1px var(--mds_foundations_table_border-color);
}
.mds .mds-table.mds-table--header-sticky thead th,
.mds .mds-table.mds-table--header-sticky thead td {
  top: 0;
  position: sticky;
  z-index: 11;
}
.mds .mds-table.mds-table--header-sticky thead th.mds-table__column--sticky,
.mds .mds-table.mds-table--header-sticky thead td.mds-table__column--sticky {
  z-index: 12;
}
.mds .mds-table.mds-table--footer-sticky tbody tr:last-child td,
.mds .mds-table.mds-table--footer-sticky tbody tr:last-child th {
  border-bottom: 0;
}
.mds .mds-table.mds-table--footer-sticky tfoot tr:first-child td,
.mds .mds-table.mds-table--footer-sticky tfoot tr:first-child th {
  border-top: 0;
}
.mds .mds-table.mds-table--footer-sticky tfoot tr td,
.mds .mds-table.mds-table--footer-sticky tfoot tr th {
  box-shadow: inset 0 1px var(--mds_foundations_table_border-color);
}
.mds .mds-table.mds-table--footer-sticky tfoot td,
.mds .mds-table.mds-table--footer-sticky tfoot th {
  bottom: 0;
  position: sticky;
  z-index: 11;
}
.mds .mds-table.mds-table--footer-sticky tfoot th.mds-table__column--sticky,
.mds .mds-table.mds-table--footer-sticky tfoot td.mds-table__column--sticky {
  z-index: 12;
}
.mds .mds-table th.mds-table__cell--text-center,
.mds .mds-table td.mds-table__cell--text-center {
  text-align: center;
}
.mds .mds-table th.mds-table__cell--text-right, .mds .mds-table th.mds-table__cell--number,
.mds .mds-table td.mds-table__cell--text-right,
.mds .mds-table td.mds-table__cell--number {
  text-align: right;
}
.mds .mds-table th.mds-table__cell--tabular-figures, .mds .mds-table th.mds-table__cell--number,
.mds .mds-table td.mds-table__cell--tabular-figures,
.mds .mds-table td.mds-table__cell--number {
  font-feature-settings: "tnum";
}
.mds .mds-table th.mds-table__cell--content-top,
.mds .mds-table td.mds-table__cell--content-top {
  vertical-align: top;
}
.mds .mds-table th.mds-table__cell--content-center,
.mds .mds-table td.mds-table__cell--content-center {
  vertical-align: middle;
}
.mds .mds-table th.mds-table__cell--content-bottom,
.mds .mds-table td.mds-table__cell--content-bottom {
  vertical-align: bottom;
}
.mds .mds-table .mds-table__expanded-row--hidden {
  display: none;
}
.mds .mds-table .mds-table__expanded-row--visible {
  display: table-row;
}
.mds .mds-table .mds-table__expanded-row--visible:last-of-type {
  border-top: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);
}
.mds .mds-table.mds-table--medium .mds-table__expanded-row.mds-table__expanded-row--no-padding td {
  padding: 0;
}
.mds .mds-table.mds-table--medium .mds-table__expanded-row td {
  padding: var(--mds_foundations_table_medium_expanded-row_padding-top) var(--mds_foundations_table_medium_expanded-row_padding-right) var(--mds_foundations_table_medium_expanded-row_padding-bottom) var(--mds_foundations_table_medium_expanded-row_padding-left);
}
.mds .mds-table .mds-table__expanded-row__trigger::part(button) {
  margin: 0;
  width: auto;
}
.mds .mds-table .mds-table__expanded-row__trigger::part(button):hover {
  background-color: transparent;
}
.mds .mds-table .mds-table__expanded-row__trigger::part(icon) {
  transition: transform var(--mds_foundations_table_row-expander-trigger_transition-duration) ease-in-out;
}
.mds .mds-table .mds-table__expanded-row__trigger--expanded::part(icon) {
  transform: rotate(-180deg);
}
.mds .mds-table-and-caption {
  margin: var(--mds_foundations_table_margin-top) 0 var(--mds_foundations_table_margin-top);
}
.mds .mds-table-and-caption .mds-table {
  margin: 0;
}
.mds .mds-table-caption {
  color: var(--mds_foundations_table_caption_text-color);
  margin-bottom: var(--mds_foundations_table_medium_caption_margin-bottom);
}
.mds .mds-table-caption.mds-table-caption--small {
  margin-bottom: var(--mds_foundations_table_small_caption_margin-bottom);
}
.mds .mds-table-caption.mds-table-caption--small {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_small_mobile_font-size);
  line-height: var(--mds_brand_typography_text_small_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table-caption.mds-table-caption--small {
    font-size: var(--mds_brand_typography_text_small_desktop_font-size);
    line-height: var(--mds_brand_typography_text_small_desktop_line-height);
  }
}
.mds .mds-table-caption.mds-table-caption--small {
  font-style: var(--mds_brand_typography_text_small_normal_font-style);
  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);
}
.mds .mds-table-caption.mds-table-caption--large {
  margin-bottom: var(--mds_foundations_table_large_caption_margin-bottom);
}
.mds .mds-table-caption {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);
  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);
  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);
}
@media screen and (min-width: 1025px) {
  .mds .mds-table-caption {
    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);
    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);
  }
}
.mds .mds-table-caption {
  font-style: var(--mds_brand_typography_text_medium_normal_font-style);
  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);
}
@container (max-width: 640px) {
  .mds .mds-xs-gap-50,
  .mds .mds-container .mds-xs-gap-50,
  .mds .mds-viewport .mds-xs-gap-50 {
    gap: 2px;
  }
  .mds .mds-xs-col-gap-50,
  .mds .mds-container .mds-xs-col-gap-50,
  .mds .mds-viewport .mds-xs-col-gap-50 {
    column-gap: 2px;
  }
  .mds .mds-xs-row-gap-50,
  .mds .mds-container .mds-xs-row-gap-50,
  .mds .mds-viewport .mds-xs-row-gap-50 {
    row-gap: 2px;
  }
  .mds .mds-xs-gap-100,
  .mds .mds-container .mds-xs-gap-100,
  .mds .mds-viewport .mds-xs-gap-100 {
    gap: 4px;
  }
  .mds .mds-xs-col-gap-100,
  .mds .mds-container .mds-xs-col-gap-100,
  .mds .mds-viewport .mds-xs-col-gap-100 {
    column-gap: 4px;
  }
  .mds .mds-xs-row-gap-100,
  .mds .mds-container .mds-xs-row-gap-100,
  .mds .mds-viewport .mds-xs-row-gap-100 {
    row-gap: 4px;
  }
  .mds .mds-xs-gap-150,
  .mds .mds-container .mds-xs-gap-150,
  .mds .mds-viewport .mds-xs-gap-150 {
    gap: 6px;
  }
  .mds .mds-xs-col-gap-150,
  .mds .mds-container .mds-xs-col-gap-150,
  .mds .mds-viewport .mds-xs-col-gap-150 {
    column-gap: 6px;
  }
  .mds .mds-xs-row-gap-150,
  .mds .mds-container .mds-xs-row-gap-150,
  .mds .mds-viewport .mds-xs-row-gap-150 {
    row-gap: 6px;
  }
  .mds .mds-xs-gap-200,
  .mds .mds-container .mds-xs-gap-200,
  .mds .mds-viewport .mds-xs-gap-200 {
    gap: 8px;
  }
  .mds .mds-xs-col-gap-200,
  .mds .mds-container .mds-xs-col-gap-200,
  .mds .mds-viewport .mds-xs-col-gap-200 {
    column-gap: 8px;
  }
  .mds .mds-xs-row-gap-200,
  .mds .mds-container .mds-xs-row-gap-200,
  .mds .mds-viewport .mds-xs-row-gap-200 {
    row-gap: 8px;
  }
  .mds .mds-xs-gap-300,
  .mds .mds-container .mds-xs-gap-300,
  .mds .mds-viewport .mds-xs-gap-300 {
    gap: 12px;
  }
  .mds .mds-xs-col-gap-300,
  .mds .mds-container .mds-xs-col-gap-300,
  .mds .mds-viewport .mds-xs-col-gap-300 {
    column-gap: 12px;
  }
  .mds .mds-xs-row-gap-300,
  .mds .mds-container .mds-xs-row-gap-300,
  .mds .mds-viewport .mds-xs-row-gap-300 {
    row-gap: 12px;
  }
  .mds .mds-xs-gap-400,
  .mds .mds-container .mds-xs-gap-400,
  .mds .mds-viewport .mds-xs-gap-400 {
    gap: 16px;
  }
  .mds .mds-xs-col-gap-400,
  .mds .mds-container .mds-xs-col-gap-400,
  .mds .mds-viewport .mds-xs-col-gap-400 {
    column-gap: 16px;
  }
  .mds .mds-xs-row-gap-400,
  .mds .mds-container .mds-xs-row-gap-400,
  .mds .mds-viewport .mds-xs-row-gap-400 {
    row-gap: 16px;
  }
  .mds .mds-xs-gap-500,
  .mds .mds-container .mds-xs-gap-500,
  .mds .mds-viewport .mds-xs-gap-500 {
    gap: 20px;
  }
  .mds .mds-xs-col-gap-500,
  .mds .mds-container .mds-xs-col-gap-500,
  .mds .mds-viewport .mds-xs-col-gap-500 {
    column-gap: 20px;
  }
  .mds .mds-xs-row-gap-500,
  .mds .mds-container .mds-xs-row-gap-500,
  .mds .mds-viewport .mds-xs-row-gap-500 {
    row-gap: 20px;
  }
  .mds .mds-xs-gap-600,
  .mds .mds-container .mds-xs-gap-600,
  .mds .mds-viewport .mds-xs-gap-600 {
    gap: 24px;
  }
  .mds .mds-xs-col-gap-600,
  .mds .mds-container .mds-xs-col-gap-600,
  .mds .mds-viewport .mds-xs-col-gap-600 {
    column-gap: 24px;
  }
  .mds .mds-xs-row-gap-600,
  .mds .mds-container .mds-xs-row-gap-600,
  .mds .mds-viewport .mds-xs-row-gap-600 {
    row-gap: 24px;
  }
  .mds .mds-xs-gap-700,
  .mds .mds-container .mds-xs-gap-700,
  .mds .mds-viewport .mds-xs-gap-700 {
    gap: 28px;
  }
  .mds .mds-xs-col-gap-700,
  .mds .mds-container .mds-xs-col-gap-700,
  .mds .mds-viewport .mds-xs-col-gap-700 {
    column-gap: 28px;
  }
  .mds .mds-xs-row-gap-700,
  .mds .mds-container .mds-xs-row-gap-700,
  .mds .mds-viewport .mds-xs-row-gap-700 {
    row-gap: 28px;
  }
  .mds .mds-xs-gap-800,
  .mds .mds-container .mds-xs-gap-800,
  .mds .mds-viewport .mds-xs-gap-800 {
    gap: 32px;
  }
  .mds .mds-xs-col-gap-800,
  .mds .mds-container .mds-xs-col-gap-800,
  .mds .mds-viewport .mds-xs-col-gap-800 {
    column-gap: 32px;
  }
  .mds .mds-xs-row-gap-800,
  .mds .mds-container .mds-xs-row-gap-800,
  .mds .mds-viewport .mds-xs-row-gap-800 {
    row-gap: 32px;
  }
  .mds .mds-xs-gap-900,
  .mds .mds-container .mds-xs-gap-900,
  .mds .mds-viewport .mds-xs-gap-900 {
    gap: 36px;
  }
  .mds .mds-xs-col-gap-900,
  .mds .mds-container .mds-xs-col-gap-900,
  .mds .mds-viewport .mds-xs-col-gap-900 {
    column-gap: 36px;
  }
  .mds .mds-xs-row-gap-900,
  .mds .mds-container .mds-xs-row-gap-900,
  .mds .mds-viewport .mds-xs-row-gap-900 {
    row-gap: 36px;
  }
  .mds .mds-xs-gap-1000,
  .mds .mds-container .mds-xs-gap-1000,
  .mds .mds-viewport .mds-xs-gap-1000 {
    gap: 40px;
  }
  .mds .mds-xs-col-gap-1000,
  .mds .mds-container .mds-xs-col-gap-1000,
  .mds .mds-viewport .mds-xs-col-gap-1000 {
    column-gap: 40px;
  }
  .mds .mds-xs-row-gap-1000,
  .mds .mds-container .mds-xs-row-gap-1000,
  .mds .mds-viewport .mds-xs-row-gap-1000 {
    row-gap: 40px;
  }
  .mds .mds-xs-gap-1200,
  .mds .mds-container .mds-xs-gap-1200,
  .mds .mds-viewport .mds-xs-gap-1200 {
    gap: 48px;
  }
  .mds .mds-xs-col-gap-1200,
  .mds .mds-container .mds-xs-col-gap-1200,
  .mds .mds-viewport .mds-xs-col-gap-1200 {
    column-gap: 48px;
  }
  .mds .mds-xs-row-gap-1200,
  .mds .mds-container .mds-xs-row-gap-1200,
  .mds .mds-viewport .mds-xs-row-gap-1200 {
    row-gap: 48px;
  }
  .mds .mds-xs-gap-1600,
  .mds .mds-container .mds-xs-gap-1600,
  .mds .mds-viewport .mds-xs-gap-1600 {
    gap: 64px;
  }
  .mds .mds-xs-col-gap-1600,
  .mds .mds-container .mds-xs-col-gap-1600,
  .mds .mds-viewport .mds-xs-col-gap-1600 {
    column-gap: 64px;
  }
  .mds .mds-xs-row-gap-1600,
  .mds .mds-container .mds-xs-row-gap-1600,
  .mds .mds-viewport .mds-xs-row-gap-1600 {
    row-gap: 64px;
  }
  .mds .mds-xs-gap-2000,
  .mds .mds-container .mds-xs-gap-2000,
  .mds .mds-viewport .mds-xs-gap-2000 {
    gap: 80px;
  }
  .mds .mds-xs-col-gap-2000,
  .mds .mds-container .mds-xs-col-gap-2000,
  .mds .mds-viewport .mds-xs-col-gap-2000 {
    column-gap: 80px;
  }
  .mds .mds-xs-row-gap-2000,
  .mds .mds-container .mds-xs-row-gap-2000,
  .mds .mds-viewport .mds-xs-row-gap-2000 {
    row-gap: 80px;
  }
  .mds .mds-xs-gap-2400,
  .mds .mds-container .mds-xs-gap-2400,
  .mds .mds-viewport .mds-xs-gap-2400 {
    gap: 96px;
  }
  .mds .mds-xs-col-gap-2400,
  .mds .mds-container .mds-xs-col-gap-2400,
  .mds .mds-viewport .mds-xs-col-gap-2400 {
    column-gap: 96px;
  }
  .mds .mds-xs-row-gap-2400,
  .mds .mds-container .mds-xs-row-gap-2400,
  .mds .mds-viewport .mds-xs-row-gap-2400 {
    row-gap: 96px;
  }
  .mds .mds-xs-gap-2800,
  .mds .mds-container .mds-xs-gap-2800,
  .mds .mds-viewport .mds-xs-gap-2800 {
    gap: 112px;
  }
  .mds .mds-xs-col-gap-2800,
  .mds .mds-container .mds-xs-col-gap-2800,
  .mds .mds-viewport .mds-xs-col-gap-2800 {
    column-gap: 112px;
  }
  .mds .mds-xs-row-gap-2800,
  .mds .mds-container .mds-xs-row-gap-2800,
  .mds .mds-viewport .mds-xs-row-gap-2800 {
    row-gap: 112px;
  }
  .mds .mds-xs-gap-3200,
  .mds .mds-container .mds-xs-gap-3200,
  .mds .mds-viewport .mds-xs-gap-3200 {
    gap: 128px;
  }
  .mds .mds-xs-col-gap-3200,
  .mds .mds-container .mds-xs-col-gap-3200,
  .mds .mds-viewport .mds-xs-col-gap-3200 {
    column-gap: 128px;
  }
  .mds .mds-xs-row-gap-3200,
  .mds .mds-container .mds-xs-row-gap-3200,
  .mds .mds-viewport .mds-xs-row-gap-3200 {
    row-gap: 128px;
  }
}
@container (min-width: 641px) {
  .mds .mds-sm-gap-50,
  .mds .mds-container .mds-sm-gap-50,
  .mds .mds-viewport .mds-sm-gap-50 {
    gap: 2px;
  }
  .mds .mds-sm-col-gap-50,
  .mds .mds-container .mds-sm-col-gap-50,
  .mds .mds-viewport .mds-sm-col-gap-50 {
    column-gap: 2px;
  }
  .mds .mds-sm-row-gap-50,
  .mds .mds-container .mds-sm-row-gap-50,
  .mds .mds-viewport .mds-sm-row-gap-50 {
    row-gap: 2px;
  }
  .mds .mds-sm-gap-100,
  .mds .mds-container .mds-sm-gap-100,
  .mds .mds-viewport .mds-sm-gap-100 {
    gap: 4px;
  }
  .mds .mds-sm-col-gap-100,
  .mds .mds-container .mds-sm-col-gap-100,
  .mds .mds-viewport .mds-sm-col-gap-100 {
    column-gap: 4px;
  }
  .mds .mds-sm-row-gap-100,
  .mds .mds-container .mds-sm-row-gap-100,
  .mds .mds-viewport .mds-sm-row-gap-100 {
    row-gap: 4px;
  }
  .mds .mds-sm-gap-150,
  .mds .mds-container .mds-sm-gap-150,
  .mds .mds-viewport .mds-sm-gap-150 {
    gap: 6px;
  }
  .mds .mds-sm-col-gap-150,
  .mds .mds-container .mds-sm-col-gap-150,
  .mds .mds-viewport .mds-sm-col-gap-150 {
    column-gap: 6px;
  }
  .mds .mds-sm-row-gap-150,
  .mds .mds-container .mds-sm-row-gap-150,
  .mds .mds-viewport .mds-sm-row-gap-150 {
    row-gap: 6px;
  }
  .mds .mds-sm-gap-200,
  .mds .mds-container .mds-sm-gap-200,
  .mds .mds-viewport .mds-sm-gap-200 {
    gap: 8px;
  }
  .mds .mds-sm-col-gap-200,
  .mds .mds-container .mds-sm-col-gap-200,
  .mds .mds-viewport .mds-sm-col-gap-200 {
    column-gap: 8px;
  }
  .mds .mds-sm-row-gap-200,
  .mds .mds-container .mds-sm-row-gap-200,
  .mds .mds-viewport .mds-sm-row-gap-200 {
    row-gap: 8px;
  }
  .mds .mds-sm-gap-300,
  .mds .mds-container .mds-sm-gap-300,
  .mds .mds-viewport .mds-sm-gap-300 {
    gap: 12px;
  }
  .mds .mds-sm-col-gap-300,
  .mds .mds-container .mds-sm-col-gap-300,
  .mds .mds-viewport .mds-sm-col-gap-300 {
    column-gap: 12px;
  }
  .mds .mds-sm-row-gap-300,
  .mds .mds-container .mds-sm-row-gap-300,
  .mds .mds-viewport .mds-sm-row-gap-300 {
    row-gap: 12px;
  }
  .mds .mds-sm-gap-400,
  .mds .mds-container .mds-sm-gap-400,
  .mds .mds-viewport .mds-sm-gap-400 {
    gap: 16px;
  }
  .mds .mds-sm-col-gap-400,
  .mds .mds-container .mds-sm-col-gap-400,
  .mds .mds-viewport .mds-sm-col-gap-400 {
    column-gap: 16px;
  }
  .mds .mds-sm-row-gap-400,
  .mds .mds-container .mds-sm-row-gap-400,
  .mds .mds-viewport .mds-sm-row-gap-400 {
    row-gap: 16px;
  }
  .mds .mds-sm-gap-500,
  .mds .mds-container .mds-sm-gap-500,
  .mds .mds-viewport .mds-sm-gap-500 {
    gap: 20px;
  }
  .mds .mds-sm-col-gap-500,
  .mds .mds-container .mds-sm-col-gap-500,
  .mds .mds-viewport .mds-sm-col-gap-500 {
    column-gap: 20px;
  }
  .mds .mds-sm-row-gap-500,
  .mds .mds-container .mds-sm-row-gap-500,
  .mds .mds-viewport .mds-sm-row-gap-500 {
    row-gap: 20px;
  }
  .mds .mds-sm-gap-600,
  .mds .mds-container .mds-sm-gap-600,
  .mds .mds-viewport .mds-sm-gap-600 {
    gap: 24px;
  }
  .mds .mds-sm-col-gap-600,
  .mds .mds-container .mds-sm-col-gap-600,
  .mds .mds-viewport .mds-sm-col-gap-600 {
    column-gap: 24px;
  }
  .mds .mds-sm-row-gap-600,
  .mds .mds-container .mds-sm-row-gap-600,
  .mds .mds-viewport .mds-sm-row-gap-600 {
    row-gap: 24px;
  }
  .mds .mds-sm-gap-700,
  .mds .mds-container .mds-sm-gap-700,
  .mds .mds-viewport .mds-sm-gap-700 {
    gap: 28px;
  }
  .mds .mds-sm-col-gap-700,
  .mds .mds-container .mds-sm-col-gap-700,
  .mds .mds-viewport .mds-sm-col-gap-700 {
    column-gap: 28px;
  }
  .mds .mds-sm-row-gap-700,
  .mds .mds-container .mds-sm-row-gap-700,
  .mds .mds-viewport .mds-sm-row-gap-700 {
    row-gap: 28px;
  }
  .mds .mds-sm-gap-800,
  .mds .mds-container .mds-sm-gap-800,
  .mds .mds-viewport .mds-sm-gap-800 {
    gap: 32px;
  }
  .mds .mds-sm-col-gap-800,
  .mds .mds-container .mds-sm-col-gap-800,
  .mds .mds-viewport .mds-sm-col-gap-800 {
    column-gap: 32px;
  }
  .mds .mds-sm-row-gap-800,
  .mds .mds-container .mds-sm-row-gap-800,
  .mds .mds-viewport .mds-sm-row-gap-800 {
    row-gap: 32px;
  }
  .mds .mds-sm-gap-900,
  .mds .mds-container .mds-sm-gap-900,
  .mds .mds-viewport .mds-sm-gap-900 {
    gap: 36px;
  }
  .mds .mds-sm-col-gap-900,
  .mds .mds-container .mds-sm-col-gap-900,
  .mds .mds-viewport .mds-sm-col-gap-900 {
    column-gap: 36px;
  }
  .mds .mds-sm-row-gap-900,
  .mds .mds-container .mds-sm-row-gap-900,
  .mds .mds-viewport .mds-sm-row-gap-900 {
    row-gap: 36px;
  }
  .mds .mds-sm-gap-1000,
  .mds .mds-container .mds-sm-gap-1000,
  .mds .mds-viewport .mds-sm-gap-1000 {
    gap: 40px;
  }
  .mds .mds-sm-col-gap-1000,
  .mds .mds-container .mds-sm-col-gap-1000,
  .mds .mds-viewport .mds-sm-col-gap-1000 {
    column-gap: 40px;
  }
  .mds .mds-sm-row-gap-1000,
  .mds .mds-container .mds-sm-row-gap-1000,
  .mds .mds-viewport .mds-sm-row-gap-1000 {
    row-gap: 40px;
  }
  .mds .mds-sm-gap-1200,
  .mds .mds-container .mds-sm-gap-1200,
  .mds .mds-viewport .mds-sm-gap-1200 {
    gap: 48px;
  }
  .mds .mds-sm-col-gap-1200,
  .mds .mds-container .mds-sm-col-gap-1200,
  .mds .mds-viewport .mds-sm-col-gap-1200 {
    column-gap: 48px;
  }
  .mds .mds-sm-row-gap-1200,
  .mds .mds-container .mds-sm-row-gap-1200,
  .mds .mds-viewport .mds-sm-row-gap-1200 {
    row-gap: 48px;
  }
  .mds .mds-sm-gap-1600,
  .mds .mds-container .mds-sm-gap-1600,
  .mds .mds-viewport .mds-sm-gap-1600 {
    gap: 64px;
  }
  .mds .mds-sm-col-gap-1600,
  .mds .mds-container .mds-sm-col-gap-1600,
  .mds .mds-viewport .mds-sm-col-gap-1600 {
    column-gap: 64px;
  }
  .mds .mds-sm-row-gap-1600,
  .mds .mds-container .mds-sm-row-gap-1600,
  .mds .mds-viewport .mds-sm-row-gap-1600 {
    row-gap: 64px;
  }
  .mds .mds-sm-gap-2000,
  .mds .mds-container .mds-sm-gap-2000,
  .mds .mds-viewport .mds-sm-gap-2000 {
    gap: 80px;
  }
  .mds .mds-sm-col-gap-2000,
  .mds .mds-container .mds-sm-col-gap-2000,
  .mds .mds-viewport .mds-sm-col-gap-2000 {
    column-gap: 80px;
  }
  .mds .mds-sm-row-gap-2000,
  .mds .mds-container .mds-sm-row-gap-2000,
  .mds .mds-viewport .mds-sm-row-gap-2000 {
    row-gap: 80px;
  }
  .mds .mds-sm-gap-2400,
  .mds .mds-container .mds-sm-gap-2400,
  .mds .mds-viewport .mds-sm-gap-2400 {
    gap: 96px;
  }
  .mds .mds-sm-col-gap-2400,
  .mds .mds-container .mds-sm-col-gap-2400,
  .mds .mds-viewport .mds-sm-col-gap-2400 {
    column-gap: 96px;
  }
  .mds .mds-sm-row-gap-2400,
  .mds .mds-container .mds-sm-row-gap-2400,
  .mds .mds-viewport .mds-sm-row-gap-2400 {
    row-gap: 96px;
  }
  .mds .mds-sm-gap-2800,
  .mds .mds-container .mds-sm-gap-2800,
  .mds .mds-viewport .mds-sm-gap-2800 {
    gap: 112px;
  }
  .mds .mds-sm-col-gap-2800,
  .mds .mds-container .mds-sm-col-gap-2800,
  .mds .mds-viewport .mds-sm-col-gap-2800 {
    column-gap: 112px;
  }
  .mds .mds-sm-row-gap-2800,
  .mds .mds-container .mds-sm-row-gap-2800,
  .mds .mds-viewport .mds-sm-row-gap-2800 {
    row-gap: 112px;
  }
  .mds .mds-sm-gap-3200,
  .mds .mds-container .mds-sm-gap-3200,
  .mds .mds-viewport .mds-sm-gap-3200 {
    gap: 128px;
  }
  .mds .mds-sm-col-gap-3200,
  .mds .mds-container .mds-sm-col-gap-3200,
  .mds .mds-viewport .mds-sm-col-gap-3200 {
    column-gap: 128px;
  }
  .mds .mds-sm-row-gap-3200,
  .mds .mds-container .mds-sm-row-gap-3200,
  .mds .mds-viewport .mds-sm-row-gap-3200 {
    row-gap: 128px;
  }
}
@container (min-width: 1025px) {
  .mds .mds-md-gap-50,
  .mds .mds-container .mds-md-gap-50,
  .mds .mds-viewport .mds-md-gap-50 {
    gap: 2px;
  }
  .mds .mds-md-col-gap-50,
  .mds .mds-container .mds-md-col-gap-50,
  .mds .mds-viewport .mds-md-col-gap-50 {
    column-gap: 2px;
  }
  .mds .mds-md-row-gap-50,
  .mds .mds-container .mds-md-row-gap-50,
  .mds .mds-viewport .mds-md-row-gap-50 {
    row-gap: 2px;
  }
  .mds .mds-md-gap-100,
  .mds .mds-container .mds-md-gap-100,
  .mds .mds-viewport .mds-md-gap-100 {
    gap: 4px;
  }
  .mds .mds-md-col-gap-100,
  .mds .mds-container .mds-md-col-gap-100,
  .mds .mds-viewport .mds-md-col-gap-100 {
    column-gap: 4px;
  }
  .mds .mds-md-row-gap-100,
  .mds .mds-container .mds-md-row-gap-100,
  .mds .mds-viewport .mds-md-row-gap-100 {
    row-gap: 4px;
  }
  .mds .mds-md-gap-150,
  .mds .mds-container .mds-md-gap-150,
  .mds .mds-viewport .mds-md-gap-150 {
    gap: 6px;
  }
  .mds .mds-md-col-gap-150,
  .mds .mds-container .mds-md-col-gap-150,
  .mds .mds-viewport .mds-md-col-gap-150 {
    column-gap: 6px;
  }
  .mds .mds-md-row-gap-150,
  .mds .mds-container .mds-md-row-gap-150,
  .mds .mds-viewport .mds-md-row-gap-150 {
    row-gap: 6px;
  }
  .mds .mds-md-gap-200,
  .mds .mds-container .mds-md-gap-200,
  .mds .mds-viewport .mds-md-gap-200 {
    gap: 8px;
  }
  .mds .mds-md-col-gap-200,
  .mds .mds-container .mds-md-col-gap-200,
  .mds .mds-viewport .mds-md-col-gap-200 {
    column-gap: 8px;
  }
  .mds .mds-md-row-gap-200,
  .mds .mds-container .mds-md-row-gap-200,
  .mds .mds-viewport .mds-md-row-gap-200 {
    row-gap: 8px;
  }
  .mds .mds-md-gap-300,
  .mds .mds-container .mds-md-gap-300,
  .mds .mds-viewport .mds-md-gap-300 {
    gap: 12px;
  }
  .mds .mds-md-col-gap-300,
  .mds .mds-container .mds-md-col-gap-300,
  .mds .mds-viewport .mds-md-col-gap-300 {
    column-gap: 12px;
  }
  .mds .mds-md-row-gap-300,
  .mds .mds-container .mds-md-row-gap-300,
  .mds .mds-viewport .mds-md-row-gap-300 {
    row-gap: 12px;
  }
  .mds .mds-md-gap-400,
  .mds .mds-container .mds-md-gap-400,
  .mds .mds-viewport .mds-md-gap-400 {
    gap: 16px;
  }
  .mds .mds-md-col-gap-400,
  .mds .mds-container .mds-md-col-gap-400,
  .mds .mds-viewport .mds-md-col-gap-400 {
    column-gap: 16px;
  }
  .mds .mds-md-row-gap-400,
  .mds .mds-container .mds-md-row-gap-400,
  .mds .mds-viewport .mds-md-row-gap-400 {
    row-gap: 16px;
  }
  .mds .mds-md-gap-500,
  .mds .mds-container .mds-md-gap-500,
  .mds .mds-viewport .mds-md-gap-500 {
    gap: 20px;
  }
  .mds .mds-md-col-gap-500,
  .mds .mds-container .mds-md-col-gap-500,
  .mds .mds-viewport .mds-md-col-gap-500 {
    column-gap: 20px;
  }
  .mds .mds-md-row-gap-500,
  .mds .mds-container .mds-md-row-gap-500,
  .mds .mds-viewport .mds-md-row-gap-500 {
    row-gap: 20px;
  }
  .mds .mds-md-gap-600,
  .mds .mds-container .mds-md-gap-600,
  .mds .mds-viewport .mds-md-gap-600 {
    gap: 24px;
  }
  .mds .mds-md-col-gap-600,
  .mds .mds-container .mds-md-col-gap-600,
  .mds .mds-viewport .mds-md-col-gap-600 {
    column-gap: 24px;
  }
  .mds .mds-md-row-gap-600,
  .mds .mds-container .mds-md-row-gap-600,
  .mds .mds-viewport .mds-md-row-gap-600 {
    row-gap: 24px;
  }
  .mds .mds-md-gap-700,
  .mds .mds-container .mds-md-gap-700,
  .mds .mds-viewport .mds-md-gap-700 {
    gap: 28px;
  }
  .mds .mds-md-col-gap-700,
  .mds .mds-container .mds-md-col-gap-700,
  .mds .mds-viewport .mds-md-col-gap-700 {
    column-gap: 28px;
  }
  .mds .mds-md-row-gap-700,
  .mds .mds-container .mds-md-row-gap-700,
  .mds .mds-viewport .mds-md-row-gap-700 {
    row-gap: 28px;
  }
  .mds .mds-md-gap-800,
  .mds .mds-container .mds-md-gap-800,
  .mds .mds-viewport .mds-md-gap-800 {
    gap: 32px;
  }
  .mds .mds-md-col-gap-800,
  .mds .mds-container .mds-md-col-gap-800,
  .mds .mds-viewport .mds-md-col-gap-800 {
    column-gap: 32px;
  }
  .mds .mds-md-row-gap-800,
  .mds .mds-container .mds-md-row-gap-800,
  .mds .mds-viewport .mds-md-row-gap-800 {
    row-gap: 32px;
  }
  .mds .mds-md-gap-900,
  .mds .mds-container .mds-md-gap-900,
  .mds .mds-viewport .mds-md-gap-900 {
    gap: 36px;
  }
  .mds .mds-md-col-gap-900,
  .mds .mds-container .mds-md-col-gap-900,
  .mds .mds-viewport .mds-md-col-gap-900 {
    column-gap: 36px;
  }
  .mds .mds-md-row-gap-900,
  .mds .mds-container .mds-md-row-gap-900,
  .mds .mds-viewport .mds-md-row-gap-900 {
    row-gap: 36px;
  }
  .mds .mds-md-gap-1000,
  .mds .mds-container .mds-md-gap-1000,
  .mds .mds-viewport .mds-md-gap-1000 {
    gap: 40px;
  }
  .mds .mds-md-col-gap-1000,
  .mds .mds-container .mds-md-col-gap-1000,
  .mds .mds-viewport .mds-md-col-gap-1000 {
    column-gap: 40px;
  }
  .mds .mds-md-row-gap-1000,
  .mds .mds-container .mds-md-row-gap-1000,
  .mds .mds-viewport .mds-md-row-gap-1000 {
    row-gap: 40px;
  }
  .mds .mds-md-gap-1200,
  .mds .mds-container .mds-md-gap-1200,
  .mds .mds-viewport .mds-md-gap-1200 {
    gap: 48px;
  }
  .mds .mds-md-col-gap-1200,
  .mds .mds-container .mds-md-col-gap-1200,
  .mds .mds-viewport .mds-md-col-gap-1200 {
    column-gap: 48px;
  }
  .mds .mds-md-row-gap-1200,
  .mds .mds-container .mds-md-row-gap-1200,
  .mds .mds-viewport .mds-md-row-gap-1200 {
    row-gap: 48px;
  }
  .mds .mds-md-gap-1600,
  .mds .mds-container .mds-md-gap-1600,
  .mds .mds-viewport .mds-md-gap-1600 {
    gap: 64px;
  }
  .mds .mds-md-col-gap-1600,
  .mds .mds-container .mds-md-col-gap-1600,
  .mds .mds-viewport .mds-md-col-gap-1600 {
    column-gap: 64px;
  }
  .mds .mds-md-row-gap-1600,
  .mds .mds-container .mds-md-row-gap-1600,
  .mds .mds-viewport .mds-md-row-gap-1600 {
    row-gap: 64px;
  }
  .mds .mds-md-gap-2000,
  .mds .mds-container .mds-md-gap-2000,
  .mds .mds-viewport .mds-md-gap-2000 {
    gap: 80px;
  }
  .mds .mds-md-col-gap-2000,
  .mds .mds-container .mds-md-col-gap-2000,
  .mds .mds-viewport .mds-md-col-gap-2000 {
    column-gap: 80px;
  }
  .mds .mds-md-row-gap-2000,
  .mds .mds-container .mds-md-row-gap-2000,
  .mds .mds-viewport .mds-md-row-gap-2000 {
    row-gap: 80px;
  }
  .mds .mds-md-gap-2400,
  .mds .mds-container .mds-md-gap-2400,
  .mds .mds-viewport .mds-md-gap-2400 {
    gap: 96px;
  }
  .mds .mds-md-col-gap-2400,
  .mds .mds-container .mds-md-col-gap-2400,
  .mds .mds-viewport .mds-md-col-gap-2400 {
    column-gap: 96px;
  }
  .mds .mds-md-row-gap-2400,
  .mds .mds-container .mds-md-row-gap-2400,
  .mds .mds-viewport .mds-md-row-gap-2400 {
    row-gap: 96px;
  }
  .mds .mds-md-gap-2800,
  .mds .mds-container .mds-md-gap-2800,
  .mds .mds-viewport .mds-md-gap-2800 {
    gap: 112px;
  }
  .mds .mds-md-col-gap-2800,
  .mds .mds-container .mds-md-col-gap-2800,
  .mds .mds-viewport .mds-md-col-gap-2800 {
    column-gap: 112px;
  }
  .mds .mds-md-row-gap-2800,
  .mds .mds-container .mds-md-row-gap-2800,
  .mds .mds-viewport .mds-md-row-gap-2800 {
    row-gap: 112px;
  }
  .mds .mds-md-gap-3200,
  .mds .mds-container .mds-md-gap-3200,
  .mds .mds-viewport .mds-md-gap-3200 {
    gap: 128px;
  }
  .mds .mds-md-col-gap-3200,
  .mds .mds-container .mds-md-col-gap-3200,
  .mds .mds-viewport .mds-md-col-gap-3200 {
    column-gap: 128px;
  }
  .mds .mds-md-row-gap-3200,
  .mds .mds-container .mds-md-row-gap-3200,
  .mds .mds-viewport .mds-md-row-gap-3200 {
    row-gap: 128px;
  }
}
@container (min-width: 1441px) {
  .mds .mds-lg-gap-50,
  .mds .mds-container .mds-lg-gap-50,
  .mds .mds-viewport .mds-lg-gap-50 {
    gap: 2px;
  }
  .mds .mds-lg-col-gap-50,
  .mds .mds-container .mds-lg-col-gap-50,
  .mds .mds-viewport .mds-lg-col-gap-50 {
    column-gap: 2px;
  }
  .mds .mds-lg-row-gap-50,
  .mds .mds-container .mds-lg-row-gap-50,
  .mds .mds-viewport .mds-lg-row-gap-50 {
    row-gap: 2px;
  }
  .mds .mds-lg-gap-100,
  .mds .mds-container .mds-lg-gap-100,
  .mds .mds-viewport .mds-lg-gap-100 {
    gap: 4px;
  }
  .mds .mds-lg-col-gap-100,
  .mds .mds-container .mds-lg-col-gap-100,
  .mds .mds-viewport .mds-lg-col-gap-100 {
    column-gap: 4px;
  }
  .mds .mds-lg-row-gap-100,
  .mds .mds-container .mds-lg-row-gap-100,
  .mds .mds-viewport .mds-lg-row-gap-100 {
    row-gap: 4px;
  }
  .mds .mds-lg-gap-150,
  .mds .mds-container .mds-lg-gap-150,
  .mds .mds-viewport .mds-lg-gap-150 {
    gap: 6px;
  }
  .mds .mds-lg-col-gap-150,
  .mds .mds-container .mds-lg-col-gap-150,
  .mds .mds-viewport .mds-lg-col-gap-150 {
    column-gap: 6px;
  }
  .mds .mds-lg-row-gap-150,
  .mds .mds-container .mds-lg-row-gap-150,
  .mds .mds-viewport .mds-lg-row-gap-150 {
    row-gap: 6px;
  }
  .mds .mds-lg-gap-200,
  .mds .mds-container .mds-lg-gap-200,
  .mds .mds-viewport .mds-lg-gap-200 {
    gap: 8px;
  }
  .mds .mds-lg-col-gap-200,
  .mds .mds-container .mds-lg-col-gap-200,
  .mds .mds-viewport .mds-lg-col-gap-200 {
    column-gap: 8px;
  }
  .mds .mds-lg-row-gap-200,
  .mds .mds-container .mds-lg-row-gap-200,
  .mds .mds-viewport .mds-lg-row-gap-200 {
    row-gap: 8px;
  }
  .mds .mds-lg-gap-300,
  .mds .mds-container .mds-lg-gap-300,
  .mds .mds-viewport .mds-lg-gap-300 {
    gap: 12px;
  }
  .mds .mds-lg-col-gap-300,
  .mds .mds-container .mds-lg-col-gap-300,
  .mds .mds-viewport .mds-lg-col-gap-300 {
    column-gap: 12px;
  }
  .mds .mds-lg-row-gap-300,
  .mds .mds-container .mds-lg-row-gap-300,
  .mds .mds-viewport .mds-lg-row-gap-300 {
    row-gap: 12px;
  }
  .mds .mds-lg-gap-400,
  .mds .mds-container .mds-lg-gap-400,
  .mds .mds-viewport .mds-lg-gap-400 {
    gap: 16px;
  }
  .mds .mds-lg-col-gap-400,
  .mds .mds-container .mds-lg-col-gap-400,
  .mds .mds-viewport .mds-lg-col-gap-400 {
    column-gap: 16px;
  }
  .mds .mds-lg-row-gap-400,
  .mds .mds-container .mds-lg-row-gap-400,
  .mds .mds-viewport .mds-lg-row-gap-400 {
    row-gap: 16px;
  }
  .mds .mds-lg-gap-500,
  .mds .mds-container .mds-lg-gap-500,
  .mds .mds-viewport .mds-lg-gap-500 {
    gap: 20px;
  }
  .mds .mds-lg-col-gap-500,
  .mds .mds-container .mds-lg-col-gap-500,
  .mds .mds-viewport .mds-lg-col-gap-500 {
    column-gap: 20px;
  }
  .mds .mds-lg-row-gap-500,
  .mds .mds-container .mds-lg-row-gap-500,
  .mds .mds-viewport .mds-lg-row-gap-500 {
    row-gap: 20px;
  }
  .mds .mds-lg-gap-600,
  .mds .mds-container .mds-lg-gap-600,
  .mds .mds-viewport .mds-lg-gap-600 {
    gap: 24px;
  }
  .mds .mds-lg-col-gap-600,
  .mds .mds-container .mds-lg-col-gap-600,
  .mds .mds-viewport .mds-lg-col-gap-600 {
    column-gap: 24px;
  }
  .mds .mds-lg-row-gap-600,
  .mds .mds-container .mds-lg-row-gap-600,
  .mds .mds-viewport .mds-lg-row-gap-600 {
    row-gap: 24px;
  }
  .mds .mds-lg-gap-700,
  .mds .mds-container .mds-lg-gap-700,
  .mds .mds-viewport .mds-lg-gap-700 {
    gap: 28px;
  }
  .mds .mds-lg-col-gap-700,
  .mds .mds-container .mds-lg-col-gap-700,
  .mds .mds-viewport .mds-lg-col-gap-700 {
    column-gap: 28px;
  }
  .mds .mds-lg-row-gap-700,
  .mds .mds-container .mds-lg-row-gap-700,
  .mds .mds-viewport .mds-lg-row-gap-700 {
    row-gap: 28px;
  }
  .mds .mds-lg-gap-800,
  .mds .mds-container .mds-lg-gap-800,
  .mds .mds-viewport .mds-lg-gap-800 {
    gap: 32px;
  }
  .mds .mds-lg-col-gap-800,
  .mds .mds-container .mds-lg-col-gap-800,
  .mds .mds-viewport .mds-lg-col-gap-800 {
    column-gap: 32px;
  }
  .mds .mds-lg-row-gap-800,
  .mds .mds-container .mds-lg-row-gap-800,
  .mds .mds-viewport .mds-lg-row-gap-800 {
    row-gap: 32px;
  }
  .mds .mds-lg-gap-900,
  .mds .mds-container .mds-lg-gap-900,
  .mds .mds-viewport .mds-lg-gap-900 {
    gap: 36px;
  }
  .mds .mds-lg-col-gap-900,
  .mds .mds-container .mds-lg-col-gap-900,
  .mds .mds-viewport .mds-lg-col-gap-900 {
    column-gap: 36px;
  }
  .mds .mds-lg-row-gap-900,
  .mds .mds-container .mds-lg-row-gap-900,
  .mds .mds-viewport .mds-lg-row-gap-900 {
    row-gap: 36px;
  }
  .mds .mds-lg-gap-1000,
  .mds .mds-container .mds-lg-gap-1000,
  .mds .mds-viewport .mds-lg-gap-1000 {
    gap: 40px;
  }
  .mds .mds-lg-col-gap-1000,
  .mds .mds-container .mds-lg-col-gap-1000,
  .mds .mds-viewport .mds-lg-col-gap-1000 {
    column-gap: 40px;
  }
  .mds .mds-lg-row-gap-1000,
  .mds .mds-container .mds-lg-row-gap-1000,
  .mds .mds-viewport .mds-lg-row-gap-1000 {
    row-gap: 40px;
  }
  .mds .mds-lg-gap-1200,
  .mds .mds-container .mds-lg-gap-1200,
  .mds .mds-viewport .mds-lg-gap-1200 {
    gap: 48px;
  }
  .mds .mds-lg-col-gap-1200,
  .mds .mds-container .mds-lg-col-gap-1200,
  .mds .mds-viewport .mds-lg-col-gap-1200 {
    column-gap: 48px;
  }
  .mds .mds-lg-row-gap-1200,
  .mds .mds-container .mds-lg-row-gap-1200,
  .mds .mds-viewport .mds-lg-row-gap-1200 {
    row-gap: 48px;
  }
  .mds .mds-lg-gap-1600,
  .mds .mds-container .mds-lg-gap-1600,
  .mds .mds-viewport .mds-lg-gap-1600 {
    gap: 64px;
  }
  .mds .mds-lg-col-gap-1600,
  .mds .mds-container .mds-lg-col-gap-1600,
  .mds .mds-viewport .mds-lg-col-gap-1600 {
    column-gap: 64px;
  }
  .mds .mds-lg-row-gap-1600,
  .mds .mds-container .mds-lg-row-gap-1600,
  .mds .mds-viewport .mds-lg-row-gap-1600 {
    row-gap: 64px;
  }
  .mds .mds-lg-gap-2000,
  .mds .mds-container .mds-lg-gap-2000,
  .mds .mds-viewport .mds-lg-gap-2000 {
    gap: 80px;
  }
  .mds .mds-lg-col-gap-2000,
  .mds .mds-container .mds-lg-col-gap-2000,
  .mds .mds-viewport .mds-lg-col-gap-2000 {
    column-gap: 80px;
  }
  .mds .mds-lg-row-gap-2000,
  .mds .mds-container .mds-lg-row-gap-2000,
  .mds .mds-viewport .mds-lg-row-gap-2000 {
    row-gap: 80px;
  }
  .mds .mds-lg-gap-2400,
  .mds .mds-container .mds-lg-gap-2400,
  .mds .mds-viewport .mds-lg-gap-2400 {
    gap: 96px;
  }
  .mds .mds-lg-col-gap-2400,
  .mds .mds-container .mds-lg-col-gap-2400,
  .mds .mds-viewport .mds-lg-col-gap-2400 {
    column-gap: 96px;
  }
  .mds .mds-lg-row-gap-2400,
  .mds .mds-container .mds-lg-row-gap-2400,
  .mds .mds-viewport .mds-lg-row-gap-2400 {
    row-gap: 96px;
  }
  .mds .mds-lg-gap-2800,
  .mds .mds-container .mds-lg-gap-2800,
  .mds .mds-viewport .mds-lg-gap-2800 {
    gap: 112px;
  }
  .mds .mds-lg-col-gap-2800,
  .mds .mds-container .mds-lg-col-gap-2800,
  .mds .mds-viewport .mds-lg-col-gap-2800 {
    column-gap: 112px;
  }
  .mds .mds-lg-row-gap-2800,
  .mds .mds-container .mds-lg-row-gap-2800,
  .mds .mds-viewport .mds-lg-row-gap-2800 {
    row-gap: 112px;
  }
  .mds .mds-lg-gap-3200,
  .mds .mds-container .mds-lg-gap-3200,
  .mds .mds-viewport .mds-lg-gap-3200 {
    gap: 128px;
  }
  .mds .mds-lg-col-gap-3200,
  .mds .mds-container .mds-lg-col-gap-3200,
  .mds .mds-viewport .mds-lg-col-gap-3200 {
    column-gap: 128px;
  }
  .mds .mds-lg-row-gap-3200,
  .mds .mds-container .mds-lg-row-gap-3200,
  .mds .mds-viewport .mds-lg-row-gap-3200 {
    row-gap: 128px;
  }
}
@container (min-width: 1921px) {
  .mds .mds-xl-gap-50,
  .mds .mds-container .mds-xl-gap-50,
  .mds .mds-viewport .mds-xl-gap-50 {
    gap: 2px;
  }
  .mds .mds-xl-col-gap-50,
  .mds .mds-container .mds-xl-col-gap-50,
  .mds .mds-viewport .mds-xl-col-gap-50 {
    column-gap: 2px;
  }
  .mds .mds-xl-row-gap-50,
  .mds .mds-container .mds-xl-row-gap-50,
  .mds .mds-viewport .mds-xl-row-gap-50 {
    row-gap: 2px;
  }
  .mds .mds-xl-gap-100,
  .mds .mds-container .mds-xl-gap-100,
  .mds .mds-viewport .mds-xl-gap-100 {
    gap: 4px;
  }
  .mds .mds-xl-col-gap-100,
  .mds .mds-container .mds-xl-col-gap-100,
  .mds .mds-viewport .mds-xl-col-gap-100 {
    column-gap: 4px;
  }
  .mds .mds-xl-row-gap-100,
  .mds .mds-container .mds-xl-row-gap-100,
  .mds .mds-viewport .mds-xl-row-gap-100 {
    row-gap: 4px;
  }
  .mds .mds-xl-gap-150,
  .mds .mds-container .mds-xl-gap-150,
  .mds .mds-viewport .mds-xl-gap-150 {
    gap: 6px;
  }
  .mds .mds-xl-col-gap-150,
  .mds .mds-container .mds-xl-col-gap-150,
  .mds .mds-viewport .mds-xl-col-gap-150 {
    column-gap: 6px;
  }
  .mds .mds-xl-row-gap-150,
  .mds .mds-container .mds-xl-row-gap-150,
  .mds .mds-viewport .mds-xl-row-gap-150 {
    row-gap: 6px;
  }
  .mds .mds-xl-gap-200,
  .mds .mds-container .mds-xl-gap-200,
  .mds .mds-viewport .mds-xl-gap-200 {
    gap: 8px;
  }
  .mds .mds-xl-col-gap-200,
  .mds .mds-container .mds-xl-col-gap-200,
  .mds .mds-viewport .mds-xl-col-gap-200 {
    column-gap: 8px;
  }
  .mds .mds-xl-row-gap-200,
  .mds .mds-container .mds-xl-row-gap-200,
  .mds .mds-viewport .mds-xl-row-gap-200 {
    row-gap: 8px;
  }
  .mds .mds-xl-gap-300,
  .mds .mds-container .mds-xl-gap-300,
  .mds .mds-viewport .mds-xl-gap-300 {
    gap: 12px;
  }
  .mds .mds-xl-col-gap-300,
  .mds .mds-container .mds-xl-col-gap-300,
  .mds .mds-viewport .mds-xl-col-gap-300 {
    column-gap: 12px;
  }
  .mds .mds-xl-row-gap-300,
  .mds .mds-container .mds-xl-row-gap-300,
  .mds .mds-viewport .mds-xl-row-gap-300 {
    row-gap: 12px;
  }
  .mds .mds-xl-gap-400,
  .mds .mds-container .mds-xl-gap-400,
  .mds .mds-viewport .mds-xl-gap-400 {
    gap: 16px;
  }
  .mds .mds-xl-col-gap-400,
  .mds .mds-container .mds-xl-col-gap-400,
  .mds .mds-viewport .mds-xl-col-gap-400 {
    column-gap: 16px;
  }
  .mds .mds-xl-row-gap-400,
  .mds .mds-container .mds-xl-row-gap-400,
  .mds .mds-viewport .mds-xl-row-gap-400 {
    row-gap: 16px;
  }
  .mds .mds-xl-gap-500,
  .mds .mds-container .mds-xl-gap-500,
  .mds .mds-viewport .mds-xl-gap-500 {
    gap: 20px;
  }
  .mds .mds-xl-col-gap-500,
  .mds .mds-container .mds-xl-col-gap-500,
  .mds .mds-viewport .mds-xl-col-gap-500 {
    column-gap: 20px;
  }
  .mds .mds-xl-row-gap-500,
  .mds .mds-container .mds-xl-row-gap-500,
  .mds .mds-viewport .mds-xl-row-gap-500 {
    row-gap: 20px;
  }
  .mds .mds-xl-gap-600,
  .mds .mds-container .mds-xl-gap-600,
  .mds .mds-viewport .mds-xl-gap-600 {
    gap: 24px;
  }
  .mds .mds-xl-col-gap-600,
  .mds .mds-container .mds-xl-col-gap-600,
  .mds .mds-viewport .mds-xl-col-gap-600 {
    column-gap: 24px;
  }
  .mds .mds-xl-row-gap-600,
  .mds .mds-container .mds-xl-row-gap-600,
  .mds .mds-viewport .mds-xl-row-gap-600 {
    row-gap: 24px;
  }
  .mds .mds-xl-gap-700,
  .mds .mds-container .mds-xl-gap-700,
  .mds .mds-viewport .mds-xl-gap-700 {
    gap: 28px;
  }
  .mds .mds-xl-col-gap-700,
  .mds .mds-container .mds-xl-col-gap-700,
  .mds .mds-viewport .mds-xl-col-gap-700 {
    column-gap: 28px;
  }
  .mds .mds-xl-row-gap-700,
  .mds .mds-container .mds-xl-row-gap-700,
  .mds .mds-viewport .mds-xl-row-gap-700 {
    row-gap: 28px;
  }
  .mds .mds-xl-gap-800,
  .mds .mds-container .mds-xl-gap-800,
  .mds .mds-viewport .mds-xl-gap-800 {
    gap: 32px;
  }
  .mds .mds-xl-col-gap-800,
  .mds .mds-container .mds-xl-col-gap-800,
  .mds .mds-viewport .mds-xl-col-gap-800 {
    column-gap: 32px;
  }
  .mds .mds-xl-row-gap-800,
  .mds .mds-container .mds-xl-row-gap-800,
  .mds .mds-viewport .mds-xl-row-gap-800 {
    row-gap: 32px;
  }
  .mds .mds-xl-gap-900,
  .mds .mds-container .mds-xl-gap-900,
  .mds .mds-viewport .mds-xl-gap-900 {
    gap: 36px;
  }
  .mds .mds-xl-col-gap-900,
  .mds .mds-container .mds-xl-col-gap-900,
  .mds .mds-viewport .mds-xl-col-gap-900 {
    column-gap: 36px;
  }
  .mds .mds-xl-row-gap-900,
  .mds .mds-container .mds-xl-row-gap-900,
  .mds .mds-viewport .mds-xl-row-gap-900 {
    row-gap: 36px;
  }
  .mds .mds-xl-gap-1000,
  .mds .mds-container .mds-xl-gap-1000,
  .mds .mds-viewport .mds-xl-gap-1000 {
    gap: 40px;
  }
  .mds .mds-xl-col-gap-1000,
  .mds .mds-container .mds-xl-col-gap-1000,
  .mds .mds-viewport .mds-xl-col-gap-1000 {
    column-gap: 40px;
  }
  .mds .mds-xl-row-gap-1000,
  .mds .mds-container .mds-xl-row-gap-1000,
  .mds .mds-viewport .mds-xl-row-gap-1000 {
    row-gap: 40px;
  }
  .mds .mds-xl-gap-1200,
  .mds .mds-container .mds-xl-gap-1200,
  .mds .mds-viewport .mds-xl-gap-1200 {
    gap: 48px;
  }
  .mds .mds-xl-col-gap-1200,
  .mds .mds-container .mds-xl-col-gap-1200,
  .mds .mds-viewport .mds-xl-col-gap-1200 {
    column-gap: 48px;
  }
  .mds .mds-xl-row-gap-1200,
  .mds .mds-container .mds-xl-row-gap-1200,
  .mds .mds-viewport .mds-xl-row-gap-1200 {
    row-gap: 48px;
  }
  .mds .mds-xl-gap-1600,
  .mds .mds-container .mds-xl-gap-1600,
  .mds .mds-viewport .mds-xl-gap-1600 {
    gap: 64px;
  }
  .mds .mds-xl-col-gap-1600,
  .mds .mds-container .mds-xl-col-gap-1600,
  .mds .mds-viewport .mds-xl-col-gap-1600 {
    column-gap: 64px;
  }
  .mds .mds-xl-row-gap-1600,
  .mds .mds-container .mds-xl-row-gap-1600,
  .mds .mds-viewport .mds-xl-row-gap-1600 {
    row-gap: 64px;
  }
  .mds .mds-xl-gap-2000,
  .mds .mds-container .mds-xl-gap-2000,
  .mds .mds-viewport .mds-xl-gap-2000 {
    gap: 80px;
  }
  .mds .mds-xl-col-gap-2000,
  .mds .mds-container .mds-xl-col-gap-2000,
  .mds .mds-viewport .mds-xl-col-gap-2000 {
    column-gap: 80px;
  }
  .mds .mds-xl-row-gap-2000,
  .mds .mds-container .mds-xl-row-gap-2000,
  .mds .mds-viewport .mds-xl-row-gap-2000 {
    row-gap: 80px;
  }
  .mds .mds-xl-gap-2400,
  .mds .mds-container .mds-xl-gap-2400,
  .mds .mds-viewport .mds-xl-gap-2400 {
    gap: 96px;
  }
  .mds .mds-xl-col-gap-2400,
  .mds .mds-container .mds-xl-col-gap-2400,
  .mds .mds-viewport .mds-xl-col-gap-2400 {
    column-gap: 96px;
  }
  .mds .mds-xl-row-gap-2400,
  .mds .mds-container .mds-xl-row-gap-2400,
  .mds .mds-viewport .mds-xl-row-gap-2400 {
    row-gap: 96px;
  }
  .mds .mds-xl-gap-2800,
  .mds .mds-container .mds-xl-gap-2800,
  .mds .mds-viewport .mds-xl-gap-2800 {
    gap: 112px;
  }
  .mds .mds-xl-col-gap-2800,
  .mds .mds-container .mds-xl-col-gap-2800,
  .mds .mds-viewport .mds-xl-col-gap-2800 {
    column-gap: 112px;
  }
  .mds .mds-xl-row-gap-2800,
  .mds .mds-container .mds-xl-row-gap-2800,
  .mds .mds-viewport .mds-xl-row-gap-2800 {
    row-gap: 112px;
  }
  .mds .mds-xl-gap-3200,
  .mds .mds-container .mds-xl-gap-3200,
  .mds .mds-viewport .mds-xl-gap-3200 {
    gap: 128px;
  }
  .mds .mds-xl-col-gap-3200,
  .mds .mds-container .mds-xl-col-gap-3200,
  .mds .mds-viewport .mds-xl-col-gap-3200 {
    column-gap: 128px;
  }
  .mds .mds-xl-row-gap-3200,
  .mds .mds-container .mds-xl-row-gap-3200,
  .mds .mds-viewport .mds-xl-row-gap-3200 {
    row-gap: 128px;
  }
}

.mds-content h1 {
  margin: var(--mds_foundations_typography_heading-1_margin-top) 0 var(--mds_foundations_typography_heading-1_margin-bottom);
}
.mds-content h2 {
  margin: var(--mds_foundations_typography_heading-2_margin-top) 0 var(--mds_foundations_typography_heading-2_margin-bottom);
}
.mds-content h3 {
  margin: var(--mds_foundations_typography_heading-3_margin-top) 0 var(--mds_foundations_typography_heading-3_margin-bottom);
}
.mds-content h4 {
  margin: var(--mds_foundations_typography_heading-4_margin-top) 0 var(--mds_foundations_typography_heading-4_margin-bottom);
}
.mds-content h5,
.mds-content h6 {
  margin: var(--mds_foundations_typography_heading-4_margin-top) 0 var(--mds_foundations_typography_heading-4_margin-bottom);
}
.mds-content p {
  margin: var(--mds_foundations_typography_paragraph_margin-top) 0 var(--mds_foundations_typography_paragraph_margin-bottom);
  padding: 0;
}
.mds-content hr {
  margin: var(--mds_foundations_horizontal-rule_margin-top) 0 var(--mds_foundations_horizontal-rule_margin-bottom) 0;
}
.mds-content ul,
.mds-content ol {
  margin: var(--mds_foundations_list_margin-top) var(--mds_foundations_list_margin-bottom);
  padding: 0 0 0 var(--mds_foundations_list_vertical_padding-left);
}
.mds-content ul li,
.mds-content ol li {
  padding-left: var(--mds_foundations_list_item_padding-left);
}

body.mds {
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/@maersk-global/mds-foundations/css/foundations.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;GAGG;AACH;;;GAGG;AACH;;;GAGG;AACH;EACE,2EAA2E;EAC3E;iFAC+E;EAC/E;;IAEE;EACF;;;IAGE;EACF;iFAC+E;EAC/E;;;IAGE;EACF;;;IAGE;EACF;iFAC+E;EAC/E;;IAEE;EACF;;;IAGE;EACF;;IAEE;EACF;;;IAGE;EACF;;IAEE;EACF;;;IAGE;EACF;iFAC+E;EAC/E;;IAEE;EACF;iFAC+E;EAC/E;;;IAGE;EACF;;;IAGE;EACF;;;IAGE;EACF;;IAEE;EACF;;IAEE;EACF;;IAEE;EACF;;IAEE;EACF;;;;;IAKE;EACF;;IAEE;EACF;;IAEE;EACF;;;IAGE;EACF;;IAEE;EACF;;;IAGE;EACF;;IAEE;EACF;;;IAGE;EACF;iFAC+E;EAC/E;;IAEE;EACF;;IAEE;EACF;iFAC+E;EAC/E;;IAEE;EACF;;IAEE;EACF;;;KAGG;EACH;;;;GAIC;EACD;;;;;;GAMC;EACD;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;;;;GAMC;EACD;;;KAGG;EACH;;;KAGG;EACH;;;;;;;GAOC;EACD;;;KAGG;EACH,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,uBAAuB,EAAE,MAAM;EAC/B,SAAS,EAAE,MAAM;EACjB,iBAAiB,EAAE,MAAM;AAC3B;AACA;EACE,sBAAsB,EAAE,MAAM;EAC9B,cAAc,EAAE,MAAM;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB,EAAE,MAAM;EAC9B,0BAA0B,EAAE,MAAM;EAClC,yCAAiC;UAAjC,iCAAiC,EAAE,MAAM;AAC3C;AACA;;EAEE,mBAAmB;AACrB;AACA;;;EAGE,sBAAsB,EAAE,MAAM;EAC9B,cAAc,EAAE,MAAM;AACxB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,eAAe,EAAE,MAAM;EACvB,iBAAiB,EAAE,MAAM;EACzB,SAAS,EAAE,MAAM;AACnB;AACA;;EAEE,MAAM;EACN,iBAAiB;AACnB;AACA;;EAEE,MAAM;EACN,oBAAoB;AACtB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,UAAU;EACV,SAAS;AACX;AACA;EACE,sBAAsB,EAAE,MAAM;EAC9B,cAAc,EAAE,MAAM;EACtB,cAAc,EAAE,MAAM;EACtB,eAAe,EAAE,MAAM;EACvB,UAAU,EAAE,MAAM;EAClB,mBAAmB,EAAE,MAAM;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,sBAAsB,EAAE,MAAM;EAC9B,UAAU,EAAE,MAAM;AACpB;AACA;;EAEE,YAAY;AACd;AACA;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;EAKE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;AACA;;;;EAIE,gJAAgJ;AAClJ;AACA;;;;EAIE,gJAAgJ;AAClJ;AACA;;;;EAIE,gJAAgJ;AAClJ;AACA;;;;EAIE,gJAAgJ;AAClJ;AACA;;;;EAIE,gJAAgJ;AAClJ;AACA;;;;EAIE,gJAAgJ;AAClJ;AACA;;;;EAIE,gJAAgJ;AAClJ;AACA;;;;EAIE,wIAAwI;AAC1I;AACA;;;;;;;;EAQE,gHAAgH;AAClH;AACA;EACE;;;;;;;;;;;;;;;;;;;;;UAqBQ;AACV;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,wDAAwD;EACxD,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uDAAuD;AACzD;AACA;EACE,yDAAyD;EACzD,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,WAAW;AACb;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE;;;;;;;;;;;;;;;;UAgBQ;EACR,WAAS;EACT,cAAc;EACd,sBAAsB;EACtB,uEAAuE;EACvE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kEAAkE;EAClE,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,yDAAyD;EACzD,6DAA6D;AAC/D;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE;IACE,aAAa;EACf;EACA;;;;IAIE,aAAa;EACf;EACA;;IAEE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kEAAkE;IAClE,wDAAwD;EAC1D;EACA;IACE,YAAY;IACZ,yDAAyD;IACzD,6DAA6D;EAC/D;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;;;;IAIE,aAAa;EACf;EACA;;IAEE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kEAAkE;IAClE,wDAAwD;EAC1D;EACA;IACE,YAAY;IACZ,yDAAyD;IACzD,6DAA6D;EAC/D;AACF;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;;IAEE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;;EAEE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,2EAA2E;EAC3E,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gFAAwE;UAAxE,wEAAwE;EACxE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,yDAAyD;AAC3D;AACA;;EAEE,0DAA0D;AAC5D;AACA;;;EAGE,0FAA0F;EAC1F,6DAA6D;AAC/D;AACA;;;EAGE,4DAA4D;AAC9D;AACA;;;EAGE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;;;IAGE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;;;EAGE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;EAEE,UAAU;EACV,sVAAsV;AACxV;AACA;;EAEE,0DAA0D;AAC5D;AACA;EACE,wEAAwE;EACxE,6DAA6D;AAC/D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qEAAqE;EACrE,WAAW;EAEX,+DAA2a;EAE3a,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,6DAA6D;AAC/D;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,qEAAqE;EACrE,WAAW;EAEX,+DAAuV;EAEvV,gBAAgB;AAClB;AACA;EAEE,+DAAiV;AACnV;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,wEAAwE;AAC1E;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0DAA0D;AAC5D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,+DAA+D;AACjE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,yDAAyD;AAC3D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,8EAA8E;AAChF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,8EAA8E;AAChF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,2EAA2E;AAC7E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6EAA6E;AAC/E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,gFAAgF;AAClF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,8EAA8E;AAChF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6EAA6E;AAC/E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0EAA0E;AAC5E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,wEAAwE;AAC1E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,kEAAkE;AACpE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,wEAAwE;AAC1E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,kEAAkE;AACpE;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;;EAGE,0DAA0D;AAC5D;AACA;;;EAGE,4DAA4D;AAC9D;AACA;;;EAGE,+DAA+D;AACjE;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;;EAGE,4DAA4D;AAC9D;AACA;;;EAGE,yDAAyD;AAC3D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0DAA0D;AAC5D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,8EAA8E;AAChF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,2EAA2E;AAC7E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6EAA6E;AAC/E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;;EAGE,0DAA0D;AAC5D;AACA;;;EAGE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,+DAA+D;AACjE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,8DAA8D;AAChE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,gFAAgF;AAClF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6EAA6E;AAC/E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,+EAA+E;AACjF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,wEAAwE;AAC1E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,uEAAuE;AACzE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,wEAAwE;AAC1E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,uEAAuE;AACzE;AACA;;;EAGE,+DAA+D;AACjE;AACA;;;EAGE,4DAA4D;AAC9D;AACA;;;EAGE,8DAA8D;AAChE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0DAA0D;AAC5D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,uDAAuD;AACzD;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,yDAAyD;AAC3D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,2EAA2E;AAC7E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,wEAAwE;AAC1E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0EAA0E;AAC5E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,gEAAgE;AAClE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,kEAAkE;AACpE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,gEAAgE;AAClE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,kEAAkE;AACpE;AACA;;;EAGE,0DAA0D;AAC5D;AACA;;;EAGE,uDAAuD;AACzD;AACA;;;EAGE,yDAAyD;AAC3D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,2DAA2D;AAC7D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,wDAAwD;AAC1D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0DAA0D;AAC5D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,4EAA4E;AAC9E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,2EAA2E;AAC7E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,oEAAoE;AACtE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,iEAAiE;AACnE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,oEAAoE;AACtE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,iEAAiE;AACnE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;;;EAGE,2DAA2D;AAC7D;AACA;;;EAGE,wDAAwD;AAC1D;AACA;;;EAGE,0DAA0D;AAC5D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0DAA0D;AAC5D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,8EAA8E;AAChF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,2EAA2E;AAC7E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6EAA6E;AAC/E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;;EAGE,0DAA0D;AAC5D;AACA;;;EAGE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,0DAA0D;AAC5D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,8EAA8E;AAChF;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,2EAA2E;AAC7E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,6EAA6E;AAC/E;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,sEAAsE;AACxE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,qEAAqE;AACvE;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;;EAGE,0DAA0D;AAC5D;AACA;;;EAGE,4DAA4D;AAC9D;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8EAA8E;EAC9E,8EAA8E;AAChF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,YAAY;IACZ,OAAO;IACP,eAAe;IACf,MAAM;IACN,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kEAAkE;IAClE,iCAAiC;IACjC,0BAA0B;IAC1B,YAAY;EACd;AACF;AACA;EACE;IACE,kEAAkE;IAClE,iCAAiC;IACjC,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,wEAAwE;IACxE,iCAAiC;IACjC,gCAAgC;EAClC;EACA;IACE,kCAAkC;IAClC,mEAAmE;EACrE;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,oBAAoB;AACtB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,sBAAsB;AACxB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,sBAAsB;AACxB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,sBAAsB;AACxB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,sBAAsB;AACxB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,uBAAuB;AACzB;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,wBAAwB;AAC1B;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,wBAAwB;AAC1B;AACA;EACE;;;;;;;;;;;;;UAaQ;EACR,wBAAwB;AAC1B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE;;;GAGC;EACD,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,qFAAqF;IACrF,qFAAqF;EACvF;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,qFAAqF;IACrF,qFAAqF;EACvF;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,qFAAqF;IACrF,qFAAqF;EACvF;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,oBAAoB;EACtB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,qBAAqB;EACvB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,sBAAsB;EACxB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,uBAAuB;EACzB;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE;;;;;;;;;;;;;YAaQ;IACR,wBAAwB;EAC1B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE,wDAAwD;EACxD,6CAA6C;EAC7C,qCAAqC;EACrC,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,qEAAqE;EACrE,uEAAuE;AACzE;;AAEA;EACE,wHAAwH;EACxH,wEAAwE;EACxE,4EAA4E;AAC9E;AACA;EACE;IACE,yEAAyE;IACzE,6EAA6E;EAC/E;AACF;AACA;EACE,2EAA2E;EAC3E,mEAAmE;EACnE,qEAAqE;AACvE;AACA;EACE,wHAAwH;EACxH,sEAAsE;EACtE,0EAA0E;AAC5E;AACA;EACE;IACE,uEAAuE;IACvE,2EAA2E;EAC7E;AACF;AACA;EACE,yEAAyE;EACzE,iEAAiE;EACjE,mEAAmE;AACrE;AACA;EACE,wHAAwH;EACxH,uEAAuE;EACvE,2EAA2E;AAC7E;AACA;EACE;IACE,wEAAwE;IACxE,4EAA4E;EAC9E;AACF;AACA;EACE,0EAA0E;EAC1E,kEAAkE;EAClE,oEAAoE;AACtE;AACA;EACE,wHAAwH;EACxH,sEAAsE;EACtE,0EAA0E;AAC5E;AACA;EACE;IACE,uEAAuE;IACvE,2EAA2E;EAC7E;AACF;AACA;EACE,yEAAyE;EACzE,iEAAiE;EACjE,mEAAmE;AACrE;AACA;EACE,wHAAwH;EACxH,wEAAwE;EACxE,4EAA4E;AAC9E;AACA;EACE;IACE,yEAAyE;IACzE,6EAA6E;EAC/E;AACF;AACA;EACE,2EAA2E;EAC3E,mEAAmE;EACnE,qEAAqE;AACvE;AACA;EACE,gHAAgH;EAChH,oEAAoE;EACpE,wEAAwE;AAC1E;AACA;EACE;IACE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;EACE,sEAAsE;EACtE,wEAAwE;AAC1E;AACA;EACE,gHAAgH;EAChH,oEAAoE;EACpE,wEAAwE;AAC1E;AACA;EACE;IACE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;EACE,sEAAsE;EACtE,wEAAwE;AAC1E;AACA;EACE,gHAAgH;EAChH,oEAAoE;EACpE,wEAAwE;AAC1E;AACA;EACE;IACE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,gHAAgH;EAChH,oEAAoE;EACpE,wEAAwE;AAC1E;AACA;EACE;IACE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;EACE,sEAAsE;EACtE,wEAAwE;AAC1E;AACA;EACE,gHAAgH;EAChH,oEAAoE;EACpE,wEAAwE;AAC1E;AACA;EACE;IACE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;EACE,4EAA4E;EAC5E,8EAA8E;AAChF;AACA;EACE,gHAAgH;EAChH,oEAAoE;EACpE,wEAAwE;AAC1E;AACA;EACE;IACE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;EACE,0EAA0E;EAC1E,4EAA4E;AAC9E;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,kEAAkE;EAClE,oEAAoE;AACtE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,0EAA0E;EAC1E,4EAA4E;AAC9E;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,wEAAwE;EACxE,0EAA0E;AAC5E;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,qEAAqE;EACrE,uEAAuE;AACzE;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,qEAAqE;EACrE,uEAAuE;AACzE;AACA;;EAEE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;;IAEE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;;EAEE,mEAAmE;EACnE,qEAAqE;AACvE;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,qEAAqE;EACrE,uEAAuE;AACzE;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,2EAA2E;EAC3E,6EAA6E;AAC/E;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,yEAAyE;EACzE,2EAA2E;AAC7E;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,kEAAkE;EAClE,oEAAoE;AACtE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,0EAA0E;EAC1E,4EAA4E;AAC9E;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,wEAAwE;EACxE,0EAA0E;AAC5E;AACA;EACE;IACE,wEAAwE;IACxE,4EAA4E;EAC9E;AACF;AACA;EACE;IACE,yEAAyE;IACzE,6EAA6E;EAC/E;AACF;AACA;EACE;IACE,sEAAsE;IACtE,0EAA0E;EAC5E;AACF;AACA;EACE;IACE,uEAAuE;IACvE,2EAA2E;EAC7E;AACF;AACA;EACE;IACE,uEAAuE;IACvE,2EAA2E;EAC7E;AACF;AACA;EACE;IACE,wEAAwE;IACxE,4EAA4E;EAC9E;AACF;AACA;EACE;IACE,sEAAsE;IACtE,0EAA0E;EAC5E;AACF;AACA;EACE;IACE,uEAAuE;IACvE,2EAA2E;EAC7E;AACF;AACA;EACE;IACE,wEAAwE;IACxE,4EAA4E;EAC9E;AACF;AACA;EACE;IACE,yEAAyE;IACzE,6EAA6E;EAC/E;AACF;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE;IACE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;EACE;IACE,kEAAkE;IAClE,sEAAsE;EACxE;AACF;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE;;IAEE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE;;IAEE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE;IACE,kEAAkE;IAClE,sEAAsE;EACxE;AACF;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;;;;;;;EAOE,UAAU;EACV,SAAS;AACX;AACA;EACE,qEAAqE;AACvE;AACA;EACE,qEAAqE;AACvE;AACA;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;AACA;;;EAGE,QAAQ;AACV;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,QAAQ;AACV;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,QAAQ;AACV;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,QAAQ;AACV;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0KAA0K;EAC1K,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,gFAAwE;UAAxE,wEAAwE;AAC1E;AACA;EACE,sFAA8E;UAA9E,8EAA8E;AAChF;AACA;EACE,gFAAwE;UAAxE,wEAAwE;AAC1E;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,2EAAmE;UAAnE,mEAAmE;AACrE;AACA;EACE,gFAAwE;UAAxE,wEAAwE;AAC1E;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,2DAA2D;EAC3D,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,wDAAwD;EACxD,sDAAsD;EACtD,gEAAgE;EAEhE,+DAA2a;EAE3a,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,sVAAsV;AACxV;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,2EAAmE;UAAnE,mEAAmE;EACnE,oEAAoE;EACpE,sEAAsE;EACtE,yEAAyE;AAC3E;AACA;EACE,8DAA8D;EAC9D,iFAAyE;UAAzE,yEAAyE;EACzE,UAAU;EACV,gVAAgV;AAClV;AACA;EACE,iFAAyE;UAAzE,yEAAyE;AAC3E;AACA;EACE,2EAAmE;UAAnE,mEAAmE;AACrE;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD;AACA;;;;;;;;;;;;;;EAcE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;;EAKE,UAAU;EACV,sVAAsV;AACxV;AACA;EACE,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,UAAU;AACZ;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,UAAU;AACZ;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,2EAA2E;EAC3E,yDAAyD;EACzD,qIAAqI;EACrI,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,yDAAyD;AAC3D;AACA;;EAEE,kOAAkO;EAClO,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,4IAA4I;AAC9I;AACA;;EAEE,sDAAsD;EACtD,cAAc;EACd,6DAA6D;AAC/D;AACA;;EAEE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;;IAEE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;;EAEE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,2EAA2E;EAC3E,0DAA0D;AAC5D;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,mEAAmE;EACnE,qEAAqE;AACvE;AACA;EACE,oEAAoE;EACpE,mDAAmD;AACrD;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,qEAAqE;EACrE,uEAAuE;AACzE;AACA;EACE,oEAAoE;EACpE,mDAAmD;AACrD;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,mEAAmE;EACnE,qEAAqE;AACvE;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;EAEE,8NAA8N;AAChO;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,gFAAgF;EAChF,sFAAsF;AACxF;AACA;EACE,UAAU;AACZ;AACA;EACE,8PAA8P;AAChQ;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,kEAAkE;EAClE,oEAAoE;AACtE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;;EAEE,8NAA8N;AAChO;AACA;;EAEE,gHAAgH;EAChH,oEAAoE;EACpE,wEAAwE;AAC1E;AACA;EACE;;IAEE,qEAAqE;IACrE,yEAAyE;EAC3E;AACF;AACA;;EAEE,sEAAsE;EACtE,wEAAwE;AAC1E;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,kEAAkE;EAClE,oEAAoE;AACtE;AACA;EACE,gFAAgF;EAChF,sFAAsF;AACxF;AACA;EACE,UAAU;AACZ;AACA;EACE,8PAA8P;AAChQ;AACA;EACE,4EAA4E;EAC5E,2DAA2D;AAC7D;AACA;EACE,4EAA4E;EAC5E,2DAA2D;AAC7D;AACA;EACE,oEAAoE;EACpE,mDAAmD;AACrD;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,oEAAoE;EACpE,mDAAmD;AACrD;AACA;;EAEE,4EAA4E;EAC5E,2DAA2D;AAC7D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,oEAAoE;EACpE,mDAAmD;AACrD;AACA;;EAEE,4EAA4E;EAC5E,2DAA2D;AAC7D;AACA;EACE,0EAA0E;EAC1E,yDAAyD;AAC3D;AACA;;EAEE,8EAA8E;AAChF;AACA;;EAEE,+EAA+E;AACjF;AACA;;;;EAIE,iFAAiF;AACnF;AACA;;;;EAIE,kFAAkF;AACpF;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,sGAAsG;EACtG,uGAAuG;AACzG;AACA;;EAEE,uGAAuG;EACvG,wGAAwG;AAC1G;AACA;;EAEE,uGAAuG;EACvG,wGAAwG;AAC1G;AACA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;AACA;EACE,6EAA6E;EAC7E,4DAA4D;AAC9D;AACA;EACE,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,oCAA4B;UAA5B,4BAA4B;EAC5B,iFAAiF;EACjF,uFAAuF;AACzF;AACA;EACE,sFAAsF;AACxF;AACA;EACE,uFAAuF;AACzF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,cAAc;AAChB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;;;EAIE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,yIAAyI;AAC3I;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,mIAAmI;AACrI;AACA;EACE,gBAAgB;EAChB,kEAAkE;AACpE;AACA;;EAEE,MAAM;EACN,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,iEAAiE;AACnE;AACA;;EAEE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,kBAAkB;AACpB;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yIAAyI;AAC3I;AACA;EACE,UAAU;AACZ;AACA;EACE,kQAAkQ;AACpQ;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uGAAuG;AACzG;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yFAAyF;AAC3F;AACA;EACE,SAAS;AACX;AACA;EACE,sDAAsD;EACtD,wEAAwE;AAC1E;AACA;EACE,uEAAuE;AACzE;AACA;EACE,gHAAgH;EAChH,kEAAkE;EAClE,sEAAsE;AACxE;AACA;EACE;IACE,mEAAmE;IACnE,uEAAuE;EACzE;AACF;AACA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;AACA;EACE,uEAAuE;AACzE;AACA;EACE,gHAAgH;EAChH,mEAAmE;EACnE,uEAAuE;AACzE;AACA;EACE;IACE,oEAAoE;IACpE,wEAAwE;EAC1E;AACF;AACA;EACE,qEAAqE;EACrE,uEAAuE;AACzE;AACA;EACE;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;AACF;AACA;EACE;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;AACF;AACA;EACE;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;AACF;AACA;EACE;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;AACF;AACA;EACE;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,SAAS;EACX;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;EACA;;;IAGE,UAAU;EACZ;EACA;;;IAGE,iBAAiB;EACnB;EACA;;;IAGE,cAAc;EAChB;AACF;;AAEA;EACE,0HAA0H;AAC5H;AACA;EACE,0HAA0H;AAC5H;AACA;EACE,0HAA0H;AAC5H;AACA;EACE,0HAA0H;AAC5H;AACA;;EAEE,0HAA0H;AAC5H;AACA;EACE,0HAA0H;EAC1H,UAAU;AACZ;AACA;EACE,kHAAkH;AACpH;AACA;;EAEE,wFAAwF;EACxF,gEAAgE;AAClE;AACA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE,SAAS;EACT,UAAU;AACZ","sourcesContent":["@charset \"UTF-8\";\n/** \n * These SASS variables are auto-generated out of their counter-part design-tokens \n * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n **/\n/** \n * These classes are auto-generated out of their counter-part design-tokens \n * during build of foundations using scripts/utils/generate-gap-utility-classes.mjs \n **/\n/** \n * These SASS variables are auto-generated out of their counter-part design-tokens \n * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n **/\n.mds {\n  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n  /* Document\n     ========================================================================== */\n  /**\n   * Render the `main` element consistently in IE.\n   */\n  /**\n   * Correct the font size and margin on `h1` elements within `section` and\n   * `article` contexts in Chrome, Firefox, and Safari.\n   */\n  /* Grouping content\n     ========================================================================== */\n  /**\n   * 1. Add the correct box sizing in Firefox.\n   * 2. Show the overflow in Edge and IE.\n   */\n  /**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n  /* Text-level semantics\n     ========================================================================== */\n  /**\n   * Remove the gray background on active links in IE 10.\n   */\n  /**\n   * 1. Remove the bottom border in Chrome 57-\n   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n   */\n  /**\n   * Add the correct font weight in Chrome, Edge, and Safari.\n   */\n  /**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n  /**\n   * Add the correct font size in all browsers.\n   */\n  /**\n   * Prevent `sub` and `sup` elements from affecting the line height in\n   * all browsers.\n   */\n  /* Embedded content\n     ========================================================================== */\n  /**\n   * Remove the border on images inside links in IE 10.\n   */\n  /* Forms\n     ========================================================================== */\n  /**\n   * 1. Change the font styles in all browsers.\n   * 2. Remove the margin in Firefox and Safari.\n   */\n  /**\n   * Show the overflow in IE.\n   * 1. Show the overflow in Edge.\n   */\n  /**\n   * Remove the inheritance of text transform in Edge, Firefox, and IE.\n   * 1. Remove the inheritance of text transform in Firefox.\n   */\n  /**\n   * Correct the inability to style clickable types in iOS and Safari.\n   */\n  /**\n   * Remove the inner border and padding in Firefox.\n   */\n  /**\n   * Restore the focus styles unset by the previous rule.\n   */\n  /**\n   * Correct the padding in Firefox.\n   */\n  /**\n   * 1. Correct the text wrapping in Edge and IE.\n   * 2. Correct the color inheritance from `fieldset` elements in IE.\n   * 3. Remove the padding so developers are not caught out when they zero out\n   *    `fieldset` elements in all browsers.\n   */\n  /**\n   * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n   */\n  /**\n   * Remove the default vertical scrollbar in IE 10+.\n   */\n  /**\n   * 1. Add the correct box sizing in IE 10.\n   * 2. Remove the padding in IE 10.\n   */\n  /**\n   * Correct the cursor style of increment and decrement buttons in Chrome.\n   */\n  /**\n   * 1. Correct the odd appearance in Chrome and Safari.\n   * 2. Correct the outline style in Safari.\n   */\n  /**\n   * Remove the inner padding in Chrome and Safari on macOS.\n   */\n  /**\n   * 1. Correct the inability to style clickable types in iOS and Safari.\n   * 2. Change font properties to `inherit` in Safari.\n   */\n  /* Interactive\n     ========================================================================== */\n  /*\n   * Add the correct display in Edge, IE 10+, and Firefox.\n   */\n  /*\n   * Add the correct display in all browsers.\n   */\n  /* Misc\n     ========================================================================== */\n  /**\n   * Add the correct display in IE 10+.\n   */\n  /**\n   * Add the correct display in IE 10.\n   */\n  /** \n   * These SASS variables are auto-generated out of their counter-part design-tokens \n   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n   **/\n  /*\n  @description: \n  A breadcrumb is a secondary navigation component used to show users their location within a website or application hierarchy.\n  Breadcrumbs should provide context and an easy way for users to navigate up the site hierarchy. They are not intended to replace primary navigation but to enhance the user’s understanding of where they are within the website or application. Use a breadcrumb for applications with a hierarchy of more than 2 levels.\n  */\n  /*\n  @description: \n  Color system for the Maersk Design System.\n  It includes a set of color appearances and variants that can be used for text, background, borders, and links.\n  The color system is designed to be flexible, making it suitable for various design needs.\n  It includes a set of predefined colors that can be used throughout the UI.\n  */\n  /** \n   * These SASS variables are auto-generated out of their counter-part design-tokens \n   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n   **/\n  /** \n   * These SASS variables are auto-generated out of their counter-part design-tokens \n   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n   **/\n  /** \n   * These SASS variables are auto-generated out of their counter-part design-tokens \n   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n   **/\n  /*\n  @description: \n  Base grid system utilities for layouts. \n  The grid system provides a flexible layout structure, allowing for consistent alignment and spacing of elements and is independent of container or viewport size. \n  It includes utilities for defining rows, columns, and spans, enabling developers to create complex layouts with ease.\n  For responsive layouts, use the container-based grid system in _container-grid.css or viewport-based grid system in _viewport-grid.css.\n  */\n  /** \n   * These SASS variables are auto-generated out of their counter-part design-tokens \n   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n   **/\n  /** \n   * These SASS variables are auto-generated out of their counter-part design-tokens \n   * during build of foundations using scripts/utils/generate-breakpoint-sass-variables.mjs \n   **/\n  /*\n  @description: \n  Container and grid system utilities for responsive layouts. \n  Container-based grid respond to the width of the container rather than the entire viewport. \n  This enables more granular control over layout behavior—allowing components to adapt based on their immediate context. \n  It’s especially effective in complex or modular layouts where sections of a page need to remain visually consistent, even within wider screens.\n  It includes utilities for defining rows, columns, and spans, enabling developers to create complex layouts with ease.\n  */\n  /** \n   * These classes are auto-generated out of their counter-part design-tokens \n   * during build of foundations using scripts/utils/generate-gap-utility-classes.mjs \n   **/\n  /** Table with caption **/\n  /** Caption **/\n}\n.mds main {\n  display: block;\n}\n.mds h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n.mds hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n.mds pre {\n  font-family: monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n.mds a {\n  background-color: transparent;\n}\n.mds abbr[title] {\n  border-bottom-width: 0; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n.mds b,\n.mds strong {\n  font-weight: bolder;\n}\n.mds code,\n.mds kbd,\n.mds samp {\n  font-family: monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n.mds small {\n  font-size: 80%;\n}\n.mds sub,\n.mds sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n.mds sub {\n  bottom: -0.25em;\n}\n.mds sup {\n  top: -0.5em;\n}\n.mds img {\n  border-style: none;\n}\n.mds button,\n.mds input,\n.mds optgroup,\n.mds select,\n.mds textarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n.mds button,\n.mds input {\n  /* 1 */\n  overflow: visible;\n}\n.mds button,\n.mds select {\n  /* 1 */\n  text-transform: none;\n}\n.mds button,\n.mds [type=button],\n.mds [type=reset],\n.mds [type=submit] {\n  -webkit-appearance: button;\n}\n.mds button::-moz-focus-inner,\n.mds [type=button]::-moz-focus-inner,\n.mds [type=reset]::-moz-focus-inner,\n.mds [type=submit]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n.mds button:-moz-focusring,\n.mds [type=button]:-moz-focusring,\n.mds [type=reset]:-moz-focusring,\n.mds [type=submit]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n.mds fieldset {\n  border-width: 0;\n  padding: 0;\n  margin: 0;\n}\n.mds legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n.mds progress {\n  vertical-align: baseline;\n}\n.mds textarea {\n  overflow: auto;\n}\n.mds [type=checkbox],\n.mds [type=radio] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n.mds [type=number]::-webkit-inner-spin-button,\n.mds [type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n.mds [type=search] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n.mds [type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n.mds ::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n.mds details {\n  display: block;\n}\n.mds summary {\n  display: list-item;\n}\n.mds template {\n  display: none;\n}\n.mds [hidden] {\n  display: none;\n}\n.mds * {\n  box-sizing: border-box;\n}\n.mds footer,\n.mds main {\n  display: block;\n}\n.mds button,\n.mds input,\n.mds optgroup,\n.mds select,\n.mds textarea {\n  font-family: inherit;\n}\n.mds code {\n  word-break: break-word;\n}\n.mds [slot=label],\n.mds [slot=errormessage],\n.mds [slot=hint],\n.mds [slot=legend] {\n  display: flex;\n  align-items: center;\n  gap: var(--mds_foundations_slot_gap);\n}\n.mds mc-modal h1,\n.mds mc-tab-bar h1,\n.mds mc-popover h1,\n.mds mc-c-accordion h1 {\n  margin: calc(var(--mds_foundations_typography_heading-1_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-1_margin-bottom) / 2) 0;\n}\n.mds mc-modal h2,\n.mds mc-tab-bar h2,\n.mds mc-popover h2,\n.mds mc-c-accordion h2 {\n  margin: calc(var(--mds_foundations_typography_heading-2_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-2_margin-bottom) / 2) 0;\n}\n.mds mc-modal h3,\n.mds mc-tab-bar h3,\n.mds mc-popover h3,\n.mds mc-c-accordion h3 {\n  margin: calc(var(--mds_foundations_typography_heading-3_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-3_margin-bottom) / 2) 0;\n}\n.mds mc-modal h4,\n.mds mc-tab-bar h4,\n.mds mc-popover h4,\n.mds mc-c-accordion h4 {\n  margin: calc(var(--mds_foundations_typography_heading-4_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-4_margin-bottom) / 2) 0;\n}\n.mds mc-modal h5,\n.mds mc-tab-bar h5,\n.mds mc-popover h5,\n.mds mc-c-accordion h5 {\n  margin: calc(var(--mds_foundations_typography_heading-4_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-4_margin-bottom) / 2) 0;\n}\n.mds mc-modal h6,\n.mds mc-tab-bar h6,\n.mds mc-popover h6,\n.mds mc-c-accordion h6 {\n  margin: calc(var(--mds_foundations_typography_heading-4_margin-top) / 2) 0 calc(var(--mds_foundations_typography_heading-4_margin-bottom) / 2) 0;\n}\n.mds mc-modal p,\n.mds mc-tab-bar p,\n.mds mc-popover p,\n.mds mc-c-accordion p {\n  margin: calc(var(--mds_foundations_typography_paragraph_margin-top) / 2) 0 calc(var(--mds_foundations_typography_paragraph_margin-bottom) / 2) 0;\n}\n.mds mc-modal hr,\n.mds mc-tab-bar hr,\n.mds mc-popover hr,\n.mds mc-c-accordion hr {\n  margin: calc(var(----mds_foundations_horizontal-rule_margin-top) / 2) 0 calc(var(--mds_foundations_horizontal-rule_margin-bottom) / 2) 0;\n}\n.mds mc-modal ol,\n.mds mc-modal ul,\n.mds mc-tab-bar ol,\n.mds mc-tab-bar ul,\n.mds mc-popover ol,\n.mds mc-popover ul,\n.mds mc-c-accordion ol,\n.mds mc-c-accordion ul {\n  margin: calc(var(--mds_foundations_list_margin-top) / 2) 0 calc(var(--mds_foundations_list_margin-bottom) / 2) 0;\n}\n.mds .mds-breadcrumb {\n  /* \n  @name: mds-breadcrumb\n  @category: Navigation\n  @usage: \n  Use breadcrumbs to give context and help users navigate.\n  All breadcrumbs items except the current page should be clickable links.\n  Use concise and descriptive link text for each level in the breadcrumb.\n  Avoid using dynamic or changing breadcrumbs, since it can confuse users.\n  Use truncation if the breadcrumb has more than 5 levels.\n  The breadcrumb should never wrap to the second line.\n  Place the breadcrumb consistently on each page across the website or application.\n  Don’t use a breadcrumb for simple and flat hierarchies e.g. a 2 level hierarchy.\n  @example:\n  <nav class=\"mds-breadcrumb\" aria-label=\"breadcrumb\">\n    <ol>\n      <li><a href=\"#home\">Home</a></li>\n      <li><a href=\"#digital-solutions\">Digital Solutions</a></li>\n      <li><a href=\"#data-integrations\">Data Integrations</a></li>\n      <li><a href=\"#ocean-booking\">Ocean Booking</a></li>\n      <li>Current page</li>\n    </ol>\n  </nav> */\n}\n.mds .mds-breadcrumb ol {\n  list-style: none;\n  flex-flow: row wrap;\n  gap: 0;\n  margin: 0;\n  padding: 0;\n}\n.mds .mds-breadcrumb ol li {\n  display: flex;\n  padding: 0;\n}\n.mds .mds-breadcrumb ol a {\n  text-decoration: none;\n  color: var(--mds_foundations_breadcrumb_item_text-color);\n  align-items: center;\n}\n.mds .mds-breadcrumb ol a:hover {\n  text-decoration: underline;\n}\n.mds .mds-breadcrumb ol a mc-icon::part(icon) {\n  fill: var(--mds_foundations_breadcrumb_item_text-color);\n}\n.mds .mds-breadcrumb ol li::after {\n  padding: 0 var(--mds_foundations_breadcrumb_item_padding);\n  color: var(--mds_brand_appearance_neutral_weakest_text-color);\n  content: \"/\";\n}\n.mds .mds-breadcrumb ol li:last-child {\n  color: var(--mds_foundations_breadcrumb_item_text-color);\n}\n.mds .mds-breadcrumb ol li:last-child::after {\n  content: \"\";\n}\n.mds .mds-breadcrumb ol li:last-child {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-breadcrumb ol li:last-child {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-breadcrumb ol li:last-child {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n.mds .mds-breadcrumb ol .mds-breadcrumb__long-and-truncated {\n  /* \n  @name: mds-breadcrumb__long-and-truncated\n  @category: Navigation\n  @usage: \n  It is recommended to limit the breadcrumb to 3-5 levels. If the website or application has a deeper hierarchy or is too long, then use truncation. Displaying more than 5 levels will make it hard for the user to comprehend the structure and in most cases there also starts to be a problem with space.\n  When truncated the breadcrumb only shows the first and the last two levels and the levels in between is replaced by an ellipsis.\n  @example:   \n  <nav class=\"mds-breadcrumb\" aria-label=\"breadcrumb example 1\">\n    <ol>\n      <li><a href=\"#home\">Home</a></li>\n      <li>\n        <a href=\"#data-integrations\" title=\"Data Integrations</a>\n      </li>\n      <li><a href=\"#ocean-booking\">Ocean Booking</a></li>\n      <li class=\"mds-breadcrumb__long-and-truncated\">API (Leverage the power of integrated data)</li>\n    </ol>\n  </nav> */\n  flex: 0.5;\n  display: block;\n  max-width: max-content;\n  padding-right: var(--mds_foundations_breadcrumb_truncated_item_padding);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n}\n.mds .mds-breadcrumb ol .mds-breadcrumb__long-and-truncated a {\n  display: inline;\n}\n.mds .mds-breadcrumb ol .mds-breadcrumb__long-and-truncated::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li {\n  display: none;\n}\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:first-child,\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3),\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2),\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:last-child {\n  display: flex;\n}\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) ~ li.mds-breadcrumb__long-and-truncated,\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2) ~ li.mds-breadcrumb__long-and-truncated {\n  display: block;\n}\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) a {\n  display: none;\n}\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3)::after {\n  content: \"...\";\n  padding: 0 var(--mds_foundations_breadcrumb_collapsed_padding) 0 0;\n  color: var(--mds_foundations_breadcrumb_item_text-color);\n}\n.mds .mds-breadcrumb.mds-breadcrumb__collapsed ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2)::before {\n  content: \"/\";\n  padding: 0 var(--mds_foundations_breadcrumb_item_padding);\n  color: var(--mds_foundations_breadcrumb_separator_text-color);\n}\n.mds .mds-breadcrumb {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-breadcrumb {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-breadcrumb {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n@media only screen and (max-width: 640px) {\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li {\n    display: none;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:first-child,\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3),\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2),\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:last-child {\n    display: flex;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) ~ li.mds-breadcrumb__long-and-truncated,\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2) ~ li.mds-breadcrumb__long-and-truncated {\n    display: block;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) a {\n    display: none;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3)::after {\n    content: \"...\";\n    padding: 0 var(--mds_foundations_breadcrumb_collapsed_padding) 0 0;\n    color: var(--mds_foundations_breadcrumb_item_text-color);\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2)::before {\n    content: \"/\";\n    padding: 0 var(--mds_foundations_breadcrumb_item_padding);\n    color: var(--mds_foundations_breadcrumb_separator_text-color);\n  }\n}\n@container (max-width: 640px) {\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li {\n    display: none;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:first-child,\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3),\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2),\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:last-child {\n    display: flex;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) ~ li.mds-breadcrumb__long-and-truncated,\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2) ~ li.mds-breadcrumb__long-and-truncated {\n    display: block;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3) a {\n    display: none;\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(3)::after {\n    content: \"...\";\n    padding: 0 var(--mds_foundations_breadcrumb_collapsed_padding) 0 0;\n    color: var(--mds_foundations_breadcrumb_item_text-color);\n  }\n  .mds .mds-breadcrumb ol:has(> :nth-last-child(4):nth-child(-n+20)) li:nth-last-child(2)::before {\n    content: \"/\";\n    padding: 0 var(--mds_foundations_breadcrumb_item_padding);\n    color: var(--mds_foundations_breadcrumb_separator_text-color);\n  }\n}\n.mds .mds-tree-nav ul,\n.mds .mds-tree-nav ol {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.mds .mds-tree-nav ul,\n.mds .mds-tree-nav ol {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-tree-nav ul,\n  .mds .mds-tree-nav ol {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-tree-nav ul,\n.mds .mds-tree-nav ol {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n.mds .mds-tree-nav li {\n  margin: 0;\n  padding: 0;\n}\n.mds .mds-tree-nav li.mds-tree-nav--separator {\n  border-top: 1px solid var(--mds_brand_appearance_neutral_weak_border-color);\n  margin: 10px 0;\n  padding: 0;\n}\n.mds .mds-tree-nav summary,\n.mds .mds-tree-nav a {\n  position: relative;\n  border-radius: var(--mds_brand_border_medium_radius);\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 2px;\n  overflow: hidden;\n  padding: 6px 36px 6px 8px;\n  text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n}\n.mds .mds-tree-nav summary mc-icon,\n.mds .mds-tree-nav a mc-icon {\n  margin-right: 8px;\n}\n.mds .mds-tree-nav summary mc-icon::part(icon),\n.mds .mds-tree-nav a mc-icon::part(icon) {\n  fill: var(--mds_brand_appearance_neutral_weak_text-color);\n}\n.mds .mds-tree-nav summary:visited,\n.mds .mds-tree-nav a:visited {\n  color: var(--mds_brand_appearance_neutral_weak_text-color);\n}\n.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,\n.mds .mds-tree-nav a:hover,\n.mds .mds-tree-nav a:active {\n  background-color: var(--mds_brand_appearance_state_neutral_default_hover_background-color);\n  color: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-tree-nav summary:hover mc-icon::part(icon), .mds .mds-tree-nav summary:active mc-icon::part(icon),\n.mds .mds-tree-nav a:hover mc-icon::part(icon),\n.mds .mds-tree-nav a:active mc-icon::part(icon) {\n  fill: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,\n.mds .mds-tree-nav a:hover,\n.mds .mds-tree-nav a:active {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,\n  .mds .mds-tree-nav a:hover,\n  .mds .mds-tree-nav a:active {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,\n.mds .mds-tree-nav a:hover,\n.mds .mds-tree-nav a:active {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n.mds .mds-tree-nav summary:hover, .mds .mds-tree-nav summary:active,\n.mds .mds-tree-nav a:hover,\n.mds .mds-tree-nav a:active {\n  color: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-tree-nav summary:focus-visible,\n.mds .mds-tree-nav a:focus-visible {\n  outline: 0;\n  box-shadow: inset var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);\n}\n.mds .mds-tree-nav summary,\n.mds .mds-tree-nav a {\n  color: var(--mds_brand_appearance_neutral_weak_text-color);\n}\n.mds .mds-tree-nav a.mds-tree-nav__active {\n  background-color: var(--mds_brand_appearance_info_weak_background-color);\n  color: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-tree-nav a.mds-tree-nav__active mc-icon::part(icon) {\n  fill: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-tree-nav a.mds-tree-nav__active {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-tree-nav a.mds-tree-nav__active {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-tree-nav a.mds-tree-nav__active {\n  font-style: var(--mds_brand_typography_text_small_medium_font-style);\n  font-weight: var(--mds_brand_typography_text_small_medium_font-weight);\n}\n.mds .mds-tree-nav a.mds-tree-nav__external::after {\n  margin-left: 16px;\n  display: inline;\n  height: 20px;\n  width: 20px;\n  background-color: var(--mds_brand_appearance_neutral_weak_text-color);\n  content: \"\";\n  -webkit-mask: url('data:image/svg+xml,<svg part=\"icon\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M15.293 4H12V3h3.293a1 1 0 0 1 .707.293l.707.707a1 1 0 0 1 .293.707V8h-1V4.707l-6.646 6.647-.708-.708L15.293 4zM3 7a2 2 0 0 1 2-2h4v1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4h1v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z\"></path></svg>') no-repeat 50% 50%;\n  mask: url('data:image/svg+xml,<svg part=\"icon\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M15.293 4H12V3h3.293a1 1 0 0 1 .707.293l.707.707a1 1 0 0 1 .293.707V8h-1V4.707l-6.646 6.647-.708-.708L15.293 4zM3 7a2 2 0 0 1 2-2h4v1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4h1v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z\"></path></svg>') no-repeat 50% 50%;\n  -webkit-mask-size: cover;\n  mask-size: cover;\n}\n.mds .mds-tree-nav summary {\n  list-style-type: none;\n  border-radius: var(--mds_brand_border_large_radius);\n}\n.mds .mds-tree-nav summary::-webkit-details-marker {\n  display: none;\n}\n.mds .mds-tree-nav details[open] {\n  color: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-tree-nav details > summary::after,\n.mds .mds-tree-nav a.mds-tree-nav__external::after {\n  position: absolute;\n  right: 8px;\n}\n.mds .mds-tree-nav details > summary::after {\n  margin-left: 16px;\n  height: 20px;\n  width: 20px;\n  background-color: var(--mds_brand_appearance_neutral_weak_text-color);\n  content: \"\";\n  -webkit-mask: url('data:image/svg+xml,<svg part=\"icon\" id=\"mi-chevron-down\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M8.717 13.643l-5.1-6.071.766-.644L9.483 13h1.034l5.1-6.072.766.644-5.1 6.071a1 1 0 0 1-.766.357H9.483a1 1 0 0 1-.766-.357z\"/></svg>') no-repeat 50% 50%;\n  mask: url('data:image/svg+xml,<svg part=\"icon\" id=\"mi-chevron-down\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M8.717 13.643l-5.1-6.071.766-.644L9.483 13h1.034l5.1-6.072.766.644-5.1 6.071a1 1 0 0 1-.766.357H9.483a1 1 0 0 1-.766-.357z\"/></svg>') no-repeat 50% 50%;\n  -webkit-mask-size: cover;\n  mask-size: cover;\n}\n.mds .mds-tree-nav details[open] > summary::after {\n  -webkit-mask: url('data:image/svg+xml,<svg part=\"icon\" id=\"mi-chevron-up\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M10.517 7H9.483l-5.1 6.072-.766-.644 5.1-6.071A1 1 0 0 1 9.483 6h1.034a1 1 0 0 1 .766.357l5.1 6.071-.766.644L10.517 7z\"/></svg>') no-repeat 50% 50%;\n  mask: url('data:image/svg+xml,<svg part=\"icon\" id=\"mi-chevron-up\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M10.517 7H9.483l-5.1 6.072-.766-.644 5.1-6.071A1 1 0 0 1 9.483 6h1.034a1 1 0 0 1 .766.357l5.1 6.071-.766.644L10.517 7z\"/></svg>') no-repeat 50% 50%;\n}\n.mds .mds-tree-nav details[open] > summary {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-tree-nav details[open] > summary {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-tree-nav details[open] > summary {\n  font-style: var(--mds_brand_typography_text_small_medium_font-style);\n  font-weight: var(--mds_brand_typography_text_small_medium_font-weight);\n}\n.mds .mds-tree-nav details > summary:hover::after {\n  background-color: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-tree-nav summary:has(mc-badge),\n.mds .mds-tree-nav a:has(mc-badge) {\n  padding-right: 8px;\n}\n.mds .mds-tree-nav summary:has(mc-badge[position=right]),\n.mds .mds-tree-nav a:has(mc-badge[position=right]) {\n  justify-content: space-between;\n}\n.mds .mds-tree-nav summary mc-badge[position=right] {\n  padding-right: 28px;\n}\n.mds .mds-tree-nav .mds-tree-nav__external mc-badge[position=right] {\n  padding-right: 28px;\n}\n.mds .mds-tree-nav li details li a,\n.mds .mds-tree-nav li details li summary {\n  padding-left: 24px;\n}\n.mds .mds-tree-nav li details li details li a,\n.mds .mds-tree-nav li details li details li summary {\n  padding-left: 48px;\n}\n.mds .mds-tree-nav li details li details li details li a,\n.mds .mds-tree-nav li details li details li details li summary {\n  padding-left: 72px;\n}\n.mds .mds-tree-nav li details li details li details li details li a,\n.mds .mds-tree-nav li details li details li details li details li summary {\n  padding-left: 96px;\n}\n.mds .mds-tree-nav li details li details li details li details li details li a,\n.mds .mds-tree-nav li details li details li details li details li details li summary {\n  padding-left: 120px;\n}\n.mds .mds-neutral__text-color {\n  /* \n  @name: mds-neutral__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral__text-color class to get the neutral color for text.\n  @example:\n  <div class=\"mds-neutral__text-color\">text color in neutral appearance</div>\n  */\n}\n.mds .mds-neutral__text-color {\n  color: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds .mds-neutral--weakest__text-color {\n  /* \n  @name: mds-neutral--weakest__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weakest__text-color class to get the neutral weakest color for text.\n  @example:\n  <div class=\"mds-neutral--weakest__text-color\">text color in neutral weakest appearance</div>\n  */\n}\n.mds .mds-neutral--weakest__text-color {\n  color: var(--mds_brand_appearance_neutral_weakest_text-color);\n}\n.mds .mds-neutral--weak__text-color {\n  /* \n  @name: mds-neutral--weak__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weak__text-color class to get the neutral weak color for text.\n  @example:\n  <div class=\"mds-neutral--weak__text-color\">text color in neutral weak appearance</div>\n  */\n}\n.mds .mds-neutral--weak__text-color {\n  color: var(--mds_brand_appearance_neutral_weak_text-color);\n}\n.mds .mds-neutral--strong__text-color {\n  /* \n  @name: mds-neutral--strong__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strong__text-color class to get the neutral strong color for text.\n  @example:\n  <div class=\"mds-neutral--strong__text-color\">text color in neutral strong appearance</div>\n  */\n}\n.mds .mds-neutral--strong__text-color {\n  color: var(--mds_brand_appearance_neutral_strong_text-color);\n}\n.mds .mds-neutral--strongest__text-color {\n  /* \n  @name: mds-neutral--strongest__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strongest__text-color class to get the neutral strongest color for text.\n  @example:\n  <div class=\"mds-neutral--strongest__text-color\">text color in neutral strongest appearance</div>\n  */\n}\n.mds .mds-neutral--strongest__text-color {\n  color: var(--mds_brand_appearance_neutral_strongest_text-color);\n}\n.mds .mds-neutral--inverse__text-color {\n  /* \n  @name: mds-neutral--inverse__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--inverse__text-color class to get the neutral inverse color for text.\n  @example:\n  <div class=\"mds-neutral--inverse__text-color\">text color in neutral inverse appearance</div>\n  */\n}\n.mds .mds-neutral--inverse__text-color {\n  color: var(--mds_brand_appearance_neutral_inverse_text-color);\n}\n.mds .mds-neutral--subtle__text-color {\n  /* \n  @name: mds-neutral--subtle__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--subtle__text-color class to get the neutral subtle color for text.\n  @example:\n  <div class=\"mds-neutral--subtle__text-color\">text color in neutral subtle appearance</div>\n  */\n}\n.mds .mds-neutral--subtle__text-color {\n  color: var(--mds_brand_appearance_neutral_subtle_text-color);\n}\n.mds .mds-neutral--alt__text-color {\n  /* \n  @name: mds-neutral--alt__text-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--alt__text-color class to get the neutral alt color for text.\n  @example:\n  <div class=\"mds-neutral--alt__text-color\">text color in neutral alt appearance</div>\n  */\n}\n.mds .mds-neutral--alt__text-color {\n  color: var(--mds_brand_appearance_neutral_alt_text-color);\n}\n.mds .mds-neutral__background-color {\n  /* \n  @name: mds-neutral__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral__background-color class to get the neutral color for background.\n  @example:\n  <div class=\"mds-neutral__background-color\">background color in neutral appearance</div>\n  */\n}\n.mds .mds-neutral__background-color {\n  background-color: var(--mds_brand_appearance_neutral_default_background-color);\n}\n.mds .mds-neutral--weakest__background-color {\n  /* \n  @name: mds-neutral--weakest__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weakest__background-color class to get the neutral weakest color for background.\n  @example:\n  <div class=\"mds-neutral--weakest__background-color\">background color in neutral weakest appearance</div>\n  */\n}\n.mds .mds-neutral--weakest__background-color {\n  background-color: var(--mds_brand_appearance_neutral_weakest_background-color);\n}\n.mds .mds-neutral--weak__background-color {\n  /* \n  @name: mds-neutral--weak__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weak__background-color class to get the neutral weak color for background.\n  @example:\n  <div class=\"mds-neutral--weak__background-color\">background color in neutral weak appearance</div>\n  */\n}\n.mds .mds-neutral--weak__background-color {\n  background-color: var(--mds_brand_appearance_neutral_weak_background-color);\n}\n.mds .mds-neutral--strong__background-color {\n  /* \n  @name: mds-neutral--strong__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strong__background-color class to get the neutral strong color for background.\n  @example:\n  <div class=\"mds-neutral--strong__background-color\">background color in neutral strong appearance</div>\n  */\n}\n.mds .mds-neutral--strong__background-color {\n  background-color: var(--mds_brand_appearance_neutral_strong_background-color);\n}\n.mds .mds-neutral--strongest__background-color {\n  /* \n  @name: mds-neutral--strongest__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strongest__background-color class to get the neutral strongest color for background.\n  @example:\n  <div class=\"mds-neutral--strongest__background-color\">background color in neutral strongest appearance</div>\n  */\n}\n.mds .mds-neutral--strongest__background-color {\n  background-color: var(--mds_brand_appearance_neutral_strongest_background-color);\n}\n.mds .mds-neutral--inverse__background-color {\n  /* \n  @name: mds-neutral--inverse__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--inverse__background-color class to get the neutral inverse color for background.\n  @example:\n  <div class=\"mds-neutral--inverse__background-color\">background color in neutral inverse appearance</div>\n  */\n}\n.mds .mds-neutral--inverse__background-color {\n  background-color: var(--mds_brand_appearance_neutral_inverse_background-color);\n}\n.mds .mds-neutral--subtle__background-color {\n  /* \n  @name: mds-neutral--subtle__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--subtle__background-color class to get the neutral subtle color for background.\n  @example:\n  <div class=\"mds-neutral--subtle__background-color\">background color in neutral subtle appearance</div>\n  */\n}\n.mds .mds-neutral--subtle__background-color {\n  background-color: var(--mds_brand_appearance_neutral_subtle_background-color);\n}\n.mds .mds-neutral--alt__background-color {\n  /* \n  @name: mds-neutral--alt__background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--alt__background-color class to get the neutral alt color for background.\n  @example:\n  <div class=\"mds-neutral--alt__background-color\">background color in neutral alt appearance</div>\n  */\n}\n.mds .mds-neutral--alt__background-color {\n  background-color: var(--mds_brand_appearance_neutral_alt_background-color);\n}\n.mds .mds-neutral__on-background-color {\n  /* \n  @name: mds-neutral__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral__on-background-color class to get the neutral color for on-background.\n  @example:\n  <div class=\"mds-neutral__on-background-color\">on-background color in neutral appearance</div>\n  */\n}\n.mds .mds-neutral__on-background-color {\n  color: var(--mds_brand_appearance_neutral_default_on-background-color);\n}\n.mds .mds-neutral--weakest__on-background-color {\n  /* \n  @name: mds-neutral--weakest__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weakest__on-background-color class to get the neutral weakest color for on-background.\n  @example:\n  <div class=\"mds-neutral--weakest__on-background-color\">on-background color in neutral weakest appearance</div>\n  */\n}\n.mds .mds-neutral--weakest__on-background-color {\n  color: var(--mds_brand_appearance_neutral_weakest_on-background-color);\n}\n.mds .mds-neutral--weak__on-background-color {\n  /* \n  @name: mds-neutral--weak__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weak__on-background-color class to get the neutral weak color for on-background.\n  @example:\n  <div class=\"mds-neutral--weak__on-background-color\">on-background color in neutral weak appearance</div>\n  */\n}\n.mds .mds-neutral--weak__on-background-color {\n  color: var(--mds_brand_appearance_neutral_weak_on-background-color);\n}\n.mds .mds-neutral--strong__on-background-color {\n  /* \n  @name: mds-neutral--strong__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strong__on-background-color class to get the neutral strong color for on-background.\n  @example:\n  <div class=\"mds-neutral--strong__on-background-color\">on-background color in neutral strong appearance</div>\n  */\n}\n.mds .mds-neutral--strong__on-background-color {\n  color: var(--mds_brand_appearance_neutral_strong_on-background-color);\n}\n.mds .mds-neutral--strongest__on-background-color {\n  /* \n  @name: mds-neutral--strongest__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strongest__on-background-color class to get the neutral strongest color for on-background.\n  @example:\n  <div class=\"mds-neutral--strongest__on-background-color\">on-background color in neutral strongest appearance</div>\n  */\n}\n.mds .mds-neutral--strongest__on-background-color {\n  color: var(--mds_brand_appearance_neutral_strongest_on-background-color);\n}\n.mds .mds-neutral--inverse__on-background-color {\n  /* \n  @name: mds-neutral--inverse__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--inverse__on-background-color class to get the neutral inverse color for on-background.\n  @example:\n  <div class=\"mds-neutral--inverse__on-background-color\">on-background color in neutral inverse appearance</div>\n  */\n}\n.mds .mds-neutral--inverse__on-background-color {\n  color: var(--mds_brand_appearance_neutral_inverse_on-background-color);\n}\n.mds .mds-neutral--subtle__on-background-color {\n  /* \n  @name: mds-neutral--subtle__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--subtle__on-background-color class to get the neutral subtle color for on-background.\n  @example:\n  <div class=\"mds-neutral--subtle__on-background-color\">on-background color in neutral subtle appearance</div>\n  */\n}\n.mds .mds-neutral--subtle__on-background-color {\n  color: var(--mds_brand_appearance_neutral_subtle_on-background-color);\n}\n.mds .mds-neutral--alt__on-background-color {\n  /* \n  @name: mds-neutral--alt__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--alt__on-background-color class to get the neutral alt color for on-background.\n  @example:\n  <div class=\"mds-neutral--alt__on-background-color\">on-background color in neutral alt appearance</div>\n  */\n}\n.mds .mds-neutral--alt__on-background-color {\n  color: var(--mds_brand_appearance_neutral_alt_on-background-color);\n}\n.mds .mds-neutral__border-color {\n  /* \n  @name: mds-neutral__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral__border-color class to get the neutral color for border.\n  @example:\n  <div class=\"mds-neutral__border-color\">border color in neutral appearance</div>\n  */\n}\n.mds .mds-neutral__border-color {\n  border-color: var(--mds_brand_appearance_neutral_default_border-color);\n}\n.mds .mds-neutral--weakest__border-color {\n  /* \n  @name: mds-neutral--weakest__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weakest__border-color class to get the neutral weakest color for border.\n  @example:\n  <div class=\"mds-neutral--weakest__border-color\">border color in neutral weakest appearance</div>\n  */\n}\n.mds .mds-neutral--weakest__border-color {\n  border-color: var(--mds_brand_appearance_neutral_weakest_border-color);\n}\n.mds .mds-neutral--weak__border-color {\n  /* \n  @name: mds-neutral--weak__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--weak__border-color class to get the neutral weak color for border.\n  @example:\n  <div class=\"mds-neutral--weak__border-color\">border color in neutral weak appearance</div>\n  */\n}\n.mds .mds-neutral--weak__border-color {\n  border-color: var(--mds_brand_appearance_neutral_weak_border-color);\n}\n.mds .mds-neutral--strong__border-color {\n  /* \n  @name: mds-neutral--strong__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strong__border-color class to get the neutral strong color for border.\n  @example:\n  <div class=\"mds-neutral--strong__border-color\">border color in neutral strong appearance</div>\n  */\n}\n.mds .mds-neutral--strong__border-color {\n  border-color: var(--mds_brand_appearance_neutral_strong_border-color);\n}\n.mds .mds-neutral--strongest__border-color {\n  /* \n  @name: mds-neutral--strongest__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--strongest__border-color class to get the neutral strongest color for border.\n  @example:\n  <div class=\"mds-neutral--strongest__border-color\">border color in neutral strongest appearance</div>\n  */\n}\n.mds .mds-neutral--strongest__border-color {\n  border-color: var(--mds_brand_appearance_neutral_strongest_border-color);\n}\n.mds .mds-neutral--inverse__border-color {\n  /* \n  @name: mds-neutral--inverse__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--inverse__border-color class to get the neutral inverse color for border.\n  @example:\n  <div class=\"mds-neutral--inverse__border-color\">border color in neutral inverse appearance</div>\n  */\n}\n.mds .mds-neutral--inverse__border-color {\n  border-color: var(--mds_brand_appearance_neutral_inverse_border-color);\n}\n.mds .mds-neutral--subtle__border-color {\n  /* \n  @name: mds-neutral--subtle__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--subtle__border-color class to get the neutral subtle color for border.\n  @example:\n  <div class=\"mds-neutral--subtle__border-color\">border color in neutral subtle appearance</div>\n  */\n}\n.mds .mds-neutral--subtle__border-color {\n  border-color: var(--mds_brand_appearance_neutral_subtle_border-color);\n}\n.mds .mds-neutral--alt__border-color {\n  /* \n  @name: mds-neutral--alt__border-color\n  @category: Colors\n  @usage: \n  Use mds-neutral--alt__border-color class to get the neutral alt color for border.\n  @example:\n  <div class=\"mds-neutral--alt__border-color\">border color in neutral alt appearance</div>\n  */\n}\n.mds .mds-neutral--alt__border-color {\n  border-color: var(--mds_brand_appearance_neutral_alt_border-color);\n}\n.mds a.mds-neutral__text-color,\n.mds a.mds-neutral__text-color:active,\n.mds a.mds-neutral__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_default_text-color);\n}\n.mds a.mds-neutral--weakest__text-color,\n.mds a.mds-neutral--weakest__text-color:active,\n.mds a.mds-neutral--weakest__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_weakest_text-color);\n}\n.mds a.mds-neutral--weak__text-color,\n.mds a.mds-neutral--weak__text-color:active,\n.mds a.mds-neutral--weak__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_weak_text-color);\n}\n.mds a.mds-neutral--strong__text-color,\n.mds a.mds-neutral--strong__text-color:active,\n.mds a.mds-neutral--strong__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_strong_text-color);\n}\n.mds a.mds-neutral--strongest__text-color,\n.mds a.mds-neutral--strongest__text-color:active,\n.mds a.mds-neutral--strongest__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_strongest_text-color);\n}\n.mds a.mds-neutral--inverse__text-color,\n.mds a.mds-neutral--inverse__text-color:active,\n.mds a.mds-neutral--inverse__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_inverse_text-color);\n}\n.mds a.mds-neutral--subtle__text-color,\n.mds a.mds-neutral--subtle__text-color:active,\n.mds a.mds-neutral--subtle__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_subtle_text-color);\n}\n.mds a.mds-neutral--alt__text-color,\n.mds a.mds-neutral--alt__text-color:active,\n.mds a.mds-neutral--alt__text-color:visited {\n  color: var(--mds_brand_appearance_neutral_alt_text-color);\n}\n.mds .mds-primary__text-color {\n  /* \n  @name: mds-primary__text-color\n  @category: Colors\n  @usage: \n  Use mds-primary__text-color class to get the primary color for text.\n  @example:\n  <div class=\"mds-primary__text-color\">text color in primary appearance</div>\n  */\n}\n.mds .mds-primary__text-color {\n  color: var(--mds_brand_appearance_primary_default_text-color);\n}\n.mds .mds-primary--weak__text-color {\n  /* \n  @name: mds-primary--weak__text-color\n  @category: Colors\n  @usage: \n  Use mds-primary--weak__text-color class to get the primary weak color for text.\n  @example:\n  <div class=\"mds-primary--weak__text-color\">text color in primary weak appearance</div>\n  */\n}\n.mds .mds-primary--weak__text-color {\n  color: var(--mds_brand_appearance_primary_weak_text-color);\n}\n.mds .mds-primary--subtle__text-color {\n  /* \n  @name: mds-primary--subtle__text-color\n  @category: Colors\n  @usage: \n  Use mds-primary--subtle__text-color class to get the primary subtle color for text.\n  @example:\n  <div class=\"mds-primary--subtle__text-color\">text color in primary subtle appearance</div>\n  */\n}\n.mds .mds-primary--subtle__text-color {\n  color: var(--mds_brand_appearance_primary_subtle_text-color);\n}\n.mds .mds-primary__background-color {\n  /* \n  @name: mds-primary__background-color\n  @category: Colors\n  @usage: \n  Use mds-primary__background-color class to get the primary color for background.\n  @example:\n  <div class=\"mds-primary__background-color\">background color in primary appearance</div>\n  */\n}\n.mds .mds-primary__background-color {\n  background-color: var(--mds_brand_appearance_primary_default_background-color);\n}\n.mds .mds-primary--weak__background-color {\n  /* \n  @name: mds-primary--weak__background-color\n  @category: Colors\n  @usage: \n  Use mds-primary--weak__background-color class to get the primary weak color for background.\n  @example:\n  <div class=\"mds-primary--weak__background-color\">background color in primary weak appearance</div>\n  */\n}\n.mds .mds-primary--weak__background-color {\n  background-color: var(--mds_brand_appearance_primary_weak_background-color);\n}\n.mds .mds-primary--subtle__background-color {\n  /* \n  @name: mds-primary--subtle__background-color\n  @category: Colors\n  @usage: \n  Use mds-primary--subtle__background-color class to get the primary subtle color for background.\n  @example:\n  <div class=\"mds-primary--subtle__background-color\">background color in primary subtle appearance</div>\n  */\n}\n.mds .mds-primary--subtle__background-color {\n  background-color: var(--mds_brand_appearance_primary_subtle_background-color);\n}\n.mds .mds-primary__on-background-color {\n  /* \n  @name: mds-primary__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-primary__on-background-color class to get the primary color for on-background.\n  @example:\n  <div class=\"mds-primary__on-background-color\">on-background color in primary appearance</div>\n  */\n}\n.mds .mds-primary__on-background-color {\n  color: var(--mds_brand_appearance_primary_default_on-background-color);\n}\n.mds .mds-primary--weak__on-background-color {\n  /* \n  @name: mds-primary--weak__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-primary--weak__on-background-color class to get the primary weak color for on-background.\n  @example:\n  <div class=\"mds-primary--weak__on-background-color\">on-background color in primary weak appearance</div>\n  */\n}\n.mds .mds-primary--weak__on-background-color {\n  color: var(--mds_brand_appearance_primary_weak_on-background-color);\n}\n.mds .mds-primary--subtle__on-background-color {\n  /* \n  @name: mds-primary--subtle__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-primary--subtle__on-background-color class to get the primary subtle color for on-background.\n  @example:\n  <div class=\"mds-primary--subtle__on-background-color\">on-background color in primary subtle appearance</div>\n  */\n}\n.mds .mds-primary--subtle__on-background-color {\n  color: var(--mds_brand_appearance_primary_subtle_on-background-color);\n}\n.mds .mds-primary__border-color {\n  /* \n  @name: mds-primary__border-color\n  @category: Colors\n  @usage: \n  Use mds-primary__border-color class to get the primary color for border.\n  @example:\n  <div class=\"mds-primary__border-color\">border color in primary appearance</div>\n  */\n}\n.mds .mds-primary__border-color {\n  border-color: var(--mds_brand_appearance_primary_default_border-color);\n}\n.mds .mds-primary--weak__border-color {\n  /* \n  @name: mds-primary--weak__border-color\n  @category: Colors\n  @usage: \n  Use mds-primary--weak__border-color class to get the primary weak color for border.\n  @example:\n  <div class=\"mds-primary--weak__border-color\">border color in primary weak appearance</div>\n  */\n}\n.mds .mds-primary--weak__border-color {\n  border-color: var(--mds_brand_appearance_primary_weak_border-color);\n}\n.mds .mds-primary--subtle__border-color {\n  /* \n  @name: mds-primary--subtle__border-color\n  @category: Colors\n  @usage: \n  Use mds-primary--subtle__border-color class to get the primary subtle color for border.\n  @example:\n  <div class=\"mds-primary--subtle__border-color\">border color in primary subtle appearance</div>\n  */\n}\n.mds .mds-primary--subtle__border-color {\n  border-color: var(--mds_brand_appearance_primary_subtle_border-color);\n}\n.mds a.mds-primary__text-color,\n.mds a.mds-primary__text-color:active,\n.mds a.mds-primary__text-color:visited {\n  color: var(--mds_brand_appearance_primary_default_text-color);\n}\n.mds a.mds-primary--weak__text-color,\n.mds a.mds-primary--weak__text-color:active,\n.mds a.mds-primary--weak__text-color:visited {\n  color: var(--mds_brand_appearance_primary_weak_text-color);\n}\n.mds a.mds-primary--subtle__text-color,\n.mds a.mds-primary--subtle__text-color:active,\n.mds a.mds-primary--subtle__text-color:visited {\n  color: var(--mds_brand_appearance_primary_subtle_text-color);\n}\n.mds .mds-secondary__text-color {\n  /* \n  @name: mds-secondary__text-color\n  @category: Colors\n  @usage: \n  Use mds-secondary__text-color class to get the secondary color for text.\n  @example:\n  <div class=\"mds-secondary__text-color\">text color in secondary appearance</div>\n  */\n}\n.mds .mds-secondary__text-color {\n  color: var(--mds_brand_appearance_secondary_default_text-color);\n}\n.mds .mds-secondary--weak__text-color {\n  /* \n  @name: mds-secondary--weak__text-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--weak__text-color class to get the secondary weak color for text.\n  @example:\n  <div class=\"mds-secondary--weak__text-color\">text color in secondary weak appearance</div>\n  */\n}\n.mds .mds-secondary--weak__text-color {\n  color: var(--mds_brand_appearance_secondary_weak_text-color);\n}\n.mds .mds-secondary--subtle__text-color {\n  /* \n  @name: mds-secondary--subtle__text-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--subtle__text-color class to get the secondary subtle color for text.\n  @example:\n  <div class=\"mds-secondary--subtle__text-color\">text color in secondary subtle appearance</div>\n  */\n}\n.mds .mds-secondary--subtle__text-color {\n  color: var(--mds_brand_appearance_secondary_subtle_text-color);\n}\n.mds .mds-secondary__background-color {\n  /* \n  @name: mds-secondary__background-color\n  @category: Colors\n  @usage: \n  Use mds-secondary__background-color class to get the secondary color for background.\n  @example:\n  <div class=\"mds-secondary__background-color\">background color in secondary appearance</div>\n  */\n}\n.mds .mds-secondary__background-color {\n  background-color: var(--mds_brand_appearance_secondary_default_background-color);\n}\n.mds .mds-secondary--weak__background-color {\n  /* \n  @name: mds-secondary--weak__background-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--weak__background-color class to get the secondary weak color for background.\n  @example:\n  <div class=\"mds-secondary--weak__background-color\">background color in secondary weak appearance</div>\n  */\n}\n.mds .mds-secondary--weak__background-color {\n  background-color: var(--mds_brand_appearance_secondary_weak_background-color);\n}\n.mds .mds-secondary--subtle__background-color {\n  /* \n  @name: mds-secondary--subtle__background-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--subtle__background-color class to get the secondary subtle color for background.\n  @example:\n  <div class=\"mds-secondary--subtle__background-color\">background color in secondary subtle appearance</div>\n  */\n}\n.mds .mds-secondary--subtle__background-color {\n  background-color: var(--mds_brand_appearance_secondary_subtle_background-color);\n}\n.mds .mds-secondary__on-background-color {\n  /* \n  @name: mds-secondary__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-secondary__on-background-color class to get the secondary color for on-background.\n  @example:\n  <div class=\"mds-secondary__on-background-color\">on-background color in secondary appearance</div>\n  */\n}\n.mds .mds-secondary__on-background-color {\n  color: var(--mds_brand_appearance_secondary_default_on-background-color);\n}\n.mds .mds-secondary--weak__on-background-color {\n  /* \n  @name: mds-secondary--weak__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--weak__on-background-color class to get the secondary weak color for on-background.\n  @example:\n  <div class=\"mds-secondary--weak__on-background-color\">on-background color in secondary weak appearance</div>\n  */\n}\n.mds .mds-secondary--weak__on-background-color {\n  color: var(--mds_brand_appearance_secondary_weak_on-background-color);\n}\n.mds .mds-secondary--subtle__on-background-color {\n  /* \n  @name: mds-secondary--subtle__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--subtle__on-background-color class to get the secondary subtle color for on-background.\n  @example:\n  <div class=\"mds-secondary--subtle__on-background-color\">on-background color in secondary subtle appearance</div>\n  */\n}\n.mds .mds-secondary--subtle__on-background-color {\n  color: var(--mds_brand_appearance_secondary_subtle_on-background-color);\n}\n.mds .mds-secondary__border-color {\n  /* \n  @name: mds-secondary__border-color\n  @category: Colors\n  @usage: \n  Use mds-secondary__border-color class to get the secondary color for border.\n  @example:\n  <div class=\"mds-secondary__border-color\">border color in secondary appearance</div>\n  */\n}\n.mds .mds-secondary__border-color {\n  border-color: var(--mds_brand_appearance_secondary_default_border-color);\n}\n.mds .mds-secondary--weak__border-color {\n  /* \n  @name: mds-secondary--weak__border-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--weak__border-color class to get the secondary weak color for border.\n  @example:\n  <div class=\"mds-secondary--weak__border-color\">border color in secondary weak appearance</div>\n  */\n}\n.mds .mds-secondary--weak__border-color {\n  border-color: var(--mds_brand_appearance_secondary_weak_border-color);\n}\n.mds .mds-secondary--subtle__border-color {\n  /* \n  @name: mds-secondary--subtle__border-color\n  @category: Colors\n  @usage: \n  Use mds-secondary--subtle__border-color class to get the secondary subtle color for border.\n  @example:\n  <div class=\"mds-secondary--subtle__border-color\">border color in secondary subtle appearance</div>\n  */\n}\n.mds .mds-secondary--subtle__border-color {\n  border-color: var(--mds_brand_appearance_secondary_subtle_border-color);\n}\n.mds a.mds-secondary__text-color,\n.mds a.mds-secondary__text-color:active,\n.mds a.mds-secondary__text-color:visited {\n  color: var(--mds_brand_appearance_secondary_default_text-color);\n}\n.mds a.mds-secondary--weak__text-color,\n.mds a.mds-secondary--weak__text-color:active,\n.mds a.mds-secondary--weak__text-color:visited {\n  color: var(--mds_brand_appearance_secondary_weak_text-color);\n}\n.mds a.mds-secondary--subtle__text-color,\n.mds a.mds-secondary--subtle__text-color:active,\n.mds a.mds-secondary--subtle__text-color:visited {\n  color: var(--mds_brand_appearance_secondary_subtle_text-color);\n}\n.mds .mds-info__text-color {\n  /* \n  @name: mds-info__text-color\n  @category: Colors\n  @usage: \n  Use mds-info__text-color class to get the info color for text.\n  @example:\n  <div class=\"mds-info__text-color\">text color in info appearance</div>\n  */\n}\n.mds .mds-info__text-color {\n  color: var(--mds_brand_appearance_info_default_text-color);\n}\n.mds .mds-info--weak__text-color {\n  /* \n  @name: mds-info--weak__text-color\n  @category: Colors\n  @usage: \n  Use mds-info--weak__text-color class to get the info weak color for text.\n  @example:\n  <div class=\"mds-info--weak__text-color\">text color in info weak appearance</div>\n  */\n}\n.mds .mds-info--weak__text-color {\n  color: var(--mds_brand_appearance_info_weak_text-color);\n}\n.mds .mds-info--subtle__text-color {\n  /* \n  @name: mds-info--subtle__text-color\n  @category: Colors\n  @usage: \n  Use mds-info--subtle__text-color class to get the info subtle color for text.\n  @example:\n  <div class=\"mds-info--subtle__text-color\">text color in info subtle appearance</div>\n  */\n}\n.mds .mds-info--subtle__text-color {\n  color: var(--mds_brand_appearance_info_subtle_text-color);\n}\n.mds .mds-info__background-color {\n  /* \n  @name: mds-info__background-color\n  @category: Colors\n  @usage: \n  Use mds-info__background-color class to get the info color for background.\n  @example:\n  <div class=\"mds-info__background-color\">background color in info appearance</div>\n  */\n}\n.mds .mds-info__background-color {\n  background-color: var(--mds_brand_appearance_info_default_background-color);\n}\n.mds .mds-info--weak__background-color {\n  /* \n  @name: mds-info--weak__background-color\n  @category: Colors\n  @usage: \n  Use mds-info--weak__background-color class to get the info weak color for background.\n  @example:\n  <div class=\"mds-info--weak__background-color\">background color in info weak appearance</div>\n  */\n}\n.mds .mds-info--weak__background-color {\n  background-color: var(--mds_brand_appearance_info_weak_background-color);\n}\n.mds .mds-info--subtle__background-color {\n  /* \n  @name: mds-info--subtle__background-color\n  @category: Colors\n  @usage: \n  Use mds-info--subtle__background-color class to get the info subtle color for background.\n  @example:\n  <div class=\"mds-info--subtle__background-color\">background color in info subtle appearance</div>\n  */\n}\n.mds .mds-info--subtle__background-color {\n  background-color: var(--mds_brand_appearance_info_subtle_background-color);\n}\n.mds .mds-info__on-background-color {\n  /* \n  @name: mds-info__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-info__on-background-color class to get the info color for on-background.\n  @example:\n  <div class=\"mds-info__on-background-color\">on-background color in info appearance</div>\n  */\n}\n.mds .mds-info__on-background-color {\n  color: var(--mds_brand_appearance_info_default_on-background-color);\n}\n.mds .mds-info--weak__on-background-color {\n  /* \n  @name: mds-info--weak__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-info--weak__on-background-color class to get the info weak color for on-background.\n  @example:\n  <div class=\"mds-info--weak__on-background-color\">on-background color in info weak appearance</div>\n  */\n}\n.mds .mds-info--weak__on-background-color {\n  color: var(--mds_brand_appearance_info_weak_on-background-color);\n}\n.mds .mds-info--subtle__on-background-color {\n  /* \n  @name: mds-info--subtle__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-info--subtle__on-background-color class to get the info subtle color for on-background.\n  @example:\n  <div class=\"mds-info--subtle__on-background-color\">on-background color in info subtle appearance</div>\n  */\n}\n.mds .mds-info--subtle__on-background-color {\n  color: var(--mds_brand_appearance_info_subtle_on-background-color);\n}\n.mds .mds-info__border-color {\n  /* \n  @name: mds-info__border-color\n  @category: Colors\n  @usage: \n  Use mds-info__border-color class to get the info color for border.\n  @example:\n  <div class=\"mds-info__border-color\">border color in info appearance</div>\n  */\n}\n.mds .mds-info__border-color {\n  border-color: var(--mds_brand_appearance_info_default_border-color);\n}\n.mds .mds-info--weak__border-color {\n  /* \n  @name: mds-info--weak__border-color\n  @category: Colors\n  @usage: \n  Use mds-info--weak__border-color class to get the info weak color for border.\n  @example:\n  <div class=\"mds-info--weak__border-color\">border color in info weak appearance</div>\n  */\n}\n.mds .mds-info--weak__border-color {\n  border-color: var(--mds_brand_appearance_info_weak_border-color);\n}\n.mds .mds-info--subtle__border-color {\n  /* \n  @name: mds-info--subtle__border-color\n  @category: Colors\n  @usage: \n  Use mds-info--subtle__border-color class to get the info subtle color for border.\n  @example:\n  <div class=\"mds-info--subtle__border-color\">border color in info subtle appearance</div>\n  */\n}\n.mds .mds-info--subtle__border-color {\n  border-color: var(--mds_brand_appearance_info_subtle_border-color);\n}\n.mds a.mds-info__text-color,\n.mds a.mds-info__text-color:active,\n.mds a.mds-info__text-color:visited {\n  color: var(--mds_brand_appearance_info_default_text-color);\n}\n.mds a.mds-info--weak__text-color,\n.mds a.mds-info--weak__text-color:active,\n.mds a.mds-info--weak__text-color:visited {\n  color: var(--mds_brand_appearance_info_weak_text-color);\n}\n.mds a.mds-info--subtle__text-color,\n.mds a.mds-info--subtle__text-color:active,\n.mds a.mds-info--subtle__text-color:visited {\n  color: var(--mds_brand_appearance_info_subtle_text-color);\n}\n.mds .mds-error__text-color {\n  /* \n  @name: mds-error__text-color\n  @category: Colors\n  @usage: \n  Use mds-error__text-color class to get the error color for text.\n  @example:\n  <div class=\"mds-error__text-color\">text color in error appearance</div>\n  */\n}\n.mds .mds-error__text-color {\n  color: var(--mds_brand_appearance_error_default_text-color);\n}\n.mds .mds-error--weak__text-color {\n  /* \n  @name: mds-error--weak__text-color\n  @category: Colors\n  @usage: \n  Use mds-error--weak__text-color class to get the error weak color for text.\n  @example:\n  <div class=\"mds-error--weak__text-color\">text color in error weak appearance</div>\n  */\n}\n.mds .mds-error--weak__text-color {\n  color: var(--mds_brand_appearance_error_weak_text-color);\n}\n.mds .mds-error--subtle__text-color {\n  /* \n  @name: mds-error--subtle__text-color\n  @category: Colors\n  @usage: \n  Use mds-error--subtle__text-color class to get the error subtle color for text.\n  @example:\n  <div class=\"mds-error--subtle__text-color\">text color in error subtle appearance</div>\n  */\n}\n.mds .mds-error--subtle__text-color {\n  color: var(--mds_brand_appearance_error_subtle_text-color);\n}\n.mds .mds-error__background-color {\n  /* \n  @name: mds-error__background-color\n  @category: Colors\n  @usage: \n  Use mds-error__background-color class to get the error color for background.\n  @example:\n  <div class=\"mds-error__background-color\">background color in error appearance</div>\n  */\n}\n.mds .mds-error__background-color {\n  background-color: var(--mds_brand_appearance_error_default_background-color);\n}\n.mds .mds-error--weak__background-color {\n  /* \n  @name: mds-error--weak__background-color\n  @category: Colors\n  @usage: \n  Use mds-error--weak__background-color class to get the error weak color for background.\n  @example:\n  <div class=\"mds-error--weak__background-color\">background color in error weak appearance</div>\n  */\n}\n.mds .mds-error--weak__background-color {\n  background-color: var(--mds_brand_appearance_error_weak_background-color);\n}\n.mds .mds-error--subtle__background-color {\n  /* \n  @name: mds-error--subtle__background-color\n  @category: Colors\n  @usage: \n  Use mds-error--subtle__background-color class to get the error subtle color for background.\n  @example:\n  <div class=\"mds-error--subtle__background-color\">background color in error subtle appearance</div>\n  */\n}\n.mds .mds-error--subtle__background-color {\n  background-color: var(--mds_brand_appearance_error_subtle_background-color);\n}\n.mds .mds-error__on-background-color {\n  /* \n  @name: mds-error__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-error__on-background-color class to get the error color for on-background.\n  @example:\n  <div class=\"mds-error__on-background-color\">on-background color in error appearance</div>\n  */\n}\n.mds .mds-error__on-background-color {\n  color: var(--mds_brand_appearance_error_default_on-background-color);\n}\n.mds .mds-error--weak__on-background-color {\n  /* \n  @name: mds-error--weak__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-error--weak__on-background-color class to get the error weak color for on-background.\n  @example:\n  <div class=\"mds-error--weak__on-background-color\">on-background color in error weak appearance</div>\n  */\n}\n.mds .mds-error--weak__on-background-color {\n  color: var(--mds_brand_appearance_error_weak_on-background-color);\n}\n.mds .mds-error--subtle__on-background-color {\n  /* \n  @name: mds-error--subtle__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-error--subtle__on-background-color class to get the error subtle color for on-background.\n  @example:\n  <div class=\"mds-error--subtle__on-background-color\">on-background color in error subtle appearance</div>\n  */\n}\n.mds .mds-error--subtle__on-background-color {\n  color: var(--mds_brand_appearance_error_subtle_on-background-color);\n}\n.mds .mds-error__border-color {\n  /* \n  @name: mds-error__border-color\n  @category: Colors\n  @usage: \n  Use mds-error__border-color class to get the error color for border.\n  @example:\n  <div class=\"mds-error__border-color\">border color in error appearance</div>\n  */\n}\n.mds .mds-error__border-color {\n  border-color: var(--mds_brand_appearance_error_default_border-color);\n}\n.mds .mds-error--weak__border-color {\n  /* \n  @name: mds-error--weak__border-color\n  @category: Colors\n  @usage: \n  Use mds-error--weak__border-color class to get the error weak color for border.\n  @example:\n  <div class=\"mds-error--weak__border-color\">border color in error weak appearance</div>\n  */\n}\n.mds .mds-error--weak__border-color {\n  border-color: var(--mds_brand_appearance_error_weak_border-color);\n}\n.mds .mds-error--subtle__border-color {\n  /* \n  @name: mds-error--subtle__border-color\n  @category: Colors\n  @usage: \n  Use mds-error--subtle__border-color class to get the error subtle color for border.\n  @example:\n  <div class=\"mds-error--subtle__border-color\">border color in error subtle appearance</div>\n  */\n}\n.mds .mds-error--subtle__border-color {\n  border-color: var(--mds_brand_appearance_error_subtle_border-color);\n}\n.mds a.mds-error__text-color,\n.mds a.mds-error__text-color:active,\n.mds a.mds-error__text-color:visited {\n  color: var(--mds_brand_appearance_error_default_text-color);\n}\n.mds a.mds-error--weak__text-color,\n.mds a.mds-error--weak__text-color:active,\n.mds a.mds-error--weak__text-color:visited {\n  color: var(--mds_brand_appearance_error_weak_text-color);\n}\n.mds a.mds-error--subtle__text-color,\n.mds a.mds-error--subtle__text-color:active,\n.mds a.mds-error--subtle__text-color:visited {\n  color: var(--mds_brand_appearance_error_subtle_text-color);\n}\n.mds .mds-warning__text-color {\n  /* \n  @name: mds-warning__text-color\n  @category: Colors\n  @usage: \n  Use mds-warning__text-color class to get the warning color for text.\n  @example:\n  <div class=\"mds-warning__text-color\">text color in warning appearance</div>\n  */\n}\n.mds .mds-warning__text-color {\n  color: var(--mds_brand_appearance_warning_default_text-color);\n}\n.mds .mds-warning--weak__text-color {\n  /* \n  @name: mds-warning--weak__text-color\n  @category: Colors\n  @usage: \n  Use mds-warning--weak__text-color class to get the warning weak color for text.\n  @example:\n  <div class=\"mds-warning--weak__text-color\">text color in warning weak appearance</div>\n  */\n}\n.mds .mds-warning--weak__text-color {\n  color: var(--mds_brand_appearance_warning_weak_text-color);\n}\n.mds .mds-warning--subtle__text-color {\n  /* \n  @name: mds-warning--subtle__text-color\n  @category: Colors\n  @usage: \n  Use mds-warning--subtle__text-color class to get the warning subtle color for text.\n  @example:\n  <div class=\"mds-warning--subtle__text-color\">text color in warning subtle appearance</div>\n  */\n}\n.mds .mds-warning--subtle__text-color {\n  color: var(--mds_brand_appearance_warning_subtle_text-color);\n}\n.mds .mds-warning__background-color {\n  /* \n  @name: mds-warning__background-color\n  @category: Colors\n  @usage: \n  Use mds-warning__background-color class to get the warning color for background.\n  @example:\n  <div class=\"mds-warning__background-color\">background color in warning appearance</div>\n  */\n}\n.mds .mds-warning__background-color {\n  background-color: var(--mds_brand_appearance_warning_default_background-color);\n}\n.mds .mds-warning--weak__background-color {\n  /* \n  @name: mds-warning--weak__background-color\n  @category: Colors\n  @usage: \n  Use mds-warning--weak__background-color class to get the warning weak color for background.\n  @example:\n  <div class=\"mds-warning--weak__background-color\">background color in warning weak appearance</div>\n  */\n}\n.mds .mds-warning--weak__background-color {\n  background-color: var(--mds_brand_appearance_warning_weak_background-color);\n}\n.mds .mds-warning--subtle__background-color {\n  /* \n  @name: mds-warning--subtle__background-color\n  @category: Colors\n  @usage: \n  Use mds-warning--subtle__background-color class to get the warning subtle color for background.\n  @example:\n  <div class=\"mds-warning--subtle__background-color\">background color in warning subtle appearance</div>\n  */\n}\n.mds .mds-warning--subtle__background-color {\n  background-color: var(--mds_brand_appearance_warning_subtle_background-color);\n}\n.mds .mds-warning__on-background-color {\n  /* \n  @name: mds-warning__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-warning__on-background-color class to get the warning color for on-background.\n  @example:\n  <div class=\"mds-warning__on-background-color\">on-background color in warning appearance</div>\n  */\n}\n.mds .mds-warning__on-background-color {\n  color: var(--mds_brand_appearance_warning_default_on-background-color);\n}\n.mds .mds-warning--weak__on-background-color {\n  /* \n  @name: mds-warning--weak__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-warning--weak__on-background-color class to get the warning weak color for on-background.\n  @example:\n  <div class=\"mds-warning--weak__on-background-color\">on-background color in warning weak appearance</div>\n  */\n}\n.mds .mds-warning--weak__on-background-color {\n  color: var(--mds_brand_appearance_warning_weak_on-background-color);\n}\n.mds .mds-warning--subtle__on-background-color {\n  /* \n  @name: mds-warning--subtle__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-warning--subtle__on-background-color class to get the warning subtle color for on-background.\n  @example:\n  <div class=\"mds-warning--subtle__on-background-color\">on-background color in warning subtle appearance</div>\n  */\n}\n.mds .mds-warning--subtle__on-background-color {\n  color: var(--mds_brand_appearance_warning_subtle_on-background-color);\n}\n.mds .mds-warning__border-color {\n  /* \n  @name: mds-warning__border-color\n  @category: Colors\n  @usage: \n  Use mds-warning__border-color class to get the warning color for border.\n  @example:\n  <div class=\"mds-warning__border-color\">border color in warning appearance</div>\n  */\n}\n.mds .mds-warning__border-color {\n  border-color: var(--mds_brand_appearance_warning_default_border-color);\n}\n.mds .mds-warning--weak__border-color {\n  /* \n  @name: mds-warning--weak__border-color\n  @category: Colors\n  @usage: \n  Use mds-warning--weak__border-color class to get the warning weak color for border.\n  @example:\n  <div class=\"mds-warning--weak__border-color\">border color in warning weak appearance</div>\n  */\n}\n.mds .mds-warning--weak__border-color {\n  border-color: var(--mds_brand_appearance_warning_weak_border-color);\n}\n.mds .mds-warning--subtle__border-color {\n  /* \n  @name: mds-warning--subtle__border-color\n  @category: Colors\n  @usage: \n  Use mds-warning--subtle__border-color class to get the warning subtle color for border.\n  @example:\n  <div class=\"mds-warning--subtle__border-color\">border color in warning subtle appearance</div>\n  */\n}\n.mds .mds-warning--subtle__border-color {\n  border-color: var(--mds_brand_appearance_warning_subtle_border-color);\n}\n.mds a.mds-warning__text-color,\n.mds a.mds-warning__text-color:active,\n.mds a.mds-warning__text-color:visited {\n  color: var(--mds_brand_appearance_warning_default_text-color);\n}\n.mds a.mds-warning--weak__text-color,\n.mds a.mds-warning--weak__text-color:active,\n.mds a.mds-warning--weak__text-color:visited {\n  color: var(--mds_brand_appearance_warning_weak_text-color);\n}\n.mds a.mds-warning--subtle__text-color,\n.mds a.mds-warning--subtle__text-color:active,\n.mds a.mds-warning--subtle__text-color:visited {\n  color: var(--mds_brand_appearance_warning_subtle_text-color);\n}\n.mds .mds-success__text-color {\n  /* \n  @name: mds-success__text-color\n  @category: Colors\n  @usage: \n  Use mds-success__text-color class to get the success color for text.\n  @example:\n  <div class=\"mds-success__text-color\">text color in success appearance</div>\n  */\n}\n.mds .mds-success__text-color {\n  color: var(--mds_brand_appearance_success_default_text-color);\n}\n.mds .mds-success--weak__text-color {\n  /* \n  @name: mds-success--weak__text-color\n  @category: Colors\n  @usage: \n  Use mds-success--weak__text-color class to get the success weak color for text.\n  @example:\n  <div class=\"mds-success--weak__text-color\">text color in success weak appearance</div>\n  */\n}\n.mds .mds-success--weak__text-color {\n  color: var(--mds_brand_appearance_success_weak_text-color);\n}\n.mds .mds-success--subtle__text-color {\n  /* \n  @name: mds-success--subtle__text-color\n  @category: Colors\n  @usage: \n  Use mds-success--subtle__text-color class to get the success subtle color for text.\n  @example:\n  <div class=\"mds-success--subtle__text-color\">text color in success subtle appearance</div>\n  */\n}\n.mds .mds-success--subtle__text-color {\n  color: var(--mds_brand_appearance_success_subtle_text-color);\n}\n.mds .mds-success__background-color {\n  /* \n  @name: mds-success__background-color\n  @category: Colors\n  @usage: \n  Use mds-success__background-color class to get the success color for background.\n  @example:\n  <div class=\"mds-success__background-color\">background color in success appearance</div>\n  */\n}\n.mds .mds-success__background-color {\n  background-color: var(--mds_brand_appearance_success_default_background-color);\n}\n.mds .mds-success--weak__background-color {\n  /* \n  @name: mds-success--weak__background-color\n  @category: Colors\n  @usage: \n  Use mds-success--weak__background-color class to get the success weak color for background.\n  @example:\n  <div class=\"mds-success--weak__background-color\">background color in success weak appearance</div>\n  */\n}\n.mds .mds-success--weak__background-color {\n  background-color: var(--mds_brand_appearance_success_weak_background-color);\n}\n.mds .mds-success--subtle__background-color {\n  /* \n  @name: mds-success--subtle__background-color\n  @category: Colors\n  @usage: \n  Use mds-success--subtle__background-color class to get the success subtle color for background.\n  @example:\n  <div class=\"mds-success--subtle__background-color\">background color in success subtle appearance</div>\n  */\n}\n.mds .mds-success--subtle__background-color {\n  background-color: var(--mds_brand_appearance_success_subtle_background-color);\n}\n.mds .mds-success__on-background-color {\n  /* \n  @name: mds-success__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-success__on-background-color class to get the success color for on-background.\n  @example:\n  <div class=\"mds-success__on-background-color\">on-background color in success appearance</div>\n  */\n}\n.mds .mds-success__on-background-color {\n  color: var(--mds_brand_appearance_success_default_on-background-color);\n}\n.mds .mds-success--weak__on-background-color {\n  /* \n  @name: mds-success--weak__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-success--weak__on-background-color class to get the success weak color for on-background.\n  @example:\n  <div class=\"mds-success--weak__on-background-color\">on-background color in success weak appearance</div>\n  */\n}\n.mds .mds-success--weak__on-background-color {\n  color: var(--mds_brand_appearance_success_weak_on-background-color);\n}\n.mds .mds-success--subtle__on-background-color {\n  /* \n  @name: mds-success--subtle__on-background-color\n  @category: Colors\n  @usage: \n  Use mds-success--subtle__on-background-color class to get the success subtle color for on-background.\n  @example:\n  <div class=\"mds-success--subtle__on-background-color\">on-background color in success subtle appearance</div>\n  */\n}\n.mds .mds-success--subtle__on-background-color {\n  color: var(--mds_brand_appearance_success_subtle_on-background-color);\n}\n.mds .mds-success__border-color {\n  /* \n  @name: mds-success__border-color\n  @category: Colors\n  @usage: \n  Use mds-success__border-color class to get the success color for border.\n  @example:\n  <div class=\"mds-success__border-color\">border color in success appearance</div>\n  */\n}\n.mds .mds-success__border-color {\n  border-color: var(--mds_brand_appearance_success_default_border-color);\n}\n.mds .mds-success--weak__border-color {\n  /* \n  @name: mds-success--weak__border-color\n  @category: Colors\n  @usage: \n  Use mds-success--weak__border-color class to get the success weak color for border.\n  @example:\n  <div class=\"mds-success--weak__border-color\">border color in success weak appearance</div>\n  */\n}\n.mds .mds-success--weak__border-color {\n  border-color: var(--mds_brand_appearance_success_weak_border-color);\n}\n.mds .mds-success--subtle__border-color {\n  /* \n  @name: mds-success--subtle__border-color\n  @category: Colors\n  @usage: \n  Use mds-success--subtle__border-color class to get the success subtle color for border.\n  @example:\n  <div class=\"mds-success--subtle__border-color\">border color in success subtle appearance</div>\n  */\n}\n.mds .mds-success--subtle__border-color {\n  border-color: var(--mds_brand_appearance_success_subtle_border-color);\n}\n.mds a.mds-success__text-color,\n.mds a.mds-success__text-color:active,\n.mds a.mds-success__text-color:visited {\n  color: var(--mds_brand_appearance_success_default_text-color);\n}\n.mds a.mds-success--weak__text-color,\n.mds a.mds-success--weak__text-color:active,\n.mds a.mds-success--weak__text-color:visited {\n  color: var(--mds_brand_appearance_success_weak_text-color);\n}\n.mds a.mds-success--subtle__text-color,\n.mds a.mds-success--subtle__text-color:active,\n.mds a.mds-success--subtle__text-color:visited {\n  color: var(--mds_brand_appearance_success_subtle_text-color);\n}\n.mds .mds-layout {\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  display: grid;\n  transition: none;\n}\n.mds .mds-layout mc-top-bar {\n  grid-area: top-bar;\n  height: 64px;\n  width: 100%;\n  background-color: var(--mds_brand_appearance_neutral_default_background-color);\n  border-bottom: 1px solid var(--mds_brand_appearance_neutral_weak_border-color);\n}\n@media only screen and (max-width: 1024px) {\n  .mds .mds-layout mc-top-bar {\n    padding: 0 16px 0 52px;\n  }\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-layout mc-top-bar {\n    padding: 0 24px 0 60px;\n  }\n}\n.mds .mds-layout mc-side-bar {\n  grid-area: side-bar;\n}\n.mds .mds-layout mc-side-bar:not([open]) .mds-tree-nav {\n  opacity: 0;\n}\n@media only screen and (max-width: 1024px) {\n  .mds .mds-layout mc-side-bar {\n    height: 64px;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 52px;\n  }\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-layout mc-side-bar {\n    width: 100%;\n    position: relative;\n  }\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-layout:has(mc-side-bar:not([open])) {\n    grid-template-columns: 0 1fr;\n  }\n}\n.mds .mds-layout .mds-page {\n  grid-area: page;\n  overflow-y: auto;\n  height: auto;\n}\n.mds .mds-layout .mds-page > .mds-grid {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n@media only screen and (max-width: 1024px) {\n  .mds .mds-layout .mds-page > .mds-grid {\n    margin: 24px 0;\n  }\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-layout .mds-page > .mds-grid {\n    margin: 24px auto;\n    max-width: 1080px;\n  }\n}\n.mds .mds-layout .mds-page .mds-grid.mds-full-width {\n  max-width: none;\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-layout .mds-page .mds-grid.mds-full-width {\n    margin: 24px 0;\n    max-width: none;\n  }\n}\n.mds .mds-layout .mds-footer {\n  grid-area: footer;\n}\n.mds .mds-layout.mds-layout-no-side-bar {\n  grid-template-columns: 0 1fr;\n}\n@media only screen and (max-width: 640px) {\n  .mds .mds-layout.mds-layout-no-side-bar mc-top-bar {\n    padding-left: 16px;\n  }\n}\n@media only screen and (min-width: 641px) {\n  .mds .mds-layout.mds-layout-no-side-bar mc-top-bar {\n    padding-left: 24px;\n  }\n}\n@media only screen and (max-width: 640px) {\n  .mds .mds-layout {\n    grid-template-areas: \"top-bar top-bar\" \"page page\" \"footer footer\";\n    grid-template-rows: 64px 1fr auto;\n    grid-template-columns: 1fr;\n    height: auto;\n  }\n}\n@media only screen and (min-width: 641px) {\n  .mds .mds-layout {\n    grid-template-areas: \"top-bar top-bar\" \"page page\" \"footer footer\";\n    grid-template-rows: 64px 1fr auto;\n    grid-template-columns: 1fr;\n  }\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-layout {\n    grid-template-areas: \"top-bar top-bar\" \"side-bar page\" \"side-bar footer\";\n    grid-template-rows: 64px 1fr auto;\n    grid-template-columns: 300px 1fr;\n  }\n  .mds .mds-layout:has(mc-side-bar:hover), .mds .mds-layout:has(mc-side-bar:focus-within) {\n    will-change: grid-template-columns;\n    transition: grid-template-columns 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n}\n.mds .mds-page-centered {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n@media only screen and (max-width: 1024px) {\n  .mds .mds-page-centered {\n    margin: 24px 0;\n  }\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-page-centered {\n    margin: 24px auto;\n    max-width: 1080px;\n  }\n}\n.mds .mds-page-full-width {\n  max-width: none;\n}\n@media only screen and (min-width: 1025px) {\n  .mds .mds-page-full-width {\n    margin: 24px 0;\n    max-width: none;\n  }\n}\n.mds .mds-skip-to {\n  opacity: 0;\n  position: absolute;\n  left: -9999px;\n  z-index: 999;\n  padding: 1em;\n  line-height: 86px;\n  height: 86px;\n  background-color: #f7f7f7;\n  color: #0073ab;\n  justify-content: center;\n  outline: none;\n}\n.mds .mds-skip-to:focus {\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 1;\n  box-shadow: none;\n}\n.mds .mds-container .mds-grid {\n  display: grid;\n}\n.mds .mds-container .mds-grid .mds-grid-row-1 {\n  grid-row-start: 1;\n}\n.mds .mds-container .mds-grid .mds-grid-row-2 {\n  grid-row-start: 2;\n}\n.mds .mds-container .mds-grid .mds-grid-row-3 {\n  grid-row-start: 3;\n}\n.mds .mds-container .mds-grid .mds-grid-row-4 {\n  grid-row-start: 4;\n}\n.mds .mds-container .mds-grid .mds-grid-row-5 {\n  grid-row-start: 5;\n}\n.mds .mds-container .mds-grid .mds-grid-row-6 {\n  grid-row-start: 6;\n}\n.mds .mds-container .mds-grid .mds-grid-row-7 {\n  grid-row-start: 7;\n}\n.mds .mds-container .mds-grid .mds-grid-row-8 {\n  grid-row-start: 8;\n}\n.mds .mds-container .mds-grid .mds-grid-row-9 {\n  grid-row-start: 9;\n}\n.mds .mds-container .mds-grid .mds-grid-row-10 {\n  grid-row-start: 10;\n}\n.mds .mds-container .mds-grid .mds-grid-row-11 {\n  grid-row-start: 11;\n}\n.mds .mds-container .mds-grid .mds-grid-row-12 {\n  grid-row-start: 12;\n}\n.mds .mds-container .mds-grid .mds-grid-row-13 {\n  grid-row-start: 13;\n}\n.mds .mds-container .mds-grid .mds-grid-row-14 {\n  grid-row-start: 14;\n}\n.mds .mds-container .mds-grid .mds-grid-row-15 {\n  grid-row-start: 15;\n}\n.mds .mds-container .mds-grid .mds-grid-row-16 {\n  grid-row-start: 16;\n}\n.mds .mds-container .mds-grid .mds-grid-row-17 {\n  grid-row-start: 17;\n}\n.mds .mds-container .mds-grid .mds-grid-row-18 {\n  grid-row-start: 18;\n}\n.mds .mds-container .mds-grid .mds-grid-row-19 {\n  grid-row-start: 19;\n}\n.mds .mds-container .mds-grid .mds-grid-row-20 {\n  grid-row-start: 20;\n}\n.mds .mds-container .mds-grid .mds-grid-row-21 {\n  grid-row-start: 21;\n}\n.mds .mds-container .mds-grid .mds-grid-row-22 {\n  grid-row-start: 22;\n}\n.mds .mds-container .mds-grid .mds-grid-row-23 {\n  grid-row-start: 23;\n}\n.mds .mds-container .mds-grid .mds-grid-row-24 {\n  grid-row-start: 24;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-to-end {\n  grid-row-end: -1;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-to-start {\n  grid-row-end: 1;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-1 {\n  grid-row-end: span 1;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-2 {\n  grid-row-end: span 2;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-3 {\n  grid-row-end: span 3;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-4 {\n  grid-row-end: span 4;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-5 {\n  grid-row-end: span 5;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-6 {\n  grid-row-end: span 6;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-7 {\n  grid-row-end: span 7;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-8 {\n  grid-row-end: span 8;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-9 {\n  grid-row-end: span 9;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-10 {\n  grid-row-end: span 10;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-11 {\n  grid-row-end: span 11;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-12 {\n  grid-row-end: span 12;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-13 {\n  grid-row-end: span 13;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-14 {\n  grid-row-end: span 14;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-15 {\n  grid-row-end: span 15;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-16 {\n  grid-row-end: span 16;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-17 {\n  grid-row-end: span 17;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-18 {\n  grid-row-end: span 18;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-19 {\n  grid-row-end: span 19;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-20 {\n  grid-row-end: span 20;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-21 {\n  grid-row-end: span 21;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-22 {\n  grid-row-end: span 22;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-23 {\n  grid-row-end: span 23;\n}\n.mds .mds-container .mds-grid .mds-grid-row-span-24 {\n  grid-row-end: span 24;\n}\n.mds .mds-container .mds-grid .mds-grid-col-1 {\n  /* \n  @name: mds-grid-col-1\n  @category: Grid\n  @usage: \n  Use mds-grid-col-1 class to position the cell in the 1 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 1 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 1;\n}\n.mds .mds-container .mds-grid .mds-grid-col-2 {\n  /* \n  @name: mds-grid-col-2\n  @category: Grid\n  @usage: \n  Use mds-grid-col-2 class to position the cell in the 2 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 2 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 2;\n}\n.mds .mds-container .mds-grid .mds-grid-col-3 {\n  /* \n  @name: mds-grid-col-3\n  @category: Grid\n  @usage: \n  Use mds-grid-col-3 class to position the cell in the 3 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 3 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 3;\n}\n.mds .mds-container .mds-grid .mds-grid-col-4 {\n  /* \n  @name: mds-grid-col-4\n  @category: Grid\n  @usage: \n  Use mds-grid-col-4 class to position the cell in the 4 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 4 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 4;\n}\n.mds .mds-container .mds-grid .mds-grid-col-5 {\n  /* \n  @name: mds-grid-col-5\n  @category: Grid\n  @usage: \n  Use mds-grid-col-5 class to position the cell in the 5 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 5 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 5;\n}\n.mds .mds-container .mds-grid .mds-grid-col-6 {\n  /* \n  @name: mds-grid-col-6\n  @category: Grid\n  @usage: \n  Use mds-grid-col-6 class to position the cell in the 6 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 6 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 6;\n}\n.mds .mds-container .mds-grid .mds-grid-col-7 {\n  /* \n  @name: mds-grid-col-7\n  @category: Grid\n  @usage: \n  Use mds-grid-col-7 class to position the cell in the 7 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 7 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 7;\n}\n.mds .mds-container .mds-grid .mds-grid-col-8 {\n  /* \n  @name: mds-grid-col-8\n  @category: Grid\n  @usage: \n  Use mds-grid-col-8 class to position the cell in the 8 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 8 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 8;\n}\n.mds .mds-container .mds-grid .mds-grid-col-9 {\n  /* \n  @name: mds-grid-col-9\n  @category: Grid\n  @usage: \n  Use mds-grid-col-9 class to position the cell in the 9 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 9 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 9;\n}\n.mds .mds-container .mds-grid .mds-grid-col-10 {\n  /* \n  @name: mds-grid-col-10\n  @category: Grid\n  @usage: \n  Use mds-grid-col-10 class to position the cell in the 10 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 10 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 10;\n}\n.mds .mds-container .mds-grid .mds-grid-col-11 {\n  /* \n  @name: mds-grid-col-11\n  @category: Grid\n  @usage: \n  Use mds-grid-col-11 class to position the cell in the 11 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 11 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 11;\n}\n.mds .mds-container .mds-grid .mds-grid-col-12 {\n  /* \n  @name: mds-grid-col-12\n  @category: Grid\n  @usage: \n  Use mds-grid-col-12 class to position the cell in the 12 column of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 12 in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1\">Cell in column 1 in all breakpoints</div>\n      <div class=\"mds-grid-col-2\">Cell in column 2 in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: 12;\n}\n.mds .mds-container .mds-grid .mds-grid-col-1-reverse {\n  /* \n  @name: mds-grid-col-1-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 1 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -2;\n}\n.mds .mds-container .mds-grid .mds-grid-col-2-reverse {\n  /* \n  @name: mds-grid-col-2-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 2 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -3;\n}\n.mds .mds-container .mds-grid .mds-grid-col-3-reverse {\n  /* \n  @name: mds-grid-col-3-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 3 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -4;\n}\n.mds .mds-container .mds-grid .mds-grid-col-4-reverse {\n  /* \n  @name: mds-grid-col-4-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 4 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -5;\n}\n.mds .mds-container .mds-grid .mds-grid-col-5-reverse {\n  /* \n  @name: mds-grid-col-5-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 5 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -6;\n}\n.mds .mds-container .mds-grid .mds-grid-col-6-reverse {\n  /* \n  @name: mds-grid-col-6-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 6 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -7;\n}\n.mds .mds-container .mds-grid .mds-grid-col-7-reverse {\n  /* \n  @name: mds-grid-col-7-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 7 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -8;\n}\n.mds .mds-container .mds-grid .mds-grid-col-8-reverse {\n  /* \n  @name: mds-grid-col-8-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 8 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -9;\n}\n.mds .mds-container .mds-grid .mds-grid-col-9-reverse {\n  /* \n  @name: mds-grid-col-9-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 9 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -10;\n}\n.mds .mds-container .mds-grid .mds-grid-col-10-reverse {\n  /* \n  @name: mds-grid-col-10-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 10 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -11;\n}\n.mds .mds-container .mds-grid .mds-grid-col-11-reverse {\n  /* \n  @name: mds-grid-col-11-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 11 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -12;\n}\n.mds .mds-container .mds-grid .mds-grid-col-12-reverse {\n  /* \n  @name: mds-grid-col-12-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 12 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -13;\n}\n.mds .mds-container .mds-grid .mds-grid-col-13-reverse {\n  /* \n  @name: mds-grid-col-13-reverse\n  @category: Grid\n  @usage: \n  Use mds-grid-col-13-reverse class to position the cell in the reverse order in the 13 column (from the end) of the grid.\n  The class is independent of the breakpoint, so when applied, the cell will persist to be in column 13 from the end in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n      <div class=\"mds-grid-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-start: -14;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-to-end {\n  grid-column-end: -1;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-to-start {\n  grid-column-end: 1;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-1 {\n  /* \n  @name: mds-grid-col-span-1\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-1 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 1;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-2 {\n  /* \n  @name: mds-grid-col-span-2\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-2 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 2;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-3 {\n  /* \n  @name: mds-grid-col-span-3\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-3 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 3;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-4 {\n  /* \n  @name: mds-grid-col-span-4\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-4 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 4;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-5 {\n  /* \n  @name: mds-grid-col-span-5\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-5 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 5;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-6 {\n  /* \n  @name: mds-grid-col-span-6\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-6 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 6;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-7 {\n  /* \n  @name: mds-grid-col-span-7\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-7 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 7;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-8 {\n  /* \n  @name: mds-grid-col-span-8\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-8 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 8;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-9 {\n  /* \n  @name: mds-grid-col-span-9\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-9 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 9;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-10 {\n  /* \n  @name: mds-grid-col-span-10\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-10 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 10;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-11 {\n  /* \n  @name: mds-grid-col-span-11\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-11 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 11;\n}\n.mds .mds-container .mds-grid .mds-grid-col-span-12 {\n  /* \n  @name: mds-grid-col-span-12\n  @category: Grid\n  @usage: \n  Use mds-grid-col-span-12 class to span multiple cells in your grid.\n  The class is independent of the breakpoint, so when applied, the cells spanning will persist in all screen sizes.\n  @example:\n  <div class=\"mds-container\">\n    <div class=\"mds-grid\">\n      <div class=\"mds-grid-col-1 mds-grid-col-span-2\">Cell in column 1 that spans over 2 columns in all breakpoints</div>\n      <div class=\"mds-grid-col-3 mds-grid-col-span-3\">Cell in column 3 that spans over 3 columns in all breakpoints</div>\n      ...\n    </div>\n  </div> */\n  grid-column-end: span 12;\n}\n.mds .mds-container .mds-grid.mds-grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-8 {\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-9 {\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-10 {\n  grid-template-columns: repeat(10, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-11 {\n  grid-template-columns: repeat(11, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-cols-12 {\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n.mds .mds-container .mds-grid.mds-grid-rows-1 {\n  grid-template-rows: repeat(1, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-2 {\n  grid-template-rows: repeat(2, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-3 {\n  grid-template-rows: repeat(3, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-4 {\n  grid-template-rows: repeat(4, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-5 {\n  grid-template-rows: repeat(5, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-6 {\n  grid-template-rows: repeat(6, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-7 {\n  grid-template-rows: repeat(7, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-8 {\n  grid-template-rows: repeat(8, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-9 {\n  grid-template-rows: repeat(9, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-10 {\n  grid-template-rows: repeat(10, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-11 {\n  grid-template-rows: repeat(11, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-12 {\n  grid-template-rows: repeat(12, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-13 {\n  grid-template-rows: repeat(13, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-14 {\n  grid-template-rows: repeat(14, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-15 {\n  grid-template-rows: repeat(15, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-16 {\n  grid-template-rows: repeat(16, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-17 {\n  grid-template-rows: repeat(17, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-18 {\n  grid-template-rows: repeat(18, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-19 {\n  grid-template-rows: repeat(19, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-20 {\n  grid-template-rows: repeat(20, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-21 {\n  grid-template-rows: repeat(21, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-22 {\n  grid-template-rows: repeat(22, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-23 {\n  grid-template-rows: repeat(23, auto);\n}\n.mds .mds-container .mds-grid.mds-grid-rows-24 {\n  grid-template-rows: repeat(24, auto);\n}\n.mds .mds-container {\n  /*\n  @name: mds-container\n  @category: Grid\n  */\n  container-type: inline-size;\n  contain: layout;\n  position: relative;\n  z-index: 1;\n}\n@container (max-width: 640px) {\n  .mds .mds-container .mds-grid {\n    gap: var(--mds_foundations_grid_xs_column-gap) var(--mds_foundations_grid_xs_row-gap);\n    grid-template-columns: repeat(var(--mds_foundations_grid_xs_columns), minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-1 {\n    /* \n    @name: mds-grid-xs-col-1\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-1 class to position the cell in the 1 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 1 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-2 {\n    /* \n    @name: mds-grid-xs-col-2\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-2 class to position the cell in the 2 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 2 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-3 {\n    /* \n    @name: mds-grid-xs-col-3\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-3 class to position the cell in the 3 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 3 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-4 {\n    /* \n    @name: mds-grid-xs-col-4\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-4 class to position the cell in the 4 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 4 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-5 {\n    /* \n    @name: mds-grid-xs-col-5\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-5 class to position the cell in the 5 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 5 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-6 {\n    /* \n    @name: mds-grid-xs-col-6\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-6 class to position the cell in the 6 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 6 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-7 {\n    /* \n    @name: mds-grid-xs-col-7\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-7 class to position the cell in the 7 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 7 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-8 {\n    /* \n    @name: mds-grid-xs-col-8\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-8 class to position the cell in the 8 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 8 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-9 {\n    /* \n    @name: mds-grid-xs-col-9\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-9 class to position the cell in the 9 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 9 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-10 {\n    /* \n    @name: mds-grid-xs-col-10\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-10 class to position the cell in the 10 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 10 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-11 {\n    /* \n    @name: mds-grid-xs-col-11\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-11 class to position the cell in the 11 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 11 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-12 {\n    /* \n    @name: mds-grid-xs-col-12\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-12 class to position the cell in the 12 column of the grid in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 12 for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1\">Cell in column 1 for xs breakpoint</div>\n        <div class=\"mds-grid-xs-col-2\">Cell in column 2 for xs breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-1-reverse {\n    /* \n    @name: mds-grid-xs-col-1-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 1 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-2-reverse {\n    /* \n    @name: mds-grid-xs-col-2-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 2 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-3-reverse {\n    /* \n    @name: mds-grid-xs-col-3-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 3 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-4-reverse {\n    /* \n    @name: mds-grid-xs-col-4-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 4 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-5-reverse {\n    /* \n    @name: mds-grid-xs-col-5-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 5 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-6-reverse {\n    /* \n    @name: mds-grid-xs-col-6-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 6 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-7-reverse {\n    /* \n    @name: mds-grid-xs-col-7-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 7 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-8-reverse {\n    /* \n    @name: mds-grid-xs-col-8-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 8 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-9-reverse {\n    /* \n    @name: mds-grid-xs-col-9-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 9 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-10-reverse {\n    /* \n    @name: mds-grid-xs-col-10-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 10 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-11-reverse {\n    /* \n    @name: mds-grid-xs-col-11-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 11 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-12-reverse {\n    /* \n    @name: mds-grid-xs-col-12-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) in xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 12 from the end for xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-xs-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-1 {\n    /* \n    @name: mds-grid-xs-col-span-1\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-1 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-1 class to position the cell in the 1 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-2 {\n    /* \n    @name: mds-grid-xs-col-span-2\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-2 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-2 class to position the cell in the 2 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-3 {\n    /* \n    @name: mds-grid-xs-col-span-3\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-3 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-3 class to position the cell in the 3 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-4 {\n    /* \n    @name: mds-grid-xs-col-span-4\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-4 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-4 class to position the cell in the 4 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-5 {\n    /* \n    @name: mds-grid-xs-col-span-5\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-5 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-5 class to position the cell in the 5 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-6 {\n    /* \n    @name: mds-grid-xs-col-span-6\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-6 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-6 class to position the cell in the 6 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-7 {\n    /* \n    @name: mds-grid-xs-col-span-7\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-7 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-7 class to position the cell in the 7 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-8 {\n    /* \n    @name: mds-grid-xs-col-span-8\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-8 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-8 class to position the cell in the 8 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-9 {\n    /* \n    @name: mds-grid-xs-col-span-9\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-9 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-9 class to position the cell in the 9 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-10 {\n    /* \n    @name: mds-grid-xs-col-span-10\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-10 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-10 class to position the cell in the 10 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-11 {\n    /* \n    @name: mds-grid-xs-col-span-11\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-11 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-11 class to position the cell in the 11 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-col-span-12 {\n    /* \n    @name: mds-grid-xs-col-span-12\n    @category: Grid\n    @usage: \n    Use mds-grid-xs-col-span-12 class to span multiple cells in your grid for xs breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for xs breakpoint.\n    Use it in combination with mds-grid-xs-col-12 class to position the cell in the 12 column of the grid in xs breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-xs-col-1 mds-grid-xs-col-span-2\">Cell in column 1 that spans over 2 columns in xs breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 12;\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-1 {\n    grid-row-start: 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-2 {\n    grid-row-start: 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-3 {\n    grid-row-start: 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-4 {\n    grid-row-start: 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-5 {\n    grid-row-start: 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-6 {\n    grid-row-start: 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-7 {\n    grid-row-start: 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-8 {\n    grid-row-start: 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-9 {\n    grid-row-start: 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-10 {\n    grid-row-start: 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-11 {\n    grid-row-start: 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-12 {\n    grid-row-start: 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-13 {\n    grid-row-start: 13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-14 {\n    grid-row-start: 14;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-15 {\n    grid-row-start: 15;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-16 {\n    grid-row-start: 16;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-17 {\n    grid-row-start: 17;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-18 {\n    grid-row-start: 18;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-19 {\n    grid-row-start: 19;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-20 {\n    grid-row-start: 20;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-21 {\n    grid-row-start: 21;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-22 {\n    grid-row-start: 22;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-23 {\n    grid-row-start: 23;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-24 {\n    grid-row-start: 24;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-1 {\n    grid-row-end: span 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-2 {\n    grid-row-end: span 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-3 {\n    grid-row-end: span 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-4 {\n    grid-row-end: span 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-5 {\n    grid-row-end: span 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-6 {\n    grid-row-end: span 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-7 {\n    grid-row-end: span 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-8 {\n    grid-row-end: span 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-9 {\n    grid-row-end: span 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-10 {\n    grid-row-end: span 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-11 {\n    grid-row-end: span 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-12 {\n    grid-row-end: span 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-13 {\n    grid-row-end: span 13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-14 {\n    grid-row-end: span 14;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-15 {\n    grid-row-end: span 15;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-16 {\n    grid-row-end: span 16;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-17 {\n    grid-row-end: span 17;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-18 {\n    grid-row-end: span 18;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-19 {\n    grid-row-end: span 19;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-20 {\n    grid-row-end: span 20;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-21 {\n    grid-row-end: span 21;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-22 {\n    grid-row-end: span 22;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-23 {\n    grid-row-end: span 23;\n  }\n  .mds .mds-container .mds-grid .mds-grid-xs-row-span-24 {\n    grid-row-end: span 24;\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-1 {\n    grid-template-rows: repeat(1, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-2 {\n    grid-template-rows: repeat(2, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-3 {\n    grid-template-rows: repeat(3, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-4 {\n    grid-template-rows: repeat(4, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-5 {\n    grid-template-rows: repeat(5, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-6 {\n    grid-template-rows: repeat(6, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-7 {\n    grid-template-rows: repeat(7, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-8 {\n    grid-template-rows: repeat(8, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-9 {\n    grid-template-rows: repeat(9, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-10 {\n    grid-template-rows: repeat(10, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-11 {\n    grid-template-rows: repeat(11, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-12 {\n    grid-template-rows: repeat(12, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-13 {\n    grid-template-rows: repeat(13, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-14 {\n    grid-template-rows: repeat(14, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-15 {\n    grid-template-rows: repeat(15, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-16 {\n    grid-template-rows: repeat(16, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-17 {\n    grid-template-rows: repeat(17, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-18 {\n    grid-template-rows: repeat(18, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-19 {\n    grid-template-rows: repeat(19, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-20 {\n    grid-template-rows: repeat(20, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-21 {\n    grid-template-rows: repeat(21, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-22 {\n    grid-template-rows: repeat(22, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-23 {\n    grid-template-rows: repeat(23, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-xs-rows-24 {\n    grid-template-rows: repeat(24, auto);\n  }\n}\n@container (min-width: 641px) {\n  .mds .mds-container .mds-grid {\n    gap: var(--mds_foundations_grid_sm_column-gap) var(--mds_foundations_grid_sm_row-gap);\n    grid-template-columns: repeat(var(--mds_foundations_grid_sm_columns), minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-1 {\n    /* \n    @name: mds-grid-sm-col-1\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-1 class to position the cell in the 1 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 1 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-2 {\n    /* \n    @name: mds-grid-sm-col-2\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-2 class to position the cell in the 2 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 2 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-3 {\n    /* \n    @name: mds-grid-sm-col-3\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-3 class to position the cell in the 3 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 3 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-4 {\n    /* \n    @name: mds-grid-sm-col-4\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-4 class to position the cell in the 4 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 4 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-5 {\n    /* \n    @name: mds-grid-sm-col-5\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-5 class to position the cell in the 5 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 5 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-6 {\n    /* \n    @name: mds-grid-sm-col-6\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-6 class to position the cell in the 6 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 6 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-7 {\n    /* \n    @name: mds-grid-sm-col-7\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-7 class to position the cell in the 7 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 7 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-8 {\n    /* \n    @name: mds-grid-sm-col-8\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-8 class to position the cell in the 8 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 8 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-9 {\n    /* \n    @name: mds-grid-sm-col-9\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-9 class to position the cell in the 9 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 9 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-10 {\n    /* \n    @name: mds-grid-sm-col-10\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-10 class to position the cell in the 10 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 10 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-11 {\n    /* \n    @name: mds-grid-sm-col-11\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-11 class to position the cell in the 11 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 11 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-12 {\n    /* \n    @name: mds-grid-sm-col-12\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-12 class to position the cell in the 12 column of the grid in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 12 for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1\">Cell in column 1 for sm breakpoint</div>\n        <div class=\"mds-grid-sm-col-2\">Cell in column 2 for sm breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-1-reverse {\n    /* \n    @name: mds-grid-sm-col-1-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 1 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-2-reverse {\n    /* \n    @name: mds-grid-sm-col-2-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 2 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-3-reverse {\n    /* \n    @name: mds-grid-sm-col-3-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 3 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-4-reverse {\n    /* \n    @name: mds-grid-sm-col-4-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 4 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-5-reverse {\n    /* \n    @name: mds-grid-sm-col-5-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 5 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-6-reverse {\n    /* \n    @name: mds-grid-sm-col-6-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 6 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-7-reverse {\n    /* \n    @name: mds-grid-sm-col-7-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 7 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-8-reverse {\n    /* \n    @name: mds-grid-sm-col-8-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 8 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-9-reverse {\n    /* \n    @name: mds-grid-sm-col-9-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 9 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-10-reverse {\n    /* \n    @name: mds-grid-sm-col-10-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 10 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-11-reverse {\n    /* \n    @name: mds-grid-sm-col-11-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 11 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-12-reverse {\n    /* \n    @name: mds-grid-sm-col-12-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) in sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 12 from the end for sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-sm-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-1 {\n    /* \n    @name: mds-grid-sm-col-span-1\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-1 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-1 class to position the cell in the 1 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-2 {\n    /* \n    @name: mds-grid-sm-col-span-2\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-2 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-2 class to position the cell in the 2 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-3 {\n    /* \n    @name: mds-grid-sm-col-span-3\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-3 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-3 class to position the cell in the 3 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-4 {\n    /* \n    @name: mds-grid-sm-col-span-4\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-4 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-4 class to position the cell in the 4 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-5 {\n    /* \n    @name: mds-grid-sm-col-span-5\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-5 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-5 class to position the cell in the 5 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-6 {\n    /* \n    @name: mds-grid-sm-col-span-6\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-6 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-6 class to position the cell in the 6 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-7 {\n    /* \n    @name: mds-grid-sm-col-span-7\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-7 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-7 class to position the cell in the 7 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-8 {\n    /* \n    @name: mds-grid-sm-col-span-8\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-8 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-8 class to position the cell in the 8 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-9 {\n    /* \n    @name: mds-grid-sm-col-span-9\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-9 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-9 class to position the cell in the 9 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-10 {\n    /* \n    @name: mds-grid-sm-col-span-10\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-10 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-10 class to position the cell in the 10 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-11 {\n    /* \n    @name: mds-grid-sm-col-span-11\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-11 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-11 class to position the cell in the 11 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-col-span-12 {\n    /* \n    @name: mds-grid-sm-col-span-12\n    @category: Grid\n    @usage: \n    Use mds-grid-sm-col-span-12 class to span multiple cells in your grid for sm breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for sm breakpoint.\n    Use it in combination with mds-grid-sm-col-12 class to position the cell in the 12 column of the grid in sm breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-sm-col-1 mds-grid-sm-col-span-2\">Cell in column 1 that spans over 2 columns in sm breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 12;\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-1 {\n    grid-row-start: 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-2 {\n    grid-row-start: 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-3 {\n    grid-row-start: 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-4 {\n    grid-row-start: 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-5 {\n    grid-row-start: 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-6 {\n    grid-row-start: 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-7 {\n    grid-row-start: 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-8 {\n    grid-row-start: 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-9 {\n    grid-row-start: 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-10 {\n    grid-row-start: 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-11 {\n    grid-row-start: 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-12 {\n    grid-row-start: 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-13 {\n    grid-row-start: 13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-14 {\n    grid-row-start: 14;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-15 {\n    grid-row-start: 15;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-16 {\n    grid-row-start: 16;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-17 {\n    grid-row-start: 17;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-18 {\n    grid-row-start: 18;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-19 {\n    grid-row-start: 19;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-20 {\n    grid-row-start: 20;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-21 {\n    grid-row-start: 21;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-22 {\n    grid-row-start: 22;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-23 {\n    grid-row-start: 23;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-24 {\n    grid-row-start: 24;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-1 {\n    grid-row-end: span 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-2 {\n    grid-row-end: span 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-3 {\n    grid-row-end: span 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-4 {\n    grid-row-end: span 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-5 {\n    grid-row-end: span 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-6 {\n    grid-row-end: span 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-7 {\n    grid-row-end: span 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-8 {\n    grid-row-end: span 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-9 {\n    grid-row-end: span 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-10 {\n    grid-row-end: span 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-11 {\n    grid-row-end: span 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-12 {\n    grid-row-end: span 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-13 {\n    grid-row-end: span 13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-14 {\n    grid-row-end: span 14;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-15 {\n    grid-row-end: span 15;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-16 {\n    grid-row-end: span 16;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-17 {\n    grid-row-end: span 17;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-18 {\n    grid-row-end: span 18;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-19 {\n    grid-row-end: span 19;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-20 {\n    grid-row-end: span 20;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-21 {\n    grid-row-end: span 21;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-22 {\n    grid-row-end: span 22;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-23 {\n    grid-row-end: span 23;\n  }\n  .mds .mds-container .mds-grid .mds-grid-sm-row-span-24 {\n    grid-row-end: span 24;\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-1 {\n    grid-template-rows: repeat(1, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-2 {\n    grid-template-rows: repeat(2, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-3 {\n    grid-template-rows: repeat(3, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-4 {\n    grid-template-rows: repeat(4, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-5 {\n    grid-template-rows: repeat(5, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-6 {\n    grid-template-rows: repeat(6, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-7 {\n    grid-template-rows: repeat(7, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-8 {\n    grid-template-rows: repeat(8, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-9 {\n    grid-template-rows: repeat(9, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-10 {\n    grid-template-rows: repeat(10, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-11 {\n    grid-template-rows: repeat(11, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-12 {\n    grid-template-rows: repeat(12, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-13 {\n    grid-template-rows: repeat(13, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-14 {\n    grid-template-rows: repeat(14, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-15 {\n    grid-template-rows: repeat(15, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-16 {\n    grid-template-rows: repeat(16, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-17 {\n    grid-template-rows: repeat(17, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-18 {\n    grid-template-rows: repeat(18, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-19 {\n    grid-template-rows: repeat(19, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-20 {\n    grid-template-rows: repeat(20, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-21 {\n    grid-template-rows: repeat(21, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-22 {\n    grid-template-rows: repeat(22, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-23 {\n    grid-template-rows: repeat(23, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-sm-rows-24 {\n    grid-template-rows: repeat(24, auto);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-grid {\n    gap: var(--mds_foundations_grid_md_column-gap) var(--mds_foundations_grid_md_row-gap);\n    grid-template-columns: repeat(var(--mds_foundations_grid_md_columns), minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-1 {\n    /* \n    @name: mds-grid-md-col-1\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-1 class to position the cell in the 1 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 1 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-2 {\n    /* \n    @name: mds-grid-md-col-2\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-2 class to position the cell in the 2 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 2 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-3 {\n    /* \n    @name: mds-grid-md-col-3\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-3 class to position the cell in the 3 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 3 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-4 {\n    /* \n    @name: mds-grid-md-col-4\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-4 class to position the cell in the 4 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 4 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-5 {\n    /* \n    @name: mds-grid-md-col-5\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-5 class to position the cell in the 5 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 5 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-6 {\n    /* \n    @name: mds-grid-md-col-6\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-6 class to position the cell in the 6 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 6 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-7 {\n    /* \n    @name: mds-grid-md-col-7\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-7 class to position the cell in the 7 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 7 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-8 {\n    /* \n    @name: mds-grid-md-col-8\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-8 class to position the cell in the 8 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 8 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-9 {\n    /* \n    @name: mds-grid-md-col-9\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-9 class to position the cell in the 9 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 9 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-10 {\n    /* \n    @name: mds-grid-md-col-10\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-10 class to position the cell in the 10 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 10 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-11 {\n    /* \n    @name: mds-grid-md-col-11\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-11 class to position the cell in the 11 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 11 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-12 {\n    /* \n    @name: mds-grid-md-col-12\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-12 class to position the cell in the 12 column of the grid in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will only be in column 12 for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1\">Cell in column 1 for md breakpoint</div>\n        <div class=\"mds-grid-md-col-2\">Cell in column 2 for md breakpoint</div>\n        ...\n      </div>  \n    </div> */\n    grid-column-start: 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-1-reverse {\n    /* \n    @name: mds-grid-md-col-1-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-1-reverse class to position the cell in the reverse order in the 1 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 1 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-2-reverse {\n    /* \n    @name: mds-grid-md-col-2-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-2-reverse class to position the cell in the reverse order in the 2 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 2 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-3-reverse {\n    /* \n    @name: mds-grid-md-col-3-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-3-reverse class to position the cell in the reverse order in the 3 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 3 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-4-reverse {\n    /* \n    @name: mds-grid-md-col-4-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-4-reverse class to position the cell in the reverse order in the 4 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 4 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-5-reverse {\n    /* \n    @name: mds-grid-md-col-5-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-5-reverse class to position the cell in the reverse order in the 5 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 5 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-6-reverse {\n    /* \n    @name: mds-grid-md-col-6-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-6-reverse class to position the cell in the reverse order in the 6 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 6 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-7-reverse {\n    /* \n    @name: mds-grid-md-col-7-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-7-reverse class to position the cell in the reverse order in the 7 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 7 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-8-reverse {\n    /* \n    @name: mds-grid-md-col-8-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-8-reverse class to position the cell in the reverse order in the 8 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 8 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-9-reverse {\n    /* \n    @name: mds-grid-md-col-9-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-9-reverse class to position the cell in the reverse order in the 9 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 9 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-10-reverse {\n    /* \n    @name: mds-grid-md-col-10-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-10-reverse class to position the cell in the reverse order in the 10 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 10 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-11-reverse {\n    /* \n    @name: mds-grid-md-col-11-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-11-reverse class to position the cell in the reverse order in the 11 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 11 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-12-reverse {\n    /* \n    @name: mds-grid-md-col-12-reverse\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-12-reverse class to position the cell in the reverse order in the 12 column (from the end) in md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cell will be only in column 12 from the end for md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-2-reverse\">Cell in column 2 from the end in all breakpoints</div>\n        <div class=\"mds-grid-md-col-1-reverse\">Cell in column 1 from the end in all breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-start: -13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-1 {\n    /* \n    @name: mds-grid-md-col-span-1\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-1 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-1 class to position the cell in the 1 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-2 {\n    /* \n    @name: mds-grid-md-col-span-2\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-2 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-2 class to position the cell in the 2 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-3 {\n    /* \n    @name: mds-grid-md-col-span-3\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-3 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-3 class to position the cell in the 3 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-4 {\n    /* \n    @name: mds-grid-md-col-span-4\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-4 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-4 class to position the cell in the 4 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-5 {\n    /* \n    @name: mds-grid-md-col-span-5\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-5 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-5 class to position the cell in the 5 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-6 {\n    /* \n    @name: mds-grid-md-col-span-6\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-6 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-6 class to position the cell in the 6 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-7 {\n    /* \n    @name: mds-grid-md-col-span-7\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-7 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-7 class to position the cell in the 7 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-8 {\n    /* \n    @name: mds-grid-md-col-span-8\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-8 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-8 class to position the cell in the 8 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-9 {\n    /* \n    @name: mds-grid-md-col-span-9\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-9 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-9 class to position the cell in the 9 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-10 {\n    /* \n    @name: mds-grid-md-col-span-10\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-10 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-10 class to position the cell in the 10 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-11 {\n    /* \n    @name: mds-grid-md-col-span-11\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-11 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-11 class to position the cell in the 11 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-col-span-12 {\n    /* \n    @name: mds-grid-md-col-span-12\n    @category: Grid\n    @usage: \n    Use mds-grid-md-col-span-12 class to span multiple cells in your grid for md breakpoint.\n    The class is dependent of the breakpoint, so when applied, the cells spanning will apply only for md breakpoint.\n    Use it in combination with mds-grid-md-col-12 class to position the cell in the 12 column of the grid in md breakpoint.\n    @example:\n    <div class=\"mds-container\">\n      <div class=\"mds-grid\">\n        <div class=\"mds-grid-md-col-1 mds-grid-md-col-span-2\">Cell in column 1 that spans over 2 columns in md breakpoints</div>\n        ...\n      </div>\n    </div> */\n    grid-column-end: span 12;\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-1 {\n    grid-row-start: 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-2 {\n    grid-row-start: 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-3 {\n    grid-row-start: 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-4 {\n    grid-row-start: 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-5 {\n    grid-row-start: 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-6 {\n    grid-row-start: 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-7 {\n    grid-row-start: 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-8 {\n    grid-row-start: 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-9 {\n    grid-row-start: 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-10 {\n    grid-row-start: 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-11 {\n    grid-row-start: 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-12 {\n    grid-row-start: 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-13 {\n    grid-row-start: 13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-14 {\n    grid-row-start: 14;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-15 {\n    grid-row-start: 15;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-16 {\n    grid-row-start: 16;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-17 {\n    grid-row-start: 17;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-18 {\n    grid-row-start: 18;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-19 {\n    grid-row-start: 19;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-20 {\n    grid-row-start: 20;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-21 {\n    grid-row-start: 21;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-22 {\n    grid-row-start: 22;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-23 {\n    grid-row-start: 23;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-24 {\n    grid-row-start: 24;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-1 {\n    grid-row-end: span 1;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-2 {\n    grid-row-end: span 2;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-3 {\n    grid-row-end: span 3;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-4 {\n    grid-row-end: span 4;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-5 {\n    grid-row-end: span 5;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-6 {\n    grid-row-end: span 6;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-7 {\n    grid-row-end: span 7;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-8 {\n    grid-row-end: span 8;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-9 {\n    grid-row-end: span 9;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-10 {\n    grid-row-end: span 10;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-11 {\n    grid-row-end: span 11;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-12 {\n    grid-row-end: span 12;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-13 {\n    grid-row-end: span 13;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-14 {\n    grid-row-end: span 14;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-15 {\n    grid-row-end: span 15;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-16 {\n    grid-row-end: span 16;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-17 {\n    grid-row-end: span 17;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-18 {\n    grid-row-end: span 18;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-19 {\n    grid-row-end: span 19;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-20 {\n    grid-row-end: span 20;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-21 {\n    grid-row-end: span 21;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-22 {\n    grid-row-end: span 22;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-23 {\n    grid-row-end: span 23;\n  }\n  .mds .mds-container .mds-grid .mds-grid-md-row-span-24 {\n    grid-row-end: span 24;\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-1 {\n    grid-template-rows: repeat(1, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-2 {\n    grid-template-rows: repeat(2, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-3 {\n    grid-template-rows: repeat(3, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-4 {\n    grid-template-rows: repeat(4, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-5 {\n    grid-template-rows: repeat(5, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-6 {\n    grid-template-rows: repeat(6, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-7 {\n    grid-template-rows: repeat(7, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-8 {\n    grid-template-rows: repeat(8, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-9 {\n    grid-template-rows: repeat(9, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-10 {\n    grid-template-rows: repeat(10, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-11 {\n    grid-template-rows: repeat(11, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-12 {\n    grid-template-rows: repeat(12, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-13 {\n    grid-template-rows: repeat(13, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-14 {\n    grid-template-rows: repeat(14, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-15 {\n    grid-template-rows: repeat(15, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-16 {\n    grid-template-rows: repeat(16, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-17 {\n    grid-template-rows: repeat(17, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-18 {\n    grid-template-rows: repeat(18, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-19 {\n    grid-template-rows: repeat(19, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-20 {\n    grid-template-rows: repeat(20, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-21 {\n    grid-template-rows: repeat(21, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-22 {\n    grid-template-rows: repeat(22, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-23 {\n    grid-template-rows: repeat(23, auto);\n  }\n  .mds .mds-container .mds-grid.mds-grid-md-rows-24 {\n    grid-template-rows: repeat(24, auto);\n  }\n}\n.mds {\n  background: var(--mds_foundations_body_background-color);\n  color: var(--mds_foundations_body_text-color);\n  /* Support for all WebKit browsers. */\n  -webkit-font-smoothing: antialiased;\n  /* Support for Safari and Chrome. */\n  text-rendering: optimizelegibility;\n  /* Support for Firefox. */\n  -moz-osx-font-smoothing: grayscale;\n}\n.mds {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds {\n  font-style: var(--mds_brand_typography_text_medium_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);\n}\n\n.mds .mds-headline--x-small, .mds h4 {\n  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);\n  font-size: var(--mds_brand_typography_headline_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_headline_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-headline--x-small, .mds h4 {\n    font-size: var(--mds_brand_typography_headline_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_x-small_desktop_line-height);\n  }\n}\n.mds .mds-headline--x-small, .mds h4 {\n  text-transform: var(--mds_brand_typography_headline_x-small_text-transform);\n  font-style: var(--mds_brand_typography_headline_x-small_font-style);\n  font-weight: var(--mds_brand_typography_headline_x-small_font-weight);\n}\n.mds .mds-headline--small, .mds h3 {\n  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);\n  font-size: var(--mds_brand_typography_headline_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_headline_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-headline--small, .mds h3 {\n    font-size: var(--mds_brand_typography_headline_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_small_desktop_line-height);\n  }\n}\n.mds .mds-headline--small, .mds h3 {\n  text-transform: var(--mds_brand_typography_headline_small_text-transform);\n  font-style: var(--mds_brand_typography_headline_small_font-style);\n  font-weight: var(--mds_brand_typography_headline_small_font-weight);\n}\n.mds .mds-headline--medium, .mds h2 {\n  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);\n  font-size: var(--mds_brand_typography_headline_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_headline_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-headline--medium, .mds h2 {\n    font-size: var(--mds_brand_typography_headline_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_medium_desktop_line-height);\n  }\n}\n.mds .mds-headline--medium, .mds h2 {\n  text-transform: var(--mds_brand_typography_headline_medium_text-transform);\n  font-style: var(--mds_brand_typography_headline_medium_font-style);\n  font-weight: var(--mds_brand_typography_headline_medium_font-weight);\n}\n.mds .mds-headline--large, .mds h1 {\n  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);\n  font-size: var(--mds_brand_typography_headline_large_mobile_font-size);\n  line-height: var(--mds_brand_typography_headline_large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-headline--large, .mds h1 {\n    font-size: var(--mds_brand_typography_headline_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_large_desktop_line-height);\n  }\n}\n.mds .mds-headline--large, .mds h1 {\n  text-transform: var(--mds_brand_typography_headline_large_text-transform);\n  font-style: var(--mds_brand_typography_headline_large_font-style);\n  font-weight: var(--mds_brand_typography_headline_large_font-weight);\n}\n.mds .mds-headline--x-large {\n  font-family: var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback);\n  font-size: var(--mds_brand_typography_headline_x-large_mobile_font-size);\n  line-height: var(--mds_brand_typography_headline_x-large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-headline--x-large {\n    font-size: var(--mds_brand_typography_headline_x-large_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_x-large_desktop_line-height);\n  }\n}\n.mds .mds-headline--x-large {\n  text-transform: var(--mds_brand_typography_headline_x-large_text-transform);\n  font-style: var(--mds_brand_typography_headline_x-large_font-style);\n  font-weight: var(--mds_brand_typography_headline_x-large_font-weight);\n}\n.mds .mds-text--x-small-normal {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--x-small-normal {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n.mds .mds-text--x-small-normal {\n  font-style: var(--mds_brand_typography_text_x-small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_x-small_normal_font-weight);\n}\n.mds .mds-text--x-small-medium {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--x-small-medium {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n.mds .mds-text--x-small-medium {\n  font-style: var(--mds_brand_typography_text_x-small_medium_font-style);\n  font-weight: var(--mds_brand_typography_text_x-small_medium_font-weight);\n}\n.mds .mds-text--x-small-bold {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--x-small-bold {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n.mds .mds-text--x-small-bold {\n  font-style: var(--mds_brand_typography_text_x-small_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_x-small_bold_font-weight);\n}\n.mds .mds-text--x-small-italic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--x-small-italic {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n.mds .mds-text--x-small-italic {\n  font-style: var(--mds_brand_typography_text_x-small_italic_font-style);\n  font-weight: var(--mds_brand_typography_text_x-small_italic_font-weight);\n}\n.mds .mds-text--x-small-mediumitalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--x-small-mediumitalic {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n.mds .mds-text--x-small-mediumitalic {\n  font-style: var(--mds_brand_typography_text_x-small_mediumitalic_font-style);\n  font-weight: var(--mds_brand_typography_text_x-small_mediumitalic_font-weight);\n}\n.mds .mds-text--x-small-bolditalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--x-small-bolditalic {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n.mds .mds-text--x-small-bolditalic {\n  font-style: var(--mds_brand_typography_text_x-small_bolditalic_font-style);\n  font-weight: var(--mds_brand_typography_text_x-small_bolditalic_font-weight);\n}\n.mds .mds-text--small-normal {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--small-normal {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-text--small-normal {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n.mds .mds-text--small-medium {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--small-medium {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-text--small-medium {\n  font-style: var(--mds_brand_typography_text_small_medium_font-style);\n  font-weight: var(--mds_brand_typography_text_small_medium_font-weight);\n}\n.mds .mds-text--small-bold {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--small-bold {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-text--small-bold {\n  font-style: var(--mds_brand_typography_text_small_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_small_bold_font-weight);\n}\n.mds .mds-text--small-italic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--small-italic {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-text--small-italic {\n  font-style: var(--mds_brand_typography_text_small_italic_font-style);\n  font-weight: var(--mds_brand_typography_text_small_italic_font-weight);\n}\n.mds .mds-text--small-mediumitalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--small-mediumitalic {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-text--small-mediumitalic {\n  font-style: var(--mds_brand_typography_text_small_mediumitalic_font-style);\n  font-weight: var(--mds_brand_typography_text_small_mediumitalic_font-weight);\n}\n.mds .mds-text--small-bolditalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--small-bolditalic {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-text--small-bolditalic {\n  font-style: var(--mds_brand_typography_text_small_bolditalic_font-style);\n  font-weight: var(--mds_brand_typography_text_small_bolditalic_font-weight);\n}\n.mds .mds-text--medium-normal {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--medium-normal {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-text--medium-normal {\n  font-style: var(--mds_brand_typography_text_medium_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);\n}\n.mds .mds-text--medium-medium {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--medium-medium {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-text--medium-medium {\n  font-style: var(--mds_brand_typography_text_medium_medium_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_medium_font-weight);\n}\n.mds .mds-text--medium-bold, .mds h5,\n.mds h6 {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--medium-bold, .mds h5,\n  .mds h6 {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-text--medium-bold, .mds h5,\n.mds h6 {\n  font-style: var(--mds_brand_typography_text_medium_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);\n}\n.mds .mds-text--medium-italic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--medium-italic {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-text--medium-italic {\n  font-style: var(--mds_brand_typography_text_medium_italic_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_italic_font-weight);\n}\n.mds .mds-text--medium-mediumitalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--medium-mediumitalic {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-text--medium-mediumitalic {\n  font-style: var(--mds_brand_typography_text_medium_mediumitalic_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_mediumitalic_font-weight);\n}\n.mds .mds-text--medium-bolditalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--medium-bolditalic {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-text--medium-bolditalic {\n  font-style: var(--mds_brand_typography_text_medium_bolditalic_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_bolditalic_font-weight);\n}\n.mds .mds-text--large-normal {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_large_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--large-normal {\n    font-size: var(--mds_brand_typography_text_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_large_desktop_line-height);\n  }\n}\n.mds .mds-text--large-normal {\n  font-style: var(--mds_brand_typography_text_large_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_large_normal_font-weight);\n}\n.mds .mds-text--large-medium {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_large_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--large-medium {\n    font-size: var(--mds_brand_typography_text_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_large_desktop_line-height);\n  }\n}\n.mds .mds-text--large-medium {\n  font-style: var(--mds_brand_typography_text_large_medium_font-style);\n  font-weight: var(--mds_brand_typography_text_large_medium_font-weight);\n}\n.mds .mds-text--large-bold {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_large_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--large-bold {\n    font-size: var(--mds_brand_typography_text_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_large_desktop_line-height);\n  }\n}\n.mds .mds-text--large-bold {\n  font-style: var(--mds_brand_typography_text_large_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_large_bold_font-weight);\n}\n.mds .mds-text--large-italic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_large_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--large-italic {\n    font-size: var(--mds_brand_typography_text_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_large_desktop_line-height);\n  }\n}\n.mds .mds-text--large-italic {\n  font-style: var(--mds_brand_typography_text_large_italic_font-style);\n  font-weight: var(--mds_brand_typography_text_large_italic_font-weight);\n}\n.mds .mds-text--large-mediumitalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_large_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--large-mediumitalic {\n    font-size: var(--mds_brand_typography_text_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_large_desktop_line-height);\n  }\n}\n.mds .mds-text--large-mediumitalic {\n  font-style: var(--mds_brand_typography_text_large_mediumitalic_font-style);\n  font-weight: var(--mds_brand_typography_text_large_mediumitalic_font-weight);\n}\n.mds .mds-text--large-bolditalic {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_large_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_large_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-text--large-bolditalic {\n    font-size: var(--mds_brand_typography_text_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_large_desktop_line-height);\n  }\n}\n.mds .mds-text--large-bolditalic {\n  font-style: var(--mds_brand_typography_text_large_bolditalic_font-style);\n  font-weight: var(--mds_brand_typography_text_large_bolditalic_font-weight);\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-headline--x-small, .mds .mds-container h4 {\n    font-size: var(--mds_brand_typography_headline_x-small_mobile_font-size);\n    line-height: var(--mds_brand_typography_headline_x-small_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-headline--x-small, .mds .mds-container h4 {\n    font-size: var(--mds_brand_typography_headline_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_x-small_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-headline--small, .mds .mds-container h3 {\n    font-size: var(--mds_brand_typography_headline_small_mobile_font-size);\n    line-height: var(--mds_brand_typography_headline_small_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-headline--small, .mds .mds-container h3 {\n    font-size: var(--mds_brand_typography_headline_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_small_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-headline--medium, .mds .mds-container h2 {\n    font-size: var(--mds_brand_typography_headline_medium_mobile_font-size);\n    line-height: var(--mds_brand_typography_headline_medium_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-headline--medium, .mds .mds-container h2 {\n    font-size: var(--mds_brand_typography_headline_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_medium_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-headline--large, .mds .mds-container h1 {\n    font-size: var(--mds_brand_typography_headline_large_mobile_font-size);\n    line-height: var(--mds_brand_typography_headline_large_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-headline--large, .mds .mds-container h1 {\n    font-size: var(--mds_brand_typography_headline_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_large_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-headline--x-large {\n    font-size: var(--mds_brand_typography_headline_x-large_mobile_font-size);\n    line-height: var(--mds_brand_typography_headline_x-large_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-headline--x-large {\n    font-size: var(--mds_brand_typography_headline_x-large_desktop_font-size);\n    line-height: var(--mds_brand_typography_headline_x-large_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-text--x-small-normal, .mds .mds-container .mds-text--x-small-medium, .mds .mds-container .mds-text--x-small-bold, .mds .mds-container .mds-text--x-small-italic, .mds .mds-container .mds-text--x-small-mediumitalic, .mds .mds-container .mds-text--x-small-bolditalic {\n    font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-text--x-small-normal, .mds .mds-container .mds-text--x-small-medium, .mds .mds-container .mds-text--x-small-bold, .mds .mds-container .mds-text--x-small-italic, .mds .mds-container .mds-text--x-small-mediumitalic, .mds .mds-container .mds-text--x-small-bolditalic {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-text--small-normal, .mds .mds-container .mds-text--small-medium, .mds .mds-container .mds-text--small-bold, .mds .mds-container .mds-text--small-italic, .mds .mds-container .mds-text--small-mediumitalic, .mds .mds-container .mds-text--small-bolditalic {\n    font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n    line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-text--small-normal, .mds .mds-container .mds-text--small-medium, .mds .mds-container .mds-text--small-bold, .mds .mds-container .mds-text--small-italic, .mds .mds-container .mds-text--small-mediumitalic, .mds .mds-container .mds-text--small-bolditalic {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-text--medium-normal, .mds .mds-container .mds-text--medium-medium, .mds .mds-container .mds-text--medium-bold, .mds .mds-container h5,\n  .mds .mds-container h6, .mds .mds-container .mds-text--medium-italic, .mds .mds-container .mds-text--medium-mediumitalic, .mds .mds-container .mds-text--medium-bolditalic {\n    font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n    line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-text--medium-normal, .mds .mds-container .mds-text--medium-medium, .mds .mds-container .mds-text--medium-bold, .mds .mds-container h5,\n  .mds .mds-container h6, .mds .mds-container .mds-text--medium-italic, .mds .mds-container .mds-text--medium-mediumitalic, .mds .mds-container .mds-text--medium-bolditalic {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n@container (max-width: 1024px) {\n  .mds .mds-container .mds-text--large-normal, .mds .mds-container .mds-text--large-medium, .mds .mds-container .mds-text--large-bold, .mds .mds-container .mds-text--large-italic, .mds .mds-container .mds-text--large-mediumitalic, .mds .mds-container .mds-text--large-bolditalic {\n    font-size: var(--mds_brand_typography_text_large_mobile_font-size);\n    line-height: var(--mds_brand_typography_text_large_mobile_line-height);\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-container .mds-text--large-normal, .mds .mds-container .mds-text--large-medium, .mds .mds-container .mds-text--large-bold, .mds .mds-container .mds-text--large-italic, .mds .mds-container .mds-text--large-mediumitalic, .mds .mds-container .mds-text--large-bolditalic {\n    font-size: var(--mds_brand_typography_text_large_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_large_desktop_line-height);\n  }\n}\n.mds .mds-tabular-figures {\n  font-feature-settings: \"tnum\";\n}\n.mds .mds-numeric.mds-tabular-figures {\n  font-feature-settings: \"salt\" on, \"tnum\";\n}\n.mds .mds-numeric {\n  font-feature-settings: \"salt\" on;\n  font-variant-numeric: slashed-zero;\n}\n.mds h1,\n.mds h2,\n.mds h3,\n.mds h4,\n.mds h5,\n.mds h6,\n.mds p {\n  padding: 0;\n  margin: 0;\n}\n.mds em {\n  font-style: var(--mds_brand_typography_text_medium_italic_font-style);\n}\n.mds strong {\n  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);\n}\n.mds .mds-underline--dotted {\n  text-decoration: underline dotted;\n}\n.mds .mds-gap-50,\n.mds .mds-container .mds-gap-50,\n.mds .mds-viewport .mds-gap-50 {\n  gap: 2px;\n}\n.mds .mds-col-gap-50,\n.mds .mds-container .mds-col-gap-50,\n.mds .mds-viewport .mds-col-gap-50 {\n  column-gap: 2px;\n}\n.mds .mds-row-gap-50,\n.mds .mds-container .mds-row-gap-50,\n.mds .mds-viewport .mds-row-gap-50 {\n  row-gap: 2px;\n}\n.mds .mds-gap-100,\n.mds .mds-container .mds-gap-100,\n.mds .mds-viewport .mds-gap-100 {\n  gap: 4px;\n}\n.mds .mds-col-gap-100,\n.mds .mds-container .mds-col-gap-100,\n.mds .mds-viewport .mds-col-gap-100 {\n  column-gap: 4px;\n}\n.mds .mds-row-gap-100,\n.mds .mds-container .mds-row-gap-100,\n.mds .mds-viewport .mds-row-gap-100 {\n  row-gap: 4px;\n}\n.mds .mds-gap-150,\n.mds .mds-container .mds-gap-150,\n.mds .mds-viewport .mds-gap-150 {\n  gap: 6px;\n}\n.mds .mds-col-gap-150,\n.mds .mds-container .mds-col-gap-150,\n.mds .mds-viewport .mds-col-gap-150 {\n  column-gap: 6px;\n}\n.mds .mds-row-gap-150,\n.mds .mds-container .mds-row-gap-150,\n.mds .mds-viewport .mds-row-gap-150 {\n  row-gap: 6px;\n}\n.mds .mds-gap-200,\n.mds .mds-container .mds-gap-200,\n.mds .mds-viewport .mds-gap-200 {\n  gap: 8px;\n}\n.mds .mds-col-gap-200,\n.mds .mds-container .mds-col-gap-200,\n.mds .mds-viewport .mds-col-gap-200 {\n  column-gap: 8px;\n}\n.mds .mds-row-gap-200,\n.mds .mds-container .mds-row-gap-200,\n.mds .mds-viewport .mds-row-gap-200 {\n  row-gap: 8px;\n}\n.mds .mds-gap-300,\n.mds .mds-container .mds-gap-300,\n.mds .mds-viewport .mds-gap-300 {\n  gap: 12px;\n}\n.mds .mds-col-gap-300,\n.mds .mds-container .mds-col-gap-300,\n.mds .mds-viewport .mds-col-gap-300 {\n  column-gap: 12px;\n}\n.mds .mds-row-gap-300,\n.mds .mds-container .mds-row-gap-300,\n.mds .mds-viewport .mds-row-gap-300 {\n  row-gap: 12px;\n}\n.mds .mds-gap-400,\n.mds .mds-container .mds-gap-400,\n.mds .mds-viewport .mds-gap-400 {\n  gap: 16px;\n}\n.mds .mds-col-gap-400,\n.mds .mds-container .mds-col-gap-400,\n.mds .mds-viewport .mds-col-gap-400 {\n  column-gap: 16px;\n}\n.mds .mds-row-gap-400,\n.mds .mds-container .mds-row-gap-400,\n.mds .mds-viewport .mds-row-gap-400 {\n  row-gap: 16px;\n}\n.mds .mds-gap-500,\n.mds .mds-container .mds-gap-500,\n.mds .mds-viewport .mds-gap-500 {\n  gap: 20px;\n}\n.mds .mds-col-gap-500,\n.mds .mds-container .mds-col-gap-500,\n.mds .mds-viewport .mds-col-gap-500 {\n  column-gap: 20px;\n}\n.mds .mds-row-gap-500,\n.mds .mds-container .mds-row-gap-500,\n.mds .mds-viewport .mds-row-gap-500 {\n  row-gap: 20px;\n}\n.mds .mds-gap-600,\n.mds .mds-container .mds-gap-600,\n.mds .mds-viewport .mds-gap-600 {\n  gap: 24px;\n}\n.mds .mds-col-gap-600,\n.mds .mds-container .mds-col-gap-600,\n.mds .mds-viewport .mds-col-gap-600 {\n  column-gap: 24px;\n}\n.mds .mds-row-gap-600,\n.mds .mds-container .mds-row-gap-600,\n.mds .mds-viewport .mds-row-gap-600 {\n  row-gap: 24px;\n}\n.mds .mds-gap-700,\n.mds .mds-container .mds-gap-700,\n.mds .mds-viewport .mds-gap-700 {\n  gap: 28px;\n}\n.mds .mds-col-gap-700,\n.mds .mds-container .mds-col-gap-700,\n.mds .mds-viewport .mds-col-gap-700 {\n  column-gap: 28px;\n}\n.mds .mds-row-gap-700,\n.mds .mds-container .mds-row-gap-700,\n.mds .mds-viewport .mds-row-gap-700 {\n  row-gap: 28px;\n}\n.mds .mds-gap-800,\n.mds .mds-container .mds-gap-800,\n.mds .mds-viewport .mds-gap-800 {\n  gap: 32px;\n}\n.mds .mds-col-gap-800,\n.mds .mds-container .mds-col-gap-800,\n.mds .mds-viewport .mds-col-gap-800 {\n  column-gap: 32px;\n}\n.mds .mds-row-gap-800,\n.mds .mds-container .mds-row-gap-800,\n.mds .mds-viewport .mds-row-gap-800 {\n  row-gap: 32px;\n}\n.mds .mds-gap-900,\n.mds .mds-container .mds-gap-900,\n.mds .mds-viewport .mds-gap-900 {\n  gap: 36px;\n}\n.mds .mds-col-gap-900,\n.mds .mds-container .mds-col-gap-900,\n.mds .mds-viewport .mds-col-gap-900 {\n  column-gap: 36px;\n}\n.mds .mds-row-gap-900,\n.mds .mds-container .mds-row-gap-900,\n.mds .mds-viewport .mds-row-gap-900 {\n  row-gap: 36px;\n}\n.mds .mds-gap-1000,\n.mds .mds-container .mds-gap-1000,\n.mds .mds-viewport .mds-gap-1000 {\n  gap: 40px;\n}\n.mds .mds-col-gap-1000,\n.mds .mds-container .mds-col-gap-1000,\n.mds .mds-viewport .mds-col-gap-1000 {\n  column-gap: 40px;\n}\n.mds .mds-row-gap-1000,\n.mds .mds-container .mds-row-gap-1000,\n.mds .mds-viewport .mds-row-gap-1000 {\n  row-gap: 40px;\n}\n.mds .mds-gap-1200,\n.mds .mds-container .mds-gap-1200,\n.mds .mds-viewport .mds-gap-1200 {\n  gap: 48px;\n}\n.mds .mds-col-gap-1200,\n.mds .mds-container .mds-col-gap-1200,\n.mds .mds-viewport .mds-col-gap-1200 {\n  column-gap: 48px;\n}\n.mds .mds-row-gap-1200,\n.mds .mds-container .mds-row-gap-1200,\n.mds .mds-viewport .mds-row-gap-1200 {\n  row-gap: 48px;\n}\n.mds .mds-gap-1600,\n.mds .mds-container .mds-gap-1600,\n.mds .mds-viewport .mds-gap-1600 {\n  gap: 64px;\n}\n.mds .mds-col-gap-1600,\n.mds .mds-container .mds-col-gap-1600,\n.mds .mds-viewport .mds-col-gap-1600 {\n  column-gap: 64px;\n}\n.mds .mds-row-gap-1600,\n.mds .mds-container .mds-row-gap-1600,\n.mds .mds-viewport .mds-row-gap-1600 {\n  row-gap: 64px;\n}\n.mds .mds-gap-2000,\n.mds .mds-container .mds-gap-2000,\n.mds .mds-viewport .mds-gap-2000 {\n  gap: 80px;\n}\n.mds .mds-col-gap-2000,\n.mds .mds-container .mds-col-gap-2000,\n.mds .mds-viewport .mds-col-gap-2000 {\n  column-gap: 80px;\n}\n.mds .mds-row-gap-2000,\n.mds .mds-container .mds-row-gap-2000,\n.mds .mds-viewport .mds-row-gap-2000 {\n  row-gap: 80px;\n}\n.mds .mds-gap-2400,\n.mds .mds-container .mds-gap-2400,\n.mds .mds-viewport .mds-gap-2400 {\n  gap: 96px;\n}\n.mds .mds-col-gap-2400,\n.mds .mds-container .mds-col-gap-2400,\n.mds .mds-viewport .mds-col-gap-2400 {\n  column-gap: 96px;\n}\n.mds .mds-row-gap-2400,\n.mds .mds-container .mds-row-gap-2400,\n.mds .mds-viewport .mds-row-gap-2400 {\n  row-gap: 96px;\n}\n.mds .mds-gap-2800,\n.mds .mds-container .mds-gap-2800,\n.mds .mds-viewport .mds-gap-2800 {\n  gap: 112px;\n}\n.mds .mds-col-gap-2800,\n.mds .mds-container .mds-col-gap-2800,\n.mds .mds-viewport .mds-col-gap-2800 {\n  column-gap: 112px;\n}\n.mds .mds-row-gap-2800,\n.mds .mds-container .mds-row-gap-2800,\n.mds .mds-viewport .mds-row-gap-2800 {\n  row-gap: 112px;\n}\n.mds .mds-gap-3200,\n.mds .mds-container .mds-gap-3200,\n.mds .mds-viewport .mds-gap-3200 {\n  gap: 128px;\n}\n.mds .mds-col-gap-3200,\n.mds .mds-container .mds-col-gap-3200,\n.mds .mds-viewport .mds-col-gap-3200 {\n  column-gap: 128px;\n}\n.mds .mds-row-gap-3200,\n.mds .mds-container .mds-row-gap-3200,\n.mds .mds-viewport .mds-row-gap-3200 {\n  row-gap: 128px;\n}\n.mds .mds-flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n.mds .mds-flex-items-start {\n  align-items: flex-start;\n}\n.mds .mds-flex-items-center {\n  align-items: center;\n}\n.mds .mds-flex-items-end {\n  align-items: flex-end;\n}\n.mds .mds-flex-items-baseline {\n  align-items: baseline;\n}\n.mds .mds-flex-items-stretch {\n  align-items: stretch;\n}\n.mds hr {\n  border-bottom: var(--mds_foundations_horizontal-rule_border-width) var(--mds_foundations_horizontal-rule_border-style) var(--mds_foundations_horizontal-rule_border-color);\n  border-left-width: 0;\n  border-right-width: 0;\n  border-top-width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n}\n.mds a.mds-link--stand-alone {\n  text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);\n}\n.mds a.mds-link--stand-alone:hover, .mds a.mds-link--stand-alone:active {\n  text-decoration: var(--mds_foundations_link_stand-alone_hover_text-decoration);\n}\n.mds a.mds-link--stand-alone:visited {\n  text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);\n}\n.mds a.mds-link--disabled {\n  pointer-events: inherit;\n  cursor: not-allowed;\n}\n.mds a.mds-link--disabled:hover {\n  text-decoration: var(--mds_foundations_link_inline_text-decoration);\n}\n.mds a.mds-link--disabled:hover.mds-link--stand-alone {\n  text-decoration: var(--mds_foundations_link_stand-alone_text-decoration);\n}\n.mds a.mds-link--disabled {\n  pointer-events: none;\n  touch-action: none;\n  opacity: var(--mds_brand_appearance_state_disabled_opacity);\n  user-select: none;\n}\n.mds a.mds-link--disabled * {\n  user-select: none;\n  pointer-events: none;\n  touch-action: none;\n}\n.mds a.mds-link--external {\n  display: inline-flex;\n}\n.mds a.mds-link--external::after {\n  content: \"\";\n  text-decoration: none;\n  height: var(--mds_foundations_link_external_icon_height);\n  width: var(--mds_foundations_link_external_icon_width);\n  background-color: var(--mds_foundations_link_default_text-color);\n  -webkit-mask: url('data:image/svg+xml,<svg part=\"icon\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M15.293 4H12V3h3.293a1 1 0 0 1 .707.293l.707.707a1 1 0 0 1 .293.707V8h-1V4.707l-6.646 6.647-.708-.708L15.293 4zM3 7a2 2 0 0 1 2-2h4v1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4h1v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z\"></path></svg>') no-repeat 50% 50%;\n  mask: url('data:image/svg+xml,<svg part=\"icon\" shape-rendering=\"geometricPrecision\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M15.293 4H12V3h3.293a1 1 0 0 1 .707.293l.707.707a1 1 0 0 1 .293.707V8h-1V4.707l-6.646 6.647-.708-.708L15.293 4zM3 7a2 2 0 0 1 2-2h4v1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4h1v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z\"></path></svg>') no-repeat 50% 50%;\n  -webkit-mask-size: cover;\n  mask-size: cover;\n}\n.mds a.mds-link--focus-shadow-inset:focus-visible {\n  outline: 0;\n  box-shadow: inset var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);\n}\n.mds a {\n  align-items: center;\n  cursor: pointer;\n  display: inline-flex;\n  text-decoration: var(--mds_foundations_link_inline_text-decoration);\n  transition-duration: var(--mds_foundations_link_transition-duration);\n  transition-property: var(--mds_foundations_link_transition-properties);\n  transition-timing-function: var(--mds_foundations_link_transition-timing);\n}\n.mds a:focus-visible {\n  border-radius: var(--mds_foundations_link_focus_border-radius);\n  text-decoration: var(--mds_foundations_link_inline_hover_text-decoration);\n  outline: 0;\n  box-shadow: var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);\n}\n.mds a:hover, .mds a:active {\n  text-decoration: var(--mds_foundations_link_inline_hover_text-decoration);\n}\n.mds a:visited {\n  text-decoration: var(--mds_foundations_link_inline_text-decoration);\n}\n.mds a {\n  color: var(--mds_foundations_link_default_text-color);\n}\n.mds a:active, .mds a:visited {\n  color: var(--mds_foundations_link_default_text-color);\n}\n.mds a mc-icon::part(icon) {\n  fill: var(--mds_foundations_link_default_text-color);\n}\n.mds mc-button a,\n.mds mc-button a:visited,\n.mds mc-button-group-item a,\n.mds mc-button-group-item a:visited,\n.mds mc-link-button a,\n.mds mc-link-button a:visited,\n.mds mc-list-item a,\n.mds mc-list-item a:visited,\n.mds mc-pagination a,\n.mds mc-pagination a:visited,\n.mds mc-segmented-control-item a,\n.mds mc-segmented-control-item a:visited,\n.mds mc-tab a,\n.mds mc-tab a:visited {\n  text-decoration: none;\n  display: inline-block;\n  position: relative;\n  z-index: 1;\n}\n.mds mc-button-group-item a:focus-visible,\n.mds mc-list-item a:focus-visible,\n.mds mc-pagination a:focus-visible,\n.mds mc-segmented-control-item a:focus-visible,\n.mds mc-tab a:focus-visible {\n  outline: 0;\n  box-shadow: inset var(--mds_brand_appearance_state_focus_default_shadow_offset-x) var(--mds_brand_appearance_state_focus_default_shadow_offset-y) var(--mds_brand_appearance_state_focus_default_shadow_blur-radius) var(--mds_brand_appearance_state_focus_default_shadow_spread-radius) var(--mds_brand_appearance_state_focus_default_shadow_color);\n}\n.mds ul {\n  list-style: var(--mds_foundations_list_unordered_list-style);\n  display: flex;\n  flex-direction: column;\n  gap: var(--mds_foundations_list_vertical_item_gap);\n  margin: 0;\n  padding: 0;\n}\n.mds ul.mds-list--horizontal {\n  flex-direction: row;\n  gap: var(--mds_foundations_list_horizontal_item_gap);\n  padding: 0;\n}\n.mds ul li {\n  padding: 0;\n  margin: 0;\n}\n.mds ol {\n  list-style: var(--mds_foundations_list_ordered_list-style);\n  display: flex;\n  flex-direction: column;\n  gap: var(--mds_foundations_list_vertical_item_gap);\n  margin: 0;\n  padding: 0;\n}\n.mds ol.mds-list--horizontal {\n  flex-direction: row;\n  gap: var(--mds_foundations_list_horizontal_item_gap);\n  padding: 0;\n}\n.mds ol li {\n  padding: 0;\n  margin: 0;\n}\n.mds nav ol,\n.mds nav ul {\n  list-style: none;\n}\n.mds svg:not([fill]) {\n  fill: currentcolor;\n}\n.mds mc-c-table {\n  display: block;\n}\n.mds .mds-table {\n  --row-border-radius: calc(var(--mds_foundations_table_border-radius) - 1px);\n  border-radius: var(--mds_foundations_table_border-radius);\n  border: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);\n  max-width: 100%;\n  /** Base cell styles **/\n  /** Header cell styles **/\n  /** Data cell styles **/\n  /** Footer cell styles **/\n  /** Cell positioning **/\n  /** Large fit **/\n  /** Small fit **/\n  /** Zebra stripes **/\n  /** Highlight on hover **/\n  /** Border style variations **/\n  /** Wrapping **/\n  /** Vertical alignment **/\n  /** Row selector **/\n  /** Row expander **/\n  /** Sortable header **/\n  /** Scrollable **/\n  /** No header **/\n  /** Footer **/\n  /** Sticky **/\n  /** exapnded row **/\n}\n.mds .mds-table table {\n  border-collapse: collapse;\n  border-style: hidden;\n  width: 100%;\n  border-radius: var(--mds_foundations_table_border-radius);\n}\n.mds .mds-table th,\n.mds .mds-table td {\n  padding: var(--mds_foundations_table_medium_cell_padding-top) var(--mds_foundations_table_medium_cell_padding-right) var(--mds_foundations_table_medium_cell_padding-bottom) var(--mds_foundations_table_medium_cell_padding-left);\n  text-align: left;\n  vertical-align: middle;\n  border: 0;\n  border-bottom: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);\n}\n.mds .mds-table th .mds-table__subtext,\n.mds .mds-table td .mds-table__subtext {\n  color: var(--mds_foundations_table_subtext_text-color);\n  display: block;\n  font-weight: var(--mds_foundations_table_subtext_font-weight);\n}\n.mds .mds-table th .mds-table__subtext,\n.mds .mds-table td .mds-table__subtext {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table th .mds-table__subtext,\n  .mds .mds-table td .mds-table__subtext {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-table th .mds-table__subtext,\n.mds .mds-table td .mds-table__subtext {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n.mds .mds-table th {\n  background-color: var(--mds_foundations_table_header-cell_background-color);\n  color: var(--mds_foundations_table_header-cell_text-color);\n}\n.mds .mds-table th {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table th {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-table th {\n  font-style: var(--mds_brand_typography_text_medium_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);\n}\n.mds .mds-table td {\n  background-color: var(--mds_foundations_table_cell_background-color);\n  color: var(--mds_foundations_table_cell_text-color);\n}\n.mds .mds-table td {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table td {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-table td {\n  font-style: var(--mds_brand_typography_text_medium_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);\n}\n.mds .mds-table tfoot td {\n  background-color: var(--mds_foundations_table_cell_background-color);\n  color: var(--mds_foundations_table_cell_text-color);\n}\n.mds .mds-table tfoot td {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table tfoot td {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-table tfoot td {\n  font-style: var(--mds_brand_typography_text_medium_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_bold_font-weight);\n}\n.mds .mds-table thead tr th,\n.mds .mds-table tbody tr td,\n.mds .mds-table tbody tr th,\n.mds .mds-table tfoot tr td {\n  position: relative;\n}\n.mds .mds-table.mds-table--large th,\n.mds .mds-table.mds-table--large td {\n  padding: var(--mds_foundations_table_large_cell_padding-top) var(--mds_foundations_table_large_cell_padding-right) var(--mds_foundations_table_large_cell_padding-bottom) var(--mds_foundations_table_large_cell_padding-left);\n}\n.mds .mds-table.mds-table--large .mds-table__row-selector > mc-checkbox {\n  margin-top: 0;\n}\n.mds .mds-table.mds-table--large .mds-table__row-expander > mc-button {\n  margin-top: 0;\n}\n.mds .mds-table.mds-table--large .mds-table__header-cell--sortable {\n  padding-top: var(--mds_foundations_table_large_header-cell_sortable_padding-top);\n  padding-bottom: var(--mds_foundations_table_large_header-cell_sortable_padding-bottom);\n}\n.mds .mds-table.mds-table--large .mds-table__expanded-row.mds-table__expanded-row--no-padding td {\n  padding: 0;\n}\n.mds .mds-table.mds-table--large .mds-table__expanded-row td {\n  padding: var(--mds_foundations_table_large_expanded-row_padding-top) var(--mds_foundations_table_large_expanded-row_padding-right) var(--mds_foundations_table_large_expanded-row_padding-bottom) var(--mds_foundations_table_large_expanded-row_padding-left);\n}\n.mds .mds-table.mds-table--small th {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table.mds-table--small th {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-table.mds-table--small th {\n  font-style: var(--mds_brand_typography_text_small_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_small_bold_font-weight);\n}\n.mds .mds-table.mds-table--small td {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table.mds-table--small td {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-table.mds-table--small td {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n.mds .mds-table.mds-table--small th,\n.mds .mds-table.mds-table--small td {\n  padding: var(--mds_foundations_table_small_cell_padding-top) var(--mds_foundations_table_small_cell_padding-right) var(--mds_foundations_table_small_cell_padding-bottom) var(--mds_foundations_table_small_cell_padding-left);\n}\n.mds .mds-table.mds-table--small th .mds-table__subtext,\n.mds .mds-table.mds-table--small td .mds-table__subtext {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_x-small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_x-small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table.mds-table--small th .mds-table__subtext,\n  .mds .mds-table.mds-table--small td .mds-table__subtext {\n    font-size: var(--mds_brand_typography_text_x-small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_x-small_desktop_line-height);\n  }\n}\n.mds .mds-table.mds-table--small th .mds-table__subtext,\n.mds .mds-table.mds-table--small td .mds-table__subtext {\n  font-style: var(--mds_brand_typography_text_x-small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_x-small_normal_font-weight);\n}\n.mds .mds-table.mds-table--small tfoot td {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table.mds-table--small tfoot td {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-table.mds-table--small tfoot td {\n  font-style: var(--mds_brand_typography_text_small_bold_font-style);\n  font-weight: var(--mds_brand_typography_text_small_bold_font-weight);\n}\n.mds .mds-table.mds-table--small .mds-table__header-cell--sortable {\n  padding-top: var(--mds_foundations_table_small_header-cell_sortable_padding-top);\n  padding-bottom: var(--mds_foundations_table_small_header-cell_sortable_padding-bottom);\n}\n.mds .mds-table.mds-table--small .mds-table__expanded-row.mds-table__expanded-row--no-padding td {\n  padding: 0;\n}\n.mds .mds-table.mds-table--small .mds-table__expanded-row td {\n  padding: var(--mds_foundations_table_small_expanded-row_padding-top) var(--mds_foundations_table_small_expanded-row_padding-right) var(--mds_foundations_table_small_expanded-row_padding-bottom) var(--mds_foundations_table_small_expanded-row_padding-left);\n}\n.mds .mds-table.mds-table--zebra-stripes tbody tr:nth-child(even) td {\n  background-color: var(--mds_foundations_table_zebra-stripe_background-color);\n  color: var(--mds_foundations_table_zebra-stripe_text-color);\n}\n.mds .mds-table.mds-table--zebra-stripes:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(even) td {\n  background-color: var(--mds_foundations_table_zebra-stripe_background-color);\n  color: var(--mds_foundations_table_zebra-stripe_text-color);\n}\n.mds .mds-table.mds-table--zebra-stripes:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(odd) td {\n  background-color: var(--mds_foundations_table_cell_background-color);\n  color: var(--mds_foundations_table_cell_text-color);\n}\n.mds .mds-table.mds-table--zebra-stripes-with-expand {\n  /* Use row pairs (main row + expanded row) for zebra striping */\n}\n.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+1) td,\n.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+2) td {\n  background-color: var(--mds_foundations_table_cell_background-color);\n  color: var(--mds_foundations_table_cell_text-color);\n}\n.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+3) td,\n.mds .mds-table.mds-table--zebra-stripes-with-expand tbody > tr:nth-child(4n+4) td {\n  background-color: var(--mds_foundations_table_zebra-stripe_background-color);\n  color: var(--mds_foundations_table_zebra-stripe_text-color);\n}\n.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) {\n  /* Use row pairs (main row + expanded row) for zebra striping */\n}\n.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+1) td,\n.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+2) td {\n  background-color: var(--mds_foundations_table_cell_background-color);\n  color: var(--mds_foundations_table_cell_text-color);\n}\n.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+3) td,\n.mds .mds-table.mds-table--zebra-stripes-with-expand:not(.mds-table--disable-row-highlight-on-hover) tbody > tr:nth-child(4n+4) td {\n  background-color: var(--mds_foundations_table_zebra-stripe_background-color);\n  color: var(--mds_foundations_table_zebra-stripe_text-color);\n}\n.mds .mds-table:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(even):hover td, .mds .mds-table:not(.mds-table--disable-row-highlight-on-hover) tbody tr:nth-child(odd):hover td {\n  background-color: var(--mds_foundations_table_cell_hover_background-color);\n  color: var(--mds_foundations_table_cell_hover_text-color);\n}\n.mds .mds-table thead tr:first-child th:first-child,\n.mds .mds-table thead tr:first-child td:first-child {\n  border-top-left-radius: calc(var(--mds_foundations_table_border-radius) - 1px);\n}\n.mds .mds-table thead tr:first-child th:last-child,\n.mds .mds-table thead tr:first-child td:last-child {\n  border-top-right-radius: calc(var(--mds_foundations_table_border-radius) - 1px);\n}\n.mds .mds-table tbody:last-child tr:last-child td:first-child,\n.mds .mds-table tbody:last-child tr:last-child th:first-child,\n.mds .mds-table tfoot tr:last-child td:first-child,\n.mds .mds-table tfoot tr:last-child th:first-child {\n  border-bottom-left-radius: calc(var(--mds_foundations_table_border-radius) - 1px);\n}\n.mds .mds-table tbody:last-child tr:last-child td:last-child,\n.mds .mds-table tbody:last-child tr:last-child th:last-child,\n.mds .mds-table tfoot tr:last-child td:last-child,\n.mds .mds-table tfoot tr:last-child th:last-child {\n  border-bottom-right-radius: calc(var(--mds_foundations_table_border-radius) - 1px);\n}\n.mds .mds-table.mds-table--horizontal-lines-dashed th,\n.mds .mds-table.mds-table--horizontal-lines-dashed td {\n  border-bottom-style: dashed;\n}\n.mds .mds-table.mds-table--horizontal-lines-dashed thead th,\n.mds .mds-table.mds-table--horizontal-lines-dashed thead td {\n  border-top-style: dashed;\n}\n.mds .mds-table.mds-table--horizontal-lines-dotted th,\n.mds .mds-table.mds-table--horizontal-lines-dotted td {\n  border-bottom-style: dotted;\n}\n.mds .mds-table.mds-table--horizontal-lines-dotted thead th,\n.mds .mds-table.mds-table--horizontal-lines-dotted thead td {\n  border-top-style: dotted;\n}\n.mds .mds-table.mds-table--vertical-lines-solid th,\n.mds .mds-table.mds-table--vertical-lines-solid td {\n  border-left: var(--mds_foundations_table_border-width) solid var(--mds_foundations_table_border-color);\n  border-right: var(--mds_foundations_table_border-width) solid var(--mds_foundations_table_border-color);\n}\n.mds .mds-table.mds-table--vertical-lines-dashed th,\n.mds .mds-table.mds-table--vertical-lines-dashed td {\n  border-left: var(--mds_foundations_table_border-width) dashed var(--mds_foundations_table_border-color);\n  border-right: var(--mds_foundations_table_border-width) dashed var(--mds_foundations_table_border-color);\n}\n.mds .mds-table.mds-table--vertical-lines-dotted th,\n.mds .mds-table.mds-table--vertical-lines-dotted td {\n  border-left: var(--mds_foundations_table_border-width) dotted var(--mds_foundations_table_border-color);\n  border-right: var(--mds_foundations_table_border-width) dotted var(--mds_foundations_table_border-color);\n}\n.mds .mds-table.mds-table--horizontal-lines-none th,\n.mds .mds-table.mds-table--horizontal-lines-none td {\n  border-top-width: 0;\n  border-bottom-width: 0;\n}\n.mds .mds-table.mds-table--vertical-lines-none th,\n.mds .mds-table.mds-table--vertical-lines-none td {\n  border-left-width: 0;\n  border-right-width: 0;\n}\n.mds .mds-table.mds-table--outer-border-none {\n  border-width: 0;\n}\n.mds .mds-table.mds-table--outer-border-dashed {\n  border-style: dashed;\n}\n.mds .mds-table.mds-table--outer-border-dotted {\n  border-style: dotted;\n}\n.mds .mds-table.mds-table--outer-border-corners-square {\n  border-radius: 0;\n}\n.mds .mds-table.mds-table--outer-border-corners-square thead tr:first-child th,\n.mds .mds-table.mds-table--outer-border-corners-square thead tr:first-child td,\n.mds .mds-table.mds-table--outer-border-corners-square tbody:last-child tr:last-child th,\n.mds .mds-table.mds-table--outer-border-corners-square tbody:last-child tr:last-child td,\n.mds .mds-table.mds-table--outer-border-corners-square tfoot tr:last-child th,\n.mds .mds-table.mds-table--outer-border-corners-square tfoot tr:last-child td {\n  border-radius: 0;\n}\n.mds .mds-table table tr th,\n.mds .mds-table table tr td {\n  border-radius: 0;\n}\n.mds .mds-table.mds-table--nowrap {\n  white-space: nowrap;\n}\n.mds .mds-table.mds-table--nowrap * {\n  white-space: nowrap;\n}\n.mds .mds-table .mds-table__cell--nowrap {\n  white-space: nowrap;\n}\n.mds .mds-table .mds-table__cell--nowrap * {\n  white-space: nowrap;\n}\n.mds .mds-table.mds-table--vertical-align-top td,\n.mds .mds-table.mds-table--vertical-align-top th {\n  vertical-align: top;\n}\n.mds .mds-table.mds-table--vertical-align-baseline td,\n.mds .mds-table.mds-table--vertical-align-baseline th {\n  vertical-align: baseline;\n}\n.mds .mds-table.mds-table--vertical-align-bottom td,\n.mds .mds-table.mds-table--vertical-align-bottom th {\n  vertical-align: bottom;\n}\n.mds .mds-table .mds-table__column--row-selector {\n  width: 1%;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.mds .mds-table .mds_table__row--selected td {\n  background-color: var(--mds_foundations_table_cell_selected_background-color);\n  color: var(--mds_foundations_table_cell_selected_text-color);\n}\n.mds .mds-table .mds-table__column--row-expander {\n  width: 1%;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.mds .mds-table .mds-table__header-cell--sortable {\n  cursor: pointer;\n  user-select: none !important;\n  padding-top: var(--mds_foundations_table_medium_header-cell_sortable_padding-top);\n  padding-bottom: var(--mds_foundations_table_medium_header-cell_sortable_padding-bottom);\n}\n.mds .mds-table .mds-table__header-cell--sortable:hover {\n  background-color: var(--mds_foundations_table_header-cell_sort_hover_background-color);\n}\n.mds .mds-table .mds-table__header-cell--sortable:active {\n  background-color: var(--mds_foundations_table_header-cell_sort_active_background-color);\n}\n.mds .mds-table .mds-table__header-cell--sortable mc-button {\n  pointer-events: none;\n}\n.mds .mds-table .mds-table__header-cell--sortable mc-button::part(button) {\n  border-radius: 0;\n  padding: 0;\n}\n.mds .mds-table .mds-table__header-cell--sortable mc-button::part(text-and-icon) {\n  font-weight: var(--mds_foundations_table_header-cell_sort-button_font-weight);\n}\n.mds .mds-table.mds-table--scrollable {\n  overflow: auto;\n}\n.mds .mds-table.mds-table--scrollable thead tr:first-child th:last-child,\n.mds .mds-table.mds-table--scrollable thead tr:first-child td:last-child {\n  border-top-right-radius: 0;\n}\n.mds .mds-table.mds-table--scrollable tbody:last-child tr:last-child td:last-child,\n.mds .mds-table.mds-table--scrollable tbody:last-child tr:last-child th:last-child,\n.mds .mds-table.mds-table--scrollable tfoot tr:last-child td:last-child,\n.mds .mds-table.mds-table--scrollable tfoot tr:last-child th:last-child {\n  border-bottom-right-radius: 0;\n}\n.mds .mds-table.mds-table--header-none thead {\n  display: none;\n}\n.mds .mds-table.mds-table--header-none tbody tr:first-child > *:first-child {\n  border-top-left-radius: var(--row-border-radius);\n}\n.mds .mds-table.mds-table--header-none tbody tr:first-child > *:last-child {\n  border-top-right-radius: var(--row-border-radius);\n}\n.mds .mds-table.mds-table--footer tbody tr:last-child > *:first-child {\n  border-bottom-left-radius: 0;\n}\n.mds .mds-table.mds-table--footer tbody tr:last-child > *:last-child {\n  border-bottom-right-radius: 0;\n}\n.mds .mds-table.mds-table--footer tfoot tr:first-child td,\n.mds .mds-table.mds-table--footer tfoot tr:first-child th {\n  border-top: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);\n}\n.mds .mds-table .mds-table__column--sticky {\n  left: 0;\n  position: sticky;\n  z-index: 10;\n  box-shadow: inset calc(0px - var(--mds_core_table_sticky-column_border-width, 3px)) 0 0 0 var(--mds_foundations_table_border-color);\n}\n.mds .mds-table.mds-table--header-sticky thead tr th {\n  border-bottom: 0;\n  box-shadow: inset 0 -1px var(--mds_foundations_table_border-color);\n}\n.mds .mds-table.mds-table--header-sticky thead th,\n.mds .mds-table.mds-table--header-sticky thead td {\n  top: 0;\n  position: sticky;\n  z-index: 11;\n}\n.mds .mds-table.mds-table--header-sticky thead th.mds-table__column--sticky,\n.mds .mds-table.mds-table--header-sticky thead td.mds-table__column--sticky {\n  z-index: 12;\n}\n.mds .mds-table.mds-table--footer-sticky tbody tr:last-child td,\n.mds .mds-table.mds-table--footer-sticky tbody tr:last-child th {\n  border-bottom: 0;\n}\n.mds .mds-table.mds-table--footer-sticky tfoot tr:first-child td,\n.mds .mds-table.mds-table--footer-sticky tfoot tr:first-child th {\n  border-top: 0;\n}\n.mds .mds-table.mds-table--footer-sticky tfoot tr td,\n.mds .mds-table.mds-table--footer-sticky tfoot tr th {\n  box-shadow: inset 0 1px var(--mds_foundations_table_border-color);\n}\n.mds .mds-table.mds-table--footer-sticky tfoot td,\n.mds .mds-table.mds-table--footer-sticky tfoot th {\n  bottom: 0;\n  position: sticky;\n  z-index: 11;\n}\n.mds .mds-table.mds-table--footer-sticky tfoot th.mds-table__column--sticky,\n.mds .mds-table.mds-table--footer-sticky tfoot td.mds-table__column--sticky {\n  z-index: 12;\n}\n.mds .mds-table th.mds-table__cell--text-center,\n.mds .mds-table td.mds-table__cell--text-center {\n  text-align: center;\n}\n.mds .mds-table th.mds-table__cell--text-right, .mds .mds-table th.mds-table__cell--number,\n.mds .mds-table td.mds-table__cell--text-right,\n.mds .mds-table td.mds-table__cell--number {\n  text-align: right;\n}\n.mds .mds-table th.mds-table__cell--tabular-figures, .mds .mds-table th.mds-table__cell--number,\n.mds .mds-table td.mds-table__cell--tabular-figures,\n.mds .mds-table td.mds-table__cell--number {\n  font-feature-settings: \"tnum\";\n}\n.mds .mds-table th.mds-table__cell--content-top,\n.mds .mds-table td.mds-table__cell--content-top {\n  vertical-align: top;\n}\n.mds .mds-table th.mds-table__cell--content-center,\n.mds .mds-table td.mds-table__cell--content-center {\n  vertical-align: middle;\n}\n.mds .mds-table th.mds-table__cell--content-bottom,\n.mds .mds-table td.mds-table__cell--content-bottom {\n  vertical-align: bottom;\n}\n.mds .mds-table .mds-table__expanded-row--hidden {\n  display: none;\n}\n.mds .mds-table .mds-table__expanded-row--visible {\n  display: table-row;\n}\n.mds .mds-table .mds-table__expanded-row--visible:last-of-type {\n  border-top: var(--mds_foundations_table_border-width) var(--mds_foundations_table_border-style) var(--mds_foundations_table_border-color);\n}\n.mds .mds-table.mds-table--medium .mds-table__expanded-row.mds-table__expanded-row--no-padding td {\n  padding: 0;\n}\n.mds .mds-table.mds-table--medium .mds-table__expanded-row td {\n  padding: var(--mds_foundations_table_medium_expanded-row_padding-top) var(--mds_foundations_table_medium_expanded-row_padding-right) var(--mds_foundations_table_medium_expanded-row_padding-bottom) var(--mds_foundations_table_medium_expanded-row_padding-left);\n}\n.mds .mds-table .mds-table__expanded-row__trigger::part(button) {\n  margin: 0;\n  width: auto;\n}\n.mds .mds-table .mds-table__expanded-row__trigger::part(button):hover {\n  background-color: transparent;\n}\n.mds .mds-table .mds-table__expanded-row__trigger::part(icon) {\n  transition: transform var(--mds_foundations_table_row-expander-trigger_transition-duration) ease-in-out;\n}\n.mds .mds-table .mds-table__expanded-row__trigger--expanded::part(icon) {\n  transform: rotate(-180deg);\n}\n.mds .mds-table-and-caption {\n  margin: var(--mds_foundations_table_margin-top) 0 var(--mds_foundations_table_margin-top);\n}\n.mds .mds-table-and-caption .mds-table {\n  margin: 0;\n}\n.mds .mds-table-caption {\n  color: var(--mds_foundations_table_caption_text-color);\n  margin-bottom: var(--mds_foundations_table_medium_caption_margin-bottom);\n}\n.mds .mds-table-caption.mds-table-caption--small {\n  margin-bottom: var(--mds_foundations_table_small_caption_margin-bottom);\n}\n.mds .mds-table-caption.mds-table-caption--small {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_small_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_small_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table-caption.mds-table-caption--small {\n    font-size: var(--mds_brand_typography_text_small_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_small_desktop_line-height);\n  }\n}\n.mds .mds-table-caption.mds-table-caption--small {\n  font-style: var(--mds_brand_typography_text_small_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_small_normal_font-weight);\n}\n.mds .mds-table-caption.mds-table-caption--large {\n  margin-bottom: var(--mds_foundations_table_large_caption_margin-bottom);\n}\n.mds .mds-table-caption {\n  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback);\n  font-size: var(--mds_brand_typography_text_medium_mobile_font-size);\n  line-height: var(--mds_brand_typography_text_medium_mobile_line-height);\n}\n@media screen and (min-width: 1025px) {\n  .mds .mds-table-caption {\n    font-size: var(--mds_brand_typography_text_medium_desktop_font-size);\n    line-height: var(--mds_brand_typography_text_medium_desktop_line-height);\n  }\n}\n.mds .mds-table-caption {\n  font-style: var(--mds_brand_typography_text_medium_normal_font-style);\n  font-weight: var(--mds_brand_typography_text_medium_normal_font-weight);\n}\n@container (max-width: 640px) {\n  .mds .mds-xs-gap-50,\n  .mds .mds-container .mds-xs-gap-50,\n  .mds .mds-viewport .mds-xs-gap-50 {\n    gap: 2px;\n  }\n  .mds .mds-xs-col-gap-50,\n  .mds .mds-container .mds-xs-col-gap-50,\n  .mds .mds-viewport .mds-xs-col-gap-50 {\n    column-gap: 2px;\n  }\n  .mds .mds-xs-row-gap-50,\n  .mds .mds-container .mds-xs-row-gap-50,\n  .mds .mds-viewport .mds-xs-row-gap-50 {\n    row-gap: 2px;\n  }\n  .mds .mds-xs-gap-100,\n  .mds .mds-container .mds-xs-gap-100,\n  .mds .mds-viewport .mds-xs-gap-100 {\n    gap: 4px;\n  }\n  .mds .mds-xs-col-gap-100,\n  .mds .mds-container .mds-xs-col-gap-100,\n  .mds .mds-viewport .mds-xs-col-gap-100 {\n    column-gap: 4px;\n  }\n  .mds .mds-xs-row-gap-100,\n  .mds .mds-container .mds-xs-row-gap-100,\n  .mds .mds-viewport .mds-xs-row-gap-100 {\n    row-gap: 4px;\n  }\n  .mds .mds-xs-gap-150,\n  .mds .mds-container .mds-xs-gap-150,\n  .mds .mds-viewport .mds-xs-gap-150 {\n    gap: 6px;\n  }\n  .mds .mds-xs-col-gap-150,\n  .mds .mds-container .mds-xs-col-gap-150,\n  .mds .mds-viewport .mds-xs-col-gap-150 {\n    column-gap: 6px;\n  }\n  .mds .mds-xs-row-gap-150,\n  .mds .mds-container .mds-xs-row-gap-150,\n  .mds .mds-viewport .mds-xs-row-gap-150 {\n    row-gap: 6px;\n  }\n  .mds .mds-xs-gap-200,\n  .mds .mds-container .mds-xs-gap-200,\n  .mds .mds-viewport .mds-xs-gap-200 {\n    gap: 8px;\n  }\n  .mds .mds-xs-col-gap-200,\n  .mds .mds-container .mds-xs-col-gap-200,\n  .mds .mds-viewport .mds-xs-col-gap-200 {\n    column-gap: 8px;\n  }\n  .mds .mds-xs-row-gap-200,\n  .mds .mds-container .mds-xs-row-gap-200,\n  .mds .mds-viewport .mds-xs-row-gap-200 {\n    row-gap: 8px;\n  }\n  .mds .mds-xs-gap-300,\n  .mds .mds-container .mds-xs-gap-300,\n  .mds .mds-viewport .mds-xs-gap-300 {\n    gap: 12px;\n  }\n  .mds .mds-xs-col-gap-300,\n  .mds .mds-container .mds-xs-col-gap-300,\n  .mds .mds-viewport .mds-xs-col-gap-300 {\n    column-gap: 12px;\n  }\n  .mds .mds-xs-row-gap-300,\n  .mds .mds-container .mds-xs-row-gap-300,\n  .mds .mds-viewport .mds-xs-row-gap-300 {\n    row-gap: 12px;\n  }\n  .mds .mds-xs-gap-400,\n  .mds .mds-container .mds-xs-gap-400,\n  .mds .mds-viewport .mds-xs-gap-400 {\n    gap: 16px;\n  }\n  .mds .mds-xs-col-gap-400,\n  .mds .mds-container .mds-xs-col-gap-400,\n  .mds .mds-viewport .mds-xs-col-gap-400 {\n    column-gap: 16px;\n  }\n  .mds .mds-xs-row-gap-400,\n  .mds .mds-container .mds-xs-row-gap-400,\n  .mds .mds-viewport .mds-xs-row-gap-400 {\n    row-gap: 16px;\n  }\n  .mds .mds-xs-gap-500,\n  .mds .mds-container .mds-xs-gap-500,\n  .mds .mds-viewport .mds-xs-gap-500 {\n    gap: 20px;\n  }\n  .mds .mds-xs-col-gap-500,\n  .mds .mds-container .mds-xs-col-gap-500,\n  .mds .mds-viewport .mds-xs-col-gap-500 {\n    column-gap: 20px;\n  }\n  .mds .mds-xs-row-gap-500,\n  .mds .mds-container .mds-xs-row-gap-500,\n  .mds .mds-viewport .mds-xs-row-gap-500 {\n    row-gap: 20px;\n  }\n  .mds .mds-xs-gap-600,\n  .mds .mds-container .mds-xs-gap-600,\n  .mds .mds-viewport .mds-xs-gap-600 {\n    gap: 24px;\n  }\n  .mds .mds-xs-col-gap-600,\n  .mds .mds-container .mds-xs-col-gap-600,\n  .mds .mds-viewport .mds-xs-col-gap-600 {\n    column-gap: 24px;\n  }\n  .mds .mds-xs-row-gap-600,\n  .mds .mds-container .mds-xs-row-gap-600,\n  .mds .mds-viewport .mds-xs-row-gap-600 {\n    row-gap: 24px;\n  }\n  .mds .mds-xs-gap-700,\n  .mds .mds-container .mds-xs-gap-700,\n  .mds .mds-viewport .mds-xs-gap-700 {\n    gap: 28px;\n  }\n  .mds .mds-xs-col-gap-700,\n  .mds .mds-container .mds-xs-col-gap-700,\n  .mds .mds-viewport .mds-xs-col-gap-700 {\n    column-gap: 28px;\n  }\n  .mds .mds-xs-row-gap-700,\n  .mds .mds-container .mds-xs-row-gap-700,\n  .mds .mds-viewport .mds-xs-row-gap-700 {\n    row-gap: 28px;\n  }\n  .mds .mds-xs-gap-800,\n  .mds .mds-container .mds-xs-gap-800,\n  .mds .mds-viewport .mds-xs-gap-800 {\n    gap: 32px;\n  }\n  .mds .mds-xs-col-gap-800,\n  .mds .mds-container .mds-xs-col-gap-800,\n  .mds .mds-viewport .mds-xs-col-gap-800 {\n    column-gap: 32px;\n  }\n  .mds .mds-xs-row-gap-800,\n  .mds .mds-container .mds-xs-row-gap-800,\n  .mds .mds-viewport .mds-xs-row-gap-800 {\n    row-gap: 32px;\n  }\n  .mds .mds-xs-gap-900,\n  .mds .mds-container .mds-xs-gap-900,\n  .mds .mds-viewport .mds-xs-gap-900 {\n    gap: 36px;\n  }\n  .mds .mds-xs-col-gap-900,\n  .mds .mds-container .mds-xs-col-gap-900,\n  .mds .mds-viewport .mds-xs-col-gap-900 {\n    column-gap: 36px;\n  }\n  .mds .mds-xs-row-gap-900,\n  .mds .mds-container .mds-xs-row-gap-900,\n  .mds .mds-viewport .mds-xs-row-gap-900 {\n    row-gap: 36px;\n  }\n  .mds .mds-xs-gap-1000,\n  .mds .mds-container .mds-xs-gap-1000,\n  .mds .mds-viewport .mds-xs-gap-1000 {\n    gap: 40px;\n  }\n  .mds .mds-xs-col-gap-1000,\n  .mds .mds-container .mds-xs-col-gap-1000,\n  .mds .mds-viewport .mds-xs-col-gap-1000 {\n    column-gap: 40px;\n  }\n  .mds .mds-xs-row-gap-1000,\n  .mds .mds-container .mds-xs-row-gap-1000,\n  .mds .mds-viewport .mds-xs-row-gap-1000 {\n    row-gap: 40px;\n  }\n  .mds .mds-xs-gap-1200,\n  .mds .mds-container .mds-xs-gap-1200,\n  .mds .mds-viewport .mds-xs-gap-1200 {\n    gap: 48px;\n  }\n  .mds .mds-xs-col-gap-1200,\n  .mds .mds-container .mds-xs-col-gap-1200,\n  .mds .mds-viewport .mds-xs-col-gap-1200 {\n    column-gap: 48px;\n  }\n  .mds .mds-xs-row-gap-1200,\n  .mds .mds-container .mds-xs-row-gap-1200,\n  .mds .mds-viewport .mds-xs-row-gap-1200 {\n    row-gap: 48px;\n  }\n  .mds .mds-xs-gap-1600,\n  .mds .mds-container .mds-xs-gap-1600,\n  .mds .mds-viewport .mds-xs-gap-1600 {\n    gap: 64px;\n  }\n  .mds .mds-xs-col-gap-1600,\n  .mds .mds-container .mds-xs-col-gap-1600,\n  .mds .mds-viewport .mds-xs-col-gap-1600 {\n    column-gap: 64px;\n  }\n  .mds .mds-xs-row-gap-1600,\n  .mds .mds-container .mds-xs-row-gap-1600,\n  .mds .mds-viewport .mds-xs-row-gap-1600 {\n    row-gap: 64px;\n  }\n  .mds .mds-xs-gap-2000,\n  .mds .mds-container .mds-xs-gap-2000,\n  .mds .mds-viewport .mds-xs-gap-2000 {\n    gap: 80px;\n  }\n  .mds .mds-xs-col-gap-2000,\n  .mds .mds-container .mds-xs-col-gap-2000,\n  .mds .mds-viewport .mds-xs-col-gap-2000 {\n    column-gap: 80px;\n  }\n  .mds .mds-xs-row-gap-2000,\n  .mds .mds-container .mds-xs-row-gap-2000,\n  .mds .mds-viewport .mds-xs-row-gap-2000 {\n    row-gap: 80px;\n  }\n  .mds .mds-xs-gap-2400,\n  .mds .mds-container .mds-xs-gap-2400,\n  .mds .mds-viewport .mds-xs-gap-2400 {\n    gap: 96px;\n  }\n  .mds .mds-xs-col-gap-2400,\n  .mds .mds-container .mds-xs-col-gap-2400,\n  .mds .mds-viewport .mds-xs-col-gap-2400 {\n    column-gap: 96px;\n  }\n  .mds .mds-xs-row-gap-2400,\n  .mds .mds-container .mds-xs-row-gap-2400,\n  .mds .mds-viewport .mds-xs-row-gap-2400 {\n    row-gap: 96px;\n  }\n  .mds .mds-xs-gap-2800,\n  .mds .mds-container .mds-xs-gap-2800,\n  .mds .mds-viewport .mds-xs-gap-2800 {\n    gap: 112px;\n  }\n  .mds .mds-xs-col-gap-2800,\n  .mds .mds-container .mds-xs-col-gap-2800,\n  .mds .mds-viewport .mds-xs-col-gap-2800 {\n    column-gap: 112px;\n  }\n  .mds .mds-xs-row-gap-2800,\n  .mds .mds-container .mds-xs-row-gap-2800,\n  .mds .mds-viewport .mds-xs-row-gap-2800 {\n    row-gap: 112px;\n  }\n  .mds .mds-xs-gap-3200,\n  .mds .mds-container .mds-xs-gap-3200,\n  .mds .mds-viewport .mds-xs-gap-3200 {\n    gap: 128px;\n  }\n  .mds .mds-xs-col-gap-3200,\n  .mds .mds-container .mds-xs-col-gap-3200,\n  .mds .mds-viewport .mds-xs-col-gap-3200 {\n    column-gap: 128px;\n  }\n  .mds .mds-xs-row-gap-3200,\n  .mds .mds-container .mds-xs-row-gap-3200,\n  .mds .mds-viewport .mds-xs-row-gap-3200 {\n    row-gap: 128px;\n  }\n}\n@container (min-width: 641px) {\n  .mds .mds-sm-gap-50,\n  .mds .mds-container .mds-sm-gap-50,\n  .mds .mds-viewport .mds-sm-gap-50 {\n    gap: 2px;\n  }\n  .mds .mds-sm-col-gap-50,\n  .mds .mds-container .mds-sm-col-gap-50,\n  .mds .mds-viewport .mds-sm-col-gap-50 {\n    column-gap: 2px;\n  }\n  .mds .mds-sm-row-gap-50,\n  .mds .mds-container .mds-sm-row-gap-50,\n  .mds .mds-viewport .mds-sm-row-gap-50 {\n    row-gap: 2px;\n  }\n  .mds .mds-sm-gap-100,\n  .mds .mds-container .mds-sm-gap-100,\n  .mds .mds-viewport .mds-sm-gap-100 {\n    gap: 4px;\n  }\n  .mds .mds-sm-col-gap-100,\n  .mds .mds-container .mds-sm-col-gap-100,\n  .mds .mds-viewport .mds-sm-col-gap-100 {\n    column-gap: 4px;\n  }\n  .mds .mds-sm-row-gap-100,\n  .mds .mds-container .mds-sm-row-gap-100,\n  .mds .mds-viewport .mds-sm-row-gap-100 {\n    row-gap: 4px;\n  }\n  .mds .mds-sm-gap-150,\n  .mds .mds-container .mds-sm-gap-150,\n  .mds .mds-viewport .mds-sm-gap-150 {\n    gap: 6px;\n  }\n  .mds .mds-sm-col-gap-150,\n  .mds .mds-container .mds-sm-col-gap-150,\n  .mds .mds-viewport .mds-sm-col-gap-150 {\n    column-gap: 6px;\n  }\n  .mds .mds-sm-row-gap-150,\n  .mds .mds-container .mds-sm-row-gap-150,\n  .mds .mds-viewport .mds-sm-row-gap-150 {\n    row-gap: 6px;\n  }\n  .mds .mds-sm-gap-200,\n  .mds .mds-container .mds-sm-gap-200,\n  .mds .mds-viewport .mds-sm-gap-200 {\n    gap: 8px;\n  }\n  .mds .mds-sm-col-gap-200,\n  .mds .mds-container .mds-sm-col-gap-200,\n  .mds .mds-viewport .mds-sm-col-gap-200 {\n    column-gap: 8px;\n  }\n  .mds .mds-sm-row-gap-200,\n  .mds .mds-container .mds-sm-row-gap-200,\n  .mds .mds-viewport .mds-sm-row-gap-200 {\n    row-gap: 8px;\n  }\n  .mds .mds-sm-gap-300,\n  .mds .mds-container .mds-sm-gap-300,\n  .mds .mds-viewport .mds-sm-gap-300 {\n    gap: 12px;\n  }\n  .mds .mds-sm-col-gap-300,\n  .mds .mds-container .mds-sm-col-gap-300,\n  .mds .mds-viewport .mds-sm-col-gap-300 {\n    column-gap: 12px;\n  }\n  .mds .mds-sm-row-gap-300,\n  .mds .mds-container .mds-sm-row-gap-300,\n  .mds .mds-viewport .mds-sm-row-gap-300 {\n    row-gap: 12px;\n  }\n  .mds .mds-sm-gap-400,\n  .mds .mds-container .mds-sm-gap-400,\n  .mds .mds-viewport .mds-sm-gap-400 {\n    gap: 16px;\n  }\n  .mds .mds-sm-col-gap-400,\n  .mds .mds-container .mds-sm-col-gap-400,\n  .mds .mds-viewport .mds-sm-col-gap-400 {\n    column-gap: 16px;\n  }\n  .mds .mds-sm-row-gap-400,\n  .mds .mds-container .mds-sm-row-gap-400,\n  .mds .mds-viewport .mds-sm-row-gap-400 {\n    row-gap: 16px;\n  }\n  .mds .mds-sm-gap-500,\n  .mds .mds-container .mds-sm-gap-500,\n  .mds .mds-viewport .mds-sm-gap-500 {\n    gap: 20px;\n  }\n  .mds .mds-sm-col-gap-500,\n  .mds .mds-container .mds-sm-col-gap-500,\n  .mds .mds-viewport .mds-sm-col-gap-500 {\n    column-gap: 20px;\n  }\n  .mds .mds-sm-row-gap-500,\n  .mds .mds-container .mds-sm-row-gap-500,\n  .mds .mds-viewport .mds-sm-row-gap-500 {\n    row-gap: 20px;\n  }\n  .mds .mds-sm-gap-600,\n  .mds .mds-container .mds-sm-gap-600,\n  .mds .mds-viewport .mds-sm-gap-600 {\n    gap: 24px;\n  }\n  .mds .mds-sm-col-gap-600,\n  .mds .mds-container .mds-sm-col-gap-600,\n  .mds .mds-viewport .mds-sm-col-gap-600 {\n    column-gap: 24px;\n  }\n  .mds .mds-sm-row-gap-600,\n  .mds .mds-container .mds-sm-row-gap-600,\n  .mds .mds-viewport .mds-sm-row-gap-600 {\n    row-gap: 24px;\n  }\n  .mds .mds-sm-gap-700,\n  .mds .mds-container .mds-sm-gap-700,\n  .mds .mds-viewport .mds-sm-gap-700 {\n    gap: 28px;\n  }\n  .mds .mds-sm-col-gap-700,\n  .mds .mds-container .mds-sm-col-gap-700,\n  .mds .mds-viewport .mds-sm-col-gap-700 {\n    column-gap: 28px;\n  }\n  .mds .mds-sm-row-gap-700,\n  .mds .mds-container .mds-sm-row-gap-700,\n  .mds .mds-viewport .mds-sm-row-gap-700 {\n    row-gap: 28px;\n  }\n  .mds .mds-sm-gap-800,\n  .mds .mds-container .mds-sm-gap-800,\n  .mds .mds-viewport .mds-sm-gap-800 {\n    gap: 32px;\n  }\n  .mds .mds-sm-col-gap-800,\n  .mds .mds-container .mds-sm-col-gap-800,\n  .mds .mds-viewport .mds-sm-col-gap-800 {\n    column-gap: 32px;\n  }\n  .mds .mds-sm-row-gap-800,\n  .mds .mds-container .mds-sm-row-gap-800,\n  .mds .mds-viewport .mds-sm-row-gap-800 {\n    row-gap: 32px;\n  }\n  .mds .mds-sm-gap-900,\n  .mds .mds-container .mds-sm-gap-900,\n  .mds .mds-viewport .mds-sm-gap-900 {\n    gap: 36px;\n  }\n  .mds .mds-sm-col-gap-900,\n  .mds .mds-container .mds-sm-col-gap-900,\n  .mds .mds-viewport .mds-sm-col-gap-900 {\n    column-gap: 36px;\n  }\n  .mds .mds-sm-row-gap-900,\n  .mds .mds-container .mds-sm-row-gap-900,\n  .mds .mds-viewport .mds-sm-row-gap-900 {\n    row-gap: 36px;\n  }\n  .mds .mds-sm-gap-1000,\n  .mds .mds-container .mds-sm-gap-1000,\n  .mds .mds-viewport .mds-sm-gap-1000 {\n    gap: 40px;\n  }\n  .mds .mds-sm-col-gap-1000,\n  .mds .mds-container .mds-sm-col-gap-1000,\n  .mds .mds-viewport .mds-sm-col-gap-1000 {\n    column-gap: 40px;\n  }\n  .mds .mds-sm-row-gap-1000,\n  .mds .mds-container .mds-sm-row-gap-1000,\n  .mds .mds-viewport .mds-sm-row-gap-1000 {\n    row-gap: 40px;\n  }\n  .mds .mds-sm-gap-1200,\n  .mds .mds-container .mds-sm-gap-1200,\n  .mds .mds-viewport .mds-sm-gap-1200 {\n    gap: 48px;\n  }\n  .mds .mds-sm-col-gap-1200,\n  .mds .mds-container .mds-sm-col-gap-1200,\n  .mds .mds-viewport .mds-sm-col-gap-1200 {\n    column-gap: 48px;\n  }\n  .mds .mds-sm-row-gap-1200,\n  .mds .mds-container .mds-sm-row-gap-1200,\n  .mds .mds-viewport .mds-sm-row-gap-1200 {\n    row-gap: 48px;\n  }\n  .mds .mds-sm-gap-1600,\n  .mds .mds-container .mds-sm-gap-1600,\n  .mds .mds-viewport .mds-sm-gap-1600 {\n    gap: 64px;\n  }\n  .mds .mds-sm-col-gap-1600,\n  .mds .mds-container .mds-sm-col-gap-1600,\n  .mds .mds-viewport .mds-sm-col-gap-1600 {\n    column-gap: 64px;\n  }\n  .mds .mds-sm-row-gap-1600,\n  .mds .mds-container .mds-sm-row-gap-1600,\n  .mds .mds-viewport .mds-sm-row-gap-1600 {\n    row-gap: 64px;\n  }\n  .mds .mds-sm-gap-2000,\n  .mds .mds-container .mds-sm-gap-2000,\n  .mds .mds-viewport .mds-sm-gap-2000 {\n    gap: 80px;\n  }\n  .mds .mds-sm-col-gap-2000,\n  .mds .mds-container .mds-sm-col-gap-2000,\n  .mds .mds-viewport .mds-sm-col-gap-2000 {\n    column-gap: 80px;\n  }\n  .mds .mds-sm-row-gap-2000,\n  .mds .mds-container .mds-sm-row-gap-2000,\n  .mds .mds-viewport .mds-sm-row-gap-2000 {\n    row-gap: 80px;\n  }\n  .mds .mds-sm-gap-2400,\n  .mds .mds-container .mds-sm-gap-2400,\n  .mds .mds-viewport .mds-sm-gap-2400 {\n    gap: 96px;\n  }\n  .mds .mds-sm-col-gap-2400,\n  .mds .mds-container .mds-sm-col-gap-2400,\n  .mds .mds-viewport .mds-sm-col-gap-2400 {\n    column-gap: 96px;\n  }\n  .mds .mds-sm-row-gap-2400,\n  .mds .mds-container .mds-sm-row-gap-2400,\n  .mds .mds-viewport .mds-sm-row-gap-2400 {\n    row-gap: 96px;\n  }\n  .mds .mds-sm-gap-2800,\n  .mds .mds-container .mds-sm-gap-2800,\n  .mds .mds-viewport .mds-sm-gap-2800 {\n    gap: 112px;\n  }\n  .mds .mds-sm-col-gap-2800,\n  .mds .mds-container .mds-sm-col-gap-2800,\n  .mds .mds-viewport .mds-sm-col-gap-2800 {\n    column-gap: 112px;\n  }\n  .mds .mds-sm-row-gap-2800,\n  .mds .mds-container .mds-sm-row-gap-2800,\n  .mds .mds-viewport .mds-sm-row-gap-2800 {\n    row-gap: 112px;\n  }\n  .mds .mds-sm-gap-3200,\n  .mds .mds-container .mds-sm-gap-3200,\n  .mds .mds-viewport .mds-sm-gap-3200 {\n    gap: 128px;\n  }\n  .mds .mds-sm-col-gap-3200,\n  .mds .mds-container .mds-sm-col-gap-3200,\n  .mds .mds-viewport .mds-sm-col-gap-3200 {\n    column-gap: 128px;\n  }\n  .mds .mds-sm-row-gap-3200,\n  .mds .mds-container .mds-sm-row-gap-3200,\n  .mds .mds-viewport .mds-sm-row-gap-3200 {\n    row-gap: 128px;\n  }\n}\n@container (min-width: 1025px) {\n  .mds .mds-md-gap-50,\n  .mds .mds-container .mds-md-gap-50,\n  .mds .mds-viewport .mds-md-gap-50 {\n    gap: 2px;\n  }\n  .mds .mds-md-col-gap-50,\n  .mds .mds-container .mds-md-col-gap-50,\n  .mds .mds-viewport .mds-md-col-gap-50 {\n    column-gap: 2px;\n  }\n  .mds .mds-md-row-gap-50,\n  .mds .mds-container .mds-md-row-gap-50,\n  .mds .mds-viewport .mds-md-row-gap-50 {\n    row-gap: 2px;\n  }\n  .mds .mds-md-gap-100,\n  .mds .mds-container .mds-md-gap-100,\n  .mds .mds-viewport .mds-md-gap-100 {\n    gap: 4px;\n  }\n  .mds .mds-md-col-gap-100,\n  .mds .mds-container .mds-md-col-gap-100,\n  .mds .mds-viewport .mds-md-col-gap-100 {\n    column-gap: 4px;\n  }\n  .mds .mds-md-row-gap-100,\n  .mds .mds-container .mds-md-row-gap-100,\n  .mds .mds-viewport .mds-md-row-gap-100 {\n    row-gap: 4px;\n  }\n  .mds .mds-md-gap-150,\n  .mds .mds-container .mds-md-gap-150,\n  .mds .mds-viewport .mds-md-gap-150 {\n    gap: 6px;\n  }\n  .mds .mds-md-col-gap-150,\n  .mds .mds-container .mds-md-col-gap-150,\n  .mds .mds-viewport .mds-md-col-gap-150 {\n    column-gap: 6px;\n  }\n  .mds .mds-md-row-gap-150,\n  .mds .mds-container .mds-md-row-gap-150,\n  .mds .mds-viewport .mds-md-row-gap-150 {\n    row-gap: 6px;\n  }\n  .mds .mds-md-gap-200,\n  .mds .mds-container .mds-md-gap-200,\n  .mds .mds-viewport .mds-md-gap-200 {\n    gap: 8px;\n  }\n  .mds .mds-md-col-gap-200,\n  .mds .mds-container .mds-md-col-gap-200,\n  .mds .mds-viewport .mds-md-col-gap-200 {\n    column-gap: 8px;\n  }\n  .mds .mds-md-row-gap-200,\n  .mds .mds-container .mds-md-row-gap-200,\n  .mds .mds-viewport .mds-md-row-gap-200 {\n    row-gap: 8px;\n  }\n  .mds .mds-md-gap-300,\n  .mds .mds-container .mds-md-gap-300,\n  .mds .mds-viewport .mds-md-gap-300 {\n    gap: 12px;\n  }\n  .mds .mds-md-col-gap-300,\n  .mds .mds-container .mds-md-col-gap-300,\n  .mds .mds-viewport .mds-md-col-gap-300 {\n    column-gap: 12px;\n  }\n  .mds .mds-md-row-gap-300,\n  .mds .mds-container .mds-md-row-gap-300,\n  .mds .mds-viewport .mds-md-row-gap-300 {\n    row-gap: 12px;\n  }\n  .mds .mds-md-gap-400,\n  .mds .mds-container .mds-md-gap-400,\n  .mds .mds-viewport .mds-md-gap-400 {\n    gap: 16px;\n  }\n  .mds .mds-md-col-gap-400,\n  .mds .mds-container .mds-md-col-gap-400,\n  .mds .mds-viewport .mds-md-col-gap-400 {\n    column-gap: 16px;\n  }\n  .mds .mds-md-row-gap-400,\n  .mds .mds-container .mds-md-row-gap-400,\n  .mds .mds-viewport .mds-md-row-gap-400 {\n    row-gap: 16px;\n  }\n  .mds .mds-md-gap-500,\n  .mds .mds-container .mds-md-gap-500,\n  .mds .mds-viewport .mds-md-gap-500 {\n    gap: 20px;\n  }\n  .mds .mds-md-col-gap-500,\n  .mds .mds-container .mds-md-col-gap-500,\n  .mds .mds-viewport .mds-md-col-gap-500 {\n    column-gap: 20px;\n  }\n  .mds .mds-md-row-gap-500,\n  .mds .mds-container .mds-md-row-gap-500,\n  .mds .mds-viewport .mds-md-row-gap-500 {\n    row-gap: 20px;\n  }\n  .mds .mds-md-gap-600,\n  .mds .mds-container .mds-md-gap-600,\n  .mds .mds-viewport .mds-md-gap-600 {\n    gap: 24px;\n  }\n  .mds .mds-md-col-gap-600,\n  .mds .mds-container .mds-md-col-gap-600,\n  .mds .mds-viewport .mds-md-col-gap-600 {\n    column-gap: 24px;\n  }\n  .mds .mds-md-row-gap-600,\n  .mds .mds-container .mds-md-row-gap-600,\n  .mds .mds-viewport .mds-md-row-gap-600 {\n    row-gap: 24px;\n  }\n  .mds .mds-md-gap-700,\n  .mds .mds-container .mds-md-gap-700,\n  .mds .mds-viewport .mds-md-gap-700 {\n    gap: 28px;\n  }\n  .mds .mds-md-col-gap-700,\n  .mds .mds-container .mds-md-col-gap-700,\n  .mds .mds-viewport .mds-md-col-gap-700 {\n    column-gap: 28px;\n  }\n  .mds .mds-md-row-gap-700,\n  .mds .mds-container .mds-md-row-gap-700,\n  .mds .mds-viewport .mds-md-row-gap-700 {\n    row-gap: 28px;\n  }\n  .mds .mds-md-gap-800,\n  .mds .mds-container .mds-md-gap-800,\n  .mds .mds-viewport .mds-md-gap-800 {\n    gap: 32px;\n  }\n  .mds .mds-md-col-gap-800,\n  .mds .mds-container .mds-md-col-gap-800,\n  .mds .mds-viewport .mds-md-col-gap-800 {\n    column-gap: 32px;\n  }\n  .mds .mds-md-row-gap-800,\n  .mds .mds-container .mds-md-row-gap-800,\n  .mds .mds-viewport .mds-md-row-gap-800 {\n    row-gap: 32px;\n  }\n  .mds .mds-md-gap-900,\n  .mds .mds-container .mds-md-gap-900,\n  .mds .mds-viewport .mds-md-gap-900 {\n    gap: 36px;\n  }\n  .mds .mds-md-col-gap-900,\n  .mds .mds-container .mds-md-col-gap-900,\n  .mds .mds-viewport .mds-md-col-gap-900 {\n    column-gap: 36px;\n  }\n  .mds .mds-md-row-gap-900,\n  .mds .mds-container .mds-md-row-gap-900,\n  .mds .mds-viewport .mds-md-row-gap-900 {\n    row-gap: 36px;\n  }\n  .mds .mds-md-gap-1000,\n  .mds .mds-container .mds-md-gap-1000,\n  .mds .mds-viewport .mds-md-gap-1000 {\n    gap: 40px;\n  }\n  .mds .mds-md-col-gap-1000,\n  .mds .mds-container .mds-md-col-gap-1000,\n  .mds .mds-viewport .mds-md-col-gap-1000 {\n    column-gap: 40px;\n  }\n  .mds .mds-md-row-gap-1000,\n  .mds .mds-container .mds-md-row-gap-1000,\n  .mds .mds-viewport .mds-md-row-gap-1000 {\n    row-gap: 40px;\n  }\n  .mds .mds-md-gap-1200,\n  .mds .mds-container .mds-md-gap-1200,\n  .mds .mds-viewport .mds-md-gap-1200 {\n    gap: 48px;\n  }\n  .mds .mds-md-col-gap-1200,\n  .mds .mds-container .mds-md-col-gap-1200,\n  .mds .mds-viewport .mds-md-col-gap-1200 {\n    column-gap: 48px;\n  }\n  .mds .mds-md-row-gap-1200,\n  .mds .mds-container .mds-md-row-gap-1200,\n  .mds .mds-viewport .mds-md-row-gap-1200 {\n    row-gap: 48px;\n  }\n  .mds .mds-md-gap-1600,\n  .mds .mds-container .mds-md-gap-1600,\n  .mds .mds-viewport .mds-md-gap-1600 {\n    gap: 64px;\n  }\n  .mds .mds-md-col-gap-1600,\n  .mds .mds-container .mds-md-col-gap-1600,\n  .mds .mds-viewport .mds-md-col-gap-1600 {\n    column-gap: 64px;\n  }\n  .mds .mds-md-row-gap-1600,\n  .mds .mds-container .mds-md-row-gap-1600,\n  .mds .mds-viewport .mds-md-row-gap-1600 {\n    row-gap: 64px;\n  }\n  .mds .mds-md-gap-2000,\n  .mds .mds-container .mds-md-gap-2000,\n  .mds .mds-viewport .mds-md-gap-2000 {\n    gap: 80px;\n  }\n  .mds .mds-md-col-gap-2000,\n  .mds .mds-container .mds-md-col-gap-2000,\n  .mds .mds-viewport .mds-md-col-gap-2000 {\n    column-gap: 80px;\n  }\n  .mds .mds-md-row-gap-2000,\n  .mds .mds-container .mds-md-row-gap-2000,\n  .mds .mds-viewport .mds-md-row-gap-2000 {\n    row-gap: 80px;\n  }\n  .mds .mds-md-gap-2400,\n  .mds .mds-container .mds-md-gap-2400,\n  .mds .mds-viewport .mds-md-gap-2400 {\n    gap: 96px;\n  }\n  .mds .mds-md-col-gap-2400,\n  .mds .mds-container .mds-md-col-gap-2400,\n  .mds .mds-viewport .mds-md-col-gap-2400 {\n    column-gap: 96px;\n  }\n  .mds .mds-md-row-gap-2400,\n  .mds .mds-container .mds-md-row-gap-2400,\n  .mds .mds-viewport .mds-md-row-gap-2400 {\n    row-gap: 96px;\n  }\n  .mds .mds-md-gap-2800,\n  .mds .mds-container .mds-md-gap-2800,\n  .mds .mds-viewport .mds-md-gap-2800 {\n    gap: 112px;\n  }\n  .mds .mds-md-col-gap-2800,\n  .mds .mds-container .mds-md-col-gap-2800,\n  .mds .mds-viewport .mds-md-col-gap-2800 {\n    column-gap: 112px;\n  }\n  .mds .mds-md-row-gap-2800,\n  .mds .mds-container .mds-md-row-gap-2800,\n  .mds .mds-viewport .mds-md-row-gap-2800 {\n    row-gap: 112px;\n  }\n  .mds .mds-md-gap-3200,\n  .mds .mds-container .mds-md-gap-3200,\n  .mds .mds-viewport .mds-md-gap-3200 {\n    gap: 128px;\n  }\n  .mds .mds-md-col-gap-3200,\n  .mds .mds-container .mds-md-col-gap-3200,\n  .mds .mds-viewport .mds-md-col-gap-3200 {\n    column-gap: 128px;\n  }\n  .mds .mds-md-row-gap-3200,\n  .mds .mds-container .mds-md-row-gap-3200,\n  .mds .mds-viewport .mds-md-row-gap-3200 {\n    row-gap: 128px;\n  }\n}\n@container (min-width: 1441px) {\n  .mds .mds-lg-gap-50,\n  .mds .mds-container .mds-lg-gap-50,\n  .mds .mds-viewport .mds-lg-gap-50 {\n    gap: 2px;\n  }\n  .mds .mds-lg-col-gap-50,\n  .mds .mds-container .mds-lg-col-gap-50,\n  .mds .mds-viewport .mds-lg-col-gap-50 {\n    column-gap: 2px;\n  }\n  .mds .mds-lg-row-gap-50,\n  .mds .mds-container .mds-lg-row-gap-50,\n  .mds .mds-viewport .mds-lg-row-gap-50 {\n    row-gap: 2px;\n  }\n  .mds .mds-lg-gap-100,\n  .mds .mds-container .mds-lg-gap-100,\n  .mds .mds-viewport .mds-lg-gap-100 {\n    gap: 4px;\n  }\n  .mds .mds-lg-col-gap-100,\n  .mds .mds-container .mds-lg-col-gap-100,\n  .mds .mds-viewport .mds-lg-col-gap-100 {\n    column-gap: 4px;\n  }\n  .mds .mds-lg-row-gap-100,\n  .mds .mds-container .mds-lg-row-gap-100,\n  .mds .mds-viewport .mds-lg-row-gap-100 {\n    row-gap: 4px;\n  }\n  .mds .mds-lg-gap-150,\n  .mds .mds-container .mds-lg-gap-150,\n  .mds .mds-viewport .mds-lg-gap-150 {\n    gap: 6px;\n  }\n  .mds .mds-lg-col-gap-150,\n  .mds .mds-container .mds-lg-col-gap-150,\n  .mds .mds-viewport .mds-lg-col-gap-150 {\n    column-gap: 6px;\n  }\n  .mds .mds-lg-row-gap-150,\n  .mds .mds-container .mds-lg-row-gap-150,\n  .mds .mds-viewport .mds-lg-row-gap-150 {\n    row-gap: 6px;\n  }\n  .mds .mds-lg-gap-200,\n  .mds .mds-container .mds-lg-gap-200,\n  .mds .mds-viewport .mds-lg-gap-200 {\n    gap: 8px;\n  }\n  .mds .mds-lg-col-gap-200,\n  .mds .mds-container .mds-lg-col-gap-200,\n  .mds .mds-viewport .mds-lg-col-gap-200 {\n    column-gap: 8px;\n  }\n  .mds .mds-lg-row-gap-200,\n  .mds .mds-container .mds-lg-row-gap-200,\n  .mds .mds-viewport .mds-lg-row-gap-200 {\n    row-gap: 8px;\n  }\n  .mds .mds-lg-gap-300,\n  .mds .mds-container .mds-lg-gap-300,\n  .mds .mds-viewport .mds-lg-gap-300 {\n    gap: 12px;\n  }\n  .mds .mds-lg-col-gap-300,\n  .mds .mds-container .mds-lg-col-gap-300,\n  .mds .mds-viewport .mds-lg-col-gap-300 {\n    column-gap: 12px;\n  }\n  .mds .mds-lg-row-gap-300,\n  .mds .mds-container .mds-lg-row-gap-300,\n  .mds .mds-viewport .mds-lg-row-gap-300 {\n    row-gap: 12px;\n  }\n  .mds .mds-lg-gap-400,\n  .mds .mds-container .mds-lg-gap-400,\n  .mds .mds-viewport .mds-lg-gap-400 {\n    gap: 16px;\n  }\n  .mds .mds-lg-col-gap-400,\n  .mds .mds-container .mds-lg-col-gap-400,\n  .mds .mds-viewport .mds-lg-col-gap-400 {\n    column-gap: 16px;\n  }\n  .mds .mds-lg-row-gap-400,\n  .mds .mds-container .mds-lg-row-gap-400,\n  .mds .mds-viewport .mds-lg-row-gap-400 {\n    row-gap: 16px;\n  }\n  .mds .mds-lg-gap-500,\n  .mds .mds-container .mds-lg-gap-500,\n  .mds .mds-viewport .mds-lg-gap-500 {\n    gap: 20px;\n  }\n  .mds .mds-lg-col-gap-500,\n  .mds .mds-container .mds-lg-col-gap-500,\n  .mds .mds-viewport .mds-lg-col-gap-500 {\n    column-gap: 20px;\n  }\n  .mds .mds-lg-row-gap-500,\n  .mds .mds-container .mds-lg-row-gap-500,\n  .mds .mds-viewport .mds-lg-row-gap-500 {\n    row-gap: 20px;\n  }\n  .mds .mds-lg-gap-600,\n  .mds .mds-container .mds-lg-gap-600,\n  .mds .mds-viewport .mds-lg-gap-600 {\n    gap: 24px;\n  }\n  .mds .mds-lg-col-gap-600,\n  .mds .mds-container .mds-lg-col-gap-600,\n  .mds .mds-viewport .mds-lg-col-gap-600 {\n    column-gap: 24px;\n  }\n  .mds .mds-lg-row-gap-600,\n  .mds .mds-container .mds-lg-row-gap-600,\n  .mds .mds-viewport .mds-lg-row-gap-600 {\n    row-gap: 24px;\n  }\n  .mds .mds-lg-gap-700,\n  .mds .mds-container .mds-lg-gap-700,\n  .mds .mds-viewport .mds-lg-gap-700 {\n    gap: 28px;\n  }\n  .mds .mds-lg-col-gap-700,\n  .mds .mds-container .mds-lg-col-gap-700,\n  .mds .mds-viewport .mds-lg-col-gap-700 {\n    column-gap: 28px;\n  }\n  .mds .mds-lg-row-gap-700,\n  .mds .mds-container .mds-lg-row-gap-700,\n  .mds .mds-viewport .mds-lg-row-gap-700 {\n    row-gap: 28px;\n  }\n  .mds .mds-lg-gap-800,\n  .mds .mds-container .mds-lg-gap-800,\n  .mds .mds-viewport .mds-lg-gap-800 {\n    gap: 32px;\n  }\n  .mds .mds-lg-col-gap-800,\n  .mds .mds-container .mds-lg-col-gap-800,\n  .mds .mds-viewport .mds-lg-col-gap-800 {\n    column-gap: 32px;\n  }\n  .mds .mds-lg-row-gap-800,\n  .mds .mds-container .mds-lg-row-gap-800,\n  .mds .mds-viewport .mds-lg-row-gap-800 {\n    row-gap: 32px;\n  }\n  .mds .mds-lg-gap-900,\n  .mds .mds-container .mds-lg-gap-900,\n  .mds .mds-viewport .mds-lg-gap-900 {\n    gap: 36px;\n  }\n  .mds .mds-lg-col-gap-900,\n  .mds .mds-container .mds-lg-col-gap-900,\n  .mds .mds-viewport .mds-lg-col-gap-900 {\n    column-gap: 36px;\n  }\n  .mds .mds-lg-row-gap-900,\n  .mds .mds-container .mds-lg-row-gap-900,\n  .mds .mds-viewport .mds-lg-row-gap-900 {\n    row-gap: 36px;\n  }\n  .mds .mds-lg-gap-1000,\n  .mds .mds-container .mds-lg-gap-1000,\n  .mds .mds-viewport .mds-lg-gap-1000 {\n    gap: 40px;\n  }\n  .mds .mds-lg-col-gap-1000,\n  .mds .mds-container .mds-lg-col-gap-1000,\n  .mds .mds-viewport .mds-lg-col-gap-1000 {\n    column-gap: 40px;\n  }\n  .mds .mds-lg-row-gap-1000,\n  .mds .mds-container .mds-lg-row-gap-1000,\n  .mds .mds-viewport .mds-lg-row-gap-1000 {\n    row-gap: 40px;\n  }\n  .mds .mds-lg-gap-1200,\n  .mds .mds-container .mds-lg-gap-1200,\n  .mds .mds-viewport .mds-lg-gap-1200 {\n    gap: 48px;\n  }\n  .mds .mds-lg-col-gap-1200,\n  .mds .mds-container .mds-lg-col-gap-1200,\n  .mds .mds-viewport .mds-lg-col-gap-1200 {\n    column-gap: 48px;\n  }\n  .mds .mds-lg-row-gap-1200,\n  .mds .mds-container .mds-lg-row-gap-1200,\n  .mds .mds-viewport .mds-lg-row-gap-1200 {\n    row-gap: 48px;\n  }\n  .mds .mds-lg-gap-1600,\n  .mds .mds-container .mds-lg-gap-1600,\n  .mds .mds-viewport .mds-lg-gap-1600 {\n    gap: 64px;\n  }\n  .mds .mds-lg-col-gap-1600,\n  .mds .mds-container .mds-lg-col-gap-1600,\n  .mds .mds-viewport .mds-lg-col-gap-1600 {\n    column-gap: 64px;\n  }\n  .mds .mds-lg-row-gap-1600,\n  .mds .mds-container .mds-lg-row-gap-1600,\n  .mds .mds-viewport .mds-lg-row-gap-1600 {\n    row-gap: 64px;\n  }\n  .mds .mds-lg-gap-2000,\n  .mds .mds-container .mds-lg-gap-2000,\n  .mds .mds-viewport .mds-lg-gap-2000 {\n    gap: 80px;\n  }\n  .mds .mds-lg-col-gap-2000,\n  .mds .mds-container .mds-lg-col-gap-2000,\n  .mds .mds-viewport .mds-lg-col-gap-2000 {\n    column-gap: 80px;\n  }\n  .mds .mds-lg-row-gap-2000,\n  .mds .mds-container .mds-lg-row-gap-2000,\n  .mds .mds-viewport .mds-lg-row-gap-2000 {\n    row-gap: 80px;\n  }\n  .mds .mds-lg-gap-2400,\n  .mds .mds-container .mds-lg-gap-2400,\n  .mds .mds-viewport .mds-lg-gap-2400 {\n    gap: 96px;\n  }\n  .mds .mds-lg-col-gap-2400,\n  .mds .mds-container .mds-lg-col-gap-2400,\n  .mds .mds-viewport .mds-lg-col-gap-2400 {\n    column-gap: 96px;\n  }\n  .mds .mds-lg-row-gap-2400,\n  .mds .mds-container .mds-lg-row-gap-2400,\n  .mds .mds-viewport .mds-lg-row-gap-2400 {\n    row-gap: 96px;\n  }\n  .mds .mds-lg-gap-2800,\n  .mds .mds-container .mds-lg-gap-2800,\n  .mds .mds-viewport .mds-lg-gap-2800 {\n    gap: 112px;\n  }\n  .mds .mds-lg-col-gap-2800,\n  .mds .mds-container .mds-lg-col-gap-2800,\n  .mds .mds-viewport .mds-lg-col-gap-2800 {\n    column-gap: 112px;\n  }\n  .mds .mds-lg-row-gap-2800,\n  .mds .mds-container .mds-lg-row-gap-2800,\n  .mds .mds-viewport .mds-lg-row-gap-2800 {\n    row-gap: 112px;\n  }\n  .mds .mds-lg-gap-3200,\n  .mds .mds-container .mds-lg-gap-3200,\n  .mds .mds-viewport .mds-lg-gap-3200 {\n    gap: 128px;\n  }\n  .mds .mds-lg-col-gap-3200,\n  .mds .mds-container .mds-lg-col-gap-3200,\n  .mds .mds-viewport .mds-lg-col-gap-3200 {\n    column-gap: 128px;\n  }\n  .mds .mds-lg-row-gap-3200,\n  .mds .mds-container .mds-lg-row-gap-3200,\n  .mds .mds-viewport .mds-lg-row-gap-3200 {\n    row-gap: 128px;\n  }\n}\n@container (min-width: 1921px) {\n  .mds .mds-xl-gap-50,\n  .mds .mds-container .mds-xl-gap-50,\n  .mds .mds-viewport .mds-xl-gap-50 {\n    gap: 2px;\n  }\n  .mds .mds-xl-col-gap-50,\n  .mds .mds-container .mds-xl-col-gap-50,\n  .mds .mds-viewport .mds-xl-col-gap-50 {\n    column-gap: 2px;\n  }\n  .mds .mds-xl-row-gap-50,\n  .mds .mds-container .mds-xl-row-gap-50,\n  .mds .mds-viewport .mds-xl-row-gap-50 {\n    row-gap: 2px;\n  }\n  .mds .mds-xl-gap-100,\n  .mds .mds-container .mds-xl-gap-100,\n  .mds .mds-viewport .mds-xl-gap-100 {\n    gap: 4px;\n  }\n  .mds .mds-xl-col-gap-100,\n  .mds .mds-container .mds-xl-col-gap-100,\n  .mds .mds-viewport .mds-xl-col-gap-100 {\n    column-gap: 4px;\n  }\n  .mds .mds-xl-row-gap-100,\n  .mds .mds-container .mds-xl-row-gap-100,\n  .mds .mds-viewport .mds-xl-row-gap-100 {\n    row-gap: 4px;\n  }\n  .mds .mds-xl-gap-150,\n  .mds .mds-container .mds-xl-gap-150,\n  .mds .mds-viewport .mds-xl-gap-150 {\n    gap: 6px;\n  }\n  .mds .mds-xl-col-gap-150,\n  .mds .mds-container .mds-xl-col-gap-150,\n  .mds .mds-viewport .mds-xl-col-gap-150 {\n    column-gap: 6px;\n  }\n  .mds .mds-xl-row-gap-150,\n  .mds .mds-container .mds-xl-row-gap-150,\n  .mds .mds-viewport .mds-xl-row-gap-150 {\n    row-gap: 6px;\n  }\n  .mds .mds-xl-gap-200,\n  .mds .mds-container .mds-xl-gap-200,\n  .mds .mds-viewport .mds-xl-gap-200 {\n    gap: 8px;\n  }\n  .mds .mds-xl-col-gap-200,\n  .mds .mds-container .mds-xl-col-gap-200,\n  .mds .mds-viewport .mds-xl-col-gap-200 {\n    column-gap: 8px;\n  }\n  .mds .mds-xl-row-gap-200,\n  .mds .mds-container .mds-xl-row-gap-200,\n  .mds .mds-viewport .mds-xl-row-gap-200 {\n    row-gap: 8px;\n  }\n  .mds .mds-xl-gap-300,\n  .mds .mds-container .mds-xl-gap-300,\n  .mds .mds-viewport .mds-xl-gap-300 {\n    gap: 12px;\n  }\n  .mds .mds-xl-col-gap-300,\n  .mds .mds-container .mds-xl-col-gap-300,\n  .mds .mds-viewport .mds-xl-col-gap-300 {\n    column-gap: 12px;\n  }\n  .mds .mds-xl-row-gap-300,\n  .mds .mds-container .mds-xl-row-gap-300,\n  .mds .mds-viewport .mds-xl-row-gap-300 {\n    row-gap: 12px;\n  }\n  .mds .mds-xl-gap-400,\n  .mds .mds-container .mds-xl-gap-400,\n  .mds .mds-viewport .mds-xl-gap-400 {\n    gap: 16px;\n  }\n  .mds .mds-xl-col-gap-400,\n  .mds .mds-container .mds-xl-col-gap-400,\n  .mds .mds-viewport .mds-xl-col-gap-400 {\n    column-gap: 16px;\n  }\n  .mds .mds-xl-row-gap-400,\n  .mds .mds-container .mds-xl-row-gap-400,\n  .mds .mds-viewport .mds-xl-row-gap-400 {\n    row-gap: 16px;\n  }\n  .mds .mds-xl-gap-500,\n  .mds .mds-container .mds-xl-gap-500,\n  .mds .mds-viewport .mds-xl-gap-500 {\n    gap: 20px;\n  }\n  .mds .mds-xl-col-gap-500,\n  .mds .mds-container .mds-xl-col-gap-500,\n  .mds .mds-viewport .mds-xl-col-gap-500 {\n    column-gap: 20px;\n  }\n  .mds .mds-xl-row-gap-500,\n  .mds .mds-container .mds-xl-row-gap-500,\n  .mds .mds-viewport .mds-xl-row-gap-500 {\n    row-gap: 20px;\n  }\n  .mds .mds-xl-gap-600,\n  .mds .mds-container .mds-xl-gap-600,\n  .mds .mds-viewport .mds-xl-gap-600 {\n    gap: 24px;\n  }\n  .mds .mds-xl-col-gap-600,\n  .mds .mds-container .mds-xl-col-gap-600,\n  .mds .mds-viewport .mds-xl-col-gap-600 {\n    column-gap: 24px;\n  }\n  .mds .mds-xl-row-gap-600,\n  .mds .mds-container .mds-xl-row-gap-600,\n  .mds .mds-viewport .mds-xl-row-gap-600 {\n    row-gap: 24px;\n  }\n  .mds .mds-xl-gap-700,\n  .mds .mds-container .mds-xl-gap-700,\n  .mds .mds-viewport .mds-xl-gap-700 {\n    gap: 28px;\n  }\n  .mds .mds-xl-col-gap-700,\n  .mds .mds-container .mds-xl-col-gap-700,\n  .mds .mds-viewport .mds-xl-col-gap-700 {\n    column-gap: 28px;\n  }\n  .mds .mds-xl-row-gap-700,\n  .mds .mds-container .mds-xl-row-gap-700,\n  .mds .mds-viewport .mds-xl-row-gap-700 {\n    row-gap: 28px;\n  }\n  .mds .mds-xl-gap-800,\n  .mds .mds-container .mds-xl-gap-800,\n  .mds .mds-viewport .mds-xl-gap-800 {\n    gap: 32px;\n  }\n  .mds .mds-xl-col-gap-800,\n  .mds .mds-container .mds-xl-col-gap-800,\n  .mds .mds-viewport .mds-xl-col-gap-800 {\n    column-gap: 32px;\n  }\n  .mds .mds-xl-row-gap-800,\n  .mds .mds-container .mds-xl-row-gap-800,\n  .mds .mds-viewport .mds-xl-row-gap-800 {\n    row-gap: 32px;\n  }\n  .mds .mds-xl-gap-900,\n  .mds .mds-container .mds-xl-gap-900,\n  .mds .mds-viewport .mds-xl-gap-900 {\n    gap: 36px;\n  }\n  .mds .mds-xl-col-gap-900,\n  .mds .mds-container .mds-xl-col-gap-900,\n  .mds .mds-viewport .mds-xl-col-gap-900 {\n    column-gap: 36px;\n  }\n  .mds .mds-xl-row-gap-900,\n  .mds .mds-container .mds-xl-row-gap-900,\n  .mds .mds-viewport .mds-xl-row-gap-900 {\n    row-gap: 36px;\n  }\n  .mds .mds-xl-gap-1000,\n  .mds .mds-container .mds-xl-gap-1000,\n  .mds .mds-viewport .mds-xl-gap-1000 {\n    gap: 40px;\n  }\n  .mds .mds-xl-col-gap-1000,\n  .mds .mds-container .mds-xl-col-gap-1000,\n  .mds .mds-viewport .mds-xl-col-gap-1000 {\n    column-gap: 40px;\n  }\n  .mds .mds-xl-row-gap-1000,\n  .mds .mds-container .mds-xl-row-gap-1000,\n  .mds .mds-viewport .mds-xl-row-gap-1000 {\n    row-gap: 40px;\n  }\n  .mds .mds-xl-gap-1200,\n  .mds .mds-container .mds-xl-gap-1200,\n  .mds .mds-viewport .mds-xl-gap-1200 {\n    gap: 48px;\n  }\n  .mds .mds-xl-col-gap-1200,\n  .mds .mds-container .mds-xl-col-gap-1200,\n  .mds .mds-viewport .mds-xl-col-gap-1200 {\n    column-gap: 48px;\n  }\n  .mds .mds-xl-row-gap-1200,\n  .mds .mds-container .mds-xl-row-gap-1200,\n  .mds .mds-viewport .mds-xl-row-gap-1200 {\n    row-gap: 48px;\n  }\n  .mds .mds-xl-gap-1600,\n  .mds .mds-container .mds-xl-gap-1600,\n  .mds .mds-viewport .mds-xl-gap-1600 {\n    gap: 64px;\n  }\n  .mds .mds-xl-col-gap-1600,\n  .mds .mds-container .mds-xl-col-gap-1600,\n  .mds .mds-viewport .mds-xl-col-gap-1600 {\n    column-gap: 64px;\n  }\n  .mds .mds-xl-row-gap-1600,\n  .mds .mds-container .mds-xl-row-gap-1600,\n  .mds .mds-viewport .mds-xl-row-gap-1600 {\n    row-gap: 64px;\n  }\n  .mds .mds-xl-gap-2000,\n  .mds .mds-container .mds-xl-gap-2000,\n  .mds .mds-viewport .mds-xl-gap-2000 {\n    gap: 80px;\n  }\n  .mds .mds-xl-col-gap-2000,\n  .mds .mds-container .mds-xl-col-gap-2000,\n  .mds .mds-viewport .mds-xl-col-gap-2000 {\n    column-gap: 80px;\n  }\n  .mds .mds-xl-row-gap-2000,\n  .mds .mds-container .mds-xl-row-gap-2000,\n  .mds .mds-viewport .mds-xl-row-gap-2000 {\n    row-gap: 80px;\n  }\n  .mds .mds-xl-gap-2400,\n  .mds .mds-container .mds-xl-gap-2400,\n  .mds .mds-viewport .mds-xl-gap-2400 {\n    gap: 96px;\n  }\n  .mds .mds-xl-col-gap-2400,\n  .mds .mds-container .mds-xl-col-gap-2400,\n  .mds .mds-viewport .mds-xl-col-gap-2400 {\n    column-gap: 96px;\n  }\n  .mds .mds-xl-row-gap-2400,\n  .mds .mds-container .mds-xl-row-gap-2400,\n  .mds .mds-viewport .mds-xl-row-gap-2400 {\n    row-gap: 96px;\n  }\n  .mds .mds-xl-gap-2800,\n  .mds .mds-container .mds-xl-gap-2800,\n  .mds .mds-viewport .mds-xl-gap-2800 {\n    gap: 112px;\n  }\n  .mds .mds-xl-col-gap-2800,\n  .mds .mds-container .mds-xl-col-gap-2800,\n  .mds .mds-viewport .mds-xl-col-gap-2800 {\n    column-gap: 112px;\n  }\n  .mds .mds-xl-row-gap-2800,\n  .mds .mds-container .mds-xl-row-gap-2800,\n  .mds .mds-viewport .mds-xl-row-gap-2800 {\n    row-gap: 112px;\n  }\n  .mds .mds-xl-gap-3200,\n  .mds .mds-container .mds-xl-gap-3200,\n  .mds .mds-viewport .mds-xl-gap-3200 {\n    gap: 128px;\n  }\n  .mds .mds-xl-col-gap-3200,\n  .mds .mds-container .mds-xl-col-gap-3200,\n  .mds .mds-viewport .mds-xl-col-gap-3200 {\n    column-gap: 128px;\n  }\n  .mds .mds-xl-row-gap-3200,\n  .mds .mds-container .mds-xl-row-gap-3200,\n  .mds .mds-viewport .mds-xl-row-gap-3200 {\n    row-gap: 128px;\n  }\n}\n\n.mds-content h1 {\n  margin: var(--mds_foundations_typography_heading-1_margin-top) 0 var(--mds_foundations_typography_heading-1_margin-bottom);\n}\n.mds-content h2 {\n  margin: var(--mds_foundations_typography_heading-2_margin-top) 0 var(--mds_foundations_typography_heading-2_margin-bottom);\n}\n.mds-content h3 {\n  margin: var(--mds_foundations_typography_heading-3_margin-top) 0 var(--mds_foundations_typography_heading-3_margin-bottom);\n}\n.mds-content h4 {\n  margin: var(--mds_foundations_typography_heading-4_margin-top) 0 var(--mds_foundations_typography_heading-4_margin-bottom);\n}\n.mds-content h5,\n.mds-content h6 {\n  margin: var(--mds_foundations_typography_heading-4_margin-top) 0 var(--mds_foundations_typography_heading-4_margin-bottom);\n}\n.mds-content p {\n  margin: var(--mds_foundations_typography_paragraph_margin-top) 0 var(--mds_foundations_typography_paragraph_margin-bottom);\n  padding: 0;\n}\n.mds-content hr {\n  margin: var(--mds_foundations_horizontal-rule_margin-top) 0 var(--mds_foundations_horizontal-rule_margin-bottom) 0;\n}\n.mds-content ul,\n.mds-content ol {\n  margin: var(--mds_foundations_list_margin-top) var(--mds_foundations_list_margin-bottom);\n  padding: 0 0 0 var(--mds_foundations_list_vertical_padding-left);\n}\n.mds-content ul li,\n.mds-content ol li {\n  padding-left: var(--mds_foundations_list_item_padding-left);\n}\n\nbody.mds {\n  margin: 0;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
